import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: { input: any; output: any; }
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: { input: any; output: any; }
  /** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
  AWSJSON: { input: any; output: any; }
  /** The `AWSURL` scalar type provided by AWS AppSync, represents a valid URL string (Ex: <https://example.com/>). The URL may use any scheme and may also be a local URL (Ex: <http://localhost/>).  URLs without schemes like "**example.com**" or "**www.example.com**" are considered invalid. URLs containing username and password like "**<https://username:password@example.com/>**" are also considered invalid. */
  AWSURL: { input: any; output: any; }
};

export type Actor = {
  __typename?: 'Actor';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AddExternalEventsDestinationApiResult = {
  __typename?: 'AddExternalEventsDestinationAPIResult';
  apiDestinationName: Scalars['String']['output'];
};

export type AddExternalEventsDestinationEventBusResult = {
  __typename?: 'AddExternalEventsDestinationEventBusResult';
  eventBusArn: Scalars['String']['output'];
};

export type AddExternalEventsRuleResult = {
  __typename?: 'AddExternalEventsRuleResult';
  ruleName: Scalars['String']['output'];
};

export type AdyenConfig = {
  __typename?: 'AdyenConfig';
  clientKey: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: AdyenCredentials;
  environment: AdyenEnvironment;
  id: Scalars['ID']['output'];
  liveEndpointUrlPrefix?: Maybe<Scalars['String']['output']>;
  merchantAccount: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  webhooks?: Maybe<Array<AdyenWebhook>>;
};

export type AdyenCredentials = {
  __typename?: 'AdyenCredentials';
  apiKey: Scalars['String']['output'];
  /** @deprecated will be moved to AdyenWebhookCredentials.hmac instead */
  hmac?: Maybe<Scalars['String']['output']>;
};

export enum AdyenEnvironment {
  Live = 'LIVE',
  Test = 'TEST'
}

export type AdyenWebhook = {
  __typename?: 'AdyenWebhook';
  configId?: Maybe<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sequenceNumber: Scalars['Int']['output'];
  status?: Maybe<AdyenWebhookStatus>;
  target?: Maybe<AdyenWebhookTarget>;
  tested?: Maybe<Scalars['AWSDateTime']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  username: Scalars['String']['output'];
};

export type AdyenWebhookCredentials = {
  __typename?: 'AdyenWebhookCredentials';
  hmac?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AdyenWebhookGenerationResult = {
  __typename?: 'AdyenWebhookGenerationResult';
  started: Scalars['Boolean']['output'];
};

export type AdyenWebhookLegacy = {
  __typename?: 'AdyenWebhookLegacy';
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
  username: Scalars['String']['output'];
};

export enum AdyenWebhookStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum AdyenWebhookTarget {
  OrderManagement = 'OrderManagement',
  Shopper = 'Shopper'
}

export type ApiClient = {
  __typename?: 'ApiClient';
  clientId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiClientDetails = {
  __typename?: 'ApiClientDetails';
  clientId: Scalars['ID']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  updated?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ApiClientsList = {
  __typename?: 'ApiClientsList';
  apiClients: Array<ApiClient>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ApiResource = {
  __typename?: 'ApiResource';
  identifier: Scalars['String']['output'];
  scopes?: Maybe<Array<ApiScope>>;
};

export type ApiScope = {
  __typename?: 'ApiScope';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AvardaConfig = {
  __typename?: 'AvardaConfig';
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: AvardaCredentials;
  id: Scalars['ID']['output'];
  shippingBroker?: Maybe<AvardaShippingBroker>;
  updated: Scalars['AWSDateTime']['output'];
};

export type AvardaCredentials = {
  __typename?: 'AvardaCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type AvardaShippingBroker = {
  __typename?: 'AvardaShippingBroker';
  name: Scalars['String']['output'];
};

export type AvardaShippingBrokerShipping = {
  __typename?: 'AvardaShippingBrokerShipping';
  ingrid?: Maybe<AvardaShippingBrokerShippingIngrid>;
};

export type AvardaShippingBrokerShippingIngrid = {
  __typename?: 'AvardaShippingBrokerShippingIngrid';
  carrier: Scalars['String']['output'];
  category?: Maybe<AvardaShippingBrokerShippingIngridCategory>;
  currencyCode: Scalars['String']['output'];
  deliveryType: Scalars['String']['output'];
  externalMethodId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<AvardaShippingBrokerShippingIngridLocation>;
  price: Scalars['Float']['output'];
  priceComponents?: Maybe<Array<AvardaShippingBrokerShippingIngridPriceComponent>>;
  product: Scalars['String']['output'];
  shippingMethod: Scalars['String']['output'];
  taxAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  tosId: Scalars['String']['output'];
};

export type AvardaShippingBrokerShippingIngridCategory = {
  __typename?: 'AvardaShippingBrokerShippingIngridCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags?: Maybe<Array<AvardaShippingBrokerShippingIngridCategoryTag>>;
};

export type AvardaShippingBrokerShippingIngridCategoryTag = {
  __typename?: 'AvardaShippingBrokerShippingIngridCategoryTag';
  name: Scalars['String']['output'];
};

export type AvardaShippingBrokerShippingIngridLocation = {
  __typename?: 'AvardaShippingBrokerShippingIngridLocation';
  address: AvardaShippingBrokerShippingIngridLocationAddress;
  externalId: Scalars['String']['output'];
};

export type AvardaShippingBrokerShippingIngridLocationAddress = {
  __typename?: 'AvardaShippingBrokerShippingIngridLocationAddress';
  addressLines: Array<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type AvardaShippingBrokerShippingIngridPriceComponent = {
  __typename?: 'AvardaShippingBrokerShippingIngridPriceComponent';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type BsgGiftCardConfig = {
  __typename?: 'BSGGiftCardConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: BsgGiftCardCredentials;
  id: Scalars['ID']['output'];
  scopes: Array<Scalars['String']['output']>;
  tokenUrl: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type BsgGiftCardCredentials = {
  __typename?: 'BSGGiftCardCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type BonusConfig = {
  __typename?: 'BonusConfig';
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: BonusCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type BonusCredentials = {
  __typename?: 'BonusCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type BonusProvider = {
  __typename?: 'BonusProvider';
  providerId: Scalars['String']['output'];
  providerName: BonusProviderName;
  status?: Maybe<ProviderStatusLog>;
};

export enum BonusProviderName {
  Bonus = 'Bonus'
}

export type Bundle = {
  __typename?: 'Bundle';
  discountValue?: Maybe<DiscountValue>;
  id: Scalars['String']['output'];
  itemRules: Array<BundleItemRule>;
};

export type BundleGroup = {
  __typename?: 'BundleGroup';
  bundles: Array<Bundle>;
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  storeMarkets: Array<Maybe<BundleStoreMarket>>;
  updated: Scalars['AWSDateTime']['output'];
  validDateRange?: Maybe<ValidDateRange>;
};

export type BundleGroupSearchHit = {
  __typename?: 'BundleGroupSearchHit';
  bundles: Array<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validTo?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type BundleGroupSearchHits = {
  __typename?: 'BundleGroupSearchHits';
  hits: Array<BundleGroupSearchHit>;
  total: Scalars['Int']['output'];
};

export type BundleItemRule = {
  __typename?: 'BundleItemRule';
  discountValue?: Maybe<DiscountValue>;
  excludeDiscountedPrices: Scalars['Boolean']['output'];
  excludeFullPrices: Scalars['Boolean']['output'];
  productParents: Array<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  tagConditions: Array<TagCondition>;
};

export type BundleOutcome = {
  __typename?: 'BundleOutcome';
  bundleGroupId?: Maybe<Scalars['String']['output']>;
  bundleId?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
};

export type BundleStoreMarket = {
  __typename?: 'BundleStoreMarket';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignGroupId: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  endDate: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceRule: PriceRule;
  productVariantRules: ProductVariantRules;
  roundingRules?: Maybe<RoundingRules>;
  startDate: Scalars['AWSDateTime']['output'];
  storeMarkets: Array<CampaignStoreMarket>;
  updated: Scalars['AWSDateTime']['output'];
};

export type CampaignDeletionResult = {
  __typename?: 'CampaignDeletionResult';
  result: Scalars['String']['output'];
};

export type CampaignGroup = {
  __typename?: 'CampaignGroup';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type CampaignGroupList = {
  __typename?: 'CampaignGroupList';
  campaignGroup: CampaignGroup;
  campaigns: Array<Campaign>;
};

export type CampaignGroupSearchHit = {
  __typename?: 'CampaignGroupSearchHit';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type CampaignGroupSearchHits = {
  __typename?: 'CampaignGroupSearchHits';
  hits: Array<CampaignGroupSearchHit>;
  total: Scalars['Int']['output'];
};

export type CampaignIdentity = {
  __typename?: 'CampaignIdentity';
  campaignGroupId: Scalars['ID']['output'];
  campaignId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CampaignMoney = {
  __typename?: 'CampaignMoney';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type CampaignSearchHit = {
  __typename?: 'CampaignSearchHit';
  campaignGroupId: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  endDate: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['AWSDateTime']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type CampaignSearchHits = {
  __typename?: 'CampaignSearchHits';
  hits: Array<CampaignSearchHit>;
  total: Scalars['Int']['output'];
};

export type CampaignStoreMarket = {
  __typename?: 'CampaignStoreMarket';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type CancellationBonus = {
  __typename?: 'CancellationBonus';
  reservationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CancellationGiftCard = {
  __typename?: 'CancellationGiftCard';
  giftCardId: Scalars['ID']['output'];
  reservationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CancellationGiftCardProduct = {
  __typename?: 'CancellationGiftCardProduct';
  cancelTransactionId?: Maybe<Scalars['String']['output']>;
  giftCardProductId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type CancelledPayment = {
  __typename?: 'CancelledPayment';
  reference: Scalars['String']['output'];
};

export type Capabilities = {
  __typename?: 'Capabilities';
  giftCardProviders?: Maybe<Array<Provider>>;
  paymentProviders?: Maybe<Array<Provider>>;
  shippingProviders?: Maybe<Array<Provider>>;
  taxProviders?: Maybe<Array<Provider>>;
};

export type CapabilityProvider = {
  __typename?: 'CapabilityProvider';
  id: Scalars['ID']['output'];
};

export type CartCapabilities = {
  __typename?: 'CartCapabilities';
  bonus?: Maybe<CapabilityProvider>;
  externalPrice?: Maybe<CapabilityProvider>;
  retain24?: Maybe<CapabilityProvider>;
  voyado?: Maybe<CapabilityProvider>;
};

export type CartRuleOutcome = {
  __typename?: 'CartRuleOutcome';
  discountAmount?: Maybe<Scalars['Int']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
};

export enum ChannelType {
  B2B = 'B2B',
  B2C = 'B2C'
}

export type CodeRuleOutcome = {
  __typename?: 'CodeRuleOutcome';
  code?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
};

export type CodesGenerationSearchHit = {
  __typename?: 'CodesGenerationSearchHit';
  created: Scalars['AWSDateTime']['output'];
  discountCodeRuleId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numberOfCodesGenerated: Scalars['Int']['output'];
  numberOfCodesRequested: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  usageLimit: Scalars['Int']['output'];
};

export type CodesGenerationSearchHits = {
  __typename?: 'CodesGenerationSearchHits';
  hits: Array<CodesGenerationSearchHit>;
  total: Scalars['Int']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  text: Scalars['String']['output'];
};

export type CompanyAttribute = {
  __typename?: 'CompanyAttribute';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type CompensationBonus = {
  __typename?: 'CompensationBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reservationId: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
};

export type CompensationFee = {
  __typename?: 'CompensationFee';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taxAmount: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type CompensationGiftCard = {
  __typename?: 'CompensationGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type CompensationOrderLine = {
  __typename?: 'CompensationOrderLine';
  currencyCode: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  reason?: Maybe<Reason>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type CompensationPayment = {
  __typename?: 'CompensationPayment';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type CompensationShippingFee = {
  __typename?: 'CompensationShippingFee';
  currencyCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shippingFeeId: Scalars['ID']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type Condition = {
  __typename?: 'Condition';
  id: Scalars['ID']['output'];
  identifiers?: Maybe<Array<Scalars['String']['output']>>;
  itemRule?: Maybe<ItemRule>;
  thresholds?: Maybe<Array<Money>>;
  triggerQuantity?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type CreateGenerateCodesResult = {
  __typename?: 'CreateGenerateCodesResult';
  jobId: Scalars['String']['output'];
};

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  currencyCode: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export type CurrencyRates = {
  __typename?: 'CurrencyRates';
  baseCurrencyCode: Scalars['String']['output'];
  rates: Array<CurrencyRate>;
};

export enum CustomOperation {
  Cancellation = 'CANCELLATION',
  Compensation = 'COMPENSATION',
  Delivery = 'DELIVERY',
  ModifyOrderAddresses = 'MODIFY_ORDER_ADDRESSES',
  ModifyOrderLines = 'MODIFY_ORDER_LINES',
  ModifyShippingFees = 'MODIFY_SHIPPING_FEES',
  Refund = 'REFUND',
  Release = 'RELEASE'
}

export type CustomPaymentConfig = {
  __typename?: 'CustomPaymentConfig';
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: CustomPaymentCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type CustomPaymentCredentials = {
  __typename?: 'CustomPaymentCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type CustomReasonCode = {
  __typename?: 'CustomReasonCode';
  code: Scalars['ID']['output'];
  created: Scalars['AWSDateTime']['output'];
  label?: Maybe<Scalars['String']['output']>;
  revision: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type CustomReasonCodes = {
  __typename?: 'CustomReasonCodes';
  codes: Array<Maybe<CustomReasonCode>>;
};

export type CustomState = {
  __typename?: 'CustomState';
  created: Scalars['AWSDateTime']['output'];
  deleted?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  operations?: Maybe<Array<Scalars['String']['output']>>;
  revision: Scalars['Int']['output'];
  type: CustomStateType;
  updated: Scalars['AWSDateTime']['output'];
};

export enum CustomStateType {
  Blocking = 'BLOCKING',
  Informative = 'INFORMATIVE'
}

export type CustomStates = {
  __typename?: 'CustomStates';
  states: Array<Maybe<CustomState>>;
};

export type DeletedResult = {
  __typename?: 'DeletedResult';
  status: Scalars['String']['output'];
};

export type DeliveryBonus = {
  __typename?: 'DeliveryBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reservationId: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
};

export type DeliveryCapture = {
  __typename?: 'DeliveryCapture';
  reference: Scalars['String']['output'];
};

export type DeliveryGift = {
  __typename?: 'DeliveryGift';
  giftId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type DeliveryGiftCard = {
  __typename?: 'DeliveryGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardId: Scalars['ID']['output'];
  reservationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type DeliveryGiftCardProduct = {
  __typename?: 'DeliveryGiftCardProduct';
  createFailedReason?: Maybe<Scalars['String']['output']>;
  createId?: Maybe<Scalars['String']['output']>;
  createTransactionId?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  giftCardProductId: Scalars['ID']['output'];
  priceAmount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type DeliveryOrderLine = {
  __typename?: 'DeliveryOrderLine';
  currencyCode: Scalars['String']['output'];
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type DeliveryShippingFee = {
  __typename?: 'DeliveryShippingFee';
  currencyCode: Scalars['String']['output'];
  shippingFeeId: Scalars['ID']['output'];
  totalAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type DeliveryTracking = {
  __typename?: 'DeliveryTracking';
  reference: Scalars['String']['output'];
  shippingCompany: Scalars['String']['output'];
  shippingMethod: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DeliveryVoucher = {
  __typename?: 'DeliveryVoucher';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  voucherId: Scalars['ID']['output'];
};

export type Dimensions = {
  __typename?: 'Dimensions';
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  code: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  discountCodeRuleId: Scalars['String']['output'];
  isUnlimited: Scalars['Boolean']['output'];
  updated: Scalars['AWSDateTime']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
  validDateRange?: Maybe<ValidDateRange>;
};

export type DiscountCodeRule = {
  __typename?: 'DiscountCodeRule';
  applyLast: Scalars['Boolean']['output'];
  conditions: Array<Condition>;
  created: Scalars['AWSDateTime']['output'];
  displayNames?: Maybe<Array<DisplayName>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  logicRules: Array<LogicHolder>;
  name: Scalars['String']['output'];
  outcomes: Array<Outcome>;
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validDateRange?: Maybe<ValidDateRange>;
};

export type DiscountCodeRuleSearchHit = {
  __typename?: 'DiscountCodeRuleSearchHit';
  applyLast: Scalars['Boolean']['output'];
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validTo?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DiscountCodeRuleSearchHits = {
  __typename?: 'DiscountCodeRuleSearchHits';
  hits: Array<DiscountCodeRuleSearchHit>;
  total: Scalars['Int']['output'];
};

export type DiscountCodeSearchHit = {
  __typename?: 'DiscountCodeSearchHit';
  code: Scalars['ID']['output'];
  created: Scalars['AWSDateTime']['output'];
  discountCodeRuleId: Scalars['String']['output'];
  isUnlimited: Scalars['Boolean']['output'];
  updated: Scalars['AWSDateTime']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validTo?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DiscountCodeSearchHits = {
  __typename?: 'DiscountCodeSearchHits';
  hits: Array<DiscountCodeSearchHit>;
  total: Scalars['Int']['output'];
};

export type DiscountExternalRule = {
  __typename?: 'DiscountExternalRule';
  applyLast: Scalars['Boolean']['output'];
  conditions: Array<Condition>;
  created: Scalars['AWSDateTime']['output'];
  displayNames?: Maybe<Array<DisplayName>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  logicRules: Array<LogicHolder>;
  name: Scalars['String']['output'];
  outcomes: Array<Outcome>;
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validDateRange?: Maybe<ValidDateRange>;
};

export type DiscountExternalRuleSearchHit = {
  __typename?: 'DiscountExternalRuleSearchHit';
  applyLast: Scalars['Boolean']['output'];
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validTo?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DiscountExternalRuleSearchHits = {
  __typename?: 'DiscountExternalRuleSearchHits';
  hits: Array<DiscountExternalRuleSearchHit>;
  total: Scalars['Int']['output'];
};

export type DiscountManagementQuotas = {
  __typename?: 'DiscountManagementQuotas';
  maxGenerationJobsPerDay: Scalars['Int']['output'];
  maxNumberOfCodes: Scalars['Int']['output'];
};

export type DiscountRule = {
  __typename?: 'DiscountRule';
  conditions: Array<Condition>;
  created: Scalars['AWSDateTime']['output'];
  displayNames?: Maybe<Array<DisplayName>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  logicRules: Array<LogicHolder>;
  name: Scalars['String']['output'];
  outcomes: Array<Outcome>;
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validDateRange?: Maybe<ValidDateRange>;
};

export type DiscountRuleSearchHit = {
  __typename?: 'DiscountRuleSearchHit';
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
  validFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  validTo?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DiscountRuleSearchHits = {
  __typename?: 'DiscountRuleSearchHits';
  hits: Array<DiscountRuleSearchHit>;
  total: Scalars['Int']['output'];
};

export type DiscountValue = {
  __typename?: 'DiscountValue';
  fixedDiscounts?: Maybe<Array<Money>>;
  percentage?: Maybe<Scalars['Int']['output']>;
  percentageDecimals?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type DisplayName = {
  __typename?: 'DisplayName';
  languageCode: Scalars['String']['output'];
  translation: Scalars['String']['output'];
};

export type ExternalApi = {
  __typename?: 'ExternalApi';
  discountManagementQuotas?: Maybe<DiscountManagementQuotas>;
  usagePlans: Array<UsagePlan>;
};

export type ExternalEventDestinationApi = {
  __typename?: 'ExternalEventDestinationAPI';
  active: Scalars['Boolean']['output'];
  created: Scalars['AWSDateTime']['output'];
  endpoint?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<ExternalEventDestinationApiFilter>>;
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ExternalEventDestinationApiFilter = {
  __typename?: 'ExternalEventDestinationAPIFilter';
  pattern?: Maybe<ExternalEventDestinationApiFilterPattern>;
  ruleName: Scalars['String']['output'];
};

export type ExternalEventDestinationApiFilterPattern = {
  __typename?: 'ExternalEventDestinationAPIFilterPattern';
  detailTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExternalEventDestinationApIs = {
  __typename?: 'ExternalEventDestinationAPIs';
  apiDestinations: Array<Scalars['String']['output']>;
  apiDestinationsDetails: Array<ExternalEventDestinationsDetails>;
};

export type ExternalEventDestinationEventBuses = {
  __typename?: 'ExternalEventDestinationEventBuses';
  eventBuses: Array<Scalars['String']['output']>;
};

export type ExternalEventDestinationsDetails = {
  __typename?: 'ExternalEventDestinationsDetails';
  active: Scalars['Boolean']['output'];
  created: Scalars['AWSDateTime']['output'];
  endpoint?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ExternalEventRuleState = {
  __typename?: 'ExternalEventRuleState';
  ruleName: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type ExternalEventRules = {
  __typename?: 'ExternalEventRules';
  rules: Array<ExternalEventRuleState>;
};

export type ExternalPriceConfig = {
  __typename?: 'ExternalPriceConfig';
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: ExternalPriceCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ExternalPriceCredentials = {
  __typename?: 'ExternalPriceCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type ExternalPriceProvider = {
  __typename?: 'ExternalPriceProvider';
  providerId: Scalars['String']['output'];
  providerName: ExternalPriceProviderName;
};

export enum ExternalPriceProviderName {
  ExternalPrice = 'ExternalPrice'
}

export type ExternalRuleOutcome = {
  __typename?: 'ExternalRuleOutcome';
  discountAmount?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
};

export type GenerateCodes = {
  __typename?: 'GenerateCodes';
  created: Scalars['AWSDateTime']['output'];
  discountCodeRuleId: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  numberOfCodesGenerated?: Maybe<Scalars['Int']['output']>;
  numberOfCodesRequested: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  usageLimit: Scalars['Int']['output'];
};

export type Gift = {
  __typename?: 'Gift';
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GiftCardProductProvider = {
  __typename?: 'GiftCardProductProvider';
  providerId: Scalars['String']['output'];
  providerName: GiftCardProductProviderName;
  status?: Maybe<ProviderStatusLog>;
};

export enum GiftCardProductProviderName {
  Retain24 = 'Retain24'
}

export type GiftCardProvider = {
  __typename?: 'GiftCardProvider';
  providerId: Scalars['String']['output'];
  providerName: GiftCardProviderName;
  status?: Maybe<ProviderStatusLog>;
};

export enum GiftCardProviderName {
  BsgGiftCard = 'BsgGiftCard',
  KbsGiftCard = 'KbsGiftCard',
  Retain24 = 'Retain24'
}

export type Group = {
  __typename?: 'Group';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['ID']['output'];
};

export type GroupDetails = {
  __typename?: 'GroupDetails';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['ID']['output'];
  users: Array<User>;
};

export type GroupsList = {
  __typename?: 'GroupsList';
  groups: Array<Group>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['ID']['output'];
  type: IdentityProviderType;
};

export enum IdentityProviderType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type IngridConfig = {
  __typename?: 'IngridConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: IngridCredentials;
  id: Scalars['ID']['output'];
  siteId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type IngridCredentials = {
  __typename?: 'IngridCredentials';
  apiKey: Scalars['String']['output'];
};

export type IngridDelivery = {
  __typename?: 'IngridDelivery';
  carrierProductId?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<IngridDeliveryAddress>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  locationExternalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Int']['output']>;
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
  tosId?: Maybe<Scalars['String']['output']>;
};

export type IngridDeliveryAddress = {
  __typename?: 'IngridDeliveryAddress';
  addressLines?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type InputActionBonus = {
  actionType: InputActionType;
};

export type InputActionGiftCard = {
  actionType: InputActionType;
  giftCards?: InputMaybe<Array<InputActionGiftCardManual>>;
};

export type InputActionGiftCardManual = {
  giftCardId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPaymentCancellation = {
  actionType: InputActionType;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPaymentCompensation = {
  actionType: InputActionType;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPaymentDelivery = {
  actionType: InputActionType;
  captureReference?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPaymentOrderModificationOrderLines = {
  actionType: InputActionType;
};

export type InputActionPaymentOrderModificationShippingFees = {
  actionType: InputActionType;
};

export type InputActionPaymentRefund = {
  actionType: InputActionType;
  refundReference?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPaymentRelease = {
  actionType: InputActionType;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionShipping = {
  actionType: InputActionType;
  shippingCompany?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  trackingReference?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum InputActionType {
  Auto = 'AUTO',
  Manual = 'MANUAL',
  Skip = 'SKIP'
}

export type InputAddExternalEventsDestinationApi = {
  apiDestinationEndpoint: Scalars['String']['input'];
  apiKeyAuth?: InputMaybe<InputExternalEventsApiKeyAuth>;
  basicAuth?: InputMaybe<InputExternalEventsBasicAuth>;
  filterEventRules?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputAddUserToGroup = {
  groupname: Scalars['String']['input'];
  username: Scalars['ID']['input'];
};

export type InputAdyenConfig = {
  apiKey: Scalars['String']['input'];
  clientKey: Scalars['String']['input'];
  environment: AdyenEnvironment;
  hmac?: InputMaybe<Scalars['String']['input']>;
  liveEndpointUrlPrefix?: InputMaybe<Scalars['String']['input']>;
  merchantAccount: Scalars['String']['input'];
};

export type InputAdyenWebhookChange = {
  configId: Scalars['String']['input'];
  created: Scalars['AWSDateTime']['input'];
  description: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  sequenceNumber: Scalars['Int']['input'];
  status?: InputMaybe<AdyenWebhookStatus>;
  target: AdyenWebhookTarget;
  tested?: InputMaybe<Scalars['AWSDateTime']['input']>;
  updated: Scalars['AWSDateTime']['input'];
  username: Scalars['String']['input'];
};

export type InputAvardaConfig = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  shippingBroker?: InputMaybe<InputAvardaShippingBroker>;
};

export type InputAvardaShippingBroker = {
  name: Scalars['String']['input'];
};

export type InputBsgGiftCardConfig = {
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  tokenUrl: Scalars['String']['input'];
};

export type InputBonusConfig = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type InputBundle = {
  discountValue?: InputMaybe<InputDiscountValue>;
  id: Scalars['String']['input'];
  itemRules: Array<InputBundleItemRule>;
};

export type InputBundleItemRule = {
  discountValue?: InputMaybe<InputDiscountValue>;
  excludeDiscountedPrices: Scalars['Boolean']['input'];
  excludeFullPrices: Scalars['Boolean']['input'];
  productParents: Array<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  tagConditions: Array<InputTagCondition>;
};

export type InputCampaign = {
  campaignGroupId: Scalars['String']['input'];
  endDate: Scalars['AWSDateTime']['input'];
  name: Scalars['String']['input'];
  priceRule: InputPriceRule;
  productVariantRules: InputProductVariantRules;
  roundingRules?: InputMaybe<InputRoundingRules>;
  startDate: Scalars['AWSDateTime']['input'];
  storeMarkets: Array<InputStoreMarket>;
};

export type InputCampaignGroup = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputCampaignMoney = {
  key: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type InputCampaignPeriod = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type InputCapabilities = {
  giftCardProviders?: InputMaybe<Array<InputProvider>>;
  paymentProviders?: InputMaybe<Array<InputProvider>>;
  shippingProviders?: InputMaybe<Array<InputProvider>>;
  taxProviders?: InputMaybe<Array<InputProvider>>;
};

export type InputCapabilityProvider = {
  id: Scalars['ID']['input'];
};

export type InputCartCapabilities = {
  bonus?: InputMaybe<InputCapabilityProvider>;
  externalPrice?: InputMaybe<InputCapabilityProvider>;
  retain24?: InputMaybe<InputCapabilityProvider>;
  voyado?: InputMaybe<InputCapabilityProvider>;
};

export type InputComment = {
  text: Scalars['String']['input'];
};

export type InputCondition = {
  id: Scalars['ID']['input'];
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  itemRule?: InputMaybe<InputItemRule>;
  thresholds?: InputMaybe<Array<InputMoney>>;
  triggerQuantity?: InputMaybe<Scalars['Int']['input']>;
  type: InputConditionType;
};

export enum InputConditionType {
  Cartoverthreshold = 'CARTOVERTHRESHOLD',
  Cartunderthreshold = 'CARTUNDERTHRESHOLD',
  Countrycode = 'COUNTRYCODE',
  Minitems = 'MINITEMS',
  Minitemsvalue = 'MINITEMSVALUE',
  Storegroup = 'STOREGROUP'
}

export type InputCreateApiClient = {
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type InputCreateGenerateCodes = {
  discountCodeRuleId: Scalars['String']['input'];
  numberOfCodes: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
  usageLimit: Scalars['Int']['input'];
};

export type InputCreateOrUpdateBundleGroup = {
  bundles: Array<InputBundle>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  storeMarkets: Array<InputStoreMarket>;
  validDateRange?: InputMaybe<InputValidDateRange>;
};

export type InputCreateOrUpdateDiscountCode = {
  discountCodeRuleId: Scalars['String']['input'];
  isUnlimited: Scalars['Boolean']['input'];
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  validDateRange?: InputMaybe<InputValidDateRange>;
};

export type InputCreateOrUpdateDiscountCodeRule = {
  applyLast: Scalars['Boolean']['input'];
  conditions: Array<InputCondition>;
  displayNames?: InputMaybe<Array<InputDisplayName>>;
  isActive: Scalars['Boolean']['input'];
  isExclusive: Scalars['Boolean']['input'];
  isStackable: Scalars['Boolean']['input'];
  logicRules: Array<InputLogicHolder>;
  name: Scalars['String']['input'];
  outcomes: Array<InputOutcome>;
  sortOrder: Scalars['Int']['input'];
  validDateRange?: InputMaybe<InputValidDateRange>;
};

export type InputCreateOrUpdateDiscountExternalRule = {
  applyLast: Scalars['Boolean']['input'];
  conditions: Array<InputCondition>;
  displayNames?: InputMaybe<Array<InputDisplayName>>;
  isActive: Scalars['Boolean']['input'];
  isExclusive: Scalars['Boolean']['input'];
  isStackable: Scalars['Boolean']['input'];
  logicRules: Array<InputLogicHolder>;
  name: Scalars['String']['input'];
  outcomes: Array<InputOutcome>;
  sortOrder: Scalars['Int']['input'];
  validDateRange?: InputMaybe<InputValidDateRange>;
};

export type InputCreateOrUpdateDiscountRule = {
  conditions: Array<InputCondition>;
  displayNames?: InputMaybe<Array<InputDisplayName>>;
  isActive: Scalars['Boolean']['input'];
  isStackable: Scalars['Boolean']['input'];
  logicRules: Array<InputLogicHolder>;
  name: Scalars['String']['input'];
  outcomes: Array<InputOutcome>;
  sortOrder: Scalars['Int']['input'];
  validDateRange?: InputMaybe<InputValidDateRange>;
};

export type InputCreateOrUpdateOidcIdentityProvider = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  issuerUrl: Scalars['AWSURL']['input'];
  name: Scalars['ID']['input'];
};

export type InputCreateStoreGroup = {
  channelType: ChannelType;
  countryOfSale?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputCreateStoreMarket = {
  capabilities?: InputMaybe<InputCapabilities>;
  cartCapabilities?: InputMaybe<InputCartCapabilities>;
  currencyCode: Scalars['String']['input'];
  isTaxExemptionEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxIncludedInPrice: Scalars['Boolean']['input'];
};

export type InputCreateUser = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  suppressMessages?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['AWSEmail']['input'];
};

export type InputCustomPaymentConfig = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type InputCustomReasonCode = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type InputCustomState = {
  description?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Array<CustomOperation>>;
  type: CustomStateType;
};

export type InputDiscountValue = {
  fixedDiscounts?: InputMaybe<Array<InputMoney>>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentageDecimals?: InputMaybe<Scalars['Int']['input']>;
  type: InputDiscountValueType;
};

export enum InputDiscountValueType {
  Fixed = 'FIXED',
  Relative = 'RELATIVE'
}

export type InputDisplayName = {
  languageCode: Scalars['String']['input'];
  translation: Scalars['String']['input'];
};

export type InputExternalEventsApiKeyAuth = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputExternalEventsBasicAuth = {
  password: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type InputExternalPriceConfig = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type InputGift = {
  productVariantId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type InputGiftCardProductSelection = {
  giftCardProductId: Scalars['ID']['input'];
};

export type InputIngridConfig = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

export type InputInventory = {
  address?: InputMaybe<InputInventoryAddress>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputInventoryAddress = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type InputInventoryProductVariantStock = {
  quantity: Scalars['Int']['input'];
};

export type InputItemRule = {
  excludeDiscountedPrices: Scalars['Boolean']['input'];
  excludeFullPrices?: InputMaybe<Scalars['Boolean']['input']>;
  tagConditions: Array<InputTagCondition>;
};

export type InputKbsGiftCardConfig = {
  baseUrl: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type InputKlarnaCheckoutConfig = {
  baseUrl: Scalars['String']['input'];
  klarnaShippingAssistantEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type InputLedyerConfig = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type InputLogicHolder = {
  do: Array<Scalars['String']['input']>;
  if: Scalars['String']['input'];
};

export type InputMarketRoundingRule = {
  key: Scalars['String']['input'];
  value?: InputMaybe<InputRoundingRule>;
};

export type InputMoney = {
  currencyCode: Scalars['String']['input'];
  units: Scalars['Int']['input'];
};

export type InputNShiftConfig = {
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  deliveryCheckoutId: Scalars['String']['input'];
};

export type InputOrderAddressesModification = {
  data: Scalars['AWSJSON']['input'];
  modificationType: OrderAddressesModificationType;
};

export type InputOrderCancellation = {
  reason?: InputMaybe<InputReason>;
};

export type InputOrderCompensation = {
  bonus?: InputMaybe<InputOrderCompensationBonus>;
  fee?: InputMaybe<InputOrderCompensationFee>;
  giftCards?: InputMaybe<Array<InputOrderCompensationGiftCard>>;
  orderLines?: InputMaybe<Array<InputOrderLineCompensation>>;
  payment?: InputMaybe<InputOrderCompensationPayment>;
  reason?: InputMaybe<InputReason>;
  shippingFees?: InputMaybe<Array<InputOrderShippingFeeCompensation>>;
};

export type InputOrderCompensationBonus = {
  amount: Scalars['Int']['input'];
};

export type InputOrderCompensationFee = {
  amount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  taxPercentage: Scalars['Int']['input'];
  taxPercentageDecimals: Scalars['Int']['input'];
};

export type InputOrderCompensationGiftCard = {
  amount: Scalars['Int']['input'];
  giftCardId: Scalars['ID']['input'];
};

export type InputOrderCompensationPayment = {
  amount: Scalars['Int']['input'];
};

export type InputOrderDelivery = {
  giftCardProducts?: InputMaybe<Array<InputGiftCardProductSelection>>;
  gifts?: InputMaybe<Array<InputOrderGiftSelection>>;
  orderLines?: InputMaybe<Array<InputOrderLineSelection>>;
  reason?: InputMaybe<InputReason>;
  shippingFees?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputOrderGiftSelection = {
  giftId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type InputOrderLineCompensation = {
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<InputReason>;
  taxPercentage: Scalars['Int']['input'];
  taxPercentageDecimals: Scalars['Int']['input'];
  totalAmount: Scalars['Int']['input'];
  totalDiscountAmount: Scalars['Int']['input'];
  totalTaxAmount: Scalars['Int']['input'];
};

export type InputOrderLineModification = {
  data: Scalars['AWSJSON']['input'];
  modificationType: OrderLineModificationType;
};

export type InputOrderLineSelection = {
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<InputReason>;
};

export type InputOrderModificationAddresses = {
  addresses: InputOrderAddressesModification;
  reason?: InputMaybe<InputReason>;
};

export type InputOrderModificationOrderLines = {
  orderLines: Array<InputOrderLineModification>;
  reason?: InputMaybe<InputReason>;
};

export type InputOrderModificationOrderLinesStart = {
  payment?: InputMaybe<InputActionPaymentOrderModificationOrderLines>;
};

export type InputOrderModificationShippingFees = {
  reason?: InputMaybe<InputReason>;
  shippingFees: Array<InputShippingFeeModification>;
};

export type InputOrderModificationShippingFeesStart = {
  payment?: InputMaybe<InputActionPaymentOrderModificationShippingFees>;
};

export type InputOrderRefund = {
  fee?: InputMaybe<InputOrderRefundFee>;
  giftCardProducts?: InputMaybe<Array<InputGiftCardProductSelection>>;
  gifts?: InputMaybe<Array<InputOrderGiftSelection>>;
  orderLines?: InputMaybe<Array<InputOrderLineSelection>>;
  reason?: InputMaybe<InputReason>;
  shippingFees?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputOrderRefundFee = {
  amount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  taxPercentage: Scalars['Int']['input'];
  taxPercentageDecimals: Scalars['Int']['input'];
};

export type InputOrderRelease = {
  reason?: InputMaybe<InputReason>;
};

export type InputOrderShippingFeeCompensation = {
  shippingFeeId: Scalars['ID']['input'];
  taxPercentage: Scalars['Int']['input'];
  taxPercentageDecimals: Scalars['Int']['input'];
  totalAmount: Scalars['Int']['input'];
  totalDiscountAmount: Scalars['Int']['input'];
  totalTaxAmount: Scalars['Int']['input'];
};

export type InputOrderStartCancellation = {
  bonus?: InputMaybe<InputActionBonus>;
  giftCard?: InputMaybe<InputActionGiftCard>;
  payment?: InputMaybe<InputActionPaymentCancellation>;
};

export type InputOrderStartCompensation = {
  bonus?: InputMaybe<InputActionBonus>;
  giftCard?: InputMaybe<InputActionGiftCard>;
  payment?: InputMaybe<InputActionPaymentCompensation>;
};

export type InputOrderStartDelivery = {
  bonus?: InputMaybe<InputActionBonus>;
  giftCard?: InputMaybe<InputActionGiftCard>;
  payment?: InputMaybe<InputActionPaymentDelivery>;
  shipping?: InputMaybe<InputActionShipping>;
};

export type InputOrderStartRefund = {
  bonus?: InputMaybe<InputActionBonus>;
  giftCard?: InputMaybe<InputActionGiftCard>;
  payment?: InputMaybe<InputActionPaymentRefund>;
};

export type InputOrderStartRelease = {
  bonus?: InputMaybe<InputActionBonus>;
  giftCard?: InputMaybe<InputActionGiftCard>;
  payment?: InputMaybe<InputActionPaymentRelease>;
};

export type InputOrderWorkflow = {
  name: Scalars['String']['input'];
  then: Scalars['AWSJSON']['input'];
  trigger: OrderWorkflowTriggerType;
};

export type InputOutcome = {
  combineItemDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  discountItemRule?: InputMaybe<InputItemRule>;
  discountQuantity?: InputMaybe<Scalars['Int']['input']>;
  discountValue?: InputMaybe<InputDiscountValue>;
  gifts?: InputMaybe<Array<InputGift>>;
  id: Scalars['ID']['input'];
  isRecurrent?: InputMaybe<Scalars['Boolean']['input']>;
  shippingTags?: InputMaybe<Array<Scalars['String']['input']>>;
  subOutcomes?: InputMaybe<Array<InputSubOutcome>>;
  triggerItemRule?: InputMaybe<InputItemRule>;
  triggerQuantity?: InputMaybe<Scalars['Int']['input']>;
  type: InputOutcomeType;
};

export enum InputOutcomeType {
  Buyget = 'BUYGET',
  Buyselect = 'BUYSELECT',
  Cartdiscount = 'CARTDISCOUNT',
  Freeshipping = 'FREESHIPPING',
  Gift = 'GIFT',
  Itemdiscounts = 'ITEMDISCOUNTS',
  Optimizebuygets = 'OPTIMIZEBUYGETS',
  Selectitems = 'SELECTITEMS',
  Shippingtags = 'SHIPPINGTAGS',
  Stackedparents = 'STACKEDPARENTS',
  Stackedvariants = 'STACKEDVARIANTS'
}

export type InputPriceRule = {
  monies?: InputMaybe<Array<InputCampaignMoney>>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentageDecimals?: InputMaybe<Scalars['Int']['input']>;
  type: InputPriceRuleType;
};

export enum InputPriceRuleType {
  FixedDiscount = 'FIXED_DISCOUNT',
  RelativeDiscount = 'RELATIVE_DISCOUNT',
  SetPrice = 'SET_PRICE'
}

export type InputProductVariantRules = {
  tagLogic: Scalars['String']['input'];
};

export type InputProductVariantStockConfig = {
  validateStock: Scalars['Boolean']['input'];
};

export type InputProvider = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type InputQliroOneConfig = {
  baseUrl: Scalars['String']['input'];
  integratedShipping?: InputMaybe<InputQliroOneIntegratedShipping>;
  merchantApiKey: Scalars['String']['input'];
  merchantApiSecret: Scalars['String']['input'];
  merchantOrderManagementStatusPushUrl: Scalars['String']['input'];
  useLegacyIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputQliroOneIntegratedShipping = {
  deliveryCheckoutId?: InputMaybe<Scalars['String']['input']>;
  merchantOrderAvailableShippingMethodsUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type InputReason = {
  cause?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type InputRemoveUserFromGroup = {
  groupname: Scalars['String']['input'];
  username: Scalars['ID']['input'];
};

export type InputRetain24Config = {
  baseUrl: Scalars['String']['input'];
  certificate: Scalars['String']['input'];
  certificatePassword: Scalars['String']['input'];
  redeem?: InputMaybe<Scalars['Boolean']['input']>;
  simulationKey?: InputMaybe<Scalars['String']['input']>;
};

export type InputRoundingRule = {
  roundDown: Scalars['Boolean']['input'];
  roundUp: Scalars['Boolean']['input'];
  targets: Array<Scalars['String']['input']>;
};

export type InputRoundingRules = {
  defaultRule: InputRoundingRule;
  marketRules?: InputMaybe<Array<InputMarketRoundingRule>>;
};

export type InputShippingFeeModification = {
  data: Scalars['AWSJSON']['input'];
  modificationType: ShippingFeeModificationType;
};

export type InputStoreMarket = {
  key: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type InputSubOutcome = {
  discountQuantity?: InputMaybe<Scalars['Int']['input']>;
  discountValue?: InputMaybe<InputDiscountValue>;
  triggerQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSveaCheckoutConfig = {
  apiKey: Scalars['String']['input'];
  checkoutBaseUrl: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  paymentAdminBaseUrl: Scalars['String']['input'];
};

export type InputTagCondition = {
  key: Scalars['String']['input'];
  mode: InputTagConditionMode;
  values: Array<Scalars['String']['input']>;
};

export enum InputTagConditionMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type InputTaxGroup = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputTaxJarConfig = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
};

export type InputTaxMarket = {
  taxPercentage: Scalars['Int']['input'];
  taxPercentageDecimals: Scalars['Int']['input'];
};

export type InputUpdateApiClient = {
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type InputUpdateExternalEventsDestinationApi = {
  apiKeyAuth?: InputMaybe<InputExternalEventsApiKeyAuth>;
  basicAuth?: InputMaybe<InputExternalEventsBasicAuth>;
  filterEventRules?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputUpdateStoreGroup = {
  countryOfSale?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateStoreMarket = {
  capabilities?: InputMaybe<InputCapabilities>;
  cartCapabilities?: InputMaybe<InputCartCapabilities>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxExemptionEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxIncludedInPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateUser = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
};

export type InputValidDateRange = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type InputVoyadoConfig = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
};

export type InputWalleyCheckoutConfig = {
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  deliveryModuleEnabled: Scalars['Boolean']['input'];
  profileName?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
};

export type InputZaverConfig = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  callbackApiKey: Scalars['String']['input'];
};

export type Inventory = {
  __typename?: 'Inventory';
  address?: Maybe<InventoryAddress>;
  created: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated: Scalars['AWSDateTime']['output'];
};

export type InventoryAddress = {
  __typename?: 'InventoryAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type InventoryProductVariantStock = {
  __typename?: 'InventoryProductVariantStock';
  inventoryId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InventoryProductVariantStockConfig = {
  __typename?: 'InventoryProductVariantStockConfig';
  productVariantId: Scalars['ID']['output'];
  validateStock?: Maybe<Scalars['Boolean']['output']>;
};

export type InventoryStoreMarket = {
  __typename?: 'InventoryStoreMarket';
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  inventories?: Maybe<Array<Inventory>>;
  storeDescription?: Maybe<Scalars['String']['output']>;
  storeGroupId: Scalars['String']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  updated: Scalars['AWSDateTime']['output'];
};

export type InventoryStoreMarketInventories = {
  __typename?: 'InventoryStoreMarketInventories';
  countryCode: Scalars['String']['output'];
  inventoryIds?: Maybe<Array<Scalars['String']['output']>>;
  storeGroupId: Scalars['String']['output'];
};

export type ItemRule = {
  __typename?: 'ItemRule';
  excludeDiscountedPrices: Scalars['Boolean']['output'];
  excludeFullPrices?: Maybe<Scalars['Boolean']['output']>;
  tagConditions: Array<TagCondition>;
};

export type KbsGiftCardConfig = {
  __typename?: 'KBSGiftCardConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: KbsGiftCardCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type KbsGiftCardCredentials = {
  __typename?: 'KBSGiftCardCredentials';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type KlarnaCheckoutConfig = {
  __typename?: 'KlarnaCheckoutConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: KlarnaCredentials;
  id: Scalars['ID']['output'];
  klarnaShippingAssistantEnabled?: Maybe<Scalars['Boolean']['output']>;
  merchantId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type KlarnaCredentials = {
  __typename?: 'KlarnaCredentials';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type KlarnaShippingAssistantAddon = {
  __typename?: 'KlarnaShippingAssistantAddon';
  externalId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  userInput: Scalars['String']['output'];
};

export type KlarnaShippingAssistantAddress = {
  __typename?: 'KlarnaShippingAssistantAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
};

export type KlarnaShippingAssistantCarrierProduct = {
  __typename?: 'KlarnaShippingAssistantCarrierProduct';
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KlarnaShippingAssistantLocation = {
  __typename?: 'KlarnaShippingAssistantLocation';
  address: KlarnaShippingAssistantAddress;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

export type KlarnaShippingAssistantLocationTimeslot = {
  __typename?: 'KlarnaShippingAssistantLocationTimeslot';
  cutoff: Scalars['String']['output'];
  end: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  start: Scalars['String']['output'];
};

export type KlarnaShippingAssistantSelectedShippingOption = {
  __typename?: 'KlarnaShippingAssistantSelectedShippingOption';
  carrier: Scalars['String']['output'];
  carrierProduct?: Maybe<KlarnaShippingAssistantCarrierProduct>;
  location?: Maybe<KlarnaShippingAssistantLocation>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  selectedAddons?: Maybe<Array<KlarnaShippingAssistantAddon>>;
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Int']['output'];
  timeslot?: Maybe<KlarnaShippingAssistantLocationTimeslot>;
  tmsReference: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LedyerConfig = {
  __typename?: 'LedyerConfig';
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: LedyerCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type LedyerCredentials = {
  __typename?: 'LedyerCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type LogicHolder = {
  __typename?: 'LogicHolder';
  do: Array<Scalars['String']['output']>;
  if: Scalars['String']['output'];
};

export type MarketPrice = {
  __typename?: 'MarketPrice';
  countryCode: Scalars['String']['output'];
  price: Price;
};

export type MarketRoundingRule = {
  __typename?: 'MarketRoundingRule';
  key: Scalars['String']['output'];
  value?: Maybe<RoundingRule>;
};

export type Money = {
  __typename?: 'Money';
  currencyCode: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  Order: MutationOrderManagement;
  addExternalEventsDestinationAPI: AddExternalEventsDestinationApiResult;
  addExternalEventsDestinationEventBus: AddExternalEventsDestinationEventBusResult;
  addExternalEventsRule: AddExternalEventsRuleResult;
  addUserToGroup: OperationResult;
  createApiClient: ApiClientDetails;
  createGenerateCodes?: Maybe<CreateGenerateCodesResult>;
  createOrUpdateAdyenConfig: AdyenConfig;
  createOrUpdateAvardaConfig: AvardaConfig;
  createOrUpdateBSGGiftCardConfig: BsgGiftCardConfig;
  createOrUpdateBonusConfig: BonusConfig;
  createOrUpdateBundleGroup?: Maybe<BundleGroup>;
  createOrUpdateCampaign: Campaign;
  createOrUpdateCampaignGroup: CampaignGroup;
  createOrUpdateCustomPaymentConfig: CustomPaymentConfig;
  createOrUpdateDiscountCode?: Maybe<DiscountCode>;
  createOrUpdateDiscountCodeRule?: Maybe<DiscountCodeRule>;
  createOrUpdateDiscountExternalRule?: Maybe<DiscountExternalRule>;
  createOrUpdateDiscountRule?: Maybe<DiscountRule>;
  createOrUpdateExternalPriceConfig: ExternalPriceConfig;
  createOrUpdateIngridConfig: IngridConfig;
  createOrUpdateInventory: Inventory;
  createOrUpdateKBSGiftCardConfig: KbsGiftCardConfig;
  createOrUpdateKlarnaCheckoutConfig: KlarnaCheckoutConfig;
  createOrUpdateLedyerConfig: LedyerConfig;
  createOrUpdateNShiftConfig: NShiftConfig;
  createOrUpdateOidcIdentityProvider: IdentityProvider;
  createOrUpdateQliroOneConfig: QliroOneConfig;
  createOrUpdateRetain24Config: Retain24Config;
  createOrUpdateSveaCheckoutConfig: SveaCheckoutConfig;
  createOrUpdateTaxGroup: TaxGroup;
  createOrUpdateTaxJarConfig: TaxJarConfig;
  createOrUpdateTaxMarket: TaxMarket;
  createOrUpdateVoyadoConfig: VoyadoConfig;
  createOrUpdateWalleyCheckoutConfig: WalleyCheckoutConfig;
  createOrUpdateZaverConfig: ZaverConfig;
  createStoreGroup?: Maybe<StoreGroup>;
  createStoreMarket?: Maybe<StoreMarket>;
  createUser: User;
  deleteAdyenConfig: DeletedResult;
  deleteApiClient: OperationResult;
  deleteAvardaConfig: DeletedResult;
  deleteBSGGiftCardConfig: DeletedResult;
  deleteBonusConfig: DeletedResult;
  deleteBundleGroup: DeletedResult;
  deleteCampaign: CampaignDeletionResult;
  deleteCampaignGroup: DeletedResult;
  deleteCustomPaymentConfig: DeletedResult;
  deleteDiscountCode: DeletedResult;
  deleteDiscountCodeRule: DeletedResult;
  deleteDiscountExternalRule: DeletedResult;
  deleteDiscountRule: DeletedResult;
  deleteExternalEventsDestinationAPI: DeletedResult;
  deleteExternalEventsDestinationEventBus: DeletedResult;
  deleteExternalEventsRule: DeletedResult;
  deleteExternalPriceConfig: DeletedResult;
  deleteIdentityProvider: OperationResult;
  deleteIngridConfig: DeletedResult;
  deleteInventory: DeletedResult;
  deleteInventoryProductVariantStock: DeletedResult;
  deleteKBSGiftCardConfig: DeletedResult;
  deleteKlarnaCheckoutConfig: DeletedResult;
  deleteLedyerConfig: DeletedResult;
  deleteNShiftConfig: DeletedResult;
  deleteQliroOneConfig: DeletedResult;
  deleteRetain24Config: DeletedResult;
  deleteStoreGroup: DeletedResult;
  deleteStoreMarket: DeletedResult;
  deleteSveaCheckoutConfig: DeletedResult;
  deleteTaxGroup: DeletedResult;
  deleteTaxJarConfig: DeletedResult;
  deleteTaxMarket: DeletedResult;
  deleteUser: OperationResult;
  deleteVoyadoConfig: DeletedResult;
  deleteWalleyCheckoutConfig: DeletedResult;
  deleteZaverConfig: DeletedResult;
  disableIdentityProvider: IdentityProvider;
  disableUser: OperationResult;
  enableIdentityProvider: IdentityProvider;
  enableUser: OperationResult;
  /** @deprecated use generateAdyenWebhooks() instead */
  generateAdyenWebhookCredentials: AdyenWebhookCredentials;
  generateAdyenWebhooks: AdyenWebhookGenerationResult;
  privateAdyenWebhookChange: AdyenWebhook;
  removeUserFromGroup: OperationResult;
  resendPassword: OperationResult;
  setShippingTaxGroup: ShippingTaxGroup;
  updateApiClient: ApiClientDetails;
  updateCampaignPeriod: Campaign;
  updateExternalEventsDestinationAPI: UpdateExternalEventsDestinationApiResult;
  updateInventoryProductVariantStock: InventoryProductVariantStock;
  updateInventoryStoreMarketInventories: InventoryStoreMarketInventories;
  updateProductVariantStockConfig: InventoryProductVariantStockConfig;
  updateStoreGroup?: Maybe<StoreGroup>;
  updateStoreMarket?: Maybe<StoreMarket>;
  updateUser: OperationResult;
};


export type MutationAddExternalEventsDestinationApiArgs = {
  destName: Scalars['String']['input'];
  options: InputAddExternalEventsDestinationApi;
};


export type MutationAddExternalEventsDestinationEventBusArgs = {
  eventBusArn: Scalars['String']['input'];
};


export type MutationAddExternalEventsRuleArgs = {
  ruleName: Scalars['String']['input'];
};


export type MutationAddUserToGroupArgs = {
  input: InputAddUserToGroup;
};


export type MutationCreateApiClientArgs = {
  input: InputCreateApiClient;
};


export type MutationCreateGenerateCodesArgs = {
  input: InputCreateGenerateCodes;
};


export type MutationCreateOrUpdateAdyenConfigArgs = {
  adyenConfig: InputAdyenConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateAvardaConfigArgs = {
  avardaConfig: InputAvardaConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateBsgGiftCardConfigArgs = {
  bsgGiftCardConfig: InputBsgGiftCardConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateBonusConfigArgs = {
  bonusConfig: InputBonusConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateBundleGroupArgs = {
  bundleGroup: InputCreateOrUpdateBundleGroup;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateCampaignArgs = {
  campaign: InputCampaign;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateCampaignGroupArgs = {
  campaignGroup: InputCampaignGroup;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateCustomPaymentConfigArgs = {
  customPaymentConfig: InputCustomPaymentConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateDiscountCodeArgs = {
  code: Scalars['String']['input'];
  discountCode: InputCreateOrUpdateDiscountCode;
};


export type MutationCreateOrUpdateDiscountCodeRuleArgs = {
  discountCodeRule: InputCreateOrUpdateDiscountCodeRule;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateDiscountExternalRuleArgs = {
  discountExternalRule: InputCreateOrUpdateDiscountExternalRule;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateDiscountRuleArgs = {
  discountRule: InputCreateOrUpdateDiscountRule;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateExternalPriceConfigArgs = {
  externalPriceConfig: InputExternalPriceConfig;
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateIngridConfigArgs = {
  id: Scalars['ID']['input'];
  ingridConfig: InputIngridConfig;
};


export type MutationCreateOrUpdateInventoryArgs = {
  id: Scalars['ID']['input'];
  inventory: InputInventory;
};


export type MutationCreateOrUpdateKbsGiftCardConfigArgs = {
  id: Scalars['ID']['input'];
  kbsGiftCardConfig: InputKbsGiftCardConfig;
};


export type MutationCreateOrUpdateKlarnaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
  klarnaCheckoutConfig: InputKlarnaCheckoutConfig;
};


export type MutationCreateOrUpdateLedyerConfigArgs = {
  id: Scalars['ID']['input'];
  ledyerConfig: InputLedyerConfig;
};


export type MutationCreateOrUpdateNShiftConfigArgs = {
  id: Scalars['ID']['input'];
  nShiftConfig: InputNShiftConfig;
};


export type MutationCreateOrUpdateOidcIdentityProviderArgs = {
  input: InputCreateOrUpdateOidcIdentityProvider;
};


export type MutationCreateOrUpdateQliroOneConfigArgs = {
  id: Scalars['ID']['input'];
  qliroOneConfig: InputQliroOneConfig;
};


export type MutationCreateOrUpdateRetain24ConfigArgs = {
  id: Scalars['ID']['input'];
  retain24Config: InputRetain24Config;
};


export type MutationCreateOrUpdateSveaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
  sveaCheckoutConfig: InputSveaCheckoutConfig;
};


export type MutationCreateOrUpdateTaxGroupArgs = {
  id: Scalars['ID']['input'];
  taxGroup: InputTaxGroup;
};


export type MutationCreateOrUpdateTaxJarConfigArgs = {
  id: Scalars['ID']['input'];
  taxJarConfig: InputTaxJarConfig;
};


export type MutationCreateOrUpdateTaxMarketArgs = {
  countryCode: Scalars['String']['input'];
  taxGroupId: Scalars['String']['input'];
  taxMarket: InputTaxMarket;
};


export type MutationCreateOrUpdateVoyadoConfigArgs = {
  id: Scalars['ID']['input'];
  voyadoConfig: InputVoyadoConfig;
};


export type MutationCreateOrUpdateWalleyCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
  walleyCheckoutConfig: InputWalleyCheckoutConfig;
};


export type MutationCreateOrUpdateZaverConfigArgs = {
  id: Scalars['ID']['input'];
  zaverConfig: InputZaverConfig;
};


export type MutationCreateStoreGroupArgs = {
  id: Scalars['ID']['input'];
  storeGroup: InputCreateStoreGroup;
};


export type MutationCreateStoreMarketArgs = {
  countryCode: Scalars['String']['input'];
  storeGroupId: Scalars['String']['input'];
  storeMarket: InputCreateStoreMarket;
};


export type MutationCreateUserArgs = {
  input: InputCreateUser;
};


export type MutationDeleteAdyenConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteApiClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationDeleteAvardaConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBsgGiftCardConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBonusConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBundleGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomPaymentConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationDeleteDiscountCodeRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountExternalRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExternalEventsDestinationApiArgs = {
  destName: Scalars['String']['input'];
};


export type MutationDeleteExternalEventsDestinationEventBusArgs = {
  eventBusArn: Scalars['String']['input'];
};


export type MutationDeleteExternalEventsRuleArgs = {
  ruleName: Scalars['String']['input'];
};


export type MutationDeleteExternalPriceConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIdentityProviderArgs = {
  name: Scalars['ID']['input'];
};


export type MutationDeleteIngridConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInventoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInventoryProductVariantStockArgs = {
  inventoryId: Scalars['ID']['input'];
  productVariantId: Scalars['ID']['input'];
};


export type MutationDeleteKbsGiftCardConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKlarnaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLedyerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNShiftConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQliroOneConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRetain24ConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStoreGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStoreMarketArgs = {
  countryCode: Scalars['String']['input'];
  storeGroupId: Scalars['String']['input'];
};


export type MutationDeleteSveaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxJarConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxMarketArgs = {
  countryCode: Scalars['String']['input'];
  taxGroupId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  username: Scalars['ID']['input'];
};


export type MutationDeleteVoyadoConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWalleyCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZaverConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableIdentityProviderArgs = {
  name: Scalars['ID']['input'];
};


export type MutationDisableUserArgs = {
  username: Scalars['ID']['input'];
};


export type MutationEnableIdentityProviderArgs = {
  name: Scalars['ID']['input'];
};


export type MutationEnableUserArgs = {
  username: Scalars['ID']['input'];
};


export type MutationGenerateAdyenWebhookCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateAdyenWebhooksArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPrivateAdyenWebhookChangeArgs = {
  input: InputAdyenWebhookChange;
};


export type MutationRemoveUserFromGroupArgs = {
  input: InputRemoveUserFromGroup;
};


export type MutationResendPasswordArgs = {
  username: Scalars['AWSEmail']['input'];
};


export type MutationSetShippingTaxGroupArgs = {
  taxGroupId: Scalars['String']['input'];
};


export type MutationUpdateApiClientArgs = {
  clientId: Scalars['ID']['input'];
  input: InputUpdateApiClient;
};


export type MutationUpdateCampaignPeriodArgs = {
  id: Scalars['ID']['input'];
  period: InputCampaignPeriod;
};


export type MutationUpdateExternalEventsDestinationApiArgs = {
  destName: Scalars['String']['input'];
  options: InputUpdateExternalEventsDestinationApi;
};


export type MutationUpdateInventoryProductVariantStockArgs = {
  inventoryId: Scalars['ID']['input'];
  productVariantId: Scalars['ID']['input'];
  stock: InputInventoryProductVariantStock;
};


export type MutationUpdateInventoryStoreMarketInventoriesArgs = {
  countryCode: Scalars['String']['input'];
  inventoryIds: Array<Scalars['String']['input']>;
  storeGroupId: Scalars['ID']['input'];
};


export type MutationUpdateProductVariantStockConfigArgs = {
  config: InputProductVariantStockConfig;
  productVariantId: Scalars['ID']['input'];
};


export type MutationUpdateStoreGroupArgs = {
  id: Scalars['ID']['input'];
  storeGroup: InputUpdateStoreGroup;
};


export type MutationUpdateStoreMarketArgs = {
  countryCode: Scalars['String']['input'];
  storeGroupId: Scalars['String']['input'];
  storeMarket: InputUpdateStoreMarket;
};


export type MutationUpdateUserArgs = {
  input: InputUpdateUser;
  username: Scalars['ID']['input'];
};

export type MutationOrderManagement = {
  __typename?: 'MutationOrderManagement';
  addCustomState: Scalars['ID']['output'];
  createCancellation: OrderCancellation;
  createCompensation: OrderCompensation;
  createCustomReasonCode: CustomReasonCode;
  createCustomState: CustomState;
  createDelivery: OrderDelivery;
  createOrderComment: OrderComment;
  createOrderModificationAddresses: OrderModificationAddresses;
  createOrderModificationOrderLines: OrderModificationOrderLines;
  createOrderModificationShippingFees: OrderModificationShippingFees;
  createRefund: OrderRefund;
  createRelease: OrderRelease;
  createWorkflow: Scalars['ID']['output'];
  createWorkflowTrigger: OrderWorkflowTrigger;
  deleteCancellation: OrderOperationResult;
  deleteCompensation: OrderOperationResult;
  deleteCustomReasonCode: Scalars['ID']['output'];
  deleteCustomState: Scalars['ID']['output'];
  deleteDelivery: OrderOperationResult;
  deleteOrder: Scalars['ID']['output'];
  deleteOrderComment: Scalars['ID']['output'];
  deleteOrderModificationAddresses: OrderOperationResult;
  deleteOrderModificationOrderLines: OrderOperationResult;
  deleteOrderModificationShippingFees: OrderOperationResult;
  deleteRefund: OrderOperationResult;
  deleteRelease: OrderOperationResult;
  deleteWorkflow: Scalars['ID']['output'];
  deleteWorkflowTrigger: Scalars['ID']['output'];
  removeCustomState: Scalars['ID']['output'];
  resendOrderEvent: OperationResult;
  restartCancellation: OrderOperationResult;
  restartCompensation: OrderOperationResult;
  restartDelivery: OrderOperationResult;
  restartOrderModificationOrderLines: OrderOperationResult;
  restartOrderModificationShippingFees: OrderOperationResult;
  restartRefund: OrderOperationResult;
  restartRelease: OrderOperationResult;
  startCancellation: OrderOperationResult;
  startCompensation: OrderOperationResult;
  startDelivery: OrderOperationResult;
  startOrderModificationAddresses: OrderOperationResult;
  startOrderModificationOrderLines: OrderOperationResult;
  startOrderModificationShippingFees: OrderOperationResult;
  startRefund: OrderOperationResult;
  startRelease: OrderOperationResult;
  updateCompensation: OrderCompensation;
  updateDelivery: OrderDelivery;
  updateOrderComment: OrderComment;
  updateOrderModificationAddresses: OrderModificationAddresses;
  updateOrderModificationOrderLines: OrderModificationOrderLines;
  updateOrderModificationShippingFees: OrderModificationShippingFees;
  updateRefund: OrderRefund;
};


export type MutationOrderManagementAddCustomStateArgs = {
  orderId: Scalars['ID']['input'];
  stateId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateCancellationArgs = {
  input: InputOrderCancellation;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateCompensationArgs = {
  input: InputOrderCompensation;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateCustomReasonCodeArgs = {
  code: Scalars['ID']['input'];
  input: InputCustomReasonCode;
};


export type MutationOrderManagementCreateCustomStateArgs = {
  input: InputCustomState;
  stateId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateDeliveryArgs = {
  input: InputOrderDelivery;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateOrderCommentArgs = {
  comment: InputComment;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateOrderModificationAddressesArgs = {
  input: InputOrderModificationAddresses;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateOrderModificationOrderLinesArgs = {
  input: InputOrderModificationOrderLines;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateOrderModificationShippingFeesArgs = {
  input: InputOrderModificationShippingFees;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateRefundArgs = {
  input: InputOrderRefund;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateReleaseArgs = {
  input: InputOrderRelease;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateWorkflowArgs = {
  input: InputOrderWorkflow;
  workflowId: Scalars['ID']['input'];
};


export type MutationOrderManagementCreateWorkflowTriggerArgs = {
  revision: Scalars['Int']['input'];
  workflowId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteCancellationArgs = {
  cancellationId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteCompensationArgs = {
  compensationId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteCustomReasonCodeArgs = {
  code: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteCustomStateArgs = {
  stateId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteOrderCommentArgs = {
  commentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteOrderModificationAddressesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteOrderModificationOrderLinesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteOrderModificationShippingFeesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteRefundArgs = {
  refundId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationOrderManagementDeleteWorkflowTriggerArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationOrderManagementRemoveCustomStateArgs = {
  orderId: Scalars['ID']['input'];
  stateId: Scalars['ID']['input'];
};


export type MutationOrderManagementResendOrderEventArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementRestartCancellationArgs = {
  cancellationId: Scalars['ID']['input'];
  input: InputOrderStartCancellation;
};


export type MutationOrderManagementRestartCompensationArgs = {
  compensationId: Scalars['ID']['input'];
  input: InputOrderStartCompensation;
};


export type MutationOrderManagementRestartDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
  input: InputOrderStartDelivery;
};


export type MutationOrderManagementRestartOrderModificationOrderLinesArgs = {
  input: InputOrderModificationOrderLinesStart;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementRestartOrderModificationShippingFeesArgs = {
  input: InputOrderModificationShippingFeesStart;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementRestartRefundArgs = {
  input: InputOrderStartRefund;
  refundId: Scalars['ID']['input'];
};


export type MutationOrderManagementRestartReleaseArgs = {
  input: InputOrderStartRelease;
  releaseId: Scalars['ID']['input'];
};


export type MutationOrderManagementStartCancellationArgs = {
  cancellationId: Scalars['ID']['input'];
  input: InputOrderStartCancellation;
};


export type MutationOrderManagementStartCompensationArgs = {
  compensationId: Scalars['ID']['input'];
  input: InputOrderStartCompensation;
};


export type MutationOrderManagementStartDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
  input: InputOrderStartDelivery;
};


export type MutationOrderManagementStartOrderModificationAddressesArgs = {
  input: Scalars['AWSJSON']['input'];
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementStartOrderModificationOrderLinesArgs = {
  input: InputOrderModificationOrderLinesStart;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementStartOrderModificationShippingFeesArgs = {
  input: InputOrderModificationShippingFeesStart;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementStartRefundArgs = {
  input: InputOrderStartRefund;
  refundId: Scalars['ID']['input'];
};


export type MutationOrderManagementStartReleaseArgs = {
  input: InputOrderStartRelease;
  releaseId: Scalars['ID']['input'];
};


export type MutationOrderManagementUpdateCompensationArgs = {
  compensationId: Scalars['ID']['input'];
  input: InputOrderCompensation;
};


export type MutationOrderManagementUpdateDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
  input: InputOrderDelivery;
};


export type MutationOrderManagementUpdateOrderCommentArgs = {
  comment: InputComment;
  commentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationOrderManagementUpdateOrderModificationAddressesArgs = {
  input: InputOrderModificationAddresses;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementUpdateOrderModificationOrderLinesArgs = {
  input: InputOrderModificationOrderLines;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementUpdateOrderModificationShippingFeesArgs = {
  input: InputOrderModificationShippingFees;
  modificationId: Scalars['ID']['input'];
};


export type MutationOrderManagementUpdateRefundArgs = {
  input: InputOrderRefund;
  refundId: Scalars['ID']['input'];
};

export type NShiftConfig = {
  __typename?: 'NShiftConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: NShiftCredentials;
  deliveryCheckoutId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type NShiftCredentials = {
  __typename?: 'NShiftCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type NshiftAddress = {
  __typename?: 'NshiftAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  quickId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NshiftPreparedShipment = {
  __typename?: 'NshiftPreparedShipment';
  agent?: Maybe<NshiftAddress>;
  orderNo: Scalars['String']['output'];
  prepareId: Scalars['String']['output'];
  sender: NshiftAddress;
  service: NshiftService;
};

export type NshiftService = {
  __typename?: 'NshiftService';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OperationResult = {
  __typename?: 'OperationResult';
  status: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  Bonus?: Maybe<OrderBonus>;
  Bundles?: Maybe<Array<OrderBundle>>;
  Cancellations: Array<OrderCancellation>;
  Compensations: Array<OrderCompensation>;
  Deliveries: Array<OrderDelivery>;
  GiftCard: OrderGiftCardBsgGiftCard | OrderGiftCardEmpty | OrderGiftCardKbsGiftCard | OrderGiftCardRetain24;
  GiftCardProduct: OrderGiftCardProductEmpty | OrderGiftCardProductRetain24;
  Modifications: Array<OrderModificationAddresses | OrderModificationOrderLines | OrderModificationShippingFees>;
  Payment: OrderPaymentAdyen | OrderPaymentAvarda | OrderPaymentBrinkZeroPayment | OrderPaymentCustomPayment | OrderPaymentKlarnaCheckout | OrderPaymentLedyer | OrderPaymentQliroOne | OrderPaymentSveaCheckout | OrderPaymentWalleyCheckout | OrderPaymentZaver;
  Promotion: OrderPromotionEmpty | OrderPromotionVoyado;
  Refunds: Array<OrderRefund>;
  Releases: Array<OrderRelease>;
  Reservation?: Maybe<OrderReservation>;
  Shipping: OrderShippingAvardaShippingBroker | OrderShippingEmpty | OrderShippingIngrid | OrderShippingKlarnaShippingAssistant | OrderShippingNshift | OrderShippingQliroIntegratedShipping | OrderShippingWalleyDeliveryModule;
  Voucher: OrderVoucherEmpty | OrderVoucherVoyado;
  attributes?: Maybe<OrderAttributes>;
  billingAddress: OrderAddress;
  bonusProvider?: Maybe<BonusProvider>;
  channelType: ChannelType;
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  date: Scalars['AWSDateTime']['output'];
  discountCodeRules?: Maybe<Array<OrderDiscountCodeRule>>;
  discountExternalRules?: Maybe<Array<OrderDiscountExternalRule>>;
  discountOutcome: OrderDiscountOutcome;
  discountRules?: Maybe<Array<OrderDiscountRule>>;
  externalPriceProvider?: Maybe<ExternalPriceProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  gifts?: Maybe<Array<OrderGift>>;
  id: Scalars['ID']['output'];
  isTaxExempt: Scalars['Boolean']['output'];
  isTaxExemptionEligible: Scalars['Boolean']['output'];
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  orderLines?: Maybe<Array<OrderLine>>;
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reference: Scalars['String']['output'];
  shippingAddress: OrderAddress;
  shippingFees?: Maybe<Array<ShippingFee>>;
  shippingProvider?: Maybe<ShippingProvider>;
  status: OrderStatus;
  storeGroupId: Scalars['String']['output'];
  taxationCountry: Scalars['String']['output'];
  totals: OrderTotals;
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  pcc?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderAddressesModification = {
  __typename?: 'OrderAddressesModification';
  data: OrderAddressesModificationUpdateData;
  modificationType: OrderAddressesModificationType;
};

export type OrderAddressesModificationData = {
  billingAddress?: Maybe<OrderAddressesModificationUpdateDataAddress>;
  shippingAddress?: Maybe<OrderAddressesModificationUpdateDataAddress>;
};

export type OrderAddressesModificationSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderAddressesModificationSearchHit';
  addresses: OrderOperationAddressModification;
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider?: Maybe<OrderOperationSearchProvider>;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export enum OrderAddressesModificationType {
  Update = 'UPDATE'
}

export type OrderAddressesModificationUpdateData = OrderAddressesModificationData & {
  __typename?: 'OrderAddressesModificationUpdateData';
  billingAddress?: Maybe<OrderAddressesModificationUpdateDataAddress>;
  shippingAddress?: Maybe<OrderAddressesModificationUpdateDataAddress>;
};

export type OrderAddressesModificationUpdateDataAddress = {
  __typename?: 'OrderAddressesModificationUpdateDataAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  pcc?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderAttributes = {
  __typename?: 'OrderAttributes';
  company?: Maybe<CompanyAttribute>;
  merchantReference1?: Maybe<Scalars['String']['output']>;
  merchantReference2?: Maybe<Scalars['String']['output']>;
};

export type OrderBonus = {
  __typename?: 'OrderBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type OrderBundle = {
  __typename?: 'OrderBundle';
  bundleGroupId: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
};

export type OrderCancellation = {
  __typename?: 'OrderCancellation';
  bonus?: Maybe<CancellationBonus>;
  bonusProvider?: Maybe<BonusProvider>;
  cancelledPayment?: Maybe<CancelledPayment>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProducts: Array<CancellationGiftCardProduct>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  giftCards: Array<CancellationGiftCard>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderCancellationSearchBonus = {
  __typename?: 'OrderCancellationSearchBonus';
  reservationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderCancellationSearchGiftCard = {
  __typename?: 'OrderCancellationSearchGiftCard';
  giftCardId: Scalars['String']['output'];
  reservationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type OrderCancellationSearchGiftCardProduct = {
  __typename?: 'OrderCancellationSearchGiftCardProduct';
  cancelTransactionId?: Maybe<Scalars['String']['output']>;
  giftCardProductId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderCancellationSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderCancellationSearchHit';
  bonus?: Maybe<OrderCancellationSearchBonus>;
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  cancelledPayment?: Maybe<OrderCancellationSearchPayment>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProducts: Array<OrderCancellationSearchGiftCardProduct>;
  giftCardProductsProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  giftCards: Array<OrderCancellationSearchGiftCard>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider: OrderOperationSearchProvider;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderCancellationSearchPayment = {
  __typename?: 'OrderCancellationSearchPayment';
  Reference?: Maybe<Scalars['String']['output']>;
};

export type OrderComment = {
  __typename?: 'OrderComment';
  comment: Comment;
  created: Scalars['AWSDateTime']['output'];
  createdBy: Actor;
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderCompensation = {
  __typename?: 'OrderCompensation';
  bonus?: Maybe<CompensationBonus>;
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  fee?: Maybe<CompensationFee>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  giftCards?: Maybe<Array<CompensationGiftCard>>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderLines?: Maybe<Array<CompensationOrderLine>>;
  orderReference: Scalars['String']['output'];
  payment?: Maybe<CompensationPayment>;
  paymentProvider?: Maybe<PaymentProvider>;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingFees?: Maybe<Array<CompensationShippingFee>>;
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  totals: OrderCompensationTotals;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderCompensationSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderCompensationSearchHit';
  bonus?: Maybe<OrderOperationSearchBonus>;
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  fee?: Maybe<OrderOperationSearchFee>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  giftCards: Array<OrderOperationSearchGiftCard>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderOperationSearchOrderLine>;
  orderReference: Scalars['String']['output'];
  payment?: Maybe<OrderCompensationSearchPayment>;
  paymentProvider?: Maybe<OrderOperationSearchProvider>;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingFees: Array<OrderOperationSearchShippingFee>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  totals: OrderCompensationSearchTotals;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderCompensationSearchHits = {
  __typename?: 'OrderCompensationSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<OrderCompensationSearchHit>;
  total: Scalars['Int']['output'];
};

export type OrderCompensationSearchPayment = {
  __typename?: 'OrderCompensationSearchPayment';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderCompensationSearchProviderStatus = {
  __typename?: 'OrderCompensationSearchProviderStatus';
  current: Scalars['String']['output'];
  history: Array<OrderCompensationSearchProviderStatusHistory>;
};

export type OrderCompensationSearchProviderStatusHistory = {
  __typename?: 'OrderCompensationSearchProviderStatusHistory';
  errorMessage?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  type: Scalars['String']['output'];
};

export type OrderCompensationSearchTotals = {
  __typename?: 'OrderCompensationSearchTotals';
  bonusTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  paymentTotal: Scalars['Int']['output'];
};

export type OrderCompensationTotals = {
  __typename?: 'OrderCompensationTotals';
  bonusTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  paymentTotal: Scalars['Int']['output'];
};

export type OrderCustomState = {
  __typename?: 'OrderCustomState';
  id: Scalars['ID']['output'];
  operations?: Maybe<Array<Scalars['String']['output']>>;
  type: CustomStateType;
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  bonus?: Maybe<DeliveryBonus>;
  bonusProvider?: Maybe<BonusProvider>;
  capturedPayment?: Maybe<DeliveryCapture>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProducts: Array<DeliveryGiftCardProduct>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  giftCards: Array<DeliveryGiftCard>;
  gifts: Array<DeliveryGift>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<DeliveryOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingFees: Array<DeliveryShippingFee>;
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  totals: OrderDeliveryTotals;
  tracking?: Maybe<DeliveryTracking>;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
  vouchers: Array<DeliveryVoucher>;
};

export type OrderDeliverySearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderDeliverySearchHit';
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderDeliverySearchOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: OrderOperationSearchProvider;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingFees: Array<OrderDeliverySearchShippingFee>;
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  tracking?: Maybe<OrderDeliverySearchTrackingInfo>;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderDeliverySearchOrderLine = {
  __typename?: 'OrderDeliverySearchOrderLine';
  currencyCode: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderDeliverySearchShippingFee = {
  __typename?: 'OrderDeliverySearchShippingFee';
  currencyCode: Scalars['String']['output'];
  shippingFeeId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderDeliverySearchTrackingInfo = {
  __typename?: 'OrderDeliverySearchTrackingInfo';
  URL?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryTotals = {
  __typename?: 'OrderDeliveryTotals';
  bonusTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  voucherTotal: Scalars['Int']['output'];
};

export type OrderDiscountCodeRule = {
  __typename?: 'OrderDiscountCodeRule';
  code: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shippingTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderDiscountExternalRule = {
  __typename?: 'OrderDiscountExternalRule';
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shippingTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderDiscountOutcome = {
  __typename?: 'OrderDiscountOutcome';
  cartRules?: Maybe<Array<CartRuleOutcome>>;
  codeRules?: Maybe<Array<CodeRuleOutcome>>;
  discountReduction?: Maybe<Scalars['Int']['output']>;
  externalRules?: Maybe<Array<ExternalRuleOutcome>>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  shippingTags?: Maybe<Array<Scalars['String']['output']>>;
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
};

export type OrderDiscountRule = {
  __typename?: 'OrderDiscountRule';
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shippingTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderGift = {
  __typename?: 'OrderGift';
  basePriceAmount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  discountRuleId: Scalars['String']['output'];
  displayDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderGiftCard = {
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderGiftCardBsgGiftCard = OrderGiftCard & {
  __typename?: 'OrderGiftCardBSGGiftCard';
  giftCards?: Maybe<Array<OrderGiftCardItemBsgGiftCard>>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderGiftCardEmpty = OrderGiftCard & {
  __typename?: 'OrderGiftCardEmpty';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderGiftCardItemBsgGiftCard = {
  __typename?: 'OrderGiftCardItemBSGGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type OrderGiftCardItemKbsGiftCard = {
  __typename?: 'OrderGiftCardItemKBSGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type OrderGiftCardItemRetain24 = {
  __typename?: 'OrderGiftCardItemRetain24';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  redeemId?: Maybe<Scalars['String']['output']>;
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type OrderGiftCardKbsGiftCard = OrderGiftCard & {
  __typename?: 'OrderGiftCardKBSGiftCard';
  giftCards?: Maybe<Array<OrderGiftCardItemKbsGiftCard>>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderGiftCardProduct = {
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
};

export type OrderGiftCardProductEmpty = OrderGiftCardProduct & {
  __typename?: 'OrderGiftCardProductEmpty';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
};

export type OrderGiftCardProductItem = {
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  distribution: Scalars['String']['output'];
  id: Scalars['String']['output'];
  merchantReference?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type OrderGiftCardProductItemRetain24 = OrderGiftCardProductItem & {
  __typename?: 'OrderGiftCardProductItemRetain24';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  distribution: Scalars['String']['output'];
  emailText?: Maybe<Scalars['String']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  merchantReference?: Maybe<Scalars['String']['output']>;
  multiCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sendDate?: Maybe<Scalars['AWSDateTime']['output']>;
  smsText?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  templateId: Scalars['Int']['output'];
  transactionId?: Maybe<Scalars['Int']['output']>;
};

export type OrderGiftCardProductRetain24 = OrderGiftCardProduct & {
  __typename?: 'OrderGiftCardProductRetain24';
  giftCardProducts?: Maybe<Array<OrderGiftCardProductItemRetain24>>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderGiftCardRetain24 = OrderGiftCard & {
  __typename?: 'OrderGiftCardRetain24';
  giftCards?: Maybe<Array<OrderGiftCardItemRetain24>>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  history: Array<OrderHistoryLogEntry>;
  operations?: Maybe<OrderHistoryOperations>;
  /** @deprecated moved to Order.status */
  states: Array<OrderState>;
};

export type OrderHistoryLogEntry = {
  __typename?: 'OrderHistoryLogEntry';
  actor?: Maybe<Actor>;
  comment?: Maybe<Comment>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  operation: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  reason?: Maybe<Reason>;
  status: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  type: Scalars['String']['output'];
};

export type OrderHistoryOperations = {
  __typename?: 'OrderHistoryOperations';
  compensated: OrderHistoryTransactionsCompensated;
  delivered: OrderHistoryTransactions;
  refunded: OrderHistoryTransactions;
  released: OrderHistoryTransactions;
};

export type OrderHistoryTransactionBonus = {
  __typename?: 'OrderHistoryTransactionBonus';
  amount: Scalars['Int']['output'];
};

export type OrderHistoryTransactionGift = {
  __typename?: 'OrderHistoryTransactionGift';
  giftId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderHistoryTransactionGiftCard = {
  __typename?: 'OrderHistoryTransactionGiftCard';
  amount: Scalars['Int']['output'];
  giftCardId: Scalars['String']['output'];
};

export type OrderHistoryTransactionGiftCardProduct = {
  __typename?: 'OrderHistoryTransactionGiftCardProduct';
  giftCardProductId: Scalars['String']['output'];
};

export type OrderHistoryTransactionOrderLine = {
  __typename?: 'OrderHistoryTransactionOrderLine';
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderHistoryTransactionPayment = {
  __typename?: 'OrderHistoryTransactionPayment';
  amount: Scalars['Int']['output'];
};

export type OrderHistoryTransactionShippingFee = {
  __typename?: 'OrderHistoryTransactionShippingFee';
  shippingFeeId: Scalars['String']['output'];
};

export type OrderHistoryTransactionVoucher = {
  __typename?: 'OrderHistoryTransactionVoucher';
  amount: Scalars['Int']['output'];
  voucherId: Scalars['String']['output'];
};

export type OrderHistoryTransactions = {
  __typename?: 'OrderHistoryTransactions';
  bonus?: Maybe<OrderHistoryTransactionBonus>;
  giftCardProducts: Array<OrderHistoryTransactionGiftCardProduct>;
  giftCards: Array<OrderHistoryTransactionGiftCard>;
  gifts: Array<OrderHistoryTransactionGift>;
  orderLines: Array<OrderHistoryTransactionOrderLine>;
  shippingFees: Array<OrderHistoryTransactionShippingFee>;
  vouchers: Array<OrderHistoryTransactionVoucher>;
};

export type OrderHistoryTransactionsCompensated = {
  __typename?: 'OrderHistoryTransactionsCompensated';
  bonus?: Maybe<OrderHistoryTransactionBonus>;
  giftCards: Array<OrderHistoryTransactionGiftCard>;
  payment?: Maybe<OrderHistoryTransactionPayment>;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<CampaignIdentity>;
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimensions?: Maybe<OrderLineDimensions>;
  discountAmount: Scalars['Int']['output'];
  discountOutcome: OrderLineDiscountOutcome;
  displayDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  hasExternalPrice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options: Array<OrderLineOption>;
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineBase = {
  campaign?: Maybe<OrderLineCampaign>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['AWSJSON']['output'];
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
};

export type OrderLineCampaign = {
  campaignGroupId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderLineCreate = OrderLineBase & {
  __typename?: 'OrderLineCreate';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<OrderLineCampaign>;
  description: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['AWSJSON']['output'];
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderLineData = OrderLineCreate | OrderLineDelete | OrderLineUpdate;

export type OrderLineDelete = OrderLineBase & {
  __typename?: 'OrderLineDelete';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<OrderLineCampaign>;
  description: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['AWSJSON']['output'];
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderLineDimensions = {
  __typename?: 'OrderLineDimensions';
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineDiscountOutcome = {
  __typename?: 'OrderLineDiscountOutcome';
  bundles?: Maybe<Array<BundleOutcome>>;
  cartRules?: Maybe<Array<CartRuleOutcome>>;
  codeRules?: Maybe<Array<CodeRuleOutcome>>;
  externalRules?: Maybe<Array<ExternalRuleOutcome>>;
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineModification = {
  __typename?: 'OrderLineModification';
  data: OrderLineModificationCreateData | OrderLineModificationDeleteData | OrderLineModificationUpdateData;
  modificationType: OrderLineModificationType;
};

export type OrderLineModificationCreateData = OrderLineModificationData & {
  __typename?: 'OrderLineModificationCreateData';
  basePriceAmount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalPriceAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalTaxAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePriceAmount?: Maybe<Scalars['Int']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Int']['output']>;
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  totalPriceAmount?: Maybe<Scalars['Int']['output']>;
  totalTaxAmount?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineModificationData = {
  id: Scalars['String']['output'];
};

export type OrderLineModificationDeleteData = OrderLineModificationData & {
  __typename?: 'OrderLineModificationDeleteData';
  basePriceAmount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distributedTotalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalPriceAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalTaxAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePriceAmount?: Maybe<Scalars['Int']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Int']['output']>;
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  totalPriceAmount?: Maybe<Scalars['Int']['output']>;
  totalTaxAmount?: Maybe<Scalars['Int']['output']>;
};

export enum OrderLineModificationType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type OrderLineModificationUpdateData = OrderLineModificationData & {
  __typename?: 'OrderLineModificationUpdateData';
  description?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<OrderLineModificationUpdateDataPrice>;
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
};

export type OrderLineModificationUpdateDataPrice = {
  __typename?: 'OrderLineModificationUpdateDataPrice';
  basePriceAmount: Scalars['Int']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalPriceAmount?: Maybe<Scalars['Int']['output']>;
  distributedTotalTaxAmount?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  salePriceAmount?: Maybe<Scalars['Int']['output']>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
  totalDiscountAmount?: Maybe<Scalars['Int']['output']>;
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineOption = {
  __typename?: 'OrderLineOption';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type OrderLineUpdate = OrderLineBase & {
  __typename?: 'OrderLineUpdate';
  campaign?: Maybe<OrderLineCampaign>;
  description: Scalars['String']['output'];
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['AWSJSON']['output'];
  price?: Maybe<OrderLineUpdatePrice>;
  productParentId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
};

export type OrderLineUpdatePrice = {
  __typename?: 'OrderLineUpdatePrice';
  basePriceAmount: Scalars['Int']['output'];
  discountAmount: Scalars['Int']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderModification = {
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  type: OrderModificationType;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderModificationAddresses = OrderModification & {
  __typename?: 'OrderModificationAddresses';
  addresses: OrderAddressesModification;
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  type: OrderModificationType;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderModificationOrderLines = OrderModification & {
  __typename?: 'OrderModificationOrderLines';
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  id: Scalars['String']['output'];
  newTotals?: Maybe<OrderTotals>;
  oldTotals?: Maybe<OrderTotals>;
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderLineModification>;
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  type: OrderModificationType;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderModificationShippingFees = OrderModification & {
  __typename?: 'OrderModificationShippingFees';
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  id: Scalars['String']['output'];
  newTotals?: Maybe<OrderTotals>;
  oldTotals?: Maybe<OrderTotals>;
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingFees: Array<ShippingFeeModification>;
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  type: OrderModificationType;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export enum OrderModificationType {
  OrderAddresses = 'ORDER_ADDRESSES',
  OrderLines = 'ORDER_LINES',
  ShippingFees = 'SHIPPING_FEES'
}

export type OrderOperationAddressData = {
  __typename?: 'OrderOperationAddressData';
  billingAddress?: Maybe<OrderOperationAddressModificationUpdateAddress>;
  shippingAddress?: Maybe<OrderOperationAddressModificationUpdateAddress>;
};

export type OrderOperationAddressModification = {
  __typename?: 'OrderOperationAddressModification';
  data?: Maybe<OrderOperationAddressData>;
  modificationType: Scalars['String']['output'];
  prev?: Maybe<OrderOperationAddressData>;
};

export type OrderOperationAddressModificationUpdateAddress = {
  __typename?: 'OrderOperationAddressModificationUpdateAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  pcc?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderOperationResult = {
  __typename?: 'OrderOperationResult';
  status: Scalars['String']['output'];
};

export type OrderOperationSearchActor = {
  __typename?: 'OrderOperationSearchActor';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OrderOperationSearchBonus = {
  __typename?: 'OrderOperationSearchBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reservationId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OrderOperationSearchFee = {
  __typename?: 'OrderOperationSearchFee';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taxAmount: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type OrderOperationSearchGift = {
  __typename?: 'OrderOperationSearchGift';
  giftId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderOperationSearchGiftCard = {
  __typename?: 'OrderOperationSearchGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OrderOperationSearchHit = {
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderOperationSearchHits = {
  __typename?: 'OrderOperationSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<OrderAddressesModificationSearchHit | OrderCancellationSearchHit | OrderCompensationSearchHit | OrderDeliverySearchHit | OrderOrderLinesModificationSearchHit | OrderRefundSearchHit | OrderReleaseSearchHit | OrderShippingFeesModificationSearchHit>;
  total: Scalars['Int']['output'];
};

export type OrderOperationSearchOrderLine = {
  __typename?: 'OrderOperationSearchOrderLine';
  currencyCode: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderOperationSearchProvider = {
  __typename?: 'OrderOperationSearchProvider';
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status?: Maybe<OrderCompensationSearchProviderStatus>;
};

export type OrderOperationSearchReason = {
  __typename?: 'OrderOperationSearchReason';
  cause?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export type OrderOperationSearchShippingFee = {
  __typename?: 'OrderOperationSearchShippingFee';
  currencyCode: Scalars['String']['output'];
  shippingFeeId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderOrderLinesModificationSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderOrderLinesModificationSearchHit';
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderOrderLinesModificationSearchOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider?: Maybe<OrderOperationSearchProvider>;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderOrderLinesModificationSearchOrderLine = {
  __typename?: 'OrderOrderLinesModificationSearchOrderLine';
  data?: Maybe<OrderLineData>;
  modificationType?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<OrderLineData>;
};

export type OrderPayment = {
  method?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderPaymentAdyen = OrderPayment & {
  __typename?: 'OrderPaymentAdyen';
  deepLinkPath?: Maybe<Scalars['String']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  merchantAccountCode: Scalars['String']['output'];
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  paymentMethodVariant?: Maybe<Scalars['String']['output']>;
  potentialFraud?: Maybe<Scalars['Boolean']['output']>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPaymentAvarda = OrderPayment & {
  __typename?: 'OrderPaymentAvarda';
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  purchaseId: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPaymentBrinkZeroPayment = OrderPayment & {
  __typename?: 'OrderPaymentBrinkZeroPayment';
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  originalProvider: OrderPaymentBrinkZeroPaymentOriginalProvider;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderPaymentBrinkZeroPaymentOriginalProvider = {
  __typename?: 'OrderPaymentBrinkZeroPaymentOriginalProvider';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderPaymentCustomPayment = OrderPayment & {
  __typename?: 'OrderPaymentCustomPayment';
  customPaymentSessionId: Scalars['String']['output'];
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPaymentKlarnaCheckout = OrderPayment & {
  __typename?: 'OrderPaymentKlarnaCheckout';
  deepLinkPath?: Maybe<Scalars['String']['output']>;
  fraudStatus?: Maybe<Scalars['String']['output']>;
  klarnaMerchantId: Scalars['String']['output'];
  klarnaOrderId: Scalars['String']['output'];
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPaymentLedyer = OrderPayment & {
  __typename?: 'OrderPaymentLedyer';
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  ledyerOrderId: Scalars['String']['output'];
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vatId: Scalars['String']['output'];
};

export type OrderPaymentQliroOne = OrderPayment & {
  __typename?: 'OrderPaymentQliroOne';
  identityVerified: Scalars['Boolean']['output'];
  merchantProvidedQuestionAnswer?: Maybe<Scalars['Boolean']['output']>;
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderItems?: Maybe<Array<OrderPaymentQliroOneOrderItem>>;
  paymentTypeCode?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  qliroOrderId: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  requireIdentityVerification: Scalars['Boolean']['output'];
  signupForNewsletter?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  upsell?: Maybe<OrderPaymentQliroOneUpsell>;
};

export type OrderPaymentQliroOneOrderItem = {
  __typename?: 'OrderPaymentQliroOneOrderItem';
  merchantReference: Scalars['String']['output'];
  paymentTransactionId: Scalars['Int']['output'];
};

export type OrderPaymentQliroOneUpsell = {
  __typename?: 'OrderPaymentQliroOneUpsell';
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  items: Array<OrderPaymentQliroOneUpsellItems>;
  status: Scalars['String']['output'];
  totals: OrderPaymentQliroOneUpsellTotals;
};

export type OrderPaymentQliroOneUpsellItems = {
  __typename?: 'OrderPaymentQliroOneUpsellItems';
  displayName: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type OrderPaymentQliroOneUpsellTotals = {
  __typename?: 'OrderPaymentQliroOneUpsellTotals';
  discountTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
};

export type OrderPaymentSveaCheckout = OrderPayment & {
  __typename?: 'OrderPaymentSveaCheckout';
  expirationDate?: Maybe<Scalars['String']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  peppolId?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  sveaMerchantId: Scalars['String']['output'];
  sveaOrderId: Scalars['Int']['output'];
};

export type OrderPaymentWalleyCheckout = OrderPayment & {
  __typename?: 'OrderPaymentWalleyCheckout';
  amountToPay: Scalars['Float']['output'];
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  purchaseIdentifier: Scalars['String']['output'];
  purchaseResult: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type OrderPaymentZaver = OrderPayment & {
  __typename?: 'OrderPaymentZaver';
  method: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  useVerifiedAddress: Scalars['Boolean']['output'];
};

export type OrderPromotion = {
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPromotionEmpty = OrderPromotion & {
  __typename?: 'OrderPromotionEmpty';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderPromotionItemVoyado = {
  __typename?: 'OrderPromotionItemVoyado';
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderPromotionVoyado = OrderPromotion & {
  __typename?: 'OrderPromotionVoyado';
  contactId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  promotions?: Maybe<Array<OrderPromotionItemVoyado>>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderRefund = {
  __typename?: 'OrderRefund';
  bonus?: Maybe<RefundBonus>;
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  fee?: Maybe<RefundFee>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProducts: Array<RefundGiftCardProduct>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  giftCards: Array<RefundGiftCard>;
  gifts: Array<RefundGift>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<RefundOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  refundedPayment?: Maybe<RefundedPayment>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingFees: Array<RefundShippingFee>;
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  totals: OrderRefundTotals;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
  vouchers: Array<RefundVoucher>;
};

export type OrderRefundSearchGiftCardProduct = {
  __typename?: 'OrderRefundSearchGiftCardProduct';
  cancelErrorMessage?: Maybe<Scalars['String']['output']>;
  cancelErrorStatusCode?: Maybe<Scalars['Int']['output']>;
  cancelTransactionId?: Maybe<Scalars['String']['output']>;
  createFailedReason?: Maybe<Scalars['String']['output']>;
  createId?: Maybe<Scalars['String']['output']>;
  createTransactionId?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  giftCardProductId: Scalars['String']['output'];
  priceAmount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type OrderRefundSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderRefundSearchHit';
  bonus?: Maybe<OrderOperationSearchBonus>;
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  fee?: Maybe<OrderOperationSearchFee>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProducts: Array<OrderRefundSearchGiftCardProduct>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  giftCards: Array<OrderOperationSearchGiftCard>;
  gifts: Array<OrderOperationSearchGift>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderOperationSearchOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: OrderOperationSearchProvider;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  refundedPayment?: Maybe<OrderRefundSearchPayment>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingFees: Array<OrderOperationSearchShippingFee>;
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  totals: OrderRefundSearchTotals;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderRefundSearchPayment = {
  __typename?: 'OrderRefundSearchPayment';
  reference: Scalars['String']['output'];
};

export type OrderRefundSearchTotals = {
  __typename?: 'OrderRefundSearchTotals';
  bonusTotal: Scalars['Int']['output'];
  fee?: Maybe<Scalars['Int']['output']>;
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
};

export type OrderRefundTotals = {
  __typename?: 'OrderRefundTotals';
  bonusTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  voucherTotal: Scalars['Int']['output'];
};

export type OrderRelease = {
  __typename?: 'OrderRelease';
  bonus?: Maybe<ReleaseBonus>;
  bonusProvider?: Maybe<BonusProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<GiftCardProductProvider>;
  giftCardProducts: Array<ReleaseGiftCardProduct>;
  giftCardProvider?: Maybe<GiftCardProvider>;
  giftCards: Array<ReleaseGiftCard>;
  gifts: Array<ReleaseGift>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<ReleaseOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  promotionProvider?: Maybe<PromotionProvider>;
  reason?: Maybe<Reason>;
  releasedPayment?: Maybe<ReleasedPayment>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restarts?: Maybe<Scalars['Int']['output']>;
  revision: Scalars['Int']['output'];
  shippingFees: Array<ReleaseShippingFee>;
  shippingProvider?: Maybe<ShippingProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<VoucherProvider>;
};

export type OrderReleaseSearchGiftCardProduct = {
  __typename?: 'OrderReleaseSearchGiftCardProduct';
  createFailedReason?: Maybe<Scalars['String']['output']>;
  createId?: Maybe<Scalars['String']['output']>;
  createTransactionId?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  giftCardProductId: Scalars['String']['output'];
  priceAmount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type OrderReleaseSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderReleaseSearchHit';
  bonus?: Maybe<OrderOperationSearchBonus>;
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProducts: Array<OrderReleaseSearchGiftCardProduct>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  giftCards: Array<OrderOperationSearchGiftCard>;
  gifts: Array<OrderOperationSearchGift>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLines: Array<OrderOperationSearchOrderLine>;
  orderReference: Scalars['String']['output'];
  paymentProvider: OrderOperationSearchProvider;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  refundedPayment?: Maybe<OrderReleaseSearchPayment>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingFees: Array<OrderOperationSearchShippingFee>;
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  totals: OrderReleaseSearchTotals;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderReleaseSearchPayment = {
  __typename?: 'OrderReleaseSearchPayment';
  amount: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
};

export type OrderReleaseSearchTotals = {
  __typename?: 'OrderReleaseSearchTotals';
  bonusTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  paymentTotal: Scalars['Int']['output'];
};

export type OrderReservation = {
  __typename?: 'OrderReservation';
  created: Scalars['AWSDateTime']['output'];
  orderId: Scalars['String']['output'];
  processedProductVariants: Array<ProductVariantReservation>;
  sessionId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderSearchHit = {
  __typename?: 'OrderSearchHit';
  billingAddress: OrderAddress;
  channelType?: Maybe<ChannelType>;
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  date: Scalars['AWSDateTime']['output'];
  discountCodes?: Maybe<Array<Scalars['String']['output']>>;
  discountExternalReferences?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isTaxExempt?: Maybe<Scalars['Boolean']['output']>;
  isTaxExemptionEligible?: Maybe<Scalars['Boolean']['output']>;
  isTaxIncludedInPrice?: Maybe<Scalars['Boolean']['output']>;
  merchantReference1?: Maybe<Scalars['String']['output']>;
  merchantReference2?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentProviderName: Scalars['String']['output'];
  paymentReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shippingAddress: OrderAddress;
  status: OrderStatus;
  storeGroupId: Scalars['String']['output'];
  taxationCountry?: Maybe<Scalars['String']['output']>;
  totals: OrderTotals;
};

export type OrderSearchHits = {
  __typename?: 'OrderSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<OrderSearchHit>;
  total: Scalars['Int']['output'];
};

export type OrderShipping = {
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderShippingAvardaShippingBroker = OrderShipping & {
  __typename?: 'OrderShippingAvardaShippingBroker';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shipping?: Maybe<AvardaShippingBrokerShipping>;
  shippingBroker: Scalars['String']['output'];
};

export type OrderShippingEmpty = OrderShipping & {
  __typename?: 'OrderShippingEmpty';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderShippingFeesModificationSearchHit = OrderOperationSearchHit & {
  __typename?: 'OrderShippingFeesModificationSearchHit';
  bonusProvider?: Maybe<OrderOperationSearchProvider>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  createdBy: OrderOperationSearchActor;
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  giftCardProductProvider?: Maybe<OrderOperationSearchProvider>;
  giftCardProvider?: Maybe<OrderOperationSearchProvider>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  paymentProvider?: Maybe<OrderOperationSearchProvider>;
  promotionProvider?: Maybe<OrderOperationSearchProvider>;
  reason?: Maybe<OrderOperationSearchReason>;
  restarted?: Maybe<Scalars['AWSDateTime']['output']>;
  restartedBy?: Maybe<OrderOperationSearchActor>;
  restarts: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  shippingFees: Array<OrderShippingFeesModificationSearchShippingFee>;
  shippingProvider?: Maybe<OrderOperationSearchProvider>;
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<OrderOperationSearchActor>;
  storeGroupId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  voucherProvider?: Maybe<OrderOperationSearchProvider>;
};

export type OrderShippingFeesModificationSearchShippingFee = {
  __typename?: 'OrderShippingFeesModificationSearchShippingFee';
  data?: Maybe<ShippingFeeData>;
  modificationType: Scalars['String']['output'];
  prev?: Maybe<ShippingFeeData>;
};

export type OrderShippingIngrid = OrderShipping & {
  __typename?: 'OrderShippingIngrid';
  deliveries?: Maybe<Array<IngridDelivery>>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderShippingKlarnaShippingAssistant = OrderShipping & {
  __typename?: 'OrderShippingKlarnaShippingAssistant';
  klarnaMerchantId: Scalars['String']['output'];
  klarnaOrderId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  selectedShippingOption: KlarnaShippingAssistantSelectedShippingOption;
};

export type OrderShippingNshift = OrderShipping & {
  __typename?: 'OrderShippingNshift';
  orderId: Scalars['String']['output'];
  preparedShipment?: Maybe<NshiftPreparedShipment>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type OrderShippingQliroIntegratedShipping = OrderShipping & {
  __typename?: 'OrderShippingQliroIntegratedShipping';
  ingrid?: Maybe<QliroIngrid>;
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shipments: Array<QliroShipmentOrderItem>;
};

export type OrderShippingWalleyDeliveryModule = OrderShipping & {
  __typename?: 'OrderShippingWalleyDeliveryModule';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  purchaseIdentifier: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shipping: WalleyDeliveryModuleShipping;
};

export enum OrderState {
  Cancelled = 'CANCELLED',
  FullyCompensated = 'FULLY_COMPENSATED',
  FullyDelivered = 'FULLY_DELIVERED',
  FullyRefunded = 'FULLY_REFUNDED',
  PartiallyCompensated = 'PARTIALLY_COMPENSATED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Placed = 'PLACED',
  Released = 'RELEASED'
}

export type OrderStatus = {
  __typename?: 'OrderStatus';
  customStates?: Maybe<Array<OrderCustomState>>;
  orderStates: Array<OrderState>;
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  bonusTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  /** @deprecated The voucher total is deprecated, it is now part of the discountTotal */
  voucherTotal?: Maybe<Scalars['Int']['output']>;
};

export type OrderVoucher = {
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderVoucherEmpty = OrderVoucher & {
  __typename?: 'OrderVoucherEmpty';
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderVoucherItemVoyado = {
  __typename?: 'OrderVoucherItemVoyado';
  amount: Scalars['Int']['output'];
  checkNumber: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrderVoucherVoyado = OrderVoucher & {
  __typename?: 'OrderVoucherVoyado';
  contactId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vouchers?: Maybe<Array<OrderVoucherItemVoyado>>;
};

export type OrderWorkflow = {
  __typename?: 'OrderWorkflow';
  Revisions: Array<OrderWorkflowRevision>;
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published?: Maybe<OrderWorkflowTrigger>;
  revision: Scalars['Int']['output'];
  then: Scalars['AWSJSON']['output'];
  trigger: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecution = {
  __typename?: 'OrderWorkflowExecution';
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  node: OrderWorkflowExecutionNodeTrigger;
  orderId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  workflowRevision: Scalars['Int']['output'];
};

export type OrderWorkflowExecutionNode = {
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecutionNodeAction = OrderWorkflowExecutionNode & {
  __typename?: 'OrderWorkflowExecutionNodeAction';
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  do: OrderWorkflowNodeActionDoCancellation | OrderWorkflowNodeActionDoCustomState;
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  then: Array<OrderWorkflowExecutionNodeAction | OrderWorkflowExecutionNodeBranch | OrderWorkflowExecutionNodeBranchCondition | OrderWorkflowExecutionNodeCondition>;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecutionNodeBranch = OrderWorkflowExecutionNode & {
  __typename?: 'OrderWorkflowExecutionNodeBranch';
  branches: Array<OrderWorkflowExecutionNodeBranchCondition>;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  otherwise: Array<OrderWorkflowExecutionNodeAction | OrderWorkflowExecutionNodeBranch | OrderWorkflowExecutionNodeBranchCondition | OrderWorkflowExecutionNodeCondition>;
  revision: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecutionNodeBranchCondition = OrderWorkflowExecutionNode & {
  __typename?: 'OrderWorkflowExecutionNodeBranchCondition';
  check: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  matched?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  then: Array<OrderWorkflowExecutionNodeAction | OrderWorkflowExecutionNodeBranch | OrderWorkflowExecutionNodeBranchCondition | OrderWorkflowExecutionNodeCondition>;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecutionNodeCondition = OrderWorkflowExecutionNode & {
  __typename?: 'OrderWorkflowExecutionNodeCondition';
  check: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  matched?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  otherwise: Array<OrderWorkflowExecutionNodeAction | OrderWorkflowExecutionNodeBranch | OrderWorkflowExecutionNodeBranchCondition | OrderWorkflowExecutionNodeCondition>;
  revision: Scalars['Int']['output'];
  then: Array<OrderWorkflowExecutionNodeAction | OrderWorkflowExecutionNodeBranch | OrderWorkflowExecutionNodeBranchCondition | OrderWorkflowExecutionNodeCondition>;
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowExecutionNodeTrigger = {
  __typename?: 'OrderWorkflowExecutionNodeTrigger';
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  executionId: Scalars['ID']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  then: Scalars['AWSJSON']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export enum OrderWorkflowExecutionNodeType {
  Action = 'ACTION',
  Branch = 'BRANCH',
  Condition = 'CONDITION',
  Trigger = 'TRIGGER'
}

export type OrderWorkflowExecutionSearchHit = {
  __typename?: 'OrderWorkflowExecutionSearchHit';
  completed?: Maybe<Scalars['AWSDateTime']['output']>;
  created: Scalars['AWSDateTime']['output'];
  failed?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  started?: Maybe<Scalars['AWSDateTime']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  workflowRevision: Scalars['Int']['output'];
};

export type OrderWorkflowExecutionSearchHits = {
  __typename?: 'OrderWorkflowExecutionSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<OrderWorkflowExecutionSearchHit>;
  total: Scalars['Int']['output'];
};

export type OrderWorkflowNode = {
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeAction = OrderWorkflowNode & {
  __typename?: 'OrderWorkflowNodeAction';
  do: OrderWorkflowNodeActionDoCancellation | OrderWorkflowNodeActionDoCustomState;
  name: Scalars['String']['output'];
  then: Array<OrderWorkflowNodeAction | OrderWorkflowNodeBranch | OrderWorkflowNodeCondition>;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeActionDo = {
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeActionDoCancellation = OrderWorkflowNodeActionDo & {
  __typename?: 'OrderWorkflowNodeActionDoCancellation';
  reason?: Maybe<Reason>;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeActionDoCustomState = OrderWorkflowNodeActionDo & {
  __typename?: 'OrderWorkflowNodeActionDoCustomState';
  customState: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeBranch = OrderWorkflowNode & {
  __typename?: 'OrderWorkflowNodeBranch';
  branches: Array<OrderWorkflowNodeBranchCondition>;
  name: Scalars['String']['output'];
  otherwise: Array<OrderWorkflowNodeAction | OrderWorkflowNodeBranch | OrderWorkflowNodeCondition>;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeBranchCondition = {
  __typename?: 'OrderWorkflowNodeBranchCondition';
  check: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  name: Scalars['String']['output'];
  then: Array<OrderWorkflowNodeAction | OrderWorkflowNodeBranch | OrderWorkflowNodeCondition>;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeCondition = OrderWorkflowNode & {
  __typename?: 'OrderWorkflowNodeCondition';
  check: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  name: Scalars['String']['output'];
  otherwise: Array<OrderWorkflowNodeAction | OrderWorkflowNodeBranch | OrderWorkflowNodeCondition>;
  then: Array<OrderWorkflowNodeAction | OrderWorkflowNodeBranch | OrderWorkflowNodeCondition>;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheck = {
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckAnd = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckAnd';
  check1: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  check2: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckCustomHttp = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckCustomHTTP';
  customData?: Maybe<Scalars['AWSJSON']['output']>;
  endpoint: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOr = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOr';
  check1: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  check2: OrderWorkflowNodeConditionCheckAnd | OrderWorkflowNodeConditionCheckCustomHttp | OrderWorkflowNodeConditionCheckOr | OrderWorkflowNodeConditionCheckOrderDate | OrderWorkflowNodeConditionCheckOrderLineCampaign | OrderWorkflowNodeConditionCheckOrderLineCustomAttributes | OrderWorkflowNodeConditionCheckOrderLineOptions | OrderWorkflowNodeConditionCheckOrderLineProductParentId | OrderWorkflowNodeConditionCheckOrderLineProductVariantId | OrderWorkflowNodeConditionCheckOrderLineTags | OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal | OrderWorkflowNodeConditionCheckPaymentProviderMethod | OrderWorkflowNodeConditionCheckPaymentProviderName | OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOrderDate = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderDate';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['AWSDateTime']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaign = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCampaign';
  fields: OrderWorkflowNodeConditionCheckOrderLineCampaignFields;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaignField = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCampaignField';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaignFields = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCampaignFields';
  campaignGroupId?: Maybe<OrderWorkflowNodeConditionCheckOrderLineCampaignField>;
  campaignId?: Maybe<OrderWorkflowNodeConditionCheckOrderLineCampaignField>;
  name?: Maybe<OrderWorkflowNodeConditionCheckOrderLineCampaignField>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributes = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCustomAttributes';
  keyValue: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue';
  key?: Maybe<OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey>;
  value?: Maybe<OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptions = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineOptions';
  keyValue: OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsKey = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineOptionsKey';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue';
  key?: Maybe<OrderWorkflowNodeConditionCheckOrderLineOptionsKey>;
  value?: Maybe<OrderWorkflowNodeConditionCheckOrderLineOptionsValue>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineOptionsValue';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineProductParentId = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineProductParentId';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineProductVariantId = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineProductVariantId';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTags = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineTags';
  keyValue: OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue;
  type: Scalars['String']['output'];
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsKey = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineTagsKey';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue';
  key?: Maybe<OrderWorkflowNodeConditionCheckOrderLineTagsKey>;
  value?: Maybe<OrderWorkflowNodeConditionCheckOrderLineTagsValue>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsValue = {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderLineTagsValue';
  comparison: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['Int']['output']>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderMethod = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckPaymentProviderMethod';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderName = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckPaymentProviderName';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderStatus = OrderWorkflowNodeConditionCheck & {
  __typename?: 'OrderWorkflowNodeConditionCheckPaymentProviderStatus';
  comparison: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export enum OrderWorkflowNodeConditionCheckType {
  And = 'AND',
  CustomHttp = 'CUSTOM_HTTP',
  Or = 'OR',
  OrderCreated = 'ORDER_CREATED',
  OrderLineCampaign = 'ORDER_LINE_CAMPAIGN',
  OrderLineCustomAttributes = 'ORDER_LINE_CUSTOM_ATTRIBUTES',
  OrderLineOptions = 'ORDER_LINE_OPTIONS',
  OrderLineProductParentId = 'ORDER_LINE_PRODUCT_PARENT_ID',
  OrderLineProductVariantId = 'ORDER_LINE_PRODUCT_VARIANT_ID',
  OrderLineTags = 'ORDER_LINE_TAGS',
  OrderTotalsGrandTotal = 'ORDER_TOTALS_GRAND_TOTAL',
  PaymentProviderMethod = 'PAYMENT_PROVIDER_METHOD',
  PaymentProviderName = 'PAYMENT_PROVIDER_NAME',
  PaymentProviderStatus = 'PAYMENT_PROVIDER_STATUS'
}

export enum OrderWorkflowNodeConditionComparisonType {
  BeginsWith = 'BEGINS_WITH',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  LessThan = 'LESS_THAN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS'
}

export enum OrderWorkflowNodeDoActionType {
  Cancellation = 'CANCELLATION',
  CustomState = 'CUSTOM_STATE'
}

export enum OrderWorkflowNodeType {
  Action = 'ACTION',
  Branch = 'BRANCH',
  Condition = 'CONDITION'
}

export type OrderWorkflowRevision = {
  __typename?: 'OrderWorkflowRevision';
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published?: Maybe<OrderWorkflowTrigger>;
  revision: Scalars['Int']['output'];
  then: Scalars['AWSJSON']['output'];
  trigger: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowSearchHit = {
  __typename?: 'OrderWorkflowSearchHit';
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
  trigger: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type OrderWorkflowSearchHits = {
  __typename?: 'OrderWorkflowSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<OrderWorkflowSearchHit>;
  total: Scalars['Int']['output'];
};

export type OrderWorkflowTrigger = {
  __typename?: 'OrderWorkflowTrigger';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published: Scalars['AWSDateTime']['output'];
  revision: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum OrderWorkflowTriggerType {
  OrderCreated = 'ORDER_CREATED'
}

export type OrderWorkflowTriggers = {
  __typename?: 'OrderWorkflowTriggers';
  triggers: Array<OrderWorkflowTrigger>;
};

export type Outcome = {
  __typename?: 'Outcome';
  combineItemDiscount?: Maybe<Scalars['Boolean']['output']>;
  discountItemRule?: Maybe<ItemRule>;
  discountQuantity?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<DiscountValue>;
  gifts?: Maybe<Array<Gift>>;
  id: Scalars['ID']['output'];
  isRecurrent?: Maybe<Scalars['Boolean']['output']>;
  shippingTags?: Maybe<Array<Scalars['String']['output']>>;
  subOutcomes?: Maybe<Array<SubOutcome>>;
  triggerItemRule?: Maybe<ItemRule>;
  triggerQuantity?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type PaymentProvider = {
  __typename?: 'PaymentProvider';
  providerId: Scalars['String']['output'];
  providerName: PaymentProviderName;
  status?: Maybe<ProviderStatusLog>;
};

export enum PaymentProviderName {
  Adyen = 'Adyen',
  Avarda = 'Avarda',
  BrinkZeroPayment = 'BrinkZeroPayment',
  CustomPayment = 'CustomPayment',
  KlarnaCheckout = 'KlarnaCheckout',
  Ledyer = 'Ledyer',
  QliroOne = 'QliroOne',
  SveaCheckout = 'SveaCheckout',
  WalleyCheckout = 'WalleyCheckout',
  Zaver = 'Zaver'
}

export type PlatformConfig = {
  __typename?: 'PlatformConfig';
  externalApi: ExternalApi;
};

export type Price = {
  __typename?: 'Price';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<CampaignIdentity>;
  currencyCode: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  lowestPriceRecord?: Maybe<PriceRecord>;
  priceRecords: Array<PriceRecord>;
  referencePriceAmount?: Maybe<Scalars['Int']['output']>;
  salePriceAmount: Scalars['Int']['output'];
  startDate: Scalars['AWSDateTime']['output'];
};

export type PriceRecord = {
  __typename?: 'PriceRecord';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<CampaignIdentity>;
  endDate: Scalars['AWSDateTime']['output'];
  salePriceAmount: Scalars['Int']['output'];
  startDate: Scalars['AWSDateTime']['output'];
};

export type PriceRule = {
  __typename?: 'PriceRule';
  monies?: Maybe<Array<CampaignMoney>>;
  percentage?: Maybe<Scalars['Int']['output']>;
  percentageDecimals?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type ProductParent = {
  __typename?: 'ProductParent';
  Variants?: Maybe<Array<ProductVariant>>;
  created: Scalars['AWSDateTime']['output'];
  customAttributes?: Maybe<Scalars['AWSJSON']['output']>;
  description: Scalars['String']['output'];
  displayDescriptions: Scalars['AWSJSON']['output'];
  displayNames: Scalars['AWSJSON']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ProductParentSearchHit = {
  __typename?: 'ProductParentSearchHit';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ProductParentSearchHits = {
  __typename?: 'ProductParentSearchHits';
  hits: Array<ProductParentSearchHit>;
  total: Scalars['Int']['output'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  Stock?: Maybe<Stock>;
  StoreGroupPrices: Array<StoreGroupPrice>;
  TaxGroup: TaxGroup;
  created: Scalars['AWSDateTime']['output'];
  customAttributes?: Maybe<Scalars['AWSJSON']['output']>;
  description: Scalars['String']['output'];
  dimensions?: Maybe<Dimensions>;
  displayDescriptions: Scalars['AWSJSON']['output'];
  displayNames: Scalars['AWSJSON']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['ID']['output'];
  shippingAttributes?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['AWSJSON']['output']>;
  updated: Scalars['AWSDateTime']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantReservation = {
  __typename?: 'ProductVariantReservation';
  inventoryId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type ProductVariantRules = {
  __typename?: 'ProductVariantRules';
  tagLogic: Scalars['String']['output'];
};

export type ProductVariantSearchHit = {
  __typename?: 'ProductVariantSearchHit';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  tags?: Maybe<Array<KeyValue>>;
  taxGroupId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ProductVariantSearchHits = {
  __typename?: 'ProductVariantSearchHits';
  hits: Array<ProductVariantSearchHit>;
  total: Scalars['Int']['output'];
};

export type PromotionProvider = {
  __typename?: 'PromotionProvider';
  providerId: Scalars['String']['output'];
  providerName: PromotionProviderName;
};

export enum PromotionProviderName {
  Voyado = 'Voyado'
}

export type Provider = {
  __typename?: 'Provider';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ProviderStatusLog = {
  __typename?: 'ProviderStatusLog';
  current: Scalars['String']['output'];
  history: Array<ProviderStatusLogEntry>;
};

export type ProviderStatusLogEntry = {
  __typename?: 'ProviderStatusLogEntry';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  type: Scalars['String']['output'];
};

export type QliroIngrid = {
  __typename?: 'QliroIngrid';
  checkoutSessionId?: Maybe<Scalars['String']['output']>;
  deliveries?: Maybe<Array<QliroIngridDelivery>>;
};

export type QliroIngridDelivery = {
  __typename?: 'QliroIngridDelivery';
  carrierProductId?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<QliroIngridDeliveryAddress>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  locationExternalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Int']['output']>;
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
  tosId?: Maybe<Scalars['String']['output']>;
};

export type QliroIngridDeliveryAddress = {
  __typename?: 'QliroIngridDeliveryAddress';
  addressLines?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type QliroOneConfig = {
  __typename?: 'QliroOneConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: QliroOneCredentials;
  id: Scalars['ID']['output'];
  integratedShipping?: Maybe<QliroOneIntegratedShipping>;
  merchantOrderManagementStatusPushUrl: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
  useLegacyIds?: Maybe<Scalars['Boolean']['output']>;
};

export type QliroOneCredentials = {
  __typename?: 'QliroOneCredentials';
  merchantApiKey: Scalars['String']['output'];
  merchantApiSecret: Scalars['String']['output'];
};

export type QliroOneIntegratedShipping = {
  __typename?: 'QliroOneIntegratedShipping';
  deliveryCheckoutId?: Maybe<Scalars['String']['output']>;
  merchantOrderAvailableShippingMethodsUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type QliroShipmentOrderItem = {
  __typename?: 'QliroShipmentOrderItem';
  description: Scalars['String']['output'];
  merchantReference: Scalars['String']['output'];
  metadata?: Maybe<QliroShipmentOrderItemMetadata>;
  paymentTransactionId: Scalars['Int']['output'];
  pricePerItemExVat: Scalars['Float']['output'];
  pricePerItemIncVat: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type QliroShipmentOrderItemMetadata = {
  __typename?: 'QliroShipmentOrderItemMetadata';
  shippingMethodMerchantReference: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  Configuration?: Maybe<QueryConfigurationManagement>;
  Order: QueryOrderManagement;
  PlatformConfig?: Maybe<QueryPlatformConfig>;
  Product: QueryProductManagement;
  apiClient: ApiClientDetails;
  apiClients: ApiClientsList;
  apiResources: Array<ApiResource>;
  getAdyenConfig: AdyenConfig;
  getAdyenWebhooks: Array<AdyenWebhookLegacy>;
  getAvardaConfig: AvardaConfig;
  getBSGGiftCardConfig: BsgGiftCardConfig;
  getBonusConfig: BonusConfig;
  getBonusConfigs: Array<CapabilityProvider>;
  getBundleGroup: BundleGroup;
  getCampaign: Campaign;
  getCampaignGroup: CampaignGroupList;
  getCurrencyRates?: Maybe<CurrencyRates>;
  getCustomPaymentConfig: CustomPaymentConfig;
  getDiscountCode: DiscountCode;
  getDiscountCodeRule: DiscountCodeRule;
  getDiscountExternalRule: DiscountExternalRule;
  getDiscountRule: DiscountRule;
  getExternalEventsDestinationAPI: ExternalEventDestinationApi;
  getExternalEventsDestinationAPIs: ExternalEventDestinationApIs;
  getExternalEventsDestinationEventBuses: ExternalEventDestinationEventBuses;
  getExternalEventsRule: ExternalEventRuleState;
  getExternalEventsRules: ExternalEventRules;
  getExternalPriceConfig: ExternalPriceConfig;
  getExternalPriceConfigs: Array<CapabilityProvider>;
  getGenerateCodes: GenerateCodes;
  getGiftCardProviders: Array<Provider>;
  getIngridConfig: IngridConfig;
  getInventories: Array<Inventory>;
  getInventory: Inventory;
  getInventoryStoreMarket: InventoryStoreMarket;
  getKBSGiftCardConfig: KbsGiftCardConfig;
  getKlarnaCheckoutConfig: KlarnaCheckoutConfig;
  getLedyerConfig: LedyerConfig;
  getNShiftConfig: NShiftConfig;
  getPaymentProviders: Array<Provider>;
  getQliroOneConfig: QliroOneConfig;
  getRetain24Config: Retain24Config;
  getShippingProviders: Array<Provider>;
  getShippingTaxGroup: ShippingTaxGroup;
  getStoreGroup: StoreGroup;
  getStoreGroups: Array<StoreGroup>;
  getSveaCheckoutConfig: SveaCheckoutConfig;
  getTaxGroup: TaxGroup;
  getTaxJarConfig: TaxJarConfig;
  getTaxJarConfigs: Array<CapabilityProvider>;
  getTaxMarkets: Array<TaxMarket>;
  getTaxProviders: Array<Provider>;
  getVoyadoConfig: VoyadoConfig;
  getVoyadoConfigs: Array<CapabilityProvider>;
  getWalleyCheckoutConfig: WalleyCheckoutConfig;
  getZaverConfig: ZaverConfig;
  groupUsers: UsersList;
  groups?: Maybe<GroupsList>;
  identityProviders: Array<IdentityProvider>;
  searchBundleGroups: BundleGroupSearchHits;
  searchCampaignGroups: CampaignGroupSearchHits;
  searchCampaigns: CampaignSearchHits;
  searchCodesGenerations: CodesGenerationSearchHits;
  searchDiscountCodeRules: DiscountCodeRuleSearchHits;
  searchDiscountCodes: DiscountCodeSearchHits;
  searchDiscountExternalRules: DiscountExternalRuleSearchHits;
  searchDiscountRules: DiscountRuleSearchHits;
  searchOrderOperations: OrderOperationSearchHits;
  searchOrderWorkflowExecutions: OrderWorkflowExecutionSearchHits;
  searchOrderWorkflows: OrderWorkflowSearchHits;
  searchOrders: OrderSearchHits;
  searchProductParents: ProductParentSearchHits;
  searchProductVariants: ProductVariantSearchHits;
  searchShopperInsights: ShopperInsightsSearchHits;
  searchStoreGroups: StoreGroupSearchHits;
  searchStoreMarkets: StoreMarketSearchHits;
  searchTaxGroups: TaxGroupSearchHits;
  searchTaxMarkets: TaxMarketSearchHits;
  tagKeys?: Maybe<TagKeys>;
  tagValues?: Maybe<TagValues>;
  user: UserDetails;
  users: UsersList;
};


export type QueryApiClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryApiClientsArgs = {
  limit: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAdyenConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAvardaConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBsgGiftCardConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBonusConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBundleGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCurrencyRatesArgs = {
  baseCurrencyCode: Scalars['String']['input'];
  filterCurrencies: Array<Scalars['String']['input']>;
};


export type QueryGetCustomPaymentConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDiscountCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDiscountCodeRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDiscountExternalRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDiscountRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExternalEventsDestinationApiArgs = {
  destName: Scalars['String']['input'];
};


export type QueryGetExternalEventsRuleArgs = {
  ruleName: Scalars['String']['input'];
};


export type QueryGetExternalPriceConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGenerateCodesArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetIngridConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInventoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInventoryStoreMarketArgs = {
  countryCode: Scalars['String']['input'];
  storeGroupId: Scalars['String']['input'];
};


export type QueryGetKbsGiftCardConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetKlarnaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLedyerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetNShiftConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQliroOneConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRetain24ConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStoreGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSveaCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaxGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaxJarConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaxMarketsArgs = {
  taxGroupId: Scalars['String']['input'];
};


export type QueryGetVoyadoConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWalleyCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetZaverConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupUsersArgs = {
  groupname: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupsArgs = {
  limit: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchBundleGroupsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchCampaignGroupsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchCampaignsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchCodesGenerationsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchDiscountCodeRulesArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchDiscountCodesArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchDiscountExternalRulesArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchDiscountRulesArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchOrderOperationsArgs = {
  aggs?: InputMaybe<Scalars['AWSJSON']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchOrderWorkflowExecutionsArgs = {
  aggs?: InputMaybe<Scalars['AWSJSON']['input']>;
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchOrderWorkflowsArgs = {
  aggs?: InputMaybe<Scalars['AWSJSON']['input']>;
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchOrdersArgs = {
  aggs?: InputMaybe<Scalars['AWSJSON']['input']>;
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchProductParentsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchProductVariantsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchShopperInsightsArgs = {
  aggs?: InputMaybe<Scalars['AWSJSON']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchStoreGroupsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchStoreMarketsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchTaxGroupsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchTaxMarketsArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['AWSJSON']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchSorting>>;
  trackTotalHits?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTagValuesArgs = {
  key: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  username: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  limit: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConfigurationManagement = {
  __typename?: 'QueryConfigurationManagement';
  validate?: Maybe<QueryConfigurationManagementValidate>;
};

export type QueryConfigurationManagementValidate = {
  __typename?: 'QueryConfigurationManagementValidate';
  adyen: ValidateConfigResult;
  avarda: ValidateConfigResult;
  bonus: ValidateConfigResult;
  customPayment: ValidateConfigResult;
  externalPrice: ValidateConfigResult;
  klarnaCheckout: ValidateConfigResult;
  ledyer: ValidateConfigResult;
  qliroOne: ValidateConfigResult;
  retain24: ValidateConfigResult;
  sveaCheckout: ValidateConfigResult;
  taxJar: ValidateConfigResult;
  walleyCheckout: ValidateConfigResult;
  zaver: ValidateConfigResult;
};


export type QueryConfigurationManagementValidateAdyenArgs = {
  baseUrl: Scalars['String']['input'];
  environment?: InputMaybe<Scalars['String']['input']>;
  merchantAccount: Scalars['String']['input'];
  xApiKey: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateAvardaArgs = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateBonusArgs = {
  input: InputBonusConfig;
};


export type QueryConfigurationManagementValidateCustomPaymentArgs = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateExternalPriceArgs = {
  input: InputExternalPriceConfig;
};


export type QueryConfigurationManagementValidateKlarnaCheckoutArgs = {
  baseUrl: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateLedyerArgs = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateQliroOneArgs = {
  input: InputQliroOneConfig;
};


export type QueryConfigurationManagementValidateRetain24Args = {
  input: InputRetain24Config;
};


export type QueryConfigurationManagementValidateSveaCheckoutArgs = {
  baseUrl: Scalars['String']['input'];
  checkoutSecret: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type QueryConfigurationManagementValidateTaxJarArgs = {
  input: InputTaxJarConfig;
};


export type QueryConfigurationManagementValidateWalleyCheckoutArgs = {
  input: InputWalleyCheckoutConfig;
};


export type QueryConfigurationManagementValidateZaverArgs = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
};

export type QueryOrderManagement = {
  __typename?: 'QueryOrderManagement';
  cancellation: OrderCancellation;
  compensation: OrderCompensation;
  customReasonCode: CustomReasonCode;
  customReasonCodes: CustomReasonCodes;
  customState: CustomState;
  customStates: CustomStates;
  delivery: OrderDelivery;
  details: Order;
  history: OrderHistory;
  orderModificationAddresses?: Maybe<OrderModificationAddresses>;
  orderModificationOrderLines?: Maybe<OrderModificationOrderLines>;
  orderModificationShippingFees?: Maybe<OrderModificationShippingFees>;
  refund: OrderRefund;
  release: OrderRelease;
  /** @deprecated replaced by order history */
  status: OrderHistory;
  workflow: OrderWorkflow;
  workflowExecution: OrderWorkflowExecution;
  workflowTriggers: OrderWorkflowTriggers;
};


export type QueryOrderManagementCancellationArgs = {
  cancellationId: Scalars['ID']['input'];
};


export type QueryOrderManagementCompensationArgs = {
  compensationId: Scalars['ID']['input'];
};


export type QueryOrderManagementCustomReasonCodeArgs = {
  code: Scalars['ID']['input'];
};


export type QueryOrderManagementCustomStateArgs = {
  stateId: Scalars['ID']['input'];
};


export type QueryOrderManagementDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
};


export type QueryOrderManagementDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderManagementHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderManagementOrderModificationAddressesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type QueryOrderManagementOrderModificationOrderLinesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type QueryOrderManagementOrderModificationShippingFeesArgs = {
  modificationId: Scalars['ID']['input'];
};


export type QueryOrderManagementRefundArgs = {
  refundId: Scalars['ID']['input'];
};


export type QueryOrderManagementReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};


export type QueryOrderManagementStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderManagementWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type QueryOrderManagementWorkflowExecutionArgs = {
  executionId: Scalars['ID']['input'];
};


export type QueryOrderManagementWorkflowTriggersArgs = {
  workflowTriggerType: OrderWorkflowTriggerType;
};

export type QueryPlatformConfig = {
  __typename?: 'QueryPlatformConfig';
  campaign?: Maybe<PlatformConfig>;
  discount?: Maybe<PlatformConfig>;
  order?: Maybe<PlatformConfig>;
  price?: Maybe<PlatformConfig>;
  product?: Maybe<PlatformConfig>;
  stock?: Maybe<PlatformConfig>;
  store?: Maybe<PlatformConfig>;
  tax?: Maybe<PlatformConfig>;
};

export type QueryProductManagement = {
  __typename?: 'QueryProductManagement';
  parent: ProductParent;
  variant: ProductVariant;
};


export type QueryProductManagementParentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductManagementVariantArgs = {
  id: Scalars['ID']['input'];
};

export enum QuotaPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Reason = {
  __typename?: 'Reason';
  cause?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export type RefundBonus = {
  __typename?: 'RefundBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reservationId: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
};

export type RefundFee = {
  __typename?: 'RefundFee';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taxAmount: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type RefundGift = {
  __typename?: 'RefundGift';
  giftId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type RefundGiftCard = {
  __typename?: 'RefundGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type RefundGiftCardProduct = {
  __typename?: 'RefundGiftCardProduct';
  currencyCode: Scalars['String']['output'];
  giftCardProductId: Scalars['ID']['output'];
  priceAmount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type RefundOrderLine = {
  __typename?: 'RefundOrderLine';
  currencyCode: Scalars['String']['output'];
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  reason?: Maybe<Reason>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type RefundShippingFee = {
  __typename?: 'RefundShippingFee';
  currencyCode: Scalars['String']['output'];
  shippingFeeId: Scalars['ID']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type RefundVoucher = {
  __typename?: 'RefundVoucher';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  voucherId: Scalars['ID']['output'];
};

export type RefundedPayment = {
  __typename?: 'RefundedPayment';
  reference: Scalars['String']['output'];
};

export type ReleaseBonus = {
  __typename?: 'ReleaseBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  reservationId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ReleaseGift = {
  __typename?: 'ReleaseGift';
  giftId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type ReleaseGiftCard = {
  __typename?: 'ReleaseGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ReleaseGiftCardProduct = {
  __typename?: 'ReleaseGiftCardProduct';
  cancelErrorMessage?: Maybe<Scalars['String']['output']>;
  cancelErrorStatusCode?: Maybe<Scalars['Int']['output']>;
  cancelTransactionId?: Maybe<Scalars['String']['output']>;
  createFailedReason?: Maybe<Scalars['String']['output']>;
  createId?: Maybe<Scalars['String']['output']>;
  createTransactionId?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  giftCardProductId: Scalars['ID']['output'];
  priceAmount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ReleaseOrderLine = {
  __typename?: 'ReleaseOrderLine';
  currencyCode: Scalars['String']['output'];
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type ReleaseShippingFee = {
  __typename?: 'ReleaseShippingFee';
  currencyCode: Scalars['String']['output'];
  shippingFeeId: Scalars['ID']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type ReleasedPayment = {
  __typename?: 'ReleasedPayment';
  reference: Scalars['String']['output'];
};

export type Retain24Config = {
  __typename?: 'Retain24Config';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: Retain24Credentials;
  id: Scalars['ID']['output'];
  redeem: Scalars['Boolean']['output'];
  simulationKey?: Maybe<Scalars['String']['output']>;
  updated: Scalars['AWSDateTime']['output'];
};

export type Retain24Credentials = {
  __typename?: 'Retain24Credentials';
  certificate: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
};

export type RoundingRule = {
  __typename?: 'RoundingRule';
  roundDown: Scalars['Boolean']['output'];
  roundUp: Scalars['Boolean']['output'];
  targets: Array<Scalars['String']['output']>;
};

export type RoundingRules = {
  __typename?: 'RoundingRules';
  defaultRule: RoundingRule;
  marketRules?: Maybe<Array<MarketRoundingRule>>;
};

export type Rule = {
  __typename?: 'Rule';
  discountAmount: Scalars['Int']['output'];
  discountRuleId: Scalars['String']['output'];
};

export type Schema = {
  __typename?: 'Schema';
  mutation?: Maybe<Mutation>;
  query?: Maybe<Query>;
  subscriptions?: Maybe<Subscription>;
};

export type SearchSorting = {
  field: Scalars['String']['input'];
  order?: InputMaybe<SortOrder>;
};

export type ShippingFee = {
  __typename?: 'ShippingFee';
  basePriceAmount?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salePriceAmount?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Int']['output']>;
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
};

export type ShippingFeeData = {
  __typename?: 'ShippingFeeData';
  id: Scalars['ID']['output'];
  price?: Maybe<ShippingFeeUpdatePrice>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
};

export type ShippingFeeModification = {
  __typename?: 'ShippingFeeModification';
  data: ShippingFeeModificationUpdateData;
  modificationType: ShippingFeeModificationType;
};

export type ShippingFeeModificationData = {
  id: Scalars['String']['output'];
};

export enum ShippingFeeModificationType {
  Update = 'UPDATE'
}

export type ShippingFeeModificationUpdateData = ShippingFeeModificationData & {
  __typename?: 'ShippingFeeModificationUpdateData';
  id: Scalars['String']['output'];
  price?: Maybe<ShippingFeeModificationUpdateDataPrice>;
  taxGroupId?: Maybe<Scalars['String']['output']>;
};

export type ShippingFeeModificationUpdateDataPrice = {
  __typename?: 'ShippingFeeModificationUpdateDataPrice';
  basePriceAmount: Scalars['Int']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  salePriceAmount?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals?: Maybe<Scalars['Int']['output']>;
};

export type ShippingFeeUpdatePrice = {
  __typename?: 'ShippingFeeUpdatePrice';
  basePriceAmount: Scalars['Int']['output'];
  discountAmount: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type ShippingProvider = {
  __typename?: 'ShippingProvider';
  providerId: Scalars['String']['output'];
  providerName: ShippingProviderName;
  status?: Maybe<ProviderStatusLog>;
};

export enum ShippingProviderName {
  AvardaShippingBroker = 'AvardaShippingBroker',
  Ingrid = 'Ingrid',
  KlarnaShippingAssistant = 'KlarnaShippingAssistant',
  Nshift = 'Nshift',
  QliroIntegratedShipping = 'QliroIntegratedShipping',
  WalleyDeliveryModule = 'WalleyDeliveryModule'
}

export type ShippingTaxGroup = {
  __typename?: 'ShippingTaxGroup';
  created: Scalars['AWSDateTime']['output'];
  taxGroupId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ShopperInsightsSearchHit = {
  attributes?: Maybe<ShopperInsightsSearchHitAttributes>;
  channelType: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  created: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  storeGroupId: Scalars['String']['output'];
  taxationCountry: Scalars['String']['output'];
  updated: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitAddress = {
  __typename?: 'ShopperInsightsSearchHitAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  pcc?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  stateOrProvince: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
  telephoneNumber: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitAttributes = {
  __typename?: 'ShopperInsightsSearchHitAttributes';
  company?: Maybe<Scalars['String']['output']>;
  merchantRef1?: Maybe<Scalars['String']['output']>;
  merchantRef2?: Maybe<Scalars['String']['output']>;
};

export type ShopperInsightsSearchHitAttributesCompany = {
  __typename?: 'ShopperInsightsSearchHitAttributesCompany';
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitBundle = {
  __typename?: 'ShopperInsightsSearchHitBundle';
  bundleGroupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ShopperInsightsSearchHitCampaign = {
  __typename?: 'ShopperInsightsSearchHitCampaign';
  campaignGroupId: Scalars['String']['output'];
  campaignId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitCheckout = ShopperInsightsSearchHit & {
  __typename?: 'ShopperInsightsSearchHitCheckout';
  attributes?: Maybe<ShopperInsightsSearchHitAttributes>;
  bundles: Array<ShopperInsightsSearchHitBundle>;
  channelType: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  created: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  giftCards: Array<ShopperInsightsSearchHitCheckoutGiftCard>;
  gifts: Array<ShopperInsightsSearchHitGift>;
  id: Scalars['ID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isPendingConfirmation: Scalars['Boolean']['output'];
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  items: Array<ShopperInsightsSearchHitCheckoutItem>;
  languageCode: Scalars['String']['output'];
  lock?: Maybe<ShopperInsightsSearchHitSessionLock>;
  orderId: Scalars['ID']['output'];
  orderReference: Scalars['String']['output'];
  paymentStatus: ShopperInsightsSearchHitCheckoutPaymentStatus;
  providers?: Maybe<ShopperInsightsSearchHitCheckoutProviders>;
  sessionId: Scalars['ID']['output'];
  sessionProviders?: Maybe<ShopperInsightsSearchHitSessionProviders>;
  shippingAddress?: Maybe<ShopperInsightsSearchHitAddress>;
  shippingOptions: Array<ShopperInsightsSearchHitCheckoutShippingOption>;
  storeGroupId: Scalars['String']['output'];
  taxationCountry: Scalars['String']['output'];
  updated: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitCheckoutGiftCard = {
  __typename?: 'ShopperInsightsSearchHitCheckoutGiftCard';
  balance: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitCheckoutItem = {
  __typename?: 'ShopperInsightsSearchHitCheckoutItem';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<ShopperInsightsSearchHitCampaign>;
  discountAmount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  tags?: Maybe<Array<ShopperInsightsSearchHitTag>>;
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitCheckoutPaymentStatus = {
  __typename?: 'ShopperInsightsSearchHitCheckoutPaymentStatus';
  current: Scalars['String']['output'];
  log?: Maybe<Array<ShopperInsightsSearchHitCheckoutPaymentStatusLog>>;
};

export type ShopperInsightsSearchHitCheckoutPaymentStatusLog = {
  __typename?: 'ShopperInsightsSearchHitCheckoutPaymentStatusLog';
  message?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitCheckoutProvider = {
  __typename?: 'ShopperInsightsSearchHitCheckoutProvider';
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitCheckoutProviders = {
  __typename?: 'ShopperInsightsSearchHitCheckoutProviders';
  giftCard?: Maybe<ShopperInsightsSearchHitCheckoutProvider>;
  payment?: Maybe<ShopperInsightsSearchHitCheckoutProvider>;
  shipping?: Maybe<ShopperInsightsSearchHitCheckoutProvider>;
};

export type ShopperInsightsSearchHitCheckoutShippingOption = {
  __typename?: 'ShopperInsightsSearchHitCheckoutShippingOption';
  basePriceAmount: Scalars['Int']['output'];
  discountAmount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitGift = {
  __typename?: 'ShopperInsightsSearchHitGift';
  basePriceAmount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  discountRuleId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitOrder = ShopperInsightsSearchHit & {
  __typename?: 'ShopperInsightsSearchHitOrder';
  attributes?: Maybe<ShopperInsightsSearchHitAttributes>;
  billingAddress: ShopperInsightsSearchHitAddress;
  bonus?: Maybe<ShopperInsightsSearchHitOrderBonus>;
  bundles: Array<ShopperInsightsSearchHitBundle>;
  channelType: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
  checkoutProviders: ShopperInsightsSearchHitOrderCheckoutProviders;
  countryCode: Scalars['String']['output'];
  created: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  giftCardProducts: Array<ShopperInsightsSearchHitOrderGiftCardProduct>;
  giftCards: Array<ShopperInsightsSearchHitOrderGiftCard>;
  gifts: Array<ShopperInsightsSearchHitGift>;
  id: Scalars['ID']['output'];
  isTaxExempt: Scalars['Boolean']['output'];
  isTaxExemptionEligible: Scalars['Boolean']['output'];
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  orderLines: Array<ShopperInsightsSearchHitOrderLine>;
  payment: ShopperInsightsSearchHitOrderPayment;
  promotions: Array<ShopperInsightsSearchHitOrderPromotion>;
  reference: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
  sessionProviders?: Maybe<ShopperInsightsSearchHitOrderSessionProviders>;
  shipping?: Maybe<ShopperInsightsSearchHitOrderShipping>;
  shippingAddress: ShopperInsightsSearchHitAddress;
  shippingFees: Array<ShopperInsightsSearchHitOrderShippingFee>;
  storeGroupId: Scalars['String']['output'];
  taxationCountry: Scalars['String']['output'];
  totals: ShopperInsightsSearchHitOrderTotals;
  updated: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  vouchers: Array<ShopperInsightsSearchHitOrderVoucher>;
};

export type ShopperInsightsSearchHitOrderBonus = {
  __typename?: 'ShopperInsightsSearchHitOrderBonus';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitOrderCheckoutProviders = {
  __typename?: 'ShopperInsightsSearchHitOrderCheckoutProviders';
  giftcard?: Maybe<ShopperInsightsSearchHitOrderProvider>;
  payment: ShopperInsightsSearchHitOrderProvider;
  shipping?: Maybe<ShopperInsightsSearchHitOrderProvider>;
};

export type ShopperInsightsSearchHitOrderGiftCard = {
  __typename?: 'ShopperInsightsSearchHitOrderGiftCard';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  redeemId?: Maybe<Scalars['String']['output']>;
  reservationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitOrderGiftCardProduct = {
  __typename?: 'ShopperInsightsSearchHitOrderGiftCardProduct';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  distribution?: Maybe<Scalars['String']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  merchantReference: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ShopperInsightsSearchHitOrderLine = {
  __typename?: 'ShopperInsightsSearchHitOrderLine';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<ShopperInsightsSearchHitCampaign>;
  currencyCode: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  distributedTotalDiscountAmount: Scalars['Int']['output'];
  distributedTotalPriceAmount: Scalars['Int']['output'];
  distributedTotalTaxAmount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  tags?: Maybe<Array<ShopperInsightsSearchHitTag>>;
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  totalDiscountAmount: Scalars['Int']['output'];
  totalPriceAmount: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ShopperInsightsSearchHitOrderPayment = {
  __typename?: 'ShopperInsightsSearchHitOrderPayment';
  method: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitOrderPromotion = {
  __typename?: 'ShopperInsightsSearchHitOrderPromotion';
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitOrderProvider = {
  __typename?: 'ShopperInsightsSearchHitOrderProvider';
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitOrderSessionProviders = {
  __typename?: 'ShopperInsightsSearchHitOrderSessionProviders';
  bonus?: Maybe<ShopperInsightsSearchHitOrderProvider>;
  giftCardProduct?: Maybe<ShopperInsightsSearchHitOrderProvider>;
  promotion?: Maybe<ShopperInsightsSearchHitOrderProvider>;
  voucher?: Maybe<ShopperInsightsSearchHitOrderProvider>;
};

export type ShopperInsightsSearchHitOrderShipping = {
  __typename?: 'ShopperInsightsSearchHitOrderShipping';
  providerError?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type ShopperInsightsSearchHitOrderShippingFee = {
  __typename?: 'ShopperInsightsSearchHitOrderShippingFee';
  basePriceAmount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  salePriceAmount: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitOrderTotals = {
  __typename?: 'ShopperInsightsSearchHitOrderTotals';
  bonusTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  giftCardTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitOrderVoucher = {
  __typename?: 'ShopperInsightsSearchHitOrderVoucher';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitSession = ShopperInsightsSearchHit & {
  __typename?: 'ShopperInsightsSearchHitSession';
  attributes?: Maybe<ShopperInsightsSearchHitAttributes>;
  channelType: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  created: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  items: Array<ShopperInsightsSearchHitSessionItem>;
  languageCode: Scalars['String']['output'];
  lock?: Maybe<ShopperInsightsSearchHitSessionLock>;
  providers?: Maybe<ShopperInsightsSearchHitSessionProviders>;
  storeGroupId: Scalars['String']['output'];
  taxationCountry: Scalars['String']['output'];
  updated: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitSessionItem = {
  __typename?: 'ShopperInsightsSearchHitSessionItem';
  basePriceAmount: Scalars['Int']['output'];
  campaign?: Maybe<ShopperInsightsSearchHitCampaign>;
  discountAmount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productParentId: Scalars['String']['output'];
  productVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salePriceAmount: Scalars['Int']['output'];
  tags?: Maybe<Array<ShopperInsightsSearchHitTag>>;
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitSessionLock = {
  __typename?: 'ShopperInsightsSearchHitSessionLock';
  checkoutId: Scalars['ID']['output'];
  closed: Scalars['Boolean']['output'];
};

export type ShopperInsightsSearchHitSessionProvider = {
  __typename?: 'ShopperInsightsSearchHitSessionProvider';
  bonus?: Maybe<ShopperInsightsSearchHitSessionProviderBonus>;
  giftCardProducts?: Maybe<Array<ShopperInsightsSearchHitSessionProviderGiftCardProduct>>;
  promotions?: Maybe<Array<ShopperInsightsSearchHitSessionProviderPromotion>>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  vouchers?: Maybe<Array<ShopperInsightsSearchHitSessionProviderVoucher>>;
};

export type ShopperInsightsSearchHitSessionProviderBonus = {
  __typename?: 'ShopperInsightsSearchHitSessionProviderBonus';
  amount: Scalars['Int']['output'];
  amountToUse?: Maybe<Scalars['Int']['output']>;
  currencyCode: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  reservationId?: Maybe<Scalars['Int']['output']>;
  reservedAmount?: Maybe<Scalars['Int']['output']>;
  reservedPoints?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ShopperInsightsSearchHitSessionProviderGiftCardProduct = {
  __typename?: 'ShopperInsightsSearchHitSessionProviderGiftCardProduct';
  currencyCode: Scalars['String']['output'];
  distribution?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchantReference?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceAmount: Scalars['Int']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
};

export type ShopperInsightsSearchHitSessionProviderPromotion = {
  __typename?: 'ShopperInsightsSearchHitSessionProviderPromotion';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ShopperInsightsSearchHitSessionProviderVoucher = {
  __typename?: 'ShopperInsightsSearchHitSessionProviderVoucher';
  currencyCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  valueAmount: Scalars['Int']['output'];
};

export type ShopperInsightsSearchHitSessionProviders = {
  __typename?: 'ShopperInsightsSearchHitSessionProviders';
  bonus?: Maybe<ShopperInsightsSearchHitSessionProvider>;
  giftCardProduct?: Maybe<ShopperInsightsSearchHitSessionProvider>;
  promotion?: Maybe<ShopperInsightsSearchHitSessionProvider>;
  voucher?: Maybe<ShopperInsightsSearchHitSessionProvider>;
};

export type ShopperInsightsSearchHitTag = {
  __typename?: 'ShopperInsightsSearchHitTag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ShopperInsightsSearchHits = {
  __typename?: 'ShopperInsightsSearchHits';
  aggregations?: Maybe<Scalars['AWSJSON']['output']>;
  hits: Array<ShopperInsightsSearchHitCheckout | ShopperInsightsSearchHitOrder | ShopperInsightsSearchHitSession>;
  total: Scalars['Int']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stock = {
  __typename?: 'Stock';
  id: Scalars['ID']['output'];
  inventories: Array<StockInventory>;
  stockQuantity: Scalars['Int']['output'];
  validateStock: Scalars['Boolean']['output'];
};

export type StockInventory = {
  __typename?: 'StockInventory';
  created: Scalars['AWSDateTime']['output'];
  inventoryId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type StoreGroup = {
  __typename?: 'StoreGroup';
  channelType: ChannelType;
  countryOfSale?: Maybe<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  storeMarkets?: Maybe<Array<StoreMarket>>;
  updated: Scalars['AWSDateTime']['output'];
};

export type StoreGroupPrice = {
  __typename?: 'StoreGroupPrice';
  marketPrices: Array<MarketPrice>;
  storeGroupId: Scalars['ID']['output'];
};

export type StoreGroupSearchHit = {
  __typename?: 'StoreGroupSearchHit';
  countryOfSale?: Maybe<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type StoreGroupSearchHits = {
  __typename?: 'StoreGroupSearchHits';
  hits: Array<StoreGroupSearchHit>;
  total: Scalars['Int']['output'];
};

export type StoreMarket = {
  __typename?: 'StoreMarket';
  capabilities?: Maybe<Capabilities>;
  cartCapabilities?: Maybe<CartCapabilities>;
  channelType: ChannelType;
  countryCode: Scalars['String']['output'];
  countryOfSale?: Maybe<Scalars['String']['output']>;
  created: Scalars['AWSDateTime']['output'];
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isTaxExemptionEligible?: Maybe<Scalars['Boolean']['output']>;
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  storeGroupId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type StoreMarketSearchHit = {
  __typename?: 'StoreMarketSearchHit';
  cartCapabilities?: Maybe<CartCapabilities>;
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  giftCardProviders?: Maybe<Array<Provider>>;
  isArchived: Scalars['Boolean']['output'];
  isTaxExemptionEligible?: Maybe<Scalars['Boolean']['output']>;
  isTaxIncludedInPrice: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentProviders?: Maybe<Array<Provider>>;
  shippingProviders?: Maybe<Array<Provider>>;
  storeGroupId: Scalars['String']['output'];
  taxProviders?: Maybe<Array<Provider>>;
  updated: Scalars['AWSDateTime']['output'];
};

export type StoreMarketSearchHits = {
  __typename?: 'StoreMarketSearchHits';
  hits: Array<StoreMarketSearchHit>;
  total: Scalars['Int']['output'];
};

export type SubOutcome = {
  __typename?: 'SubOutcome';
  discountQuantity?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<DiscountValue>;
  triggerQuantity?: Maybe<Scalars['Int']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  OnAdyenWebhookChanged?: Maybe<AdyenWebhook>;
};


export type SubscriptionOnAdyenWebhookChangedArgs = {
  configId: Scalars['String']['input'];
};

export type SveaCheckoutConfig = {
  __typename?: 'SveaCheckoutConfig';
  checkoutBaseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: SveaCredentials;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
  paymentAdminBaseUrl: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type SveaCredentials = {
  __typename?: 'SveaCredentials';
  apiKey: Scalars['String']['output'];
};

export type TagCondition = {
  __typename?: 'TagCondition';
  key: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type TagKeys = {
  __typename?: 'TagKeys';
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

export type TagValues = {
  __typename?: 'TagValues';
  key: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type TaxGroup = {
  __typename?: 'TaxGroup';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type TaxGroupSearchHit = {
  __typename?: 'TaxGroupSearchHit';
  created: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type TaxGroupSearchHits = {
  __typename?: 'TaxGroupSearchHits';
  hits: Array<TaxGroupSearchHit>;
  total: Scalars['Int']['output'];
};

export type TaxJarConfig = {
  __typename?: 'TaxJarConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: TaxJarCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type TaxJarCredentials = {
  __typename?: 'TaxJarCredentials';
  apiKey: Scalars['String']['output'];
};

export type TaxMarket = {
  __typename?: 'TaxMarket';
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type TaxMarketSearchHit = {
  __typename?: 'TaxMarketSearchHit';
  countryCode: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  taxGroupId: Scalars['String']['output'];
  taxPercentage: Scalars['Int']['output'];
  taxPercentageDecimals: Scalars['Int']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type TaxMarketSearchHits = {
  __typename?: 'TaxMarketSearchHits';
  hits: Array<TaxMarketSearchHit>;
  total: Scalars['Int']['output'];
};

export type UpdateExternalEventsDestinationApiResult = {
  __typename?: 'UpdateExternalEventsDestinationAPIResult';
  apiDestinationName: Scalars['String']['output'];
};

export type UsagePlan = {
  __typename?: 'UsagePlan';
  burstLimit: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quotaLimit: Scalars['Int']['output'];
  quotaPeriod: QuotaPeriod;
  rateLimit: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  created: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  enabled: Scalars['Boolean']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  status: UserStatus;
  updated: Scalars['AWSDateTime']['output'];
  username: Scalars['ID']['output'];
};

export type UserDetails = {
  __typename?: 'UserDetails';
  created: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  enabled: Scalars['Boolean']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  groups: Array<Group>;
  status: UserStatus;
  updated: Scalars['AWSDateTime']['output'];
  username: Scalars['ID']['output'];
};

export enum UserStatus {
  Archived = 'ARCHIVED',
  Confirmed = 'CONFIRMED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN'
}

export type UsersList = {
  __typename?: 'UsersList';
  nextToken?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
};

export type ValidDateRange = {
  __typename?: 'ValidDateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ValidateConfigResult = {
  __typename?: 'ValidateConfigResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type VoucherProvider = {
  __typename?: 'VoucherProvider';
  providerId: Scalars['String']['output'];
  providerName: VoucherProviderName;
};

export enum VoucherProviderName {
  Voyado = 'Voyado'
}

export type VoyadoConfig = {
  __typename?: 'VoyadoConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: VoyadoCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type VoyadoCredentials = {
  __typename?: 'VoyadoCredentials';
  apiKey: Scalars['String']['output'];
};

export type WalleyCheckoutConfig = {
  __typename?: 'WalleyCheckoutConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: WalleyCredentials;
  deliveryModuleEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  profileName?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type WalleyCredentials = {
  __typename?: 'WalleyCredentials';
  clientId: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type WalleyDeliveryModuleDeliveryDate = {
  __typename?: 'WalleyDeliveryModuleDeliveryDate';
  date: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  timeFrom: Scalars['String']['output'];
  timeTo: Scalars['String']['output'];
};

export type WalleyDeliveryModuleDestination = {
  __typename?: 'WalleyDeliveryModuleDestination';
  deliveryDate?: Maybe<WalleyDeliveryModuleDeliveryDate>;
  fee: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WalleyDeliveryModuleOption = {
  __typename?: 'WalleyDeliveryModuleOption';
  description: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WalleyDeliveryModuleShipment = {
  __typename?: 'WalleyDeliveryModuleShipment';
  bookedShipmentId?: Maybe<Scalars['String']['output']>;
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  feeItemId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shippingChoice: WalleyDeliveryModuleShippingChoice;
};

export type WalleyDeliveryModuleShipping = {
  __typename?: 'WalleyDeliveryModuleShipping';
  provider: Scalars['String']['output'];
  shipments: Array<WalleyDeliveryModuleShipment>;
  shippingFee: Scalars['Float']['output'];
};

export type WalleyDeliveryModuleShippingChoice = {
  __typename?: 'WalleyDeliveryModuleShippingChoice';
  destination: WalleyDeliveryModuleDestination;
  fee: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options: Array<WalleyDeliveryModuleOption>;
};

export type ZaverConfig = {
  __typename?: 'ZaverConfig';
  baseUrl: Scalars['String']['output'];
  created: Scalars['AWSDateTime']['output'];
  credentials: ZaverCredentials;
  id: Scalars['ID']['output'];
  updated: Scalars['AWSDateTime']['output'];
};

export type ZaverCredentials = {
  __typename?: 'ZaverCredentials';
  apiKey: Scalars['String']['output'];
  callbackApiKey: Scalars['String']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  OrderLineData: ( Omit<OrderLineCreate, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } ) | ( Omit<OrderLineDelete, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } ) | ( Omit<OrderLineUpdate, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  OrderAddressesModificationData: ( OrderAddressesModificationUpdateData );
  OrderGiftCard: ( OrderGiftCardBsgGiftCard ) | ( OrderGiftCardEmpty ) | ( OrderGiftCardKbsGiftCard ) | ( OrderGiftCardRetain24 );
  OrderGiftCardProduct: ( OrderGiftCardProductEmpty ) | ( OrderGiftCardProductRetain24 );
  OrderGiftCardProductItem: ( OrderGiftCardProductItemRetain24 );
  OrderLineBase: ( Omit<OrderLineCreate, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } ) | ( Omit<OrderLineDelete, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } ) | ( Omit<OrderLineUpdate, 'campaign'> & { campaign?: Maybe<_RefType['OrderLineCampaign']> } );
  OrderLineCampaign: never;
  OrderLineModificationData: ( OrderLineModificationCreateData ) | ( OrderLineModificationDeleteData ) | ( OrderLineModificationUpdateData );
  OrderModification: ( Omit<OrderModificationAddresses, 'addresses'> & { addresses: _RefType['OrderAddressesModification'] } ) | ( Omit<OrderModificationOrderLines, 'newTotals' | 'oldTotals' | 'orderLines'> & { newTotals?: Maybe<_RefType['OrderTotals']>, oldTotals?: Maybe<_RefType['OrderTotals']>, orderLines: Array<_RefType['OrderLineModification']> } ) | ( Omit<OrderModificationShippingFees, 'newTotals' | 'oldTotals' | 'shippingFees'> & { newTotals?: Maybe<_RefType['OrderTotals']>, oldTotals?: Maybe<_RefType['OrderTotals']>, shippingFees: Array<_RefType['ShippingFeeModification']> } );
  OrderOperationSearchHit: ( OrderAddressesModificationSearchHit ) | ( OrderCancellationSearchHit ) | ( OrderCompensationSearchHit ) | ( OrderDeliverySearchHit ) | ( Omit<OrderOrderLinesModificationSearchHit, 'orderLines'> & { orderLines: Array<_RefType['OrderOrderLinesModificationSearchOrderLine']> } ) | ( OrderRefundSearchHit ) | ( OrderReleaseSearchHit ) | ( OrderShippingFeesModificationSearchHit );
  OrderPayment: ( OrderPaymentAdyen ) | ( OrderPaymentAvarda ) | ( OrderPaymentBrinkZeroPayment ) | ( OrderPaymentCustomPayment ) | ( OrderPaymentKlarnaCheckout ) | ( OrderPaymentLedyer ) | ( OrderPaymentQliroOne ) | ( OrderPaymentSveaCheckout ) | ( OrderPaymentWalleyCheckout ) | ( OrderPaymentZaver );
  OrderPromotion: ( OrderPromotionEmpty ) | ( OrderPromotionVoyado );
  OrderShipping: ( OrderShippingAvardaShippingBroker ) | ( OrderShippingEmpty ) | ( OrderShippingIngrid ) | ( OrderShippingKlarnaShippingAssistant ) | ( OrderShippingNshift ) | ( OrderShippingQliroIntegratedShipping ) | ( OrderShippingWalleyDeliveryModule );
  OrderVoucher: ( OrderVoucherEmpty ) | ( OrderVoucherVoyado );
  OrderWorkflowExecutionNode: ( Omit<OrderWorkflowExecutionNodeAction, 'do' | 'then'> & { do: _RefType['OrderWorkflowNodeActionDo'], then: Array<_RefType['OrderWorkflowExecutionNode']> } ) | ( Omit<OrderWorkflowExecutionNodeBranch, 'branches' | 'otherwise'> & { branches: Array<_RefType['OrderWorkflowExecutionNodeBranchCondition']>, otherwise: Array<_RefType['OrderWorkflowExecutionNode']> } ) | ( Omit<OrderWorkflowExecutionNodeBranchCondition, 'check' | 'then'> & { check: _RefType['OrderWorkflowNodeConditionCheck'], then: Array<_RefType['OrderWorkflowExecutionNode']> } ) | ( Omit<OrderWorkflowExecutionNodeCondition, 'check' | 'otherwise' | 'then'> & { check: _RefType['OrderWorkflowNodeConditionCheck'], otherwise: Array<_RefType['OrderWorkflowExecutionNode']>, then: Array<_RefType['OrderWorkflowExecutionNode']> } );
  OrderWorkflowNode: ( Omit<OrderWorkflowNodeAction, 'do' | 'then'> & { do: _RefType['OrderWorkflowNodeActionDo'], then: Array<_RefType['OrderWorkflowNode']> } ) | ( Omit<OrderWorkflowNodeBranch, 'branches' | 'otherwise'> & { branches: Array<_RefType['OrderWorkflowNodeBranchCondition']>, otherwise: Array<_RefType['OrderWorkflowNode']> } ) | ( Omit<OrderWorkflowNodeCondition, 'check' | 'otherwise' | 'then'> & { check: _RefType['OrderWorkflowNodeConditionCheck'], otherwise: Array<_RefType['OrderWorkflowNode']>, then: Array<_RefType['OrderWorkflowNode']> } );
  OrderWorkflowNodeActionDo: ( OrderWorkflowNodeActionDoCancellation ) | ( OrderWorkflowNodeActionDoCustomState );
  OrderWorkflowNodeConditionCheck: ( Omit<OrderWorkflowNodeConditionCheckAnd, 'check1' | 'check2'> & { check1: _RefType['OrderWorkflowNodeConditionCheck'], check2: _RefType['OrderWorkflowNodeConditionCheck'] } ) | ( OrderWorkflowNodeConditionCheckCustomHttp ) | ( Omit<OrderWorkflowNodeConditionCheckOr, 'check1' | 'check2'> & { check1: _RefType['OrderWorkflowNodeConditionCheck'], check2: _RefType['OrderWorkflowNodeConditionCheck'] } ) | ( OrderWorkflowNodeConditionCheckOrderDate ) | ( OrderWorkflowNodeConditionCheckOrderLineCampaign ) | ( OrderWorkflowNodeConditionCheckOrderLineCustomAttributes ) | ( OrderWorkflowNodeConditionCheckOrderLineOptions ) | ( OrderWorkflowNodeConditionCheckOrderLineProductParentId ) | ( OrderWorkflowNodeConditionCheckOrderLineProductVariantId ) | ( OrderWorkflowNodeConditionCheckOrderLineTags ) | ( OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal ) | ( OrderWorkflowNodeConditionCheckPaymentProviderMethod ) | ( OrderWorkflowNodeConditionCheckPaymentProviderName ) | ( OrderWorkflowNodeConditionCheckPaymentProviderStatus );
  ShippingFeeModificationData: ( ShippingFeeModificationUpdateData );
  ShopperInsightsSearchHit: ( ShopperInsightsSearchHitCheckout ) | ( ShopperInsightsSearchHitOrder ) | ( ShopperInsightsSearchHitSession );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  Actor: ResolverTypeWrapper<Actor>;
  AddExternalEventsDestinationAPIResult: ResolverTypeWrapper<AddExternalEventsDestinationApiResult>;
  AddExternalEventsDestinationEventBusResult: ResolverTypeWrapper<AddExternalEventsDestinationEventBusResult>;
  AddExternalEventsRuleResult: ResolverTypeWrapper<AddExternalEventsRuleResult>;
  AdyenConfig: ResolverTypeWrapper<AdyenConfig>;
  AdyenCredentials: ResolverTypeWrapper<AdyenCredentials>;
  AdyenEnvironment: AdyenEnvironment;
  AdyenWebhook: ResolverTypeWrapper<AdyenWebhook>;
  AdyenWebhookCredentials: ResolverTypeWrapper<AdyenWebhookCredentials>;
  AdyenWebhookGenerationResult: ResolverTypeWrapper<AdyenWebhookGenerationResult>;
  AdyenWebhookLegacy: ResolverTypeWrapper<AdyenWebhookLegacy>;
  AdyenWebhookStatus: AdyenWebhookStatus;
  AdyenWebhookTarget: AdyenWebhookTarget;
  ApiClient: ResolverTypeWrapper<ApiClient>;
  ApiClientDetails: ResolverTypeWrapper<ApiClientDetails>;
  ApiClientsList: ResolverTypeWrapper<ApiClientsList>;
  ApiResource: ResolverTypeWrapper<ApiResource>;
  ApiScope: ResolverTypeWrapper<ApiScope>;
  AvardaConfig: ResolverTypeWrapper<AvardaConfig>;
  AvardaCredentials: ResolverTypeWrapper<AvardaCredentials>;
  AvardaShippingBroker: ResolverTypeWrapper<AvardaShippingBroker>;
  AvardaShippingBrokerShipping: ResolverTypeWrapper<AvardaShippingBrokerShipping>;
  AvardaShippingBrokerShippingIngrid: ResolverTypeWrapper<AvardaShippingBrokerShippingIngrid>;
  AvardaShippingBrokerShippingIngridCategory: ResolverTypeWrapper<AvardaShippingBrokerShippingIngridCategory>;
  AvardaShippingBrokerShippingIngridCategoryTag: ResolverTypeWrapper<AvardaShippingBrokerShippingIngridCategoryTag>;
  AvardaShippingBrokerShippingIngridLocation: ResolverTypeWrapper<AvardaShippingBrokerShippingIngridLocation>;
  AvardaShippingBrokerShippingIngridLocationAddress: ResolverTypeWrapper<AvardaShippingBrokerShippingIngridLocationAddress>;
  AvardaShippingBrokerShippingIngridPriceComponent: ResolverTypeWrapper<AvardaShippingBrokerShippingIngridPriceComponent>;
  BSGGiftCardConfig: ResolverTypeWrapper<BsgGiftCardConfig>;
  BSGGiftCardCredentials: ResolverTypeWrapper<BsgGiftCardCredentials>;
  BonusConfig: ResolverTypeWrapper<BonusConfig>;
  BonusCredentials: ResolverTypeWrapper<BonusCredentials>;
  BonusProvider: ResolverTypeWrapper<BonusProvider>;
  BonusProviderName: BonusProviderName;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Bundle: ResolverTypeWrapper<Bundle>;
  BundleGroup: ResolverTypeWrapper<BundleGroup>;
  BundleGroupSearchHit: ResolverTypeWrapper<BundleGroupSearchHit>;
  BundleGroupSearchHits: ResolverTypeWrapper<BundleGroupSearchHits>;
  BundleItemRule: ResolverTypeWrapper<BundleItemRule>;
  BundleOutcome: ResolverTypeWrapper<BundleOutcome>;
  BundleStoreMarket: ResolverTypeWrapper<BundleStoreMarket>;
  Campaign: ResolverTypeWrapper<Campaign>;
  CampaignDeletionResult: ResolverTypeWrapper<CampaignDeletionResult>;
  CampaignGroup: ResolverTypeWrapper<CampaignGroup>;
  CampaignGroupList: ResolverTypeWrapper<CampaignGroupList>;
  CampaignGroupSearchHit: ResolverTypeWrapper<CampaignGroupSearchHit>;
  CampaignGroupSearchHits: ResolverTypeWrapper<CampaignGroupSearchHits>;
  CampaignIdentity: ResolverTypeWrapper<CampaignIdentity>;
  CampaignMoney: ResolverTypeWrapper<CampaignMoney>;
  CampaignSearchHit: ResolverTypeWrapper<CampaignSearchHit>;
  CampaignSearchHits: ResolverTypeWrapper<CampaignSearchHits>;
  CampaignStoreMarket: ResolverTypeWrapper<CampaignStoreMarket>;
  CancellationBonus: ResolverTypeWrapper<CancellationBonus>;
  CancellationGiftCard: ResolverTypeWrapper<CancellationGiftCard>;
  CancellationGiftCardProduct: ResolverTypeWrapper<CancellationGiftCardProduct>;
  CancelledPayment: ResolverTypeWrapper<CancelledPayment>;
  Capabilities: ResolverTypeWrapper<Capabilities>;
  CapabilityProvider: ResolverTypeWrapper<CapabilityProvider>;
  CartCapabilities: ResolverTypeWrapper<CartCapabilities>;
  CartRuleOutcome: ResolverTypeWrapper<CartRuleOutcome>;
  ChannelType: ChannelType;
  CodeRuleOutcome: ResolverTypeWrapper<CodeRuleOutcome>;
  CodesGenerationSearchHit: ResolverTypeWrapper<CodesGenerationSearchHit>;
  CodesGenerationSearchHits: ResolverTypeWrapper<CodesGenerationSearchHits>;
  Comment: ResolverTypeWrapper<Comment>;
  CompanyAttribute: ResolverTypeWrapper<CompanyAttribute>;
  CompensationBonus: ResolverTypeWrapper<CompensationBonus>;
  CompensationFee: ResolverTypeWrapper<CompensationFee>;
  CompensationGiftCard: ResolverTypeWrapper<CompensationGiftCard>;
  CompensationOrderLine: ResolverTypeWrapper<CompensationOrderLine>;
  CompensationPayment: ResolverTypeWrapper<CompensationPayment>;
  CompensationShippingFee: ResolverTypeWrapper<CompensationShippingFee>;
  Condition: ResolverTypeWrapper<Condition>;
  CreateGenerateCodesResult: ResolverTypeWrapper<CreateGenerateCodesResult>;
  CurrencyRate: ResolverTypeWrapper<CurrencyRate>;
  CurrencyRates: ResolverTypeWrapper<CurrencyRates>;
  CustomOperation: CustomOperation;
  CustomPaymentConfig: ResolverTypeWrapper<CustomPaymentConfig>;
  CustomPaymentCredentials: ResolverTypeWrapper<CustomPaymentCredentials>;
  CustomReasonCode: ResolverTypeWrapper<CustomReasonCode>;
  CustomReasonCodes: ResolverTypeWrapper<CustomReasonCodes>;
  CustomState: ResolverTypeWrapper<CustomState>;
  CustomStateType: CustomStateType;
  CustomStates: ResolverTypeWrapper<CustomStates>;
  DeletedResult: ResolverTypeWrapper<DeletedResult>;
  DeliveryBonus: ResolverTypeWrapper<DeliveryBonus>;
  DeliveryCapture: ResolverTypeWrapper<DeliveryCapture>;
  DeliveryGift: ResolverTypeWrapper<DeliveryGift>;
  DeliveryGiftCard: ResolverTypeWrapper<DeliveryGiftCard>;
  DeliveryGiftCardProduct: ResolverTypeWrapper<DeliveryGiftCardProduct>;
  DeliveryOrderLine: ResolverTypeWrapper<DeliveryOrderLine>;
  DeliveryShippingFee: ResolverTypeWrapper<DeliveryShippingFee>;
  DeliveryTracking: ResolverTypeWrapper<DeliveryTracking>;
  DeliveryVoucher: ResolverTypeWrapper<DeliveryVoucher>;
  Dimensions: ResolverTypeWrapper<Dimensions>;
  DiscountCode: ResolverTypeWrapper<DiscountCode>;
  DiscountCodeRule: ResolverTypeWrapper<DiscountCodeRule>;
  DiscountCodeRuleSearchHit: ResolverTypeWrapper<DiscountCodeRuleSearchHit>;
  DiscountCodeRuleSearchHits: ResolverTypeWrapper<DiscountCodeRuleSearchHits>;
  DiscountCodeSearchHit: ResolverTypeWrapper<DiscountCodeSearchHit>;
  DiscountCodeSearchHits: ResolverTypeWrapper<DiscountCodeSearchHits>;
  DiscountExternalRule: ResolverTypeWrapper<DiscountExternalRule>;
  DiscountExternalRuleSearchHit: ResolverTypeWrapper<DiscountExternalRuleSearchHit>;
  DiscountExternalRuleSearchHits: ResolverTypeWrapper<DiscountExternalRuleSearchHits>;
  DiscountManagementQuotas: ResolverTypeWrapper<DiscountManagementQuotas>;
  DiscountRule: ResolverTypeWrapper<DiscountRule>;
  DiscountRuleSearchHit: ResolverTypeWrapper<DiscountRuleSearchHit>;
  DiscountRuleSearchHits: ResolverTypeWrapper<DiscountRuleSearchHits>;
  DiscountValue: ResolverTypeWrapper<DiscountValue>;
  DisplayName: ResolverTypeWrapper<DisplayName>;
  ExternalApi: ResolverTypeWrapper<ExternalApi>;
  ExternalEventDestinationAPI: ResolverTypeWrapper<ExternalEventDestinationApi>;
  ExternalEventDestinationAPIFilter: ResolverTypeWrapper<ExternalEventDestinationApiFilter>;
  ExternalEventDestinationAPIFilterPattern: ResolverTypeWrapper<ExternalEventDestinationApiFilterPattern>;
  ExternalEventDestinationAPIs: ResolverTypeWrapper<ExternalEventDestinationApIs>;
  ExternalEventDestinationEventBuses: ResolverTypeWrapper<ExternalEventDestinationEventBuses>;
  ExternalEventDestinationsDetails: ResolverTypeWrapper<ExternalEventDestinationsDetails>;
  ExternalEventRuleState: ResolverTypeWrapper<ExternalEventRuleState>;
  ExternalEventRules: ResolverTypeWrapper<ExternalEventRules>;
  ExternalPriceConfig: ResolverTypeWrapper<ExternalPriceConfig>;
  ExternalPriceCredentials: ResolverTypeWrapper<ExternalPriceCredentials>;
  ExternalPriceProvider: ResolverTypeWrapper<ExternalPriceProvider>;
  ExternalPriceProviderName: ExternalPriceProviderName;
  ExternalRuleOutcome: ResolverTypeWrapper<ExternalRuleOutcome>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GenerateCodes: ResolverTypeWrapper<GenerateCodes>;
  Gift: ResolverTypeWrapper<Gift>;
  GiftCardProductProvider: ResolverTypeWrapper<GiftCardProductProvider>;
  GiftCardProductProviderName: GiftCardProductProviderName;
  GiftCardProvider: ResolverTypeWrapper<GiftCardProvider>;
  GiftCardProviderName: GiftCardProviderName;
  Group: ResolverTypeWrapper<Group>;
  GroupDetails: ResolverTypeWrapper<GroupDetails>;
  GroupsList: ResolverTypeWrapper<GroupsList>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IdentityProvider: ResolverTypeWrapper<IdentityProvider>;
  IdentityProviderType: IdentityProviderType;
  IngridConfig: ResolverTypeWrapper<IngridConfig>;
  IngridCredentials: ResolverTypeWrapper<IngridCredentials>;
  IngridDelivery: ResolverTypeWrapper<IngridDelivery>;
  IngridDeliveryAddress: ResolverTypeWrapper<IngridDeliveryAddress>;
  InputActionBonus: InputActionBonus;
  InputActionGiftCard: InputActionGiftCard;
  InputActionGiftCardManual: InputActionGiftCardManual;
  InputActionPaymentCancellation: InputActionPaymentCancellation;
  InputActionPaymentCompensation: InputActionPaymentCompensation;
  InputActionPaymentDelivery: InputActionPaymentDelivery;
  InputActionPaymentOrderModificationOrderLines: InputActionPaymentOrderModificationOrderLines;
  InputActionPaymentOrderModificationShippingFees: InputActionPaymentOrderModificationShippingFees;
  InputActionPaymentRefund: InputActionPaymentRefund;
  InputActionPaymentRelease: InputActionPaymentRelease;
  InputActionShipping: InputActionShipping;
  InputActionType: InputActionType;
  InputAddExternalEventsDestinationAPI: InputAddExternalEventsDestinationApi;
  InputAddUserToGroup: InputAddUserToGroup;
  InputAdyenConfig: InputAdyenConfig;
  InputAdyenWebhookChange: InputAdyenWebhookChange;
  InputAvardaConfig: InputAvardaConfig;
  InputAvardaShippingBroker: InputAvardaShippingBroker;
  InputBSGGiftCardConfig: InputBsgGiftCardConfig;
  InputBonusConfig: InputBonusConfig;
  InputBundle: InputBundle;
  InputBundleItemRule: InputBundleItemRule;
  InputCampaign: InputCampaign;
  InputCampaignGroup: InputCampaignGroup;
  InputCampaignMoney: InputCampaignMoney;
  InputCampaignPeriod: InputCampaignPeriod;
  InputCapabilities: InputCapabilities;
  InputCapabilityProvider: InputCapabilityProvider;
  InputCartCapabilities: InputCartCapabilities;
  InputComment: InputComment;
  InputCondition: InputCondition;
  InputConditionType: InputConditionType;
  InputCreateApiClient: InputCreateApiClient;
  InputCreateGenerateCodes: InputCreateGenerateCodes;
  InputCreateOrUpdateBundleGroup: InputCreateOrUpdateBundleGroup;
  InputCreateOrUpdateDiscountCode: InputCreateOrUpdateDiscountCode;
  InputCreateOrUpdateDiscountCodeRule: InputCreateOrUpdateDiscountCodeRule;
  InputCreateOrUpdateDiscountExternalRule: InputCreateOrUpdateDiscountExternalRule;
  InputCreateOrUpdateDiscountRule: InputCreateOrUpdateDiscountRule;
  InputCreateOrUpdateOidcIdentityProvider: InputCreateOrUpdateOidcIdentityProvider;
  InputCreateStoreGroup: InputCreateStoreGroup;
  InputCreateStoreMarket: InputCreateStoreMarket;
  InputCreateUser: InputCreateUser;
  InputCustomPaymentConfig: InputCustomPaymentConfig;
  InputCustomReasonCode: InputCustomReasonCode;
  InputCustomState: InputCustomState;
  InputDiscountValue: InputDiscountValue;
  InputDiscountValueType: InputDiscountValueType;
  InputDisplayName: InputDisplayName;
  InputExternalEventsApiKeyAuth: InputExternalEventsApiKeyAuth;
  InputExternalEventsBasicAuth: InputExternalEventsBasicAuth;
  InputExternalPriceConfig: InputExternalPriceConfig;
  InputGift: InputGift;
  InputGiftCardProductSelection: InputGiftCardProductSelection;
  InputIngridConfig: InputIngridConfig;
  InputInventory: InputInventory;
  InputInventoryAddress: InputInventoryAddress;
  InputInventoryProductVariantStock: InputInventoryProductVariantStock;
  InputItemRule: InputItemRule;
  InputKBSGiftCardConfig: InputKbsGiftCardConfig;
  InputKlarnaCheckoutConfig: InputKlarnaCheckoutConfig;
  InputLedyerConfig: InputLedyerConfig;
  InputLogicHolder: InputLogicHolder;
  InputMarketRoundingRule: InputMarketRoundingRule;
  InputMoney: InputMoney;
  InputNShiftConfig: InputNShiftConfig;
  InputOrderAddressesModification: InputOrderAddressesModification;
  InputOrderCancellation: InputOrderCancellation;
  InputOrderCompensation: InputOrderCompensation;
  InputOrderCompensationBonus: InputOrderCompensationBonus;
  InputOrderCompensationFee: InputOrderCompensationFee;
  InputOrderCompensationGiftCard: InputOrderCompensationGiftCard;
  InputOrderCompensationPayment: InputOrderCompensationPayment;
  InputOrderDelivery: InputOrderDelivery;
  InputOrderGiftSelection: InputOrderGiftSelection;
  InputOrderLineCompensation: InputOrderLineCompensation;
  InputOrderLineModification: InputOrderLineModification;
  InputOrderLineSelection: InputOrderLineSelection;
  InputOrderModificationAddresses: InputOrderModificationAddresses;
  InputOrderModificationOrderLines: InputOrderModificationOrderLines;
  InputOrderModificationOrderLinesStart: InputOrderModificationOrderLinesStart;
  InputOrderModificationShippingFees: InputOrderModificationShippingFees;
  InputOrderModificationShippingFeesStart: InputOrderModificationShippingFeesStart;
  InputOrderRefund: InputOrderRefund;
  InputOrderRefundFee: InputOrderRefundFee;
  InputOrderRelease: InputOrderRelease;
  InputOrderShippingFeeCompensation: InputOrderShippingFeeCompensation;
  InputOrderStartCancellation: InputOrderStartCancellation;
  InputOrderStartCompensation: InputOrderStartCompensation;
  InputOrderStartDelivery: InputOrderStartDelivery;
  InputOrderStartRefund: InputOrderStartRefund;
  InputOrderStartRelease: InputOrderStartRelease;
  InputOrderWorkflow: InputOrderWorkflow;
  InputOutcome: InputOutcome;
  InputOutcomeType: InputOutcomeType;
  InputPriceRule: InputPriceRule;
  InputPriceRuleType: InputPriceRuleType;
  InputProductVariantRules: InputProductVariantRules;
  InputProductVariantStockConfig: InputProductVariantStockConfig;
  InputProvider: InputProvider;
  InputQliroOneConfig: InputQliroOneConfig;
  InputQliroOneIntegratedShipping: InputQliroOneIntegratedShipping;
  InputReason: InputReason;
  InputRemoveUserFromGroup: InputRemoveUserFromGroup;
  InputRetain24Config: InputRetain24Config;
  InputRoundingRule: InputRoundingRule;
  InputRoundingRules: InputRoundingRules;
  InputShippingFeeModification: InputShippingFeeModification;
  InputStoreMarket: InputStoreMarket;
  InputSubOutcome: InputSubOutcome;
  InputSveaCheckoutConfig: InputSveaCheckoutConfig;
  InputTagCondition: InputTagCondition;
  InputTagConditionMode: InputTagConditionMode;
  InputTaxGroup: InputTaxGroup;
  InputTaxJarConfig: InputTaxJarConfig;
  InputTaxMarket: InputTaxMarket;
  InputUpdateApiClient: InputUpdateApiClient;
  InputUpdateExternalEventsDestinationAPI: InputUpdateExternalEventsDestinationApi;
  InputUpdateStoreGroup: InputUpdateStoreGroup;
  InputUpdateStoreMarket: InputUpdateStoreMarket;
  InputUpdateUser: InputUpdateUser;
  InputValidDateRange: InputValidDateRange;
  InputVoyadoConfig: InputVoyadoConfig;
  InputWalleyCheckoutConfig: InputWalleyCheckoutConfig;
  InputZaverConfig: InputZaverConfig;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Inventory: ResolverTypeWrapper<Inventory>;
  InventoryAddress: ResolverTypeWrapper<InventoryAddress>;
  InventoryProductVariantStock: ResolverTypeWrapper<InventoryProductVariantStock>;
  InventoryProductVariantStockConfig: ResolverTypeWrapper<InventoryProductVariantStockConfig>;
  InventoryStoreMarket: ResolverTypeWrapper<InventoryStoreMarket>;
  InventoryStoreMarketInventories: ResolverTypeWrapper<InventoryStoreMarketInventories>;
  ItemRule: ResolverTypeWrapper<ItemRule>;
  KBSGiftCardConfig: ResolverTypeWrapper<KbsGiftCardConfig>;
  KBSGiftCardCredentials: ResolverTypeWrapper<KbsGiftCardCredentials>;
  KeyValue: ResolverTypeWrapper<KeyValue>;
  KlarnaCheckoutConfig: ResolverTypeWrapper<KlarnaCheckoutConfig>;
  KlarnaCredentials: ResolverTypeWrapper<KlarnaCredentials>;
  KlarnaShippingAssistantAddon: ResolverTypeWrapper<KlarnaShippingAssistantAddon>;
  KlarnaShippingAssistantAddress: ResolverTypeWrapper<KlarnaShippingAssistantAddress>;
  KlarnaShippingAssistantCarrierProduct: ResolverTypeWrapper<KlarnaShippingAssistantCarrierProduct>;
  KlarnaShippingAssistantLocation: ResolverTypeWrapper<KlarnaShippingAssistantLocation>;
  KlarnaShippingAssistantLocationTimeslot: ResolverTypeWrapper<KlarnaShippingAssistantLocationTimeslot>;
  KlarnaShippingAssistantSelectedShippingOption: ResolverTypeWrapper<KlarnaShippingAssistantSelectedShippingOption>;
  LedyerConfig: ResolverTypeWrapper<LedyerConfig>;
  LedyerCredentials: ResolverTypeWrapper<LedyerCredentials>;
  LogicHolder: ResolverTypeWrapper<LogicHolder>;
  MarketPrice: ResolverTypeWrapper<MarketPrice>;
  MarketRoundingRule: ResolverTypeWrapper<MarketRoundingRule>;
  Money: ResolverTypeWrapper<Money>;
  Mutation: ResolverTypeWrapper<{}>;
  MutationOrderManagement: ResolverTypeWrapper<Omit<MutationOrderManagement, 'createOrderModificationAddresses' | 'createOrderModificationOrderLines' | 'createOrderModificationShippingFees' | 'updateOrderModificationAddresses' | 'updateOrderModificationOrderLines' | 'updateOrderModificationShippingFees'> & { createOrderModificationAddresses: ResolversTypes['OrderModificationAddresses'], createOrderModificationOrderLines: ResolversTypes['OrderModificationOrderLines'], createOrderModificationShippingFees: ResolversTypes['OrderModificationShippingFees'], updateOrderModificationAddresses: ResolversTypes['OrderModificationAddresses'], updateOrderModificationOrderLines: ResolversTypes['OrderModificationOrderLines'], updateOrderModificationShippingFees: ResolversTypes['OrderModificationShippingFees'] }>;
  NShiftConfig: ResolverTypeWrapper<NShiftConfig>;
  NShiftCredentials: ResolverTypeWrapper<NShiftCredentials>;
  NshiftAddress: ResolverTypeWrapper<NshiftAddress>;
  NshiftPreparedShipment: ResolverTypeWrapper<NshiftPreparedShipment>;
  NshiftService: ResolverTypeWrapper<NshiftService>;
  OperationResult: ResolverTypeWrapper<OperationResult>;
  Order: ResolverTypeWrapper<Omit<Order, 'GiftCard' | 'GiftCardProduct' | 'Modifications' | 'Payment' | 'Promotion' | 'Shipping' | 'Voucher' | 'totals'> & { GiftCard: ResolversTypes['OrderGiftCard'], GiftCardProduct: ResolversTypes['OrderGiftCardProduct'], Modifications: Array<ResolversTypes['OrderModification']>, Payment: ResolversTypes['OrderPayment'], Promotion: ResolversTypes['OrderPromotion'], Shipping: ResolversTypes['OrderShipping'], Voucher: ResolversTypes['OrderVoucher'], totals: ResolversTypes['OrderTotals'] }>;
  OrderAddress: ResolverTypeWrapper<OrderAddress>;
  OrderAddressesModification: ResolverTypeWrapper<Omit<OrderAddressesModification, 'data'> & { data: ResolversTypes['OrderAddressesModificationData'] }>;
  OrderAddressesModificationData: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderAddressesModificationData']>;
  OrderAddressesModificationSearchHit: ResolverTypeWrapper<OrderAddressesModificationSearchHit>;
  OrderAddressesModificationType: OrderAddressesModificationType;
  OrderAddressesModificationUpdateData: ResolverTypeWrapper<OrderAddressesModificationUpdateData>;
  OrderAddressesModificationUpdateDataAddress: ResolverTypeWrapper<OrderAddressesModificationUpdateDataAddress>;
  OrderAttributes: ResolverTypeWrapper<OrderAttributes>;
  OrderBonus: ResolverTypeWrapper<OrderBonus>;
  OrderBundle: ResolverTypeWrapper<OrderBundle>;
  OrderCancellation: ResolverTypeWrapper<OrderCancellation>;
  OrderCancellationSearchBonus: ResolverTypeWrapper<OrderCancellationSearchBonus>;
  OrderCancellationSearchGiftCard: ResolverTypeWrapper<OrderCancellationSearchGiftCard>;
  OrderCancellationSearchGiftCardProduct: ResolverTypeWrapper<OrderCancellationSearchGiftCardProduct>;
  OrderCancellationSearchHit: ResolverTypeWrapper<OrderCancellationSearchHit>;
  OrderCancellationSearchPayment: ResolverTypeWrapper<OrderCancellationSearchPayment>;
  OrderComment: ResolverTypeWrapper<OrderComment>;
  OrderCompensation: ResolverTypeWrapper<OrderCompensation>;
  OrderCompensationSearchHit: ResolverTypeWrapper<OrderCompensationSearchHit>;
  OrderCompensationSearchHits: ResolverTypeWrapper<OrderCompensationSearchHits>;
  OrderCompensationSearchPayment: ResolverTypeWrapper<OrderCompensationSearchPayment>;
  OrderCompensationSearchProviderStatus: ResolverTypeWrapper<OrderCompensationSearchProviderStatus>;
  OrderCompensationSearchProviderStatusHistory: ResolverTypeWrapper<OrderCompensationSearchProviderStatusHistory>;
  OrderCompensationSearchTotals: ResolverTypeWrapper<OrderCompensationSearchTotals>;
  OrderCompensationTotals: ResolverTypeWrapper<OrderCompensationTotals>;
  OrderCustomState: ResolverTypeWrapper<OrderCustomState>;
  OrderDelivery: ResolverTypeWrapper<OrderDelivery>;
  OrderDeliverySearchHit: ResolverTypeWrapper<OrderDeliverySearchHit>;
  OrderDeliverySearchOrderLine: ResolverTypeWrapper<OrderDeliverySearchOrderLine>;
  OrderDeliverySearchShippingFee: ResolverTypeWrapper<OrderDeliverySearchShippingFee>;
  OrderDeliverySearchTrackingInfo: ResolverTypeWrapper<OrderDeliverySearchTrackingInfo>;
  OrderDeliveryTotals: ResolverTypeWrapper<OrderDeliveryTotals>;
  OrderDiscountCodeRule: ResolverTypeWrapper<OrderDiscountCodeRule>;
  OrderDiscountExternalRule: ResolverTypeWrapper<OrderDiscountExternalRule>;
  OrderDiscountOutcome: ResolverTypeWrapper<OrderDiscountOutcome>;
  OrderDiscountRule: ResolverTypeWrapper<OrderDiscountRule>;
  OrderGift: ResolverTypeWrapper<OrderGift>;
  OrderGiftCard: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderGiftCard']>;
  OrderGiftCardBSGGiftCard: ResolverTypeWrapper<OrderGiftCardBsgGiftCard>;
  OrderGiftCardEmpty: ResolverTypeWrapper<OrderGiftCardEmpty>;
  OrderGiftCardItemBSGGiftCard: ResolverTypeWrapper<OrderGiftCardItemBsgGiftCard>;
  OrderGiftCardItemKBSGiftCard: ResolverTypeWrapper<OrderGiftCardItemKbsGiftCard>;
  OrderGiftCardItemRetain24: ResolverTypeWrapper<OrderGiftCardItemRetain24>;
  OrderGiftCardKBSGiftCard: ResolverTypeWrapper<OrderGiftCardKbsGiftCard>;
  OrderGiftCardProduct: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderGiftCardProduct']>;
  OrderGiftCardProductEmpty: ResolverTypeWrapper<OrderGiftCardProductEmpty>;
  OrderGiftCardProductItem: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderGiftCardProductItem']>;
  OrderGiftCardProductItemRetain24: ResolverTypeWrapper<OrderGiftCardProductItemRetain24>;
  OrderGiftCardProductRetain24: ResolverTypeWrapper<OrderGiftCardProductRetain24>;
  OrderGiftCardRetain24: ResolverTypeWrapper<OrderGiftCardRetain24>;
  OrderHistory: ResolverTypeWrapper<OrderHistory>;
  OrderHistoryLogEntry: ResolverTypeWrapper<OrderHistoryLogEntry>;
  OrderHistoryOperations: ResolverTypeWrapper<OrderHistoryOperations>;
  OrderHistoryTransactionBonus: ResolverTypeWrapper<OrderHistoryTransactionBonus>;
  OrderHistoryTransactionGift: ResolverTypeWrapper<OrderHistoryTransactionGift>;
  OrderHistoryTransactionGiftCard: ResolverTypeWrapper<OrderHistoryTransactionGiftCard>;
  OrderHistoryTransactionGiftCardProduct: ResolverTypeWrapper<OrderHistoryTransactionGiftCardProduct>;
  OrderHistoryTransactionOrderLine: ResolverTypeWrapper<OrderHistoryTransactionOrderLine>;
  OrderHistoryTransactionPayment: ResolverTypeWrapper<OrderHistoryTransactionPayment>;
  OrderHistoryTransactionShippingFee: ResolverTypeWrapper<OrderHistoryTransactionShippingFee>;
  OrderHistoryTransactionVoucher: ResolverTypeWrapper<OrderHistoryTransactionVoucher>;
  OrderHistoryTransactions: ResolverTypeWrapper<OrderHistoryTransactions>;
  OrderHistoryTransactionsCompensated: ResolverTypeWrapper<OrderHistoryTransactionsCompensated>;
  OrderLine: ResolverTypeWrapper<OrderLine>;
  OrderLineBase: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderLineBase']>;
  OrderLineCampaign: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderLineCampaign']>;
  OrderLineCreate: ResolverTypeWrapper<Omit<OrderLineCreate, 'campaign'> & { campaign?: Maybe<ResolversTypes['OrderLineCampaign']> }>;
  OrderLineData: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderLineData']>;
  OrderLineDelete: ResolverTypeWrapper<Omit<OrderLineDelete, 'campaign'> & { campaign?: Maybe<ResolversTypes['OrderLineCampaign']> }>;
  OrderLineDimensions: ResolverTypeWrapper<OrderLineDimensions>;
  OrderLineDiscountOutcome: ResolverTypeWrapper<OrderLineDiscountOutcome>;
  OrderLineModification: ResolverTypeWrapper<Omit<OrderLineModification, 'data'> & { data: ResolversTypes['OrderLineModificationData'] }>;
  OrderLineModificationCreateData: ResolverTypeWrapper<OrderLineModificationCreateData>;
  OrderLineModificationData: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderLineModificationData']>;
  OrderLineModificationDeleteData: ResolverTypeWrapper<OrderLineModificationDeleteData>;
  OrderLineModificationType: OrderLineModificationType;
  OrderLineModificationUpdateData: ResolverTypeWrapper<OrderLineModificationUpdateData>;
  OrderLineModificationUpdateDataPrice: ResolverTypeWrapper<OrderLineModificationUpdateDataPrice>;
  OrderLineOption: ResolverTypeWrapper<OrderLineOption>;
  OrderLineUpdate: ResolverTypeWrapper<Omit<OrderLineUpdate, 'campaign'> & { campaign?: Maybe<ResolversTypes['OrderLineCampaign']> }>;
  OrderLineUpdatePrice: ResolverTypeWrapper<OrderLineUpdatePrice>;
  OrderModification: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderModification']>;
  OrderModificationAddresses: ResolverTypeWrapper<Omit<OrderModificationAddresses, 'addresses'> & { addresses: ResolversTypes['OrderAddressesModification'] }>;
  OrderModificationOrderLines: ResolverTypeWrapper<Omit<OrderModificationOrderLines, 'newTotals' | 'oldTotals' | 'orderLines'> & { newTotals?: Maybe<ResolversTypes['OrderTotals']>, oldTotals?: Maybe<ResolversTypes['OrderTotals']>, orderLines: Array<ResolversTypes['OrderLineModification']> }>;
  OrderModificationShippingFees: ResolverTypeWrapper<Omit<OrderModificationShippingFees, 'newTotals' | 'oldTotals' | 'shippingFees'> & { newTotals?: Maybe<ResolversTypes['OrderTotals']>, oldTotals?: Maybe<ResolversTypes['OrderTotals']>, shippingFees: Array<ResolversTypes['ShippingFeeModification']> }>;
  OrderModificationType: OrderModificationType;
  OrderOperationAddressData: ResolverTypeWrapper<OrderOperationAddressData>;
  OrderOperationAddressModification: ResolverTypeWrapper<OrderOperationAddressModification>;
  OrderOperationAddressModificationUpdateAddress: ResolverTypeWrapper<OrderOperationAddressModificationUpdateAddress>;
  OrderOperationResult: ResolverTypeWrapper<OrderOperationResult>;
  OrderOperationSearchActor: ResolverTypeWrapper<OrderOperationSearchActor>;
  OrderOperationSearchBonus: ResolverTypeWrapper<OrderOperationSearchBonus>;
  OrderOperationSearchFee: ResolverTypeWrapper<OrderOperationSearchFee>;
  OrderOperationSearchGift: ResolverTypeWrapper<OrderOperationSearchGift>;
  OrderOperationSearchGiftCard: ResolverTypeWrapper<OrderOperationSearchGiftCard>;
  OrderOperationSearchHit: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderOperationSearchHit']>;
  OrderOperationSearchHits: ResolverTypeWrapper<Omit<OrderOperationSearchHits, 'hits'> & { hits: Array<ResolversTypes['OrderOperationSearchHit']> }>;
  OrderOperationSearchOrderLine: ResolverTypeWrapper<OrderOperationSearchOrderLine>;
  OrderOperationSearchProvider: ResolverTypeWrapper<OrderOperationSearchProvider>;
  OrderOperationSearchReason: ResolverTypeWrapper<OrderOperationSearchReason>;
  OrderOperationSearchShippingFee: ResolverTypeWrapper<OrderOperationSearchShippingFee>;
  OrderOrderLinesModificationSearchHit: ResolverTypeWrapper<Omit<OrderOrderLinesModificationSearchHit, 'orderLines'> & { orderLines: Array<ResolversTypes['OrderOrderLinesModificationSearchOrderLine']> }>;
  OrderOrderLinesModificationSearchOrderLine: ResolverTypeWrapper<Omit<OrderOrderLinesModificationSearchOrderLine, 'data' | 'prev'> & { data?: Maybe<ResolversTypes['OrderLineData']>, prev?: Maybe<ResolversTypes['OrderLineData']> }>;
  OrderPayment: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderPayment']>;
  OrderPaymentAdyen: ResolverTypeWrapper<OrderPaymentAdyen>;
  OrderPaymentAvarda: ResolverTypeWrapper<OrderPaymentAvarda>;
  OrderPaymentBrinkZeroPayment: ResolverTypeWrapper<OrderPaymentBrinkZeroPayment>;
  OrderPaymentBrinkZeroPaymentOriginalProvider: ResolverTypeWrapper<OrderPaymentBrinkZeroPaymentOriginalProvider>;
  OrderPaymentCustomPayment: ResolverTypeWrapper<OrderPaymentCustomPayment>;
  OrderPaymentKlarnaCheckout: ResolverTypeWrapper<OrderPaymentKlarnaCheckout>;
  OrderPaymentLedyer: ResolverTypeWrapper<OrderPaymentLedyer>;
  OrderPaymentQliroOne: ResolverTypeWrapper<OrderPaymentQliroOne>;
  OrderPaymentQliroOneOrderItem: ResolverTypeWrapper<OrderPaymentQliroOneOrderItem>;
  OrderPaymentQliroOneUpsell: ResolverTypeWrapper<OrderPaymentQliroOneUpsell>;
  OrderPaymentQliroOneUpsellItems: ResolverTypeWrapper<OrderPaymentQliroOneUpsellItems>;
  OrderPaymentQliroOneUpsellTotals: ResolverTypeWrapper<OrderPaymentQliroOneUpsellTotals>;
  OrderPaymentSveaCheckout: ResolverTypeWrapper<OrderPaymentSveaCheckout>;
  OrderPaymentWalleyCheckout: ResolverTypeWrapper<OrderPaymentWalleyCheckout>;
  OrderPaymentZaver: ResolverTypeWrapper<OrderPaymentZaver>;
  OrderPromotion: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderPromotion']>;
  OrderPromotionEmpty: ResolverTypeWrapper<OrderPromotionEmpty>;
  OrderPromotionItemVoyado: ResolverTypeWrapper<OrderPromotionItemVoyado>;
  OrderPromotionVoyado: ResolverTypeWrapper<OrderPromotionVoyado>;
  OrderRefund: ResolverTypeWrapper<OrderRefund>;
  OrderRefundSearchGiftCardProduct: ResolverTypeWrapper<OrderRefundSearchGiftCardProduct>;
  OrderRefundSearchHit: ResolverTypeWrapper<OrderRefundSearchHit>;
  OrderRefundSearchPayment: ResolverTypeWrapper<OrderRefundSearchPayment>;
  OrderRefundSearchTotals: ResolverTypeWrapper<OrderRefundSearchTotals>;
  OrderRefundTotals: ResolverTypeWrapper<OrderRefundTotals>;
  OrderRelease: ResolverTypeWrapper<OrderRelease>;
  OrderReleaseSearchGiftCardProduct: ResolverTypeWrapper<OrderReleaseSearchGiftCardProduct>;
  OrderReleaseSearchHit: ResolverTypeWrapper<OrderReleaseSearchHit>;
  OrderReleaseSearchPayment: ResolverTypeWrapper<OrderReleaseSearchPayment>;
  OrderReleaseSearchTotals: ResolverTypeWrapper<OrderReleaseSearchTotals>;
  OrderReservation: ResolverTypeWrapper<OrderReservation>;
  OrderSearchHit: ResolverTypeWrapper<Omit<OrderSearchHit, 'totals'> & { totals: ResolversTypes['OrderTotals'] }>;
  OrderSearchHits: ResolverTypeWrapper<Omit<OrderSearchHits, 'hits'> & { hits: Array<ResolversTypes['OrderSearchHit']> }>;
  OrderShipping: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderShipping']>;
  OrderShippingAvardaShippingBroker: ResolverTypeWrapper<OrderShippingAvardaShippingBroker>;
  OrderShippingEmpty: ResolverTypeWrapper<OrderShippingEmpty>;
  OrderShippingFeesModificationSearchHit: ResolverTypeWrapper<OrderShippingFeesModificationSearchHit>;
  OrderShippingFeesModificationSearchShippingFee: ResolverTypeWrapper<OrderShippingFeesModificationSearchShippingFee>;
  OrderShippingIngrid: ResolverTypeWrapper<OrderShippingIngrid>;
  OrderShippingKlarnaShippingAssistant: ResolverTypeWrapper<OrderShippingKlarnaShippingAssistant>;
  OrderShippingNshift: ResolverTypeWrapper<OrderShippingNshift>;
  OrderShippingQliroIntegratedShipping: ResolverTypeWrapper<OrderShippingQliroIntegratedShipping>;
  OrderShippingWalleyDeliveryModule: ResolverTypeWrapper<OrderShippingWalleyDeliveryModule>;
  OrderState: OrderState;
  OrderStatus: ResolverTypeWrapper<OrderStatus>;
  OrderTotals: ResolverTypeWrapper<OrderTotals>;
  OrderVoucher: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderVoucher']>;
  OrderVoucherEmpty: ResolverTypeWrapper<OrderVoucherEmpty>;
  OrderVoucherItemVoyado: ResolverTypeWrapper<OrderVoucherItemVoyado>;
  OrderVoucherVoyado: ResolverTypeWrapper<OrderVoucherVoyado>;
  OrderWorkflow: ResolverTypeWrapper<OrderWorkflow>;
  OrderWorkflowExecution: ResolverTypeWrapper<OrderWorkflowExecution>;
  OrderWorkflowExecutionNode: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderWorkflowExecutionNode']>;
  OrderWorkflowExecutionNodeAction: ResolverTypeWrapper<Omit<OrderWorkflowExecutionNodeAction, 'do' | 'then'> & { do: ResolversTypes['OrderWorkflowNodeActionDo'], then: Array<ResolversTypes['OrderWorkflowExecutionNode']> }>;
  OrderWorkflowExecutionNodeBranch: ResolverTypeWrapper<Omit<OrderWorkflowExecutionNodeBranch, 'branches' | 'otherwise'> & { branches: Array<ResolversTypes['OrderWorkflowExecutionNodeBranchCondition']>, otherwise: Array<ResolversTypes['OrderWorkflowExecutionNode']> }>;
  OrderWorkflowExecutionNodeBranchCondition: ResolverTypeWrapper<Omit<OrderWorkflowExecutionNodeBranchCondition, 'check' | 'then'> & { check: ResolversTypes['OrderWorkflowNodeConditionCheck'], then: Array<ResolversTypes['OrderWorkflowExecutionNode']> }>;
  OrderWorkflowExecutionNodeCondition: ResolverTypeWrapper<Omit<OrderWorkflowExecutionNodeCondition, 'check' | 'otherwise' | 'then'> & { check: ResolversTypes['OrderWorkflowNodeConditionCheck'], otherwise: Array<ResolversTypes['OrderWorkflowExecutionNode']>, then: Array<ResolversTypes['OrderWorkflowExecutionNode']> }>;
  OrderWorkflowExecutionNodeTrigger: ResolverTypeWrapper<OrderWorkflowExecutionNodeTrigger>;
  OrderWorkflowExecutionNodeType: OrderWorkflowExecutionNodeType;
  OrderWorkflowExecutionSearchHit: ResolverTypeWrapper<OrderWorkflowExecutionSearchHit>;
  OrderWorkflowExecutionSearchHits: ResolverTypeWrapper<OrderWorkflowExecutionSearchHits>;
  OrderWorkflowNode: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderWorkflowNode']>;
  OrderWorkflowNodeAction: ResolverTypeWrapper<Omit<OrderWorkflowNodeAction, 'do' | 'then'> & { do: ResolversTypes['OrderWorkflowNodeActionDo'], then: Array<ResolversTypes['OrderWorkflowNode']> }>;
  OrderWorkflowNodeActionDo: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderWorkflowNodeActionDo']>;
  OrderWorkflowNodeActionDoCancellation: ResolverTypeWrapper<OrderWorkflowNodeActionDoCancellation>;
  OrderWorkflowNodeActionDoCustomState: ResolverTypeWrapper<OrderWorkflowNodeActionDoCustomState>;
  OrderWorkflowNodeBranch: ResolverTypeWrapper<Omit<OrderWorkflowNodeBranch, 'branches' | 'otherwise'> & { branches: Array<ResolversTypes['OrderWorkflowNodeBranchCondition']>, otherwise: Array<ResolversTypes['OrderWorkflowNode']> }>;
  OrderWorkflowNodeBranchCondition: ResolverTypeWrapper<Omit<OrderWorkflowNodeBranchCondition, 'check' | 'then'> & { check: ResolversTypes['OrderWorkflowNodeConditionCheck'], then: Array<ResolversTypes['OrderWorkflowNode']> }>;
  OrderWorkflowNodeCondition: ResolverTypeWrapper<Omit<OrderWorkflowNodeCondition, 'check' | 'otherwise' | 'then'> & { check: ResolversTypes['OrderWorkflowNodeConditionCheck'], otherwise: Array<ResolversTypes['OrderWorkflowNode']>, then: Array<ResolversTypes['OrderWorkflowNode']> }>;
  OrderWorkflowNodeConditionCheck: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderWorkflowNodeConditionCheck']>;
  OrderWorkflowNodeConditionCheckAnd: ResolverTypeWrapper<Omit<OrderWorkflowNodeConditionCheckAnd, 'check1' | 'check2'> & { check1: ResolversTypes['OrderWorkflowNodeConditionCheck'], check2: ResolversTypes['OrderWorkflowNodeConditionCheck'] }>;
  OrderWorkflowNodeConditionCheckCustomHTTP: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckCustomHttp>;
  OrderWorkflowNodeConditionCheckOr: ResolverTypeWrapper<Omit<OrderWorkflowNodeConditionCheckOr, 'check1' | 'check2'> & { check1: ResolversTypes['OrderWorkflowNodeConditionCheck'], check2: ResolversTypes['OrderWorkflowNodeConditionCheck'] }>;
  OrderWorkflowNodeConditionCheckOrderDate: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderDate>;
  OrderWorkflowNodeConditionCheckOrderLineCampaign: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCampaign>;
  OrderWorkflowNodeConditionCheckOrderLineCampaignField: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCampaignField>;
  OrderWorkflowNodeConditionCheckOrderLineCampaignFields: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCampaignFields>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributes: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCustomAttributes>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue>;
  OrderWorkflowNodeConditionCheckOrderLineOptions: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineOptions>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKey: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineOptionsKey>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineOptionsValue>;
  OrderWorkflowNodeConditionCheckOrderLineProductParentId: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineProductParentId>;
  OrderWorkflowNodeConditionCheckOrderLineProductVariantId: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineProductVariantId>;
  OrderWorkflowNodeConditionCheckOrderLineTags: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineTags>;
  OrderWorkflowNodeConditionCheckOrderLineTagsKey: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineTagsKey>;
  OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue>;
  OrderWorkflowNodeConditionCheckOrderLineTagsValue: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderLineTagsValue>;
  OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal>;
  OrderWorkflowNodeConditionCheckPaymentProviderMethod: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckPaymentProviderMethod>;
  OrderWorkflowNodeConditionCheckPaymentProviderName: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckPaymentProviderName>;
  OrderWorkflowNodeConditionCheckPaymentProviderStatus: ResolverTypeWrapper<OrderWorkflowNodeConditionCheckPaymentProviderStatus>;
  OrderWorkflowNodeConditionCheckType: OrderWorkflowNodeConditionCheckType;
  OrderWorkflowNodeConditionComparisonType: OrderWorkflowNodeConditionComparisonType;
  OrderWorkflowNodeDoActionType: OrderWorkflowNodeDoActionType;
  OrderWorkflowNodeType: OrderWorkflowNodeType;
  OrderWorkflowRevision: ResolverTypeWrapper<OrderWorkflowRevision>;
  OrderWorkflowSearchHit: ResolverTypeWrapper<OrderWorkflowSearchHit>;
  OrderWorkflowSearchHits: ResolverTypeWrapper<OrderWorkflowSearchHits>;
  OrderWorkflowTrigger: ResolverTypeWrapper<OrderWorkflowTrigger>;
  OrderWorkflowTriggerType: OrderWorkflowTriggerType;
  OrderWorkflowTriggers: ResolverTypeWrapper<OrderWorkflowTriggers>;
  Outcome: ResolverTypeWrapper<Outcome>;
  PaymentProvider: ResolverTypeWrapper<PaymentProvider>;
  PaymentProviderName: PaymentProviderName;
  PlatformConfig: ResolverTypeWrapper<PlatformConfig>;
  Price: ResolverTypeWrapper<Price>;
  PriceRecord: ResolverTypeWrapper<PriceRecord>;
  PriceRule: ResolverTypeWrapper<PriceRule>;
  ProductParent: ResolverTypeWrapper<ProductParent>;
  ProductParentSearchHit: ResolverTypeWrapper<ProductParentSearchHit>;
  ProductParentSearchHits: ResolverTypeWrapper<ProductParentSearchHits>;
  ProductVariant: ResolverTypeWrapper<ProductVariant>;
  ProductVariantReservation: ResolverTypeWrapper<ProductVariantReservation>;
  ProductVariantRules: ResolverTypeWrapper<ProductVariantRules>;
  ProductVariantSearchHit: ResolverTypeWrapper<ProductVariantSearchHit>;
  ProductVariantSearchHits: ResolverTypeWrapper<ProductVariantSearchHits>;
  PromotionProvider: ResolverTypeWrapper<PromotionProvider>;
  PromotionProviderName: PromotionProviderName;
  Provider: ResolverTypeWrapper<Provider>;
  ProviderStatusLog: ResolverTypeWrapper<ProviderStatusLog>;
  ProviderStatusLogEntry: ResolverTypeWrapper<ProviderStatusLogEntry>;
  QliroIngrid: ResolverTypeWrapper<QliroIngrid>;
  QliroIngridDelivery: ResolverTypeWrapper<QliroIngridDelivery>;
  QliroIngridDeliveryAddress: ResolverTypeWrapper<QliroIngridDeliveryAddress>;
  QliroOneConfig: ResolverTypeWrapper<QliroOneConfig>;
  QliroOneCredentials: ResolverTypeWrapper<QliroOneCredentials>;
  QliroOneIntegratedShipping: ResolverTypeWrapper<QliroOneIntegratedShipping>;
  QliroShipmentOrderItem: ResolverTypeWrapper<QliroShipmentOrderItem>;
  QliroShipmentOrderItemMetadata: ResolverTypeWrapper<QliroShipmentOrderItemMetadata>;
  Query: ResolverTypeWrapper<{}>;
  QueryConfigurationManagement: ResolverTypeWrapper<QueryConfigurationManagement>;
  QueryConfigurationManagementValidate: ResolverTypeWrapper<QueryConfigurationManagementValidate>;
  QueryOrderManagement: ResolverTypeWrapper<Omit<QueryOrderManagement, 'details' | 'orderModificationAddresses' | 'orderModificationOrderLines' | 'orderModificationShippingFees'> & { details: ResolversTypes['Order'], orderModificationAddresses?: Maybe<ResolversTypes['OrderModificationAddresses']>, orderModificationOrderLines?: Maybe<ResolversTypes['OrderModificationOrderLines']>, orderModificationShippingFees?: Maybe<ResolversTypes['OrderModificationShippingFees']> }>;
  QueryPlatformConfig: ResolverTypeWrapper<QueryPlatformConfig>;
  QueryProductManagement: ResolverTypeWrapper<QueryProductManagement>;
  QuotaPeriod: QuotaPeriod;
  Reason: ResolverTypeWrapper<Reason>;
  RefundBonus: ResolverTypeWrapper<RefundBonus>;
  RefundFee: ResolverTypeWrapper<RefundFee>;
  RefundGift: ResolverTypeWrapper<RefundGift>;
  RefundGiftCard: ResolverTypeWrapper<RefundGiftCard>;
  RefundGiftCardProduct: ResolverTypeWrapper<RefundGiftCardProduct>;
  RefundOrderLine: ResolverTypeWrapper<RefundOrderLine>;
  RefundShippingFee: ResolverTypeWrapper<RefundShippingFee>;
  RefundVoucher: ResolverTypeWrapper<RefundVoucher>;
  RefundedPayment: ResolverTypeWrapper<RefundedPayment>;
  ReleaseBonus: ResolverTypeWrapper<ReleaseBonus>;
  ReleaseGift: ResolverTypeWrapper<ReleaseGift>;
  ReleaseGiftCard: ResolverTypeWrapper<ReleaseGiftCard>;
  ReleaseGiftCardProduct: ResolverTypeWrapper<ReleaseGiftCardProduct>;
  ReleaseOrderLine: ResolverTypeWrapper<ReleaseOrderLine>;
  ReleaseShippingFee: ResolverTypeWrapper<ReleaseShippingFee>;
  ReleasedPayment: ResolverTypeWrapper<ReleasedPayment>;
  Retain24Config: ResolverTypeWrapper<Retain24Config>;
  Retain24Credentials: ResolverTypeWrapper<Retain24Credentials>;
  RoundingRule: ResolverTypeWrapper<RoundingRule>;
  RoundingRules: ResolverTypeWrapper<RoundingRules>;
  Rule: ResolverTypeWrapper<Rule>;
  Schema: ResolverTypeWrapper<Omit<Schema, 'mutation' | 'query'> & { mutation?: Maybe<ResolversTypes['Mutation']>, query?: Maybe<ResolversTypes['Query']> }>;
  SearchSorting: SearchSorting;
  ShippingFee: ResolverTypeWrapper<ShippingFee>;
  ShippingFeeData: ResolverTypeWrapper<ShippingFeeData>;
  ShippingFeeModification: ResolverTypeWrapper<Omit<ShippingFeeModification, 'data'> & { data: ResolversTypes['ShippingFeeModificationData'] }>;
  ShippingFeeModificationData: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ShippingFeeModificationData']>;
  ShippingFeeModificationType: ShippingFeeModificationType;
  ShippingFeeModificationUpdateData: ResolverTypeWrapper<ShippingFeeModificationUpdateData>;
  ShippingFeeModificationUpdateDataPrice: ResolverTypeWrapper<ShippingFeeModificationUpdateDataPrice>;
  ShippingFeeUpdatePrice: ResolverTypeWrapper<ShippingFeeUpdatePrice>;
  ShippingProvider: ResolverTypeWrapper<ShippingProvider>;
  ShippingProviderName: ShippingProviderName;
  ShippingTaxGroup: ResolverTypeWrapper<ShippingTaxGroup>;
  ShopperInsightsSearchHit: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ShopperInsightsSearchHit']>;
  ShopperInsightsSearchHitAddress: ResolverTypeWrapper<ShopperInsightsSearchHitAddress>;
  ShopperInsightsSearchHitAttributes: ResolverTypeWrapper<ShopperInsightsSearchHitAttributes>;
  ShopperInsightsSearchHitAttributesCompany: ResolverTypeWrapper<ShopperInsightsSearchHitAttributesCompany>;
  ShopperInsightsSearchHitBundle: ResolverTypeWrapper<ShopperInsightsSearchHitBundle>;
  ShopperInsightsSearchHitCampaign: ResolverTypeWrapper<ShopperInsightsSearchHitCampaign>;
  ShopperInsightsSearchHitCheckout: ResolverTypeWrapper<ShopperInsightsSearchHitCheckout>;
  ShopperInsightsSearchHitCheckoutGiftCard: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutGiftCard>;
  ShopperInsightsSearchHitCheckoutItem: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutItem>;
  ShopperInsightsSearchHitCheckoutPaymentStatus: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutPaymentStatus>;
  ShopperInsightsSearchHitCheckoutPaymentStatusLog: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutPaymentStatusLog>;
  ShopperInsightsSearchHitCheckoutProvider: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutProvider>;
  ShopperInsightsSearchHitCheckoutProviders: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutProviders>;
  ShopperInsightsSearchHitCheckoutShippingOption: ResolverTypeWrapper<ShopperInsightsSearchHitCheckoutShippingOption>;
  ShopperInsightsSearchHitGift: ResolverTypeWrapper<ShopperInsightsSearchHitGift>;
  ShopperInsightsSearchHitOrder: ResolverTypeWrapper<ShopperInsightsSearchHitOrder>;
  ShopperInsightsSearchHitOrderBonus: ResolverTypeWrapper<ShopperInsightsSearchHitOrderBonus>;
  ShopperInsightsSearchHitOrderCheckoutProviders: ResolverTypeWrapper<ShopperInsightsSearchHitOrderCheckoutProviders>;
  ShopperInsightsSearchHitOrderGiftCard: ResolverTypeWrapper<ShopperInsightsSearchHitOrderGiftCard>;
  ShopperInsightsSearchHitOrderGiftCardProduct: ResolverTypeWrapper<ShopperInsightsSearchHitOrderGiftCardProduct>;
  ShopperInsightsSearchHitOrderLine: ResolverTypeWrapper<ShopperInsightsSearchHitOrderLine>;
  ShopperInsightsSearchHitOrderPayment: ResolverTypeWrapper<ShopperInsightsSearchHitOrderPayment>;
  ShopperInsightsSearchHitOrderPromotion: ResolverTypeWrapper<ShopperInsightsSearchHitOrderPromotion>;
  ShopperInsightsSearchHitOrderProvider: ResolverTypeWrapper<ShopperInsightsSearchHitOrderProvider>;
  ShopperInsightsSearchHitOrderSessionProviders: ResolverTypeWrapper<ShopperInsightsSearchHitOrderSessionProviders>;
  ShopperInsightsSearchHitOrderShipping: ResolverTypeWrapper<ShopperInsightsSearchHitOrderShipping>;
  ShopperInsightsSearchHitOrderShippingFee: ResolverTypeWrapper<ShopperInsightsSearchHitOrderShippingFee>;
  ShopperInsightsSearchHitOrderTotals: ResolverTypeWrapper<ShopperInsightsSearchHitOrderTotals>;
  ShopperInsightsSearchHitOrderVoucher: ResolverTypeWrapper<ShopperInsightsSearchHitOrderVoucher>;
  ShopperInsightsSearchHitSession: ResolverTypeWrapper<ShopperInsightsSearchHitSession>;
  ShopperInsightsSearchHitSessionItem: ResolverTypeWrapper<ShopperInsightsSearchHitSessionItem>;
  ShopperInsightsSearchHitSessionLock: ResolverTypeWrapper<ShopperInsightsSearchHitSessionLock>;
  ShopperInsightsSearchHitSessionProvider: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProvider>;
  ShopperInsightsSearchHitSessionProviderBonus: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProviderBonus>;
  ShopperInsightsSearchHitSessionProviderGiftCardProduct: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProviderGiftCardProduct>;
  ShopperInsightsSearchHitSessionProviderPromotion: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProviderPromotion>;
  ShopperInsightsSearchHitSessionProviderVoucher: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProviderVoucher>;
  ShopperInsightsSearchHitSessionProviders: ResolverTypeWrapper<ShopperInsightsSearchHitSessionProviders>;
  ShopperInsightsSearchHitTag: ResolverTypeWrapper<ShopperInsightsSearchHitTag>;
  ShopperInsightsSearchHits: ResolverTypeWrapper<Omit<ShopperInsightsSearchHits, 'hits'> & { hits: Array<ResolversTypes['ShopperInsightsSearchHit']> }>;
  SortOrder: SortOrder;
  Stock: ResolverTypeWrapper<Stock>;
  StockInventory: ResolverTypeWrapper<StockInventory>;
  StoreGroup: ResolverTypeWrapper<StoreGroup>;
  StoreGroupPrice: ResolverTypeWrapper<StoreGroupPrice>;
  StoreGroupSearchHit: ResolverTypeWrapper<StoreGroupSearchHit>;
  StoreGroupSearchHits: ResolverTypeWrapper<StoreGroupSearchHits>;
  StoreMarket: ResolverTypeWrapper<StoreMarket>;
  StoreMarketSearchHit: ResolverTypeWrapper<StoreMarketSearchHit>;
  StoreMarketSearchHits: ResolverTypeWrapper<StoreMarketSearchHits>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubOutcome: ResolverTypeWrapper<SubOutcome>;
  Subscription: ResolverTypeWrapper<{}>;
  SveaCheckoutConfig: ResolverTypeWrapper<SveaCheckoutConfig>;
  SveaCredentials: ResolverTypeWrapper<SveaCredentials>;
  TagCondition: ResolverTypeWrapper<TagCondition>;
  TagKeys: ResolverTypeWrapper<TagKeys>;
  TagValues: ResolverTypeWrapper<TagValues>;
  TaxGroup: ResolverTypeWrapper<TaxGroup>;
  TaxGroupSearchHit: ResolverTypeWrapper<TaxGroupSearchHit>;
  TaxGroupSearchHits: ResolverTypeWrapper<TaxGroupSearchHits>;
  TaxJarConfig: ResolverTypeWrapper<TaxJarConfig>;
  TaxJarCredentials: ResolverTypeWrapper<TaxJarCredentials>;
  TaxMarket: ResolverTypeWrapper<TaxMarket>;
  TaxMarketSearchHit: ResolverTypeWrapper<TaxMarketSearchHit>;
  TaxMarketSearchHits: ResolverTypeWrapper<TaxMarketSearchHits>;
  UpdateExternalEventsDestinationAPIResult: ResolverTypeWrapper<UpdateExternalEventsDestinationApiResult>;
  UsagePlan: ResolverTypeWrapper<UsagePlan>;
  User: ResolverTypeWrapper<User>;
  UserDetails: ResolverTypeWrapper<UserDetails>;
  UserStatus: UserStatus;
  UsersList: ResolverTypeWrapper<UsersList>;
  ValidDateRange: ResolverTypeWrapper<ValidDateRange>;
  ValidateConfigResult: ResolverTypeWrapper<ValidateConfigResult>;
  VoucherProvider: ResolverTypeWrapper<VoucherProvider>;
  VoucherProviderName: VoucherProviderName;
  VoyadoConfig: ResolverTypeWrapper<VoyadoConfig>;
  VoyadoCredentials: ResolverTypeWrapper<VoyadoCredentials>;
  WalleyCheckoutConfig: ResolverTypeWrapper<WalleyCheckoutConfig>;
  WalleyCredentials: ResolverTypeWrapper<WalleyCredentials>;
  WalleyDeliveryModuleDeliveryDate: ResolverTypeWrapper<WalleyDeliveryModuleDeliveryDate>;
  WalleyDeliveryModuleDestination: ResolverTypeWrapper<WalleyDeliveryModuleDestination>;
  WalleyDeliveryModuleOption: ResolverTypeWrapper<WalleyDeliveryModuleOption>;
  WalleyDeliveryModuleShipment: ResolverTypeWrapper<WalleyDeliveryModuleShipment>;
  WalleyDeliveryModuleShipping: ResolverTypeWrapper<WalleyDeliveryModuleShipping>;
  WalleyDeliveryModuleShippingChoice: ResolverTypeWrapper<WalleyDeliveryModuleShippingChoice>;
  ZaverConfig: ResolverTypeWrapper<ZaverConfig>;
  ZaverCredentials: ResolverTypeWrapper<ZaverCredentials>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  Actor: Actor;
  AddExternalEventsDestinationAPIResult: AddExternalEventsDestinationApiResult;
  AddExternalEventsDestinationEventBusResult: AddExternalEventsDestinationEventBusResult;
  AddExternalEventsRuleResult: AddExternalEventsRuleResult;
  AdyenConfig: AdyenConfig;
  AdyenCredentials: AdyenCredentials;
  AdyenWebhook: AdyenWebhook;
  AdyenWebhookCredentials: AdyenWebhookCredentials;
  AdyenWebhookGenerationResult: AdyenWebhookGenerationResult;
  AdyenWebhookLegacy: AdyenWebhookLegacy;
  ApiClient: ApiClient;
  ApiClientDetails: ApiClientDetails;
  ApiClientsList: ApiClientsList;
  ApiResource: ApiResource;
  ApiScope: ApiScope;
  AvardaConfig: AvardaConfig;
  AvardaCredentials: AvardaCredentials;
  AvardaShippingBroker: AvardaShippingBroker;
  AvardaShippingBrokerShipping: AvardaShippingBrokerShipping;
  AvardaShippingBrokerShippingIngrid: AvardaShippingBrokerShippingIngrid;
  AvardaShippingBrokerShippingIngridCategory: AvardaShippingBrokerShippingIngridCategory;
  AvardaShippingBrokerShippingIngridCategoryTag: AvardaShippingBrokerShippingIngridCategoryTag;
  AvardaShippingBrokerShippingIngridLocation: AvardaShippingBrokerShippingIngridLocation;
  AvardaShippingBrokerShippingIngridLocationAddress: AvardaShippingBrokerShippingIngridLocationAddress;
  AvardaShippingBrokerShippingIngridPriceComponent: AvardaShippingBrokerShippingIngridPriceComponent;
  BSGGiftCardConfig: BsgGiftCardConfig;
  BSGGiftCardCredentials: BsgGiftCardCredentials;
  BonusConfig: BonusConfig;
  BonusCredentials: BonusCredentials;
  BonusProvider: BonusProvider;
  Boolean: Scalars['Boolean']['output'];
  Bundle: Bundle;
  BundleGroup: BundleGroup;
  BundleGroupSearchHit: BundleGroupSearchHit;
  BundleGroupSearchHits: BundleGroupSearchHits;
  BundleItemRule: BundleItemRule;
  BundleOutcome: BundleOutcome;
  BundleStoreMarket: BundleStoreMarket;
  Campaign: Campaign;
  CampaignDeletionResult: CampaignDeletionResult;
  CampaignGroup: CampaignGroup;
  CampaignGroupList: CampaignGroupList;
  CampaignGroupSearchHit: CampaignGroupSearchHit;
  CampaignGroupSearchHits: CampaignGroupSearchHits;
  CampaignIdentity: CampaignIdentity;
  CampaignMoney: CampaignMoney;
  CampaignSearchHit: CampaignSearchHit;
  CampaignSearchHits: CampaignSearchHits;
  CampaignStoreMarket: CampaignStoreMarket;
  CancellationBonus: CancellationBonus;
  CancellationGiftCard: CancellationGiftCard;
  CancellationGiftCardProduct: CancellationGiftCardProduct;
  CancelledPayment: CancelledPayment;
  Capabilities: Capabilities;
  CapabilityProvider: CapabilityProvider;
  CartCapabilities: CartCapabilities;
  CartRuleOutcome: CartRuleOutcome;
  CodeRuleOutcome: CodeRuleOutcome;
  CodesGenerationSearchHit: CodesGenerationSearchHit;
  CodesGenerationSearchHits: CodesGenerationSearchHits;
  Comment: Comment;
  CompanyAttribute: CompanyAttribute;
  CompensationBonus: CompensationBonus;
  CompensationFee: CompensationFee;
  CompensationGiftCard: CompensationGiftCard;
  CompensationOrderLine: CompensationOrderLine;
  CompensationPayment: CompensationPayment;
  CompensationShippingFee: CompensationShippingFee;
  Condition: Condition;
  CreateGenerateCodesResult: CreateGenerateCodesResult;
  CurrencyRate: CurrencyRate;
  CurrencyRates: CurrencyRates;
  CustomPaymentConfig: CustomPaymentConfig;
  CustomPaymentCredentials: CustomPaymentCredentials;
  CustomReasonCode: CustomReasonCode;
  CustomReasonCodes: CustomReasonCodes;
  CustomState: CustomState;
  CustomStates: CustomStates;
  DeletedResult: DeletedResult;
  DeliveryBonus: DeliveryBonus;
  DeliveryCapture: DeliveryCapture;
  DeliveryGift: DeliveryGift;
  DeliveryGiftCard: DeliveryGiftCard;
  DeliveryGiftCardProduct: DeliveryGiftCardProduct;
  DeliveryOrderLine: DeliveryOrderLine;
  DeliveryShippingFee: DeliveryShippingFee;
  DeliveryTracking: DeliveryTracking;
  DeliveryVoucher: DeliveryVoucher;
  Dimensions: Dimensions;
  DiscountCode: DiscountCode;
  DiscountCodeRule: DiscountCodeRule;
  DiscountCodeRuleSearchHit: DiscountCodeRuleSearchHit;
  DiscountCodeRuleSearchHits: DiscountCodeRuleSearchHits;
  DiscountCodeSearchHit: DiscountCodeSearchHit;
  DiscountCodeSearchHits: DiscountCodeSearchHits;
  DiscountExternalRule: DiscountExternalRule;
  DiscountExternalRuleSearchHit: DiscountExternalRuleSearchHit;
  DiscountExternalRuleSearchHits: DiscountExternalRuleSearchHits;
  DiscountManagementQuotas: DiscountManagementQuotas;
  DiscountRule: DiscountRule;
  DiscountRuleSearchHit: DiscountRuleSearchHit;
  DiscountRuleSearchHits: DiscountRuleSearchHits;
  DiscountValue: DiscountValue;
  DisplayName: DisplayName;
  ExternalApi: ExternalApi;
  ExternalEventDestinationAPI: ExternalEventDestinationApi;
  ExternalEventDestinationAPIFilter: ExternalEventDestinationApiFilter;
  ExternalEventDestinationAPIFilterPattern: ExternalEventDestinationApiFilterPattern;
  ExternalEventDestinationAPIs: ExternalEventDestinationApIs;
  ExternalEventDestinationEventBuses: ExternalEventDestinationEventBuses;
  ExternalEventDestinationsDetails: ExternalEventDestinationsDetails;
  ExternalEventRuleState: ExternalEventRuleState;
  ExternalEventRules: ExternalEventRules;
  ExternalPriceConfig: ExternalPriceConfig;
  ExternalPriceCredentials: ExternalPriceCredentials;
  ExternalPriceProvider: ExternalPriceProvider;
  ExternalRuleOutcome: ExternalRuleOutcome;
  Float: Scalars['Float']['output'];
  GenerateCodes: GenerateCodes;
  Gift: Gift;
  GiftCardProductProvider: GiftCardProductProvider;
  GiftCardProvider: GiftCardProvider;
  Group: Group;
  GroupDetails: GroupDetails;
  GroupsList: GroupsList;
  ID: Scalars['ID']['output'];
  IdentityProvider: IdentityProvider;
  IngridConfig: IngridConfig;
  IngridCredentials: IngridCredentials;
  IngridDelivery: IngridDelivery;
  IngridDeliveryAddress: IngridDeliveryAddress;
  InputActionBonus: InputActionBonus;
  InputActionGiftCard: InputActionGiftCard;
  InputActionGiftCardManual: InputActionGiftCardManual;
  InputActionPaymentCancellation: InputActionPaymentCancellation;
  InputActionPaymentCompensation: InputActionPaymentCompensation;
  InputActionPaymentDelivery: InputActionPaymentDelivery;
  InputActionPaymentOrderModificationOrderLines: InputActionPaymentOrderModificationOrderLines;
  InputActionPaymentOrderModificationShippingFees: InputActionPaymentOrderModificationShippingFees;
  InputActionPaymentRefund: InputActionPaymentRefund;
  InputActionPaymentRelease: InputActionPaymentRelease;
  InputActionShipping: InputActionShipping;
  InputAddExternalEventsDestinationAPI: InputAddExternalEventsDestinationApi;
  InputAddUserToGroup: InputAddUserToGroup;
  InputAdyenConfig: InputAdyenConfig;
  InputAdyenWebhookChange: InputAdyenWebhookChange;
  InputAvardaConfig: InputAvardaConfig;
  InputAvardaShippingBroker: InputAvardaShippingBroker;
  InputBSGGiftCardConfig: InputBsgGiftCardConfig;
  InputBonusConfig: InputBonusConfig;
  InputBundle: InputBundle;
  InputBundleItemRule: InputBundleItemRule;
  InputCampaign: InputCampaign;
  InputCampaignGroup: InputCampaignGroup;
  InputCampaignMoney: InputCampaignMoney;
  InputCampaignPeriod: InputCampaignPeriod;
  InputCapabilities: InputCapabilities;
  InputCapabilityProvider: InputCapabilityProvider;
  InputCartCapabilities: InputCartCapabilities;
  InputComment: InputComment;
  InputCondition: InputCondition;
  InputCreateApiClient: InputCreateApiClient;
  InputCreateGenerateCodes: InputCreateGenerateCodes;
  InputCreateOrUpdateBundleGroup: InputCreateOrUpdateBundleGroup;
  InputCreateOrUpdateDiscountCode: InputCreateOrUpdateDiscountCode;
  InputCreateOrUpdateDiscountCodeRule: InputCreateOrUpdateDiscountCodeRule;
  InputCreateOrUpdateDiscountExternalRule: InputCreateOrUpdateDiscountExternalRule;
  InputCreateOrUpdateDiscountRule: InputCreateOrUpdateDiscountRule;
  InputCreateOrUpdateOidcIdentityProvider: InputCreateOrUpdateOidcIdentityProvider;
  InputCreateStoreGroup: InputCreateStoreGroup;
  InputCreateStoreMarket: InputCreateStoreMarket;
  InputCreateUser: InputCreateUser;
  InputCustomPaymentConfig: InputCustomPaymentConfig;
  InputCustomReasonCode: InputCustomReasonCode;
  InputCustomState: InputCustomState;
  InputDiscountValue: InputDiscountValue;
  InputDisplayName: InputDisplayName;
  InputExternalEventsApiKeyAuth: InputExternalEventsApiKeyAuth;
  InputExternalEventsBasicAuth: InputExternalEventsBasicAuth;
  InputExternalPriceConfig: InputExternalPriceConfig;
  InputGift: InputGift;
  InputGiftCardProductSelection: InputGiftCardProductSelection;
  InputIngridConfig: InputIngridConfig;
  InputInventory: InputInventory;
  InputInventoryAddress: InputInventoryAddress;
  InputInventoryProductVariantStock: InputInventoryProductVariantStock;
  InputItemRule: InputItemRule;
  InputKBSGiftCardConfig: InputKbsGiftCardConfig;
  InputKlarnaCheckoutConfig: InputKlarnaCheckoutConfig;
  InputLedyerConfig: InputLedyerConfig;
  InputLogicHolder: InputLogicHolder;
  InputMarketRoundingRule: InputMarketRoundingRule;
  InputMoney: InputMoney;
  InputNShiftConfig: InputNShiftConfig;
  InputOrderAddressesModification: InputOrderAddressesModification;
  InputOrderCancellation: InputOrderCancellation;
  InputOrderCompensation: InputOrderCompensation;
  InputOrderCompensationBonus: InputOrderCompensationBonus;
  InputOrderCompensationFee: InputOrderCompensationFee;
  InputOrderCompensationGiftCard: InputOrderCompensationGiftCard;
  InputOrderCompensationPayment: InputOrderCompensationPayment;
  InputOrderDelivery: InputOrderDelivery;
  InputOrderGiftSelection: InputOrderGiftSelection;
  InputOrderLineCompensation: InputOrderLineCompensation;
  InputOrderLineModification: InputOrderLineModification;
  InputOrderLineSelection: InputOrderLineSelection;
  InputOrderModificationAddresses: InputOrderModificationAddresses;
  InputOrderModificationOrderLines: InputOrderModificationOrderLines;
  InputOrderModificationOrderLinesStart: InputOrderModificationOrderLinesStart;
  InputOrderModificationShippingFees: InputOrderModificationShippingFees;
  InputOrderModificationShippingFeesStart: InputOrderModificationShippingFeesStart;
  InputOrderRefund: InputOrderRefund;
  InputOrderRefundFee: InputOrderRefundFee;
  InputOrderRelease: InputOrderRelease;
  InputOrderShippingFeeCompensation: InputOrderShippingFeeCompensation;
  InputOrderStartCancellation: InputOrderStartCancellation;
  InputOrderStartCompensation: InputOrderStartCompensation;
  InputOrderStartDelivery: InputOrderStartDelivery;
  InputOrderStartRefund: InputOrderStartRefund;
  InputOrderStartRelease: InputOrderStartRelease;
  InputOrderWorkflow: InputOrderWorkflow;
  InputOutcome: InputOutcome;
  InputPriceRule: InputPriceRule;
  InputProductVariantRules: InputProductVariantRules;
  InputProductVariantStockConfig: InputProductVariantStockConfig;
  InputProvider: InputProvider;
  InputQliroOneConfig: InputQliroOneConfig;
  InputQliroOneIntegratedShipping: InputQliroOneIntegratedShipping;
  InputReason: InputReason;
  InputRemoveUserFromGroup: InputRemoveUserFromGroup;
  InputRetain24Config: InputRetain24Config;
  InputRoundingRule: InputRoundingRule;
  InputRoundingRules: InputRoundingRules;
  InputShippingFeeModification: InputShippingFeeModification;
  InputStoreMarket: InputStoreMarket;
  InputSubOutcome: InputSubOutcome;
  InputSveaCheckoutConfig: InputSveaCheckoutConfig;
  InputTagCondition: InputTagCondition;
  InputTaxGroup: InputTaxGroup;
  InputTaxJarConfig: InputTaxJarConfig;
  InputTaxMarket: InputTaxMarket;
  InputUpdateApiClient: InputUpdateApiClient;
  InputUpdateExternalEventsDestinationAPI: InputUpdateExternalEventsDestinationApi;
  InputUpdateStoreGroup: InputUpdateStoreGroup;
  InputUpdateStoreMarket: InputUpdateStoreMarket;
  InputUpdateUser: InputUpdateUser;
  InputValidDateRange: InputValidDateRange;
  InputVoyadoConfig: InputVoyadoConfig;
  InputWalleyCheckoutConfig: InputWalleyCheckoutConfig;
  InputZaverConfig: InputZaverConfig;
  Int: Scalars['Int']['output'];
  Inventory: Inventory;
  InventoryAddress: InventoryAddress;
  InventoryProductVariantStock: InventoryProductVariantStock;
  InventoryProductVariantStockConfig: InventoryProductVariantStockConfig;
  InventoryStoreMarket: InventoryStoreMarket;
  InventoryStoreMarketInventories: InventoryStoreMarketInventories;
  ItemRule: ItemRule;
  KBSGiftCardConfig: KbsGiftCardConfig;
  KBSGiftCardCredentials: KbsGiftCardCredentials;
  KeyValue: KeyValue;
  KlarnaCheckoutConfig: KlarnaCheckoutConfig;
  KlarnaCredentials: KlarnaCredentials;
  KlarnaShippingAssistantAddon: KlarnaShippingAssistantAddon;
  KlarnaShippingAssistantAddress: KlarnaShippingAssistantAddress;
  KlarnaShippingAssistantCarrierProduct: KlarnaShippingAssistantCarrierProduct;
  KlarnaShippingAssistantLocation: KlarnaShippingAssistantLocation;
  KlarnaShippingAssistantLocationTimeslot: KlarnaShippingAssistantLocationTimeslot;
  KlarnaShippingAssistantSelectedShippingOption: KlarnaShippingAssistantSelectedShippingOption;
  LedyerConfig: LedyerConfig;
  LedyerCredentials: LedyerCredentials;
  LogicHolder: LogicHolder;
  MarketPrice: MarketPrice;
  MarketRoundingRule: MarketRoundingRule;
  Money: Money;
  Mutation: {};
  MutationOrderManagement: Omit<MutationOrderManagement, 'createOrderModificationAddresses' | 'createOrderModificationOrderLines' | 'createOrderModificationShippingFees' | 'updateOrderModificationAddresses' | 'updateOrderModificationOrderLines' | 'updateOrderModificationShippingFees'> & { createOrderModificationAddresses: ResolversParentTypes['OrderModificationAddresses'], createOrderModificationOrderLines: ResolversParentTypes['OrderModificationOrderLines'], createOrderModificationShippingFees: ResolversParentTypes['OrderModificationShippingFees'], updateOrderModificationAddresses: ResolversParentTypes['OrderModificationAddresses'], updateOrderModificationOrderLines: ResolversParentTypes['OrderModificationOrderLines'], updateOrderModificationShippingFees: ResolversParentTypes['OrderModificationShippingFees'] };
  NShiftConfig: NShiftConfig;
  NShiftCredentials: NShiftCredentials;
  NshiftAddress: NshiftAddress;
  NshiftPreparedShipment: NshiftPreparedShipment;
  NshiftService: NshiftService;
  OperationResult: OperationResult;
  Order: Omit<Order, 'GiftCard' | 'GiftCardProduct' | 'Modifications' | 'Payment' | 'Promotion' | 'Shipping' | 'Voucher' | 'totals'> & { GiftCard: ResolversParentTypes['OrderGiftCard'], GiftCardProduct: ResolversParentTypes['OrderGiftCardProduct'], Modifications: Array<ResolversParentTypes['OrderModification']>, Payment: ResolversParentTypes['OrderPayment'], Promotion: ResolversParentTypes['OrderPromotion'], Shipping: ResolversParentTypes['OrderShipping'], Voucher: ResolversParentTypes['OrderVoucher'], totals: ResolversParentTypes['OrderTotals'] };
  OrderAddress: OrderAddress;
  OrderAddressesModification: Omit<OrderAddressesModification, 'data'> & { data: ResolversParentTypes['OrderAddressesModificationData'] };
  OrderAddressesModificationData: ResolversInterfaceTypes<ResolversParentTypes>['OrderAddressesModificationData'];
  OrderAddressesModificationSearchHit: OrderAddressesModificationSearchHit;
  OrderAddressesModificationUpdateData: OrderAddressesModificationUpdateData;
  OrderAddressesModificationUpdateDataAddress: OrderAddressesModificationUpdateDataAddress;
  OrderAttributes: OrderAttributes;
  OrderBonus: OrderBonus;
  OrderBundle: OrderBundle;
  OrderCancellation: OrderCancellation;
  OrderCancellationSearchBonus: OrderCancellationSearchBonus;
  OrderCancellationSearchGiftCard: OrderCancellationSearchGiftCard;
  OrderCancellationSearchGiftCardProduct: OrderCancellationSearchGiftCardProduct;
  OrderCancellationSearchHit: OrderCancellationSearchHit;
  OrderCancellationSearchPayment: OrderCancellationSearchPayment;
  OrderComment: OrderComment;
  OrderCompensation: OrderCompensation;
  OrderCompensationSearchHit: OrderCompensationSearchHit;
  OrderCompensationSearchHits: OrderCompensationSearchHits;
  OrderCompensationSearchPayment: OrderCompensationSearchPayment;
  OrderCompensationSearchProviderStatus: OrderCompensationSearchProviderStatus;
  OrderCompensationSearchProviderStatusHistory: OrderCompensationSearchProviderStatusHistory;
  OrderCompensationSearchTotals: OrderCompensationSearchTotals;
  OrderCompensationTotals: OrderCompensationTotals;
  OrderCustomState: OrderCustomState;
  OrderDelivery: OrderDelivery;
  OrderDeliverySearchHit: OrderDeliverySearchHit;
  OrderDeliverySearchOrderLine: OrderDeliverySearchOrderLine;
  OrderDeliverySearchShippingFee: OrderDeliverySearchShippingFee;
  OrderDeliverySearchTrackingInfo: OrderDeliverySearchTrackingInfo;
  OrderDeliveryTotals: OrderDeliveryTotals;
  OrderDiscountCodeRule: OrderDiscountCodeRule;
  OrderDiscountExternalRule: OrderDiscountExternalRule;
  OrderDiscountOutcome: OrderDiscountOutcome;
  OrderDiscountRule: OrderDiscountRule;
  OrderGift: OrderGift;
  OrderGiftCard: ResolversInterfaceTypes<ResolversParentTypes>['OrderGiftCard'];
  OrderGiftCardBSGGiftCard: OrderGiftCardBsgGiftCard;
  OrderGiftCardEmpty: OrderGiftCardEmpty;
  OrderGiftCardItemBSGGiftCard: OrderGiftCardItemBsgGiftCard;
  OrderGiftCardItemKBSGiftCard: OrderGiftCardItemKbsGiftCard;
  OrderGiftCardItemRetain24: OrderGiftCardItemRetain24;
  OrderGiftCardKBSGiftCard: OrderGiftCardKbsGiftCard;
  OrderGiftCardProduct: ResolversInterfaceTypes<ResolversParentTypes>['OrderGiftCardProduct'];
  OrderGiftCardProductEmpty: OrderGiftCardProductEmpty;
  OrderGiftCardProductItem: ResolversInterfaceTypes<ResolversParentTypes>['OrderGiftCardProductItem'];
  OrderGiftCardProductItemRetain24: OrderGiftCardProductItemRetain24;
  OrderGiftCardProductRetain24: OrderGiftCardProductRetain24;
  OrderGiftCardRetain24: OrderGiftCardRetain24;
  OrderHistory: OrderHistory;
  OrderHistoryLogEntry: OrderHistoryLogEntry;
  OrderHistoryOperations: OrderHistoryOperations;
  OrderHistoryTransactionBonus: OrderHistoryTransactionBonus;
  OrderHistoryTransactionGift: OrderHistoryTransactionGift;
  OrderHistoryTransactionGiftCard: OrderHistoryTransactionGiftCard;
  OrderHistoryTransactionGiftCardProduct: OrderHistoryTransactionGiftCardProduct;
  OrderHistoryTransactionOrderLine: OrderHistoryTransactionOrderLine;
  OrderHistoryTransactionPayment: OrderHistoryTransactionPayment;
  OrderHistoryTransactionShippingFee: OrderHistoryTransactionShippingFee;
  OrderHistoryTransactionVoucher: OrderHistoryTransactionVoucher;
  OrderHistoryTransactions: OrderHistoryTransactions;
  OrderHistoryTransactionsCompensated: OrderHistoryTransactionsCompensated;
  OrderLine: OrderLine;
  OrderLineBase: ResolversInterfaceTypes<ResolversParentTypes>['OrderLineBase'];
  OrderLineCampaign: ResolversInterfaceTypes<ResolversParentTypes>['OrderLineCampaign'];
  OrderLineCreate: Omit<OrderLineCreate, 'campaign'> & { campaign?: Maybe<ResolversParentTypes['OrderLineCampaign']> };
  OrderLineData: ResolversUnionTypes<ResolversParentTypes>['OrderLineData'];
  OrderLineDelete: Omit<OrderLineDelete, 'campaign'> & { campaign?: Maybe<ResolversParentTypes['OrderLineCampaign']> };
  OrderLineDimensions: OrderLineDimensions;
  OrderLineDiscountOutcome: OrderLineDiscountOutcome;
  OrderLineModification: Omit<OrderLineModification, 'data'> & { data: ResolversParentTypes['OrderLineModificationData'] };
  OrderLineModificationCreateData: OrderLineModificationCreateData;
  OrderLineModificationData: ResolversInterfaceTypes<ResolversParentTypes>['OrderLineModificationData'];
  OrderLineModificationDeleteData: OrderLineModificationDeleteData;
  OrderLineModificationUpdateData: OrderLineModificationUpdateData;
  OrderLineModificationUpdateDataPrice: OrderLineModificationUpdateDataPrice;
  OrderLineOption: OrderLineOption;
  OrderLineUpdate: Omit<OrderLineUpdate, 'campaign'> & { campaign?: Maybe<ResolversParentTypes['OrderLineCampaign']> };
  OrderLineUpdatePrice: OrderLineUpdatePrice;
  OrderModification: ResolversInterfaceTypes<ResolversParentTypes>['OrderModification'];
  OrderModificationAddresses: Omit<OrderModificationAddresses, 'addresses'> & { addresses: ResolversParentTypes['OrderAddressesModification'] };
  OrderModificationOrderLines: Omit<OrderModificationOrderLines, 'newTotals' | 'oldTotals' | 'orderLines'> & { newTotals?: Maybe<ResolversParentTypes['OrderTotals']>, oldTotals?: Maybe<ResolversParentTypes['OrderTotals']>, orderLines: Array<ResolversParentTypes['OrderLineModification']> };
  OrderModificationShippingFees: Omit<OrderModificationShippingFees, 'newTotals' | 'oldTotals' | 'shippingFees'> & { newTotals?: Maybe<ResolversParentTypes['OrderTotals']>, oldTotals?: Maybe<ResolversParentTypes['OrderTotals']>, shippingFees: Array<ResolversParentTypes['ShippingFeeModification']> };
  OrderOperationAddressData: OrderOperationAddressData;
  OrderOperationAddressModification: OrderOperationAddressModification;
  OrderOperationAddressModificationUpdateAddress: OrderOperationAddressModificationUpdateAddress;
  OrderOperationResult: OrderOperationResult;
  OrderOperationSearchActor: OrderOperationSearchActor;
  OrderOperationSearchBonus: OrderOperationSearchBonus;
  OrderOperationSearchFee: OrderOperationSearchFee;
  OrderOperationSearchGift: OrderOperationSearchGift;
  OrderOperationSearchGiftCard: OrderOperationSearchGiftCard;
  OrderOperationSearchHit: ResolversInterfaceTypes<ResolversParentTypes>['OrderOperationSearchHit'];
  OrderOperationSearchHits: Omit<OrderOperationSearchHits, 'hits'> & { hits: Array<ResolversParentTypes['OrderOperationSearchHit']> };
  OrderOperationSearchOrderLine: OrderOperationSearchOrderLine;
  OrderOperationSearchProvider: OrderOperationSearchProvider;
  OrderOperationSearchReason: OrderOperationSearchReason;
  OrderOperationSearchShippingFee: OrderOperationSearchShippingFee;
  OrderOrderLinesModificationSearchHit: Omit<OrderOrderLinesModificationSearchHit, 'orderLines'> & { orderLines: Array<ResolversParentTypes['OrderOrderLinesModificationSearchOrderLine']> };
  OrderOrderLinesModificationSearchOrderLine: Omit<OrderOrderLinesModificationSearchOrderLine, 'data' | 'prev'> & { data?: Maybe<ResolversParentTypes['OrderLineData']>, prev?: Maybe<ResolversParentTypes['OrderLineData']> };
  OrderPayment: ResolversInterfaceTypes<ResolversParentTypes>['OrderPayment'];
  OrderPaymentAdyen: OrderPaymentAdyen;
  OrderPaymentAvarda: OrderPaymentAvarda;
  OrderPaymentBrinkZeroPayment: OrderPaymentBrinkZeroPayment;
  OrderPaymentBrinkZeroPaymentOriginalProvider: OrderPaymentBrinkZeroPaymentOriginalProvider;
  OrderPaymentCustomPayment: OrderPaymentCustomPayment;
  OrderPaymentKlarnaCheckout: OrderPaymentKlarnaCheckout;
  OrderPaymentLedyer: OrderPaymentLedyer;
  OrderPaymentQliroOne: OrderPaymentQliroOne;
  OrderPaymentQliroOneOrderItem: OrderPaymentQliroOneOrderItem;
  OrderPaymentQliroOneUpsell: OrderPaymentQliroOneUpsell;
  OrderPaymentQliroOneUpsellItems: OrderPaymentQliroOneUpsellItems;
  OrderPaymentQliroOneUpsellTotals: OrderPaymentQliroOneUpsellTotals;
  OrderPaymentSveaCheckout: OrderPaymentSveaCheckout;
  OrderPaymentWalleyCheckout: OrderPaymentWalleyCheckout;
  OrderPaymentZaver: OrderPaymentZaver;
  OrderPromotion: ResolversInterfaceTypes<ResolversParentTypes>['OrderPromotion'];
  OrderPromotionEmpty: OrderPromotionEmpty;
  OrderPromotionItemVoyado: OrderPromotionItemVoyado;
  OrderPromotionVoyado: OrderPromotionVoyado;
  OrderRefund: OrderRefund;
  OrderRefundSearchGiftCardProduct: OrderRefundSearchGiftCardProduct;
  OrderRefundSearchHit: OrderRefundSearchHit;
  OrderRefundSearchPayment: OrderRefundSearchPayment;
  OrderRefundSearchTotals: OrderRefundSearchTotals;
  OrderRefundTotals: OrderRefundTotals;
  OrderRelease: OrderRelease;
  OrderReleaseSearchGiftCardProduct: OrderReleaseSearchGiftCardProduct;
  OrderReleaseSearchHit: OrderReleaseSearchHit;
  OrderReleaseSearchPayment: OrderReleaseSearchPayment;
  OrderReleaseSearchTotals: OrderReleaseSearchTotals;
  OrderReservation: OrderReservation;
  OrderSearchHit: Omit<OrderSearchHit, 'totals'> & { totals: ResolversParentTypes['OrderTotals'] };
  OrderSearchHits: Omit<OrderSearchHits, 'hits'> & { hits: Array<ResolversParentTypes['OrderSearchHit']> };
  OrderShipping: ResolversInterfaceTypes<ResolversParentTypes>['OrderShipping'];
  OrderShippingAvardaShippingBroker: OrderShippingAvardaShippingBroker;
  OrderShippingEmpty: OrderShippingEmpty;
  OrderShippingFeesModificationSearchHit: OrderShippingFeesModificationSearchHit;
  OrderShippingFeesModificationSearchShippingFee: OrderShippingFeesModificationSearchShippingFee;
  OrderShippingIngrid: OrderShippingIngrid;
  OrderShippingKlarnaShippingAssistant: OrderShippingKlarnaShippingAssistant;
  OrderShippingNshift: OrderShippingNshift;
  OrderShippingQliroIntegratedShipping: OrderShippingQliroIntegratedShipping;
  OrderShippingWalleyDeliveryModule: OrderShippingWalleyDeliveryModule;
  OrderStatus: OrderStatus;
  OrderTotals: OrderTotals;
  OrderVoucher: ResolversInterfaceTypes<ResolversParentTypes>['OrderVoucher'];
  OrderVoucherEmpty: OrderVoucherEmpty;
  OrderVoucherItemVoyado: OrderVoucherItemVoyado;
  OrderVoucherVoyado: OrderVoucherVoyado;
  OrderWorkflow: OrderWorkflow;
  OrderWorkflowExecution: OrderWorkflowExecution;
  OrderWorkflowExecutionNode: ResolversInterfaceTypes<ResolversParentTypes>['OrderWorkflowExecutionNode'];
  OrderWorkflowExecutionNodeAction: Omit<OrderWorkflowExecutionNodeAction, 'do' | 'then'> & { do: ResolversParentTypes['OrderWorkflowNodeActionDo'], then: Array<ResolversParentTypes['OrderWorkflowExecutionNode']> };
  OrderWorkflowExecutionNodeBranch: Omit<OrderWorkflowExecutionNodeBranch, 'branches' | 'otherwise'> & { branches: Array<ResolversParentTypes['OrderWorkflowExecutionNodeBranchCondition']>, otherwise: Array<ResolversParentTypes['OrderWorkflowExecutionNode']> };
  OrderWorkflowExecutionNodeBranchCondition: Omit<OrderWorkflowExecutionNodeBranchCondition, 'check' | 'then'> & { check: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], then: Array<ResolversParentTypes['OrderWorkflowExecutionNode']> };
  OrderWorkflowExecutionNodeCondition: Omit<OrderWorkflowExecutionNodeCondition, 'check' | 'otherwise' | 'then'> & { check: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], otherwise: Array<ResolversParentTypes['OrderWorkflowExecutionNode']>, then: Array<ResolversParentTypes['OrderWorkflowExecutionNode']> };
  OrderWorkflowExecutionNodeTrigger: OrderWorkflowExecutionNodeTrigger;
  OrderWorkflowExecutionSearchHit: OrderWorkflowExecutionSearchHit;
  OrderWorkflowExecutionSearchHits: OrderWorkflowExecutionSearchHits;
  OrderWorkflowNode: ResolversInterfaceTypes<ResolversParentTypes>['OrderWorkflowNode'];
  OrderWorkflowNodeAction: Omit<OrderWorkflowNodeAction, 'do' | 'then'> & { do: ResolversParentTypes['OrderWorkflowNodeActionDo'], then: Array<ResolversParentTypes['OrderWorkflowNode']> };
  OrderWorkflowNodeActionDo: ResolversInterfaceTypes<ResolversParentTypes>['OrderWorkflowNodeActionDo'];
  OrderWorkflowNodeActionDoCancellation: OrderWorkflowNodeActionDoCancellation;
  OrderWorkflowNodeActionDoCustomState: OrderWorkflowNodeActionDoCustomState;
  OrderWorkflowNodeBranch: Omit<OrderWorkflowNodeBranch, 'branches' | 'otherwise'> & { branches: Array<ResolversParentTypes['OrderWorkflowNodeBranchCondition']>, otherwise: Array<ResolversParentTypes['OrderWorkflowNode']> };
  OrderWorkflowNodeBranchCondition: Omit<OrderWorkflowNodeBranchCondition, 'check' | 'then'> & { check: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], then: Array<ResolversParentTypes['OrderWorkflowNode']> };
  OrderWorkflowNodeCondition: Omit<OrderWorkflowNodeCondition, 'check' | 'otherwise' | 'then'> & { check: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], otherwise: Array<ResolversParentTypes['OrderWorkflowNode']>, then: Array<ResolversParentTypes['OrderWorkflowNode']> };
  OrderWorkflowNodeConditionCheck: ResolversInterfaceTypes<ResolversParentTypes>['OrderWorkflowNodeConditionCheck'];
  OrderWorkflowNodeConditionCheckAnd: Omit<OrderWorkflowNodeConditionCheckAnd, 'check1' | 'check2'> & { check1: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], check2: ResolversParentTypes['OrderWorkflowNodeConditionCheck'] };
  OrderWorkflowNodeConditionCheckCustomHTTP: OrderWorkflowNodeConditionCheckCustomHttp;
  OrderWorkflowNodeConditionCheckOr: Omit<OrderWorkflowNodeConditionCheckOr, 'check1' | 'check2'> & { check1: ResolversParentTypes['OrderWorkflowNodeConditionCheck'], check2: ResolversParentTypes['OrderWorkflowNodeConditionCheck'] };
  OrderWorkflowNodeConditionCheckOrderDate: OrderWorkflowNodeConditionCheckOrderDate;
  OrderWorkflowNodeConditionCheckOrderLineCampaign: OrderWorkflowNodeConditionCheckOrderLineCampaign;
  OrderWorkflowNodeConditionCheckOrderLineCampaignField: OrderWorkflowNodeConditionCheckOrderLineCampaignField;
  OrderWorkflowNodeConditionCheckOrderLineCampaignFields: OrderWorkflowNodeConditionCheckOrderLineCampaignFields;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributes: OrderWorkflowNodeConditionCheckOrderLineCustomAttributes;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue;
  OrderWorkflowNodeConditionCheckOrderLineOptions: OrderWorkflowNodeConditionCheckOrderLineOptions;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKey: OrderWorkflowNodeConditionCheckOrderLineOptionsKey;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue: OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue;
  OrderWorkflowNodeConditionCheckOrderLineOptionsValue: OrderWorkflowNodeConditionCheckOrderLineOptionsValue;
  OrderWorkflowNodeConditionCheckOrderLineProductParentId: OrderWorkflowNodeConditionCheckOrderLineProductParentId;
  OrderWorkflowNodeConditionCheckOrderLineProductVariantId: OrderWorkflowNodeConditionCheckOrderLineProductVariantId;
  OrderWorkflowNodeConditionCheckOrderLineTags: OrderWorkflowNodeConditionCheckOrderLineTags;
  OrderWorkflowNodeConditionCheckOrderLineTagsKey: OrderWorkflowNodeConditionCheckOrderLineTagsKey;
  OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue: OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue;
  OrderWorkflowNodeConditionCheckOrderLineTagsValue: OrderWorkflowNodeConditionCheckOrderLineTagsValue;
  OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal: OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal;
  OrderWorkflowNodeConditionCheckPaymentProviderMethod: OrderWorkflowNodeConditionCheckPaymentProviderMethod;
  OrderWorkflowNodeConditionCheckPaymentProviderName: OrderWorkflowNodeConditionCheckPaymentProviderName;
  OrderWorkflowNodeConditionCheckPaymentProviderStatus: OrderWorkflowNodeConditionCheckPaymentProviderStatus;
  OrderWorkflowRevision: OrderWorkflowRevision;
  OrderWorkflowSearchHit: OrderWorkflowSearchHit;
  OrderWorkflowSearchHits: OrderWorkflowSearchHits;
  OrderWorkflowTrigger: OrderWorkflowTrigger;
  OrderWorkflowTriggers: OrderWorkflowTriggers;
  Outcome: Outcome;
  PaymentProvider: PaymentProvider;
  PlatformConfig: PlatformConfig;
  Price: Price;
  PriceRecord: PriceRecord;
  PriceRule: PriceRule;
  ProductParent: ProductParent;
  ProductParentSearchHit: ProductParentSearchHit;
  ProductParentSearchHits: ProductParentSearchHits;
  ProductVariant: ProductVariant;
  ProductVariantReservation: ProductVariantReservation;
  ProductVariantRules: ProductVariantRules;
  ProductVariantSearchHit: ProductVariantSearchHit;
  ProductVariantSearchHits: ProductVariantSearchHits;
  PromotionProvider: PromotionProvider;
  Provider: Provider;
  ProviderStatusLog: ProviderStatusLog;
  ProviderStatusLogEntry: ProviderStatusLogEntry;
  QliroIngrid: QliroIngrid;
  QliroIngridDelivery: QliroIngridDelivery;
  QliroIngridDeliveryAddress: QliroIngridDeliveryAddress;
  QliroOneConfig: QliroOneConfig;
  QliroOneCredentials: QliroOneCredentials;
  QliroOneIntegratedShipping: QliroOneIntegratedShipping;
  QliroShipmentOrderItem: QliroShipmentOrderItem;
  QliroShipmentOrderItemMetadata: QliroShipmentOrderItemMetadata;
  Query: {};
  QueryConfigurationManagement: QueryConfigurationManagement;
  QueryConfigurationManagementValidate: QueryConfigurationManagementValidate;
  QueryOrderManagement: Omit<QueryOrderManagement, 'details' | 'orderModificationAddresses' | 'orderModificationOrderLines' | 'orderModificationShippingFees'> & { details: ResolversParentTypes['Order'], orderModificationAddresses?: Maybe<ResolversParentTypes['OrderModificationAddresses']>, orderModificationOrderLines?: Maybe<ResolversParentTypes['OrderModificationOrderLines']>, orderModificationShippingFees?: Maybe<ResolversParentTypes['OrderModificationShippingFees']> };
  QueryPlatformConfig: QueryPlatformConfig;
  QueryProductManagement: QueryProductManagement;
  Reason: Reason;
  RefundBonus: RefundBonus;
  RefundFee: RefundFee;
  RefundGift: RefundGift;
  RefundGiftCard: RefundGiftCard;
  RefundGiftCardProduct: RefundGiftCardProduct;
  RefundOrderLine: RefundOrderLine;
  RefundShippingFee: RefundShippingFee;
  RefundVoucher: RefundVoucher;
  RefundedPayment: RefundedPayment;
  ReleaseBonus: ReleaseBonus;
  ReleaseGift: ReleaseGift;
  ReleaseGiftCard: ReleaseGiftCard;
  ReleaseGiftCardProduct: ReleaseGiftCardProduct;
  ReleaseOrderLine: ReleaseOrderLine;
  ReleaseShippingFee: ReleaseShippingFee;
  ReleasedPayment: ReleasedPayment;
  Retain24Config: Retain24Config;
  Retain24Credentials: Retain24Credentials;
  RoundingRule: RoundingRule;
  RoundingRules: RoundingRules;
  Rule: Rule;
  Schema: Omit<Schema, 'mutation' | 'query'> & { mutation?: Maybe<ResolversParentTypes['Mutation']>, query?: Maybe<ResolversParentTypes['Query']> };
  SearchSorting: SearchSorting;
  ShippingFee: ShippingFee;
  ShippingFeeData: ShippingFeeData;
  ShippingFeeModification: Omit<ShippingFeeModification, 'data'> & { data: ResolversParentTypes['ShippingFeeModificationData'] };
  ShippingFeeModificationData: ResolversInterfaceTypes<ResolversParentTypes>['ShippingFeeModificationData'];
  ShippingFeeModificationUpdateData: ShippingFeeModificationUpdateData;
  ShippingFeeModificationUpdateDataPrice: ShippingFeeModificationUpdateDataPrice;
  ShippingFeeUpdatePrice: ShippingFeeUpdatePrice;
  ShippingProvider: ShippingProvider;
  ShippingTaxGroup: ShippingTaxGroup;
  ShopperInsightsSearchHit: ResolversInterfaceTypes<ResolversParentTypes>['ShopperInsightsSearchHit'];
  ShopperInsightsSearchHitAddress: ShopperInsightsSearchHitAddress;
  ShopperInsightsSearchHitAttributes: ShopperInsightsSearchHitAttributes;
  ShopperInsightsSearchHitAttributesCompany: ShopperInsightsSearchHitAttributesCompany;
  ShopperInsightsSearchHitBundle: ShopperInsightsSearchHitBundle;
  ShopperInsightsSearchHitCampaign: ShopperInsightsSearchHitCampaign;
  ShopperInsightsSearchHitCheckout: ShopperInsightsSearchHitCheckout;
  ShopperInsightsSearchHitCheckoutGiftCard: ShopperInsightsSearchHitCheckoutGiftCard;
  ShopperInsightsSearchHitCheckoutItem: ShopperInsightsSearchHitCheckoutItem;
  ShopperInsightsSearchHitCheckoutPaymentStatus: ShopperInsightsSearchHitCheckoutPaymentStatus;
  ShopperInsightsSearchHitCheckoutPaymentStatusLog: ShopperInsightsSearchHitCheckoutPaymentStatusLog;
  ShopperInsightsSearchHitCheckoutProvider: ShopperInsightsSearchHitCheckoutProvider;
  ShopperInsightsSearchHitCheckoutProviders: ShopperInsightsSearchHitCheckoutProviders;
  ShopperInsightsSearchHitCheckoutShippingOption: ShopperInsightsSearchHitCheckoutShippingOption;
  ShopperInsightsSearchHitGift: ShopperInsightsSearchHitGift;
  ShopperInsightsSearchHitOrder: ShopperInsightsSearchHitOrder;
  ShopperInsightsSearchHitOrderBonus: ShopperInsightsSearchHitOrderBonus;
  ShopperInsightsSearchHitOrderCheckoutProviders: ShopperInsightsSearchHitOrderCheckoutProviders;
  ShopperInsightsSearchHitOrderGiftCard: ShopperInsightsSearchHitOrderGiftCard;
  ShopperInsightsSearchHitOrderGiftCardProduct: ShopperInsightsSearchHitOrderGiftCardProduct;
  ShopperInsightsSearchHitOrderLine: ShopperInsightsSearchHitOrderLine;
  ShopperInsightsSearchHitOrderPayment: ShopperInsightsSearchHitOrderPayment;
  ShopperInsightsSearchHitOrderPromotion: ShopperInsightsSearchHitOrderPromotion;
  ShopperInsightsSearchHitOrderProvider: ShopperInsightsSearchHitOrderProvider;
  ShopperInsightsSearchHitOrderSessionProviders: ShopperInsightsSearchHitOrderSessionProviders;
  ShopperInsightsSearchHitOrderShipping: ShopperInsightsSearchHitOrderShipping;
  ShopperInsightsSearchHitOrderShippingFee: ShopperInsightsSearchHitOrderShippingFee;
  ShopperInsightsSearchHitOrderTotals: ShopperInsightsSearchHitOrderTotals;
  ShopperInsightsSearchHitOrderVoucher: ShopperInsightsSearchHitOrderVoucher;
  ShopperInsightsSearchHitSession: ShopperInsightsSearchHitSession;
  ShopperInsightsSearchHitSessionItem: ShopperInsightsSearchHitSessionItem;
  ShopperInsightsSearchHitSessionLock: ShopperInsightsSearchHitSessionLock;
  ShopperInsightsSearchHitSessionProvider: ShopperInsightsSearchHitSessionProvider;
  ShopperInsightsSearchHitSessionProviderBonus: ShopperInsightsSearchHitSessionProviderBonus;
  ShopperInsightsSearchHitSessionProviderGiftCardProduct: ShopperInsightsSearchHitSessionProviderGiftCardProduct;
  ShopperInsightsSearchHitSessionProviderPromotion: ShopperInsightsSearchHitSessionProviderPromotion;
  ShopperInsightsSearchHitSessionProviderVoucher: ShopperInsightsSearchHitSessionProviderVoucher;
  ShopperInsightsSearchHitSessionProviders: ShopperInsightsSearchHitSessionProviders;
  ShopperInsightsSearchHitTag: ShopperInsightsSearchHitTag;
  ShopperInsightsSearchHits: Omit<ShopperInsightsSearchHits, 'hits'> & { hits: Array<ResolversParentTypes['ShopperInsightsSearchHit']> };
  Stock: Stock;
  StockInventory: StockInventory;
  StoreGroup: StoreGroup;
  StoreGroupPrice: StoreGroupPrice;
  StoreGroupSearchHit: StoreGroupSearchHit;
  StoreGroupSearchHits: StoreGroupSearchHits;
  StoreMarket: StoreMarket;
  StoreMarketSearchHit: StoreMarketSearchHit;
  StoreMarketSearchHits: StoreMarketSearchHits;
  String: Scalars['String']['output'];
  SubOutcome: SubOutcome;
  Subscription: {};
  SveaCheckoutConfig: SveaCheckoutConfig;
  SveaCredentials: SveaCredentials;
  TagCondition: TagCondition;
  TagKeys: TagKeys;
  TagValues: TagValues;
  TaxGroup: TaxGroup;
  TaxGroupSearchHit: TaxGroupSearchHit;
  TaxGroupSearchHits: TaxGroupSearchHits;
  TaxJarConfig: TaxJarConfig;
  TaxJarCredentials: TaxJarCredentials;
  TaxMarket: TaxMarket;
  TaxMarketSearchHit: TaxMarketSearchHit;
  TaxMarketSearchHits: TaxMarketSearchHits;
  UpdateExternalEventsDestinationAPIResult: UpdateExternalEventsDestinationApiResult;
  UsagePlan: UsagePlan;
  User: User;
  UserDetails: UserDetails;
  UsersList: UsersList;
  ValidDateRange: ValidDateRange;
  ValidateConfigResult: ValidateConfigResult;
  VoucherProvider: VoucherProvider;
  VoyadoConfig: VoyadoConfig;
  VoyadoCredentials: VoyadoCredentials;
  WalleyCheckoutConfig: WalleyCheckoutConfig;
  WalleyCredentials: WalleyCredentials;
  WalleyDeliveryModuleDeliveryDate: WalleyDeliveryModuleDeliveryDate;
  WalleyDeliveryModuleDestination: WalleyDeliveryModuleDestination;
  WalleyDeliveryModuleOption: WalleyDeliveryModuleOption;
  WalleyDeliveryModuleShipment: WalleyDeliveryModuleShipment;
  WalleyDeliveryModuleShipping: WalleyDeliveryModuleShipping;
  WalleyDeliveryModuleShippingChoice: WalleyDeliveryModuleShippingChoice;
  ZaverConfig: ZaverConfig;
  ZaverCredentials: ZaverCredentials;
};

export type Aws_Api_KeyDirectiveArgs = { };

export type Aws_Api_KeyDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_AuthDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type Aws_AuthDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_LambdaDirectiveArgs = { };

export type Aws_LambdaDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_OidcDirectiveArgs = { };

export type Aws_OidcDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_PublishDirectiveArgs = {
  subscriptions?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type Aws_PublishDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_PublishDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DeferDirectiveArgs = { };

export type DeferDirectiveResolver<Result, Parent, ContextType = any, Args = DeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface AwsEmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface AwsurlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type ActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Actor'] = ResolversParentTypes['Actor']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddExternalEventsDestinationApiResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddExternalEventsDestinationAPIResult'] = ResolversParentTypes['AddExternalEventsDestinationAPIResult']> = {
  apiDestinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddExternalEventsDestinationEventBusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddExternalEventsDestinationEventBusResult'] = ResolversParentTypes['AddExternalEventsDestinationEventBusResult']> = {
  eventBusArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddExternalEventsRuleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddExternalEventsRuleResult'] = ResolversParentTypes['AddExternalEventsRuleResult']> = {
  ruleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenConfig'] = ResolversParentTypes['AdyenConfig']> = {
  clientKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['AdyenCredentials'], ParentType, ContextType>;
  environment?: Resolver<ResolversTypes['AdyenEnvironment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  liveEndpointUrlPrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  webhooks?: Resolver<Maybe<Array<ResolversTypes['AdyenWebhook']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenCredentials'] = ResolversParentTypes['AdyenCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hmac?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenWebhook'] = ResolversParentTypes['AdyenWebhook']> = {
  configId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sequenceNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['AdyenWebhookStatus']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['AdyenWebhookTarget']>, ParentType, ContextType>;
  tested?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenWebhookCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenWebhookCredentials'] = ResolversParentTypes['AdyenWebhookCredentials']> = {
  hmac?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenWebhookGenerationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenWebhookGenerationResult'] = ResolversParentTypes['AdyenWebhookGenerationResult']> = {
  started?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdyenWebhookLegacyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdyenWebhookLegacy'] = ResolversParentTypes['AdyenWebhookLegacy']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiClient'] = ResolversParentTypes['ApiClient']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiClientDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiClientDetails'] = ResolversParentTypes['ApiClientDetails']> = {
  clientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scopes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiClientsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiClientsList'] = ResolversParentTypes['ApiClientsList']> = {
  apiClients?: Resolver<Array<ResolversTypes['ApiClient']>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiResource'] = ResolversParentTypes['ApiResource']> = {
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scopes?: Resolver<Maybe<Array<ResolversTypes['ApiScope']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiScope'] = ResolversParentTypes['ApiScope']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaConfig'] = ResolversParentTypes['AvardaConfig']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['AvardaCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shippingBroker?: Resolver<Maybe<ResolversTypes['AvardaShippingBroker']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaCredentials'] = ResolversParentTypes['AvardaCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBroker'] = ResolversParentTypes['AvardaShippingBroker']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShipping'] = ResolversParentTypes['AvardaShippingBrokerShipping']> = {
  ingrid?: Resolver<Maybe<ResolversTypes['AvardaShippingBrokerShippingIngrid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngrid'] = ResolversParentTypes['AvardaShippingBrokerShippingIngrid']> = {
  carrier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['AvardaShippingBrokerShippingIngridCategory']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deliveryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalMethodId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['AvardaShippingBrokerShippingIngridLocation']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceComponents?: Resolver<Maybe<Array<ResolversTypes['AvardaShippingBrokerShippingIngridPriceComponent']>>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tosId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngridCategory'] = ResolversParentTypes['AvardaShippingBrokerShippingIngridCategory']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['AvardaShippingBrokerShippingIngridCategoryTag']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridCategoryTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngridCategoryTag'] = ResolversParentTypes['AvardaShippingBrokerShippingIngridCategoryTag']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngridLocation'] = ResolversParentTypes['AvardaShippingBrokerShippingIngridLocation']> = {
  address?: Resolver<ResolversTypes['AvardaShippingBrokerShippingIngridLocationAddress'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridLocationAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngridLocationAddress'] = ResolversParentTypes['AvardaShippingBrokerShippingIngridLocationAddress']> = {
  addressLines?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvardaShippingBrokerShippingIngridPriceComponentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvardaShippingBrokerShippingIngridPriceComponent'] = ResolversParentTypes['AvardaShippingBrokerShippingIngridPriceComponent']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vatRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BsgGiftCardConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BSGGiftCardConfig'] = ResolversParentTypes['BSGGiftCardConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['BSGGiftCardCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tokenUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BsgGiftCardCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BSGGiftCardCredentials'] = ResolversParentTypes['BSGGiftCardCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BonusConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BonusConfig'] = ResolversParentTypes['BonusConfig']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['BonusCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BonusCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BonusCredentials'] = ResolversParentTypes['BonusCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BonusProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['BonusProvider'] = ResolversParentTypes['BonusProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['BonusProviderName'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProviderStatusLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bundle'] = ResolversParentTypes['Bundle']> = {
  discountValue?: Resolver<Maybe<ResolversTypes['DiscountValue']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemRules?: Resolver<Array<ResolversTypes['BundleItemRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleGroup'] = ResolversParentTypes['BundleGroup']> = {
  bundles?: Resolver<Array<ResolversTypes['Bundle']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeMarkets?: Resolver<Array<Maybe<ResolversTypes['BundleStoreMarket']>>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validDateRange?: Resolver<Maybe<ResolversTypes['ValidDateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleGroupSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleGroupSearchHit'] = ResolversParentTypes['BundleGroupSearchHit']> = {
  bundles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleGroupSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleGroupSearchHits'] = ResolversParentTypes['BundleGroupSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['BundleGroupSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleItemRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleItemRule'] = ResolversParentTypes['BundleItemRule']> = {
  discountValue?: Resolver<Maybe<ResolversTypes['DiscountValue']>, ParentType, ContextType>;
  excludeDiscountedPrices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  excludeFullPrices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productParents?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tagConditions?: Resolver<Array<ResolversTypes['TagCondition']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleOutcome'] = ResolversParentTypes['BundleOutcome']> = {
  bundleGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleStoreMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleStoreMarket'] = ResolversParentTypes['BundleStoreMarket']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['Campaign'] = ResolversParentTypes['Campaign']> = {
  campaignGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceRule?: Resolver<ResolversTypes['PriceRule'], ParentType, ContextType>;
  productVariantRules?: Resolver<ResolversTypes['ProductVariantRules'], ParentType, ContextType>;
  roundingRules?: Resolver<Maybe<ResolversTypes['RoundingRules']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  storeMarkets?: Resolver<Array<ResolversTypes['CampaignStoreMarket']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignDeletionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignDeletionResult'] = ResolversParentTypes['CampaignDeletionResult']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignGroup'] = ResolversParentTypes['CampaignGroup']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignGroupListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignGroupList'] = ResolversParentTypes['CampaignGroupList']> = {
  campaignGroup?: Resolver<ResolversTypes['CampaignGroup'], ParentType, ContextType>;
  campaigns?: Resolver<Array<ResolversTypes['Campaign']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignGroupSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignGroupSearchHit'] = ResolversParentTypes['CampaignGroupSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignGroupSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignGroupSearchHits'] = ResolversParentTypes['CampaignGroupSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['CampaignGroupSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignIdentity'] = ResolversParentTypes['CampaignIdentity']> = {
  campaignGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignMoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignMoney'] = ResolversParentTypes['CampaignMoney']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignSearchHit'] = ResolversParentTypes['CampaignSearchHit']> = {
  campaignGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignSearchHits'] = ResolversParentTypes['CampaignSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['CampaignSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignStoreMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignStoreMarket'] = ResolversParentTypes['CampaignStoreMarket']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancellationBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancellationBonus'] = ResolversParentTypes['CancellationBonus']> = {
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancellationGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancellationGiftCard'] = ResolversParentTypes['CancellationGiftCard']> = {
  giftCardId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancellationGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancellationGiftCardProduct'] = ResolversParentTypes['CancellationGiftCardProduct']> = {
  cancelTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelledPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelledPayment'] = ResolversParentTypes['CancelledPayment']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CapabilitiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Capabilities'] = ResolversParentTypes['Capabilities']> = {
  giftCardProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  paymentProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  shippingProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  taxProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CapabilityProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapabilityProvider'] = ResolversParentTypes['CapabilityProvider']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartCapabilitiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartCapabilities'] = ResolversParentTypes['CartCapabilities']> = {
  bonus?: Resolver<Maybe<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  externalPrice?: Resolver<Maybe<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  retain24?: Resolver<Maybe<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  voyado?: Resolver<Maybe<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartRuleOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartRuleOutcome'] = ResolversParentTypes['CartRuleOutcome']> = {
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ruleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeRuleOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeRuleOutcome'] = ResolversParentTypes['CodeRuleOutcome']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ruleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodesGenerationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodesGenerationSearchHit'] = ResolversParentTypes['CodesGenerationSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodeRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  numberOfCodesGenerated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numberOfCodesRequested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  usageLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodesGenerationSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodesGenerationSearchHits'] = ResolversParentTypes['CodesGenerationSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['CodesGenerationSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment']> = {
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyAttribute'] = ResolversParentTypes['CompanyAttribute']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationBonus'] = ResolversParentTypes['CompensationBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationFee'] = ResolversParentTypes['CompensationFee']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationGiftCard'] = ResolversParentTypes['CompensationGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationOrderLine'] = ResolversParentTypes['CompensationOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationPayment'] = ResolversParentTypes['CompensationPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompensationShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompensationShippingFee'] = ResolversParentTypes['CompensationShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Condition'] = ResolversParentTypes['Condition']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identifiers?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  itemRule?: Resolver<Maybe<ResolversTypes['ItemRule']>, ParentType, ContextType>;
  thresholds?: Resolver<Maybe<Array<ResolversTypes['Money']>>, ParentType, ContextType>;
  triggerQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateGenerateCodesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateGenerateCodesResult'] = ResolversParentTypes['CreateGenerateCodesResult']> = {
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyRate'] = ResolversParentTypes['CurrencyRate']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyRatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyRates'] = ResolversParentTypes['CurrencyRates']> = {
  baseCurrencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rates?: Resolver<Array<ResolversTypes['CurrencyRate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPaymentConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomPaymentConfig'] = ResolversParentTypes['CustomPaymentConfig']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['CustomPaymentCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPaymentCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomPaymentCredentials'] = ResolversParentTypes['CustomPaymentCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomReasonCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomReasonCode'] = ResolversParentTypes['CustomReasonCode']> = {
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomReasonCodesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomReasonCodes'] = ResolversParentTypes['CustomReasonCodes']> = {
  codes?: Resolver<Array<Maybe<ResolversTypes['CustomReasonCode']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomState'] = ResolversParentTypes['CustomState']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  operations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CustomStateType'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomStatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomStates'] = ResolversParentTypes['CustomStates']> = {
  states?: Resolver<Array<Maybe<ResolversTypes['CustomState']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletedResult'] = ResolversParentTypes['DeletedResult']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryBonus'] = ResolversParentTypes['DeliveryBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryCaptureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCapture'] = ResolversParentTypes['DeliveryCapture']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryGift'] = ResolversParentTypes['DeliveryGift']> = {
  giftId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryGiftCard'] = ResolversParentTypes['DeliveryGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryGiftCardProduct'] = ResolversParentTypes['DeliveryGiftCardProduct']> = {
  createFailedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryOrderLine'] = ResolversParentTypes['DeliveryOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryShippingFee'] = ResolversParentTypes['DeliveryShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryTracking'] = ResolversParentTypes['DeliveryTracking']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingCompany?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryVoucher'] = ResolversParentTypes['DeliveryVoucher']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  voucherId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DimensionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dimensions'] = ResolversParentTypes['Dimensions']> = {
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCode'] = ResolversParentTypes['DiscountCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodeRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isUnlimited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  usageLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  validDateRange?: Resolver<Maybe<ResolversTypes['ValidDateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeRule'] = ResolversParentTypes['DiscountCodeRule']> = {
  applyLast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  conditions?: Resolver<Array<ResolversTypes['Condition']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  displayNames?: Resolver<Maybe<Array<ResolversTypes['DisplayName']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logicRules?: Resolver<Array<ResolversTypes['LogicHolder']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outcomes?: Resolver<Array<ResolversTypes['Outcome']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validDateRange?: Resolver<Maybe<ResolversTypes['ValidDateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeRuleSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeRuleSearchHit'] = ResolversParentTypes['DiscountCodeRuleSearchHit']> = {
  applyLast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeRuleSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeRuleSearchHits'] = ResolversParentTypes['DiscountCodeRuleSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['DiscountCodeRuleSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeSearchHit'] = ResolversParentTypes['DiscountCodeSearchHit']> = {
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodeRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isUnlimited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  usageLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeSearchHits'] = ResolversParentTypes['DiscountCodeSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['DiscountCodeSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountExternalRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountExternalRule'] = ResolversParentTypes['DiscountExternalRule']> = {
  applyLast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  conditions?: Resolver<Array<ResolversTypes['Condition']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  displayNames?: Resolver<Maybe<Array<ResolversTypes['DisplayName']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logicRules?: Resolver<Array<ResolversTypes['LogicHolder']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outcomes?: Resolver<Array<ResolversTypes['Outcome']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validDateRange?: Resolver<Maybe<ResolversTypes['ValidDateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountExternalRuleSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountExternalRuleSearchHit'] = ResolversParentTypes['DiscountExternalRuleSearchHit']> = {
  applyLast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountExternalRuleSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountExternalRuleSearchHits'] = ResolversParentTypes['DiscountExternalRuleSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['DiscountExternalRuleSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountManagementQuotasResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountManagementQuotas'] = ResolversParentTypes['DiscountManagementQuotas']> = {
  maxGenerationJobsPerDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxNumberOfCodes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountRule'] = ResolversParentTypes['DiscountRule']> = {
  conditions?: Resolver<Array<ResolversTypes['Condition']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  displayNames?: Resolver<Maybe<Array<ResolversTypes['DisplayName']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logicRules?: Resolver<Array<ResolversTypes['LogicHolder']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outcomes?: Resolver<Array<ResolversTypes['Outcome']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validDateRange?: Resolver<Maybe<ResolversTypes['ValidDateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountRuleSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountRuleSearchHit'] = ResolversParentTypes['DiscountRuleSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStackable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountRuleSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountRuleSearchHits'] = ResolversParentTypes['DiscountRuleSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['DiscountRuleSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountValue'] = ResolversParentTypes['DiscountValue']> = {
  fixedDiscounts?: Resolver<Maybe<Array<ResolversTypes['Money']>>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayName'] = ResolversParentTypes['DisplayName']> = {
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  translation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalApiResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalApi'] = ResolversParentTypes['ExternalApi']> = {
  discountManagementQuotas?: Resolver<Maybe<ResolversTypes['DiscountManagementQuotas']>, ParentType, ContextType>;
  usagePlans?: Resolver<Array<ResolversTypes['UsagePlan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationApiResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationAPI'] = ResolversParentTypes['ExternalEventDestinationAPI']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filters?: Resolver<Maybe<Array<ResolversTypes['ExternalEventDestinationAPIFilter']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationApiFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationAPIFilter'] = ResolversParentTypes['ExternalEventDestinationAPIFilter']> = {
  pattern?: Resolver<Maybe<ResolversTypes['ExternalEventDestinationAPIFilterPattern']>, ParentType, ContextType>;
  ruleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationApiFilterPatternResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationAPIFilterPattern'] = ResolversParentTypes['ExternalEventDestinationAPIFilterPattern']> = {
  detailTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationApIsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationAPIs'] = ResolversParentTypes['ExternalEventDestinationAPIs']> = {
  apiDestinations?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  apiDestinationsDetails?: Resolver<Array<ResolversTypes['ExternalEventDestinationsDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationEventBusesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationEventBuses'] = ResolversParentTypes['ExternalEventDestinationEventBuses']> = {
  eventBuses?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventDestinationsDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventDestinationsDetails'] = ResolversParentTypes['ExternalEventDestinationsDetails']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventRuleStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventRuleState'] = ResolversParentTypes['ExternalEventRuleState']> = {
  ruleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventRules'] = ResolversParentTypes['ExternalEventRules']> = {
  rules?: Resolver<Array<ResolversTypes['ExternalEventRuleState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalPriceConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalPriceConfig'] = ResolversParentTypes['ExternalPriceConfig']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['ExternalPriceCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalPriceCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalPriceCredentials'] = ResolversParentTypes['ExternalPriceCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalPriceProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalPriceProvider'] = ResolversParentTypes['ExternalPriceProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['ExternalPriceProviderName'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalRuleOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalRuleOutcome'] = ResolversParentTypes['ExternalRuleOutcome']> = {
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ruleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateCodesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCodes'] = ResolversParentTypes['GenerateCodes']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodeRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfCodesGenerated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfCodesRequested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  usageLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['Gift'] = ResolversParentTypes['Gift']> = {
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftCardProductProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftCardProductProvider'] = ResolversParentTypes['GiftCardProductProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['GiftCardProductProviderName'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProviderStatusLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftCardProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftCardProvider'] = ResolversParentTypes['GiftCardProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['GiftCardProviderName'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProviderStatusLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupDetails'] = ResolversParentTypes['GroupDetails']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupsList'] = ResolversParentTypes['GroupsList']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityProvider'] = ResolversParentTypes['IdentityProvider']> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IdentityProviderType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngridConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngridConfig'] = ResolversParentTypes['IngridConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['IngridCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  siteId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngridCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngridCredentials'] = ResolversParentTypes['IngridCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngridDeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngridDelivery'] = ResolversParentTypes['IngridDelivery']> = {
  carrierProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryAddress?: Resolver<Maybe<ResolversTypes['IngridDeliveryAddress']>, ParentType, ContextType>;
  deliveryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationExternalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tosId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngridDeliveryAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngridDeliveryAddress'] = ResolversParentTypes['IngridDeliveryAddress']> = {
  addressLines?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Inventory'] = ResolversParentTypes['Inventory']> = {
  address?: Resolver<Maybe<ResolversTypes['InventoryAddress']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryAddress'] = ResolversParentTypes['InventoryAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryProductVariantStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryProductVariantStock'] = ResolversParentTypes['InventoryProductVariantStock']> = {
  inventoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryProductVariantStockConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryProductVariantStockConfig'] = ResolversParentTypes['InventoryProductVariantStockConfig']> = {
  productVariantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  validateStock?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryStoreMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryStoreMarket'] = ResolversParentTypes['InventoryStoreMarket']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  inventories?: Resolver<Maybe<Array<ResolversTypes['Inventory']>>, ParentType, ContextType>;
  storeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryStoreMarketInventoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryStoreMarketInventories'] = ResolversParentTypes['InventoryStoreMarketInventories']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inventoryIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemRule'] = ResolversParentTypes['ItemRule']> = {
  excludeDiscountedPrices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  excludeFullPrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tagConditions?: Resolver<Array<ResolversTypes['TagCondition']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KbsGiftCardConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['KBSGiftCardConfig'] = ResolversParentTypes['KBSGiftCardConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['KBSGiftCardCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KbsGiftCardCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['KBSGiftCardCredentials'] = ResolversParentTypes['KBSGiftCardCredentials']> = {
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyValue'] = ResolversParentTypes['KeyValue']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaCheckoutConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaCheckoutConfig'] = ResolversParentTypes['KlarnaCheckoutConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['KlarnaCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  klarnaShippingAssistantEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaCredentials'] = ResolversParentTypes['KlarnaCredentials']> = {
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantAddonResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantAddon'] = ResolversParentTypes['KlarnaShippingAssistantAddon']> = {
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userInput?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantAddress'] = ResolversParentTypes['KlarnaShippingAssistantAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress2?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantCarrierProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantCarrierProduct'] = ResolversParentTypes['KlarnaShippingAssistantCarrierProduct']> = {
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantLocation'] = ResolversParentTypes['KlarnaShippingAssistantLocation']> = {
  address?: Resolver<ResolversTypes['KlarnaShippingAssistantAddress'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantLocationTimeslotResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantLocationTimeslot'] = ResolversParentTypes['KlarnaShippingAssistantLocationTimeslot']> = {
  cutoff?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KlarnaShippingAssistantSelectedShippingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KlarnaShippingAssistantSelectedShippingOption'] = ResolversParentTypes['KlarnaShippingAssistantSelectedShippingOption']> = {
  carrier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrierProduct?: Resolver<Maybe<ResolversTypes['KlarnaShippingAssistantCarrierProduct']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['KlarnaShippingAssistantLocation']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedAddons?: Resolver<Maybe<Array<ResolversTypes['KlarnaShippingAssistantAddon']>>, ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeslot?: Resolver<Maybe<ResolversTypes['KlarnaShippingAssistantLocationTimeslot']>, ParentType, ContextType>;
  tmsReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedyerConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedyerConfig'] = ResolversParentTypes['LedyerConfig']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['LedyerCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedyerCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedyerCredentials'] = ResolversParentTypes['LedyerCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogicHolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogicHolder'] = ResolversParentTypes['LogicHolder']> = {
  do?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  if?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketPrice'] = ResolversParentTypes['MarketPrice']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Price'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketRoundingRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketRoundingRule'] = ResolversParentTypes['MarketRoundingRule']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['RoundingRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  Order?: Resolver<ResolversTypes['MutationOrderManagement'], ParentType, ContextType>;
  addExternalEventsDestinationAPI?: Resolver<ResolversTypes['AddExternalEventsDestinationAPIResult'], ParentType, ContextType, RequireFields<MutationAddExternalEventsDestinationApiArgs, 'destName' | 'options'>>;
  addExternalEventsDestinationEventBus?: Resolver<ResolversTypes['AddExternalEventsDestinationEventBusResult'], ParentType, ContextType, RequireFields<MutationAddExternalEventsDestinationEventBusArgs, 'eventBusArn'>>;
  addExternalEventsRule?: Resolver<ResolversTypes['AddExternalEventsRuleResult'], ParentType, ContextType, RequireFields<MutationAddExternalEventsRuleArgs, 'ruleName'>>;
  addUserToGroup?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationAddUserToGroupArgs, 'input'>>;
  createApiClient?: Resolver<ResolversTypes['ApiClientDetails'], ParentType, ContextType, RequireFields<MutationCreateApiClientArgs, 'input'>>;
  createGenerateCodes?: Resolver<Maybe<ResolversTypes['CreateGenerateCodesResult']>, ParentType, ContextType, RequireFields<MutationCreateGenerateCodesArgs, 'input'>>;
  createOrUpdateAdyenConfig?: Resolver<ResolversTypes['AdyenConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateAdyenConfigArgs, 'adyenConfig' | 'id'>>;
  createOrUpdateAvardaConfig?: Resolver<ResolversTypes['AvardaConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateAvardaConfigArgs, 'avardaConfig' | 'id'>>;
  createOrUpdateBSGGiftCardConfig?: Resolver<ResolversTypes['BSGGiftCardConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateBsgGiftCardConfigArgs, 'bsgGiftCardConfig' | 'id'>>;
  createOrUpdateBonusConfig?: Resolver<ResolversTypes['BonusConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateBonusConfigArgs, 'bonusConfig' | 'id'>>;
  createOrUpdateBundleGroup?: Resolver<Maybe<ResolversTypes['BundleGroup']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateBundleGroupArgs, 'bundleGroup' | 'id'>>;
  createOrUpdateCampaign?: Resolver<ResolversTypes['Campaign'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateCampaignArgs, 'campaign' | 'id'>>;
  createOrUpdateCampaignGroup?: Resolver<ResolversTypes['CampaignGroup'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateCampaignGroupArgs, 'campaignGroup' | 'id'>>;
  createOrUpdateCustomPaymentConfig?: Resolver<ResolversTypes['CustomPaymentConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateCustomPaymentConfigArgs, 'customPaymentConfig' | 'id'>>;
  createOrUpdateDiscountCode?: Resolver<Maybe<ResolversTypes['DiscountCode']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateDiscountCodeArgs, 'code' | 'discountCode'>>;
  createOrUpdateDiscountCodeRule?: Resolver<Maybe<ResolversTypes['DiscountCodeRule']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateDiscountCodeRuleArgs, 'discountCodeRule' | 'id'>>;
  createOrUpdateDiscountExternalRule?: Resolver<Maybe<ResolversTypes['DiscountExternalRule']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateDiscountExternalRuleArgs, 'discountExternalRule' | 'id'>>;
  createOrUpdateDiscountRule?: Resolver<Maybe<ResolversTypes['DiscountRule']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateDiscountRuleArgs, 'discountRule' | 'id'>>;
  createOrUpdateExternalPriceConfig?: Resolver<ResolversTypes['ExternalPriceConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateExternalPriceConfigArgs, 'externalPriceConfig' | 'id'>>;
  createOrUpdateIngridConfig?: Resolver<ResolversTypes['IngridConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateIngridConfigArgs, 'id' | 'ingridConfig'>>;
  createOrUpdateInventory?: Resolver<ResolversTypes['Inventory'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateInventoryArgs, 'id' | 'inventory'>>;
  createOrUpdateKBSGiftCardConfig?: Resolver<ResolversTypes['KBSGiftCardConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateKbsGiftCardConfigArgs, 'id' | 'kbsGiftCardConfig'>>;
  createOrUpdateKlarnaCheckoutConfig?: Resolver<ResolversTypes['KlarnaCheckoutConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateKlarnaCheckoutConfigArgs, 'id' | 'klarnaCheckoutConfig'>>;
  createOrUpdateLedyerConfig?: Resolver<ResolversTypes['LedyerConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateLedyerConfigArgs, 'id' | 'ledyerConfig'>>;
  createOrUpdateNShiftConfig?: Resolver<ResolversTypes['NShiftConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateNShiftConfigArgs, 'id' | 'nShiftConfig'>>;
  createOrUpdateOidcIdentityProvider?: Resolver<ResolversTypes['IdentityProvider'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateOidcIdentityProviderArgs, 'input'>>;
  createOrUpdateQliroOneConfig?: Resolver<ResolversTypes['QliroOneConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateQliroOneConfigArgs, 'id' | 'qliroOneConfig'>>;
  createOrUpdateRetain24Config?: Resolver<ResolversTypes['Retain24Config'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateRetain24ConfigArgs, 'id' | 'retain24Config'>>;
  createOrUpdateSveaCheckoutConfig?: Resolver<ResolversTypes['SveaCheckoutConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateSveaCheckoutConfigArgs, 'id' | 'sveaCheckoutConfig'>>;
  createOrUpdateTaxGroup?: Resolver<ResolversTypes['TaxGroup'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateTaxGroupArgs, 'id' | 'taxGroup'>>;
  createOrUpdateTaxJarConfig?: Resolver<ResolversTypes['TaxJarConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateTaxJarConfigArgs, 'id' | 'taxJarConfig'>>;
  createOrUpdateTaxMarket?: Resolver<ResolversTypes['TaxMarket'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateTaxMarketArgs, 'countryCode' | 'taxGroupId' | 'taxMarket'>>;
  createOrUpdateVoyadoConfig?: Resolver<ResolversTypes['VoyadoConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateVoyadoConfigArgs, 'id' | 'voyadoConfig'>>;
  createOrUpdateWalleyCheckoutConfig?: Resolver<ResolversTypes['WalleyCheckoutConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateWalleyCheckoutConfigArgs, 'id' | 'walleyCheckoutConfig'>>;
  createOrUpdateZaverConfig?: Resolver<ResolversTypes['ZaverConfig'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateZaverConfigArgs, 'id' | 'zaverConfig'>>;
  createStoreGroup?: Resolver<Maybe<ResolversTypes['StoreGroup']>, ParentType, ContextType, RequireFields<MutationCreateStoreGroupArgs, 'id' | 'storeGroup'>>;
  createStoreMarket?: Resolver<Maybe<ResolversTypes['StoreMarket']>, ParentType, ContextType, RequireFields<MutationCreateStoreMarketArgs, 'countryCode' | 'storeGroupId' | 'storeMarket'>>;
  createUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  deleteAdyenConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteAdyenConfigArgs, 'id'>>;
  deleteApiClient?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationDeleteApiClientArgs, 'clientId'>>;
  deleteAvardaConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteAvardaConfigArgs, 'id'>>;
  deleteBSGGiftCardConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteBsgGiftCardConfigArgs, 'id'>>;
  deleteBonusConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteBonusConfigArgs, 'id'>>;
  deleteBundleGroup?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteBundleGroupArgs, 'id'>>;
  deleteCampaign?: Resolver<ResolversTypes['CampaignDeletionResult'], ParentType, ContextType, RequireFields<MutationDeleteCampaignArgs, 'id'>>;
  deleteCampaignGroup?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteCampaignGroupArgs, 'id'>>;
  deleteCustomPaymentConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteCustomPaymentConfigArgs, 'id'>>;
  deleteDiscountCode?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteDiscountCodeArgs, 'code'>>;
  deleteDiscountCodeRule?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteDiscountCodeRuleArgs, 'id'>>;
  deleteDiscountExternalRule?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteDiscountExternalRuleArgs, 'id'>>;
  deleteDiscountRule?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteDiscountRuleArgs, 'id'>>;
  deleteExternalEventsDestinationAPI?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteExternalEventsDestinationApiArgs, 'destName'>>;
  deleteExternalEventsDestinationEventBus?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteExternalEventsDestinationEventBusArgs, 'eventBusArn'>>;
  deleteExternalEventsRule?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteExternalEventsRuleArgs, 'ruleName'>>;
  deleteExternalPriceConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteExternalPriceConfigArgs, 'id'>>;
  deleteIdentityProvider?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationDeleteIdentityProviderArgs, 'name'>>;
  deleteIngridConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteIngridConfigArgs, 'id'>>;
  deleteInventory?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteInventoryArgs, 'id'>>;
  deleteInventoryProductVariantStock?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteInventoryProductVariantStockArgs, 'inventoryId' | 'productVariantId'>>;
  deleteKBSGiftCardConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteKbsGiftCardConfigArgs, 'id'>>;
  deleteKlarnaCheckoutConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteKlarnaCheckoutConfigArgs, 'id'>>;
  deleteLedyerConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteLedyerConfigArgs, 'id'>>;
  deleteNShiftConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteNShiftConfigArgs, 'id'>>;
  deleteQliroOneConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteQliroOneConfigArgs, 'id'>>;
  deleteRetain24Config?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteRetain24ConfigArgs, 'id'>>;
  deleteStoreGroup?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteStoreGroupArgs, 'id'>>;
  deleteStoreMarket?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteStoreMarketArgs, 'countryCode' | 'storeGroupId'>>;
  deleteSveaCheckoutConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteSveaCheckoutConfigArgs, 'id'>>;
  deleteTaxGroup?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteTaxGroupArgs, 'id'>>;
  deleteTaxJarConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteTaxJarConfigArgs, 'id'>>;
  deleteTaxMarket?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteTaxMarketArgs, 'countryCode' | 'taxGroupId'>>;
  deleteUser?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'username'>>;
  deleteVoyadoConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteVoyadoConfigArgs, 'id'>>;
  deleteWalleyCheckoutConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteWalleyCheckoutConfigArgs, 'id'>>;
  deleteZaverConfig?: Resolver<ResolversTypes['DeletedResult'], ParentType, ContextType, RequireFields<MutationDeleteZaverConfigArgs, 'id'>>;
  disableIdentityProvider?: Resolver<ResolversTypes['IdentityProvider'], ParentType, ContextType, RequireFields<MutationDisableIdentityProviderArgs, 'name'>>;
  disableUser?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationDisableUserArgs, 'username'>>;
  enableIdentityProvider?: Resolver<ResolversTypes['IdentityProvider'], ParentType, ContextType, RequireFields<MutationEnableIdentityProviderArgs, 'name'>>;
  enableUser?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationEnableUserArgs, 'username'>>;
  generateAdyenWebhookCredentials?: Resolver<ResolversTypes['AdyenWebhookCredentials'], ParentType, ContextType, RequireFields<MutationGenerateAdyenWebhookCredentialsArgs, 'id'>>;
  generateAdyenWebhooks?: Resolver<ResolversTypes['AdyenWebhookGenerationResult'], ParentType, ContextType, RequireFields<MutationGenerateAdyenWebhooksArgs, 'id'>>;
  privateAdyenWebhookChange?: Resolver<ResolversTypes['AdyenWebhook'], ParentType, ContextType, RequireFields<MutationPrivateAdyenWebhookChangeArgs, 'input'>>;
  removeUserFromGroup?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationRemoveUserFromGroupArgs, 'input'>>;
  resendPassword?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationResendPasswordArgs, 'username'>>;
  setShippingTaxGroup?: Resolver<ResolversTypes['ShippingTaxGroup'], ParentType, ContextType, RequireFields<MutationSetShippingTaxGroupArgs, 'taxGroupId'>>;
  updateApiClient?: Resolver<ResolversTypes['ApiClientDetails'], ParentType, ContextType, RequireFields<MutationUpdateApiClientArgs, 'clientId' | 'input'>>;
  updateCampaignPeriod?: Resolver<ResolversTypes['Campaign'], ParentType, ContextType, RequireFields<MutationUpdateCampaignPeriodArgs, 'id' | 'period'>>;
  updateExternalEventsDestinationAPI?: Resolver<ResolversTypes['UpdateExternalEventsDestinationAPIResult'], ParentType, ContextType, RequireFields<MutationUpdateExternalEventsDestinationApiArgs, 'destName' | 'options'>>;
  updateInventoryProductVariantStock?: Resolver<ResolversTypes['InventoryProductVariantStock'], ParentType, ContextType, RequireFields<MutationUpdateInventoryProductVariantStockArgs, 'inventoryId' | 'productVariantId' | 'stock'>>;
  updateInventoryStoreMarketInventories?: Resolver<ResolversTypes['InventoryStoreMarketInventories'], ParentType, ContextType, RequireFields<MutationUpdateInventoryStoreMarketInventoriesArgs, 'countryCode' | 'inventoryIds' | 'storeGroupId'>>;
  updateProductVariantStockConfig?: Resolver<ResolversTypes['InventoryProductVariantStockConfig'], ParentType, ContextType, RequireFields<MutationUpdateProductVariantStockConfigArgs, 'config' | 'productVariantId'>>;
  updateStoreGroup?: Resolver<Maybe<ResolversTypes['StoreGroup']>, ParentType, ContextType, RequireFields<MutationUpdateStoreGroupArgs, 'id' | 'storeGroup'>>;
  updateStoreMarket?: Resolver<Maybe<ResolversTypes['StoreMarket']>, ParentType, ContextType, RequireFields<MutationUpdateStoreMarketArgs, 'countryCode' | 'storeGroupId' | 'storeMarket'>>;
  updateUser?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input' | 'username'>>;
};

export type MutationOrderManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['MutationOrderManagement'] = ResolversParentTypes['MutationOrderManagement']> = {
  addCustomState?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementAddCustomStateArgs, 'orderId' | 'stateId'>>;
  createCancellation?: Resolver<ResolversTypes['OrderCancellation'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateCancellationArgs, 'input' | 'orderId'>>;
  createCompensation?: Resolver<ResolversTypes['OrderCompensation'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateCompensationArgs, 'input' | 'orderId'>>;
  createCustomReasonCode?: Resolver<ResolversTypes['CustomReasonCode'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateCustomReasonCodeArgs, 'code' | 'input'>>;
  createCustomState?: Resolver<ResolversTypes['CustomState'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateCustomStateArgs, 'input' | 'stateId'>>;
  createDelivery?: Resolver<ResolversTypes['OrderDelivery'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateDeliveryArgs, 'input' | 'orderId'>>;
  createOrderComment?: Resolver<ResolversTypes['OrderComment'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateOrderCommentArgs, 'comment' | 'orderId'>>;
  createOrderModificationAddresses?: Resolver<ResolversTypes['OrderModificationAddresses'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateOrderModificationAddressesArgs, 'input' | 'orderId'>>;
  createOrderModificationOrderLines?: Resolver<ResolversTypes['OrderModificationOrderLines'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateOrderModificationOrderLinesArgs, 'input' | 'orderId'>>;
  createOrderModificationShippingFees?: Resolver<ResolversTypes['OrderModificationShippingFees'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateOrderModificationShippingFeesArgs, 'input' | 'orderId'>>;
  createRefund?: Resolver<ResolversTypes['OrderRefund'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateRefundArgs, 'input' | 'orderId'>>;
  createRelease?: Resolver<ResolversTypes['OrderRelease'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateReleaseArgs, 'input' | 'orderId'>>;
  createWorkflow?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateWorkflowArgs, 'input' | 'workflowId'>>;
  createWorkflowTrigger?: Resolver<ResolversTypes['OrderWorkflowTrigger'], ParentType, ContextType, RequireFields<MutationOrderManagementCreateWorkflowTriggerArgs, 'revision' | 'workflowId'>>;
  deleteCancellation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteCancellationArgs, 'cancellationId'>>;
  deleteCompensation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteCompensationArgs, 'compensationId'>>;
  deleteCustomReasonCode?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteCustomReasonCodeArgs, 'code'>>;
  deleteCustomState?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteCustomStateArgs, 'stateId'>>;
  deleteDelivery?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteDeliveryArgs, 'deliveryId'>>;
  deleteOrder?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteOrderArgs, 'orderId'>>;
  deleteOrderComment?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteOrderCommentArgs, 'commentId' | 'orderId'>>;
  deleteOrderModificationAddresses?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteOrderModificationAddressesArgs, 'modificationId'>>;
  deleteOrderModificationOrderLines?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteOrderModificationOrderLinesArgs, 'modificationId'>>;
  deleteOrderModificationShippingFees?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteOrderModificationShippingFeesArgs, 'modificationId'>>;
  deleteRefund?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteRefundArgs, 'refundId'>>;
  deleteRelease?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteReleaseArgs, 'releaseId'>>;
  deleteWorkflow?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteWorkflowArgs, 'workflowId'>>;
  deleteWorkflowTrigger?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementDeleteWorkflowTriggerArgs, 'workflowId'>>;
  removeCustomState?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationOrderManagementRemoveCustomStateArgs, 'orderId' | 'stateId'>>;
  resendOrderEvent?: Resolver<ResolversTypes['OperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementResendOrderEventArgs, 'orderId'>>;
  restartCancellation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartCancellationArgs, 'cancellationId' | 'input'>>;
  restartCompensation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartCompensationArgs, 'compensationId' | 'input'>>;
  restartDelivery?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartDeliveryArgs, 'deliveryId' | 'input'>>;
  restartOrderModificationOrderLines?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartOrderModificationOrderLinesArgs, 'input' | 'modificationId'>>;
  restartOrderModificationShippingFees?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartOrderModificationShippingFeesArgs, 'input' | 'modificationId'>>;
  restartRefund?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartRefundArgs, 'input' | 'refundId'>>;
  restartRelease?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementRestartReleaseArgs, 'input' | 'releaseId'>>;
  startCancellation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartCancellationArgs, 'cancellationId' | 'input'>>;
  startCompensation?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartCompensationArgs, 'compensationId' | 'input'>>;
  startDelivery?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartDeliveryArgs, 'deliveryId' | 'input'>>;
  startOrderModificationAddresses?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartOrderModificationAddressesArgs, 'input' | 'modificationId'>>;
  startOrderModificationOrderLines?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartOrderModificationOrderLinesArgs, 'input' | 'modificationId'>>;
  startOrderModificationShippingFees?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartOrderModificationShippingFeesArgs, 'input' | 'modificationId'>>;
  startRefund?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartRefundArgs, 'input' | 'refundId'>>;
  startRelease?: Resolver<ResolversTypes['OrderOperationResult'], ParentType, ContextType, RequireFields<MutationOrderManagementStartReleaseArgs, 'input' | 'releaseId'>>;
  updateCompensation?: Resolver<ResolversTypes['OrderCompensation'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateCompensationArgs, 'compensationId' | 'input'>>;
  updateDelivery?: Resolver<ResolversTypes['OrderDelivery'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateDeliveryArgs, 'deliveryId' | 'input'>>;
  updateOrderComment?: Resolver<ResolversTypes['OrderComment'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateOrderCommentArgs, 'comment' | 'commentId' | 'orderId'>>;
  updateOrderModificationAddresses?: Resolver<ResolversTypes['OrderModificationAddresses'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateOrderModificationAddressesArgs, 'input' | 'modificationId'>>;
  updateOrderModificationOrderLines?: Resolver<ResolversTypes['OrderModificationOrderLines'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateOrderModificationOrderLinesArgs, 'input' | 'modificationId'>>;
  updateOrderModificationShippingFees?: Resolver<ResolversTypes['OrderModificationShippingFees'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateOrderModificationShippingFeesArgs, 'input' | 'modificationId'>>;
  updateRefund?: Resolver<ResolversTypes['OrderRefund'], ParentType, ContextType, RequireFields<MutationOrderManagementUpdateRefundArgs, 'input' | 'refundId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NShiftConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['NShiftConfig'] = ResolversParentTypes['NShiftConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['NShiftCredentials'], ParentType, ContextType>;
  deliveryCheckoutId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NShiftCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NShiftCredentials'] = ResolversParentTypes['NShiftCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NshiftAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['NshiftAddress'] = ResolversParentTypes['NshiftAddress']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NshiftPreparedShipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NshiftPreparedShipment'] = ResolversParentTypes['NshiftPreparedShipment']> = {
  agent?: Resolver<Maybe<ResolversTypes['NshiftAddress']>, ParentType, ContextType>;
  orderNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prepareId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['NshiftAddress'], ParentType, ContextType>;
  service?: Resolver<ResolversTypes['NshiftService'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NshiftServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['NshiftService'] = ResolversParentTypes['NshiftService']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceSystem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperationResult'] = ResolversParentTypes['OperationResult']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = {
  Bonus?: Resolver<Maybe<ResolversTypes['OrderBonus']>, ParentType, ContextType>;
  Bundles?: Resolver<Maybe<Array<ResolversTypes['OrderBundle']>>, ParentType, ContextType>;
  Cancellations?: Resolver<Array<ResolversTypes['OrderCancellation']>, ParentType, ContextType>;
  Compensations?: Resolver<Array<ResolversTypes['OrderCompensation']>, ParentType, ContextType>;
  Deliveries?: Resolver<Array<ResolversTypes['OrderDelivery']>, ParentType, ContextType>;
  GiftCard?: Resolver<ResolversTypes['OrderGiftCard'], ParentType, ContextType>;
  GiftCardProduct?: Resolver<ResolversTypes['OrderGiftCardProduct'], ParentType, ContextType>;
  Modifications?: Resolver<Array<ResolversTypes['OrderModification']>, ParentType, ContextType>;
  Payment?: Resolver<ResolversTypes['OrderPayment'], ParentType, ContextType>;
  Promotion?: Resolver<ResolversTypes['OrderPromotion'], ParentType, ContextType>;
  Refunds?: Resolver<Array<ResolversTypes['OrderRefund']>, ParentType, ContextType>;
  Releases?: Resolver<Array<ResolversTypes['OrderRelease']>, ParentType, ContextType>;
  Reservation?: Resolver<Maybe<ResolversTypes['OrderReservation']>, ParentType, ContextType>;
  Shipping?: Resolver<ResolversTypes['OrderShipping'], ParentType, ContextType>;
  Voucher?: Resolver<ResolversTypes['OrderVoucher'], ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['OrderAttributes']>, ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['OrderAddress'], ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['ChannelType'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodeRules?: Resolver<Maybe<Array<ResolversTypes['OrderDiscountCodeRule']>>, ParentType, ContextType>;
  discountExternalRules?: Resolver<Maybe<Array<ResolversTypes['OrderDiscountExternalRule']>>, ParentType, ContextType>;
  discountOutcome?: Resolver<ResolversTypes['OrderDiscountOutcome'], ParentType, ContextType>;
  discountRules?: Resolver<Maybe<Array<ResolversTypes['OrderDiscountRule']>>, ParentType, ContextType>;
  externalPriceProvider?: Resolver<Maybe<ResolversTypes['ExternalPriceProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  gifts?: Resolver<Maybe<Array<ResolversTypes['OrderGift']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTaxExempt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxExemptionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Maybe<Array<ResolversTypes['OrderLine']>>, ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingAddress?: Resolver<ResolversTypes['OrderAddress'], ParentType, ContextType>;
  shippingFees?: Resolver<Maybe<Array<ResolversTypes['ShippingFee']>>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderStatus'], ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderTotals'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddress'] = ResolversParentTypes['OrderAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateOrProvince?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressesModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddressesModification'] = ResolversParentTypes['OrderAddressesModification']> = {
  data?: Resolver<ResolversTypes['OrderAddressesModificationData'], ParentType, ContextType>;
  modificationType?: Resolver<ResolversTypes['OrderAddressesModificationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressesModificationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddressesModificationData'] = ResolversParentTypes['OrderAddressesModificationData']> = {
  __resolveType: TypeResolveFn<'OrderAddressesModificationUpdateData', ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['OrderAddressesModificationUpdateDataAddress']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['OrderAddressesModificationUpdateDataAddress']>, ParentType, ContextType>;
};

export type OrderAddressesModificationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddressesModificationSearchHit'] = ResolversParentTypes['OrderAddressesModificationSearchHit']> = {
  addresses?: Resolver<ResolversTypes['OrderOperationAddressModification'], ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressesModificationUpdateDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddressesModificationUpdateData'] = ResolversParentTypes['OrderAddressesModificationUpdateData']> = {
  billingAddress?: Resolver<Maybe<ResolversTypes['OrderAddressesModificationUpdateDataAddress']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['OrderAddressesModificationUpdateDataAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressesModificationUpdateDataAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddressesModificationUpdateDataAddress'] = ResolversParentTypes['OrderAddressesModificationUpdateDataAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateOrProvince?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAttributes'] = ResolversParentTypes['OrderAttributes']> = {
  company?: Resolver<Maybe<ResolversTypes['CompanyAttribute']>, ParentType, ContextType>;
  merchantReference1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantReference2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBonus'] = ResolversParentTypes['OrderBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  points?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderBundleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBundle'] = ResolversParentTypes['OrderBundle']> = {
  bundleGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellation'] = ResolversParentTypes['OrderCancellation']> = {
  bonus?: Resolver<Maybe<ResolversTypes['CancellationBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  cancelledPayment?: Resolver<Maybe<ResolversTypes['CancelledPayment']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['CancellationGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['CancellationGiftCard']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationSearchBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellationSearchBonus'] = ResolversParentTypes['OrderCancellationSearchBonus']> = {
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationSearchGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellationSearchGiftCard'] = ResolversParentTypes['OrderCancellationSearchGiftCard']> = {
  giftCardId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationSearchGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellationSearchGiftCardProduct'] = ResolversParentTypes['OrderCancellationSearchGiftCardProduct']> = {
  cancelTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellationSearchHit'] = ResolversParentTypes['OrderCancellationSearchHit']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderCancellationSearchBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  cancelledPayment?: Resolver<Maybe<ResolversTypes['OrderCancellationSearchPayment']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['OrderCancellationSearchGiftCardProduct']>, ParentType, ContextType>;
  giftCardProductsProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderCancellationSearchGiftCard']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['OrderOperationSearchProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancellationSearchPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancellationSearchPayment'] = ResolversParentTypes['OrderCancellationSearchPayment']> = {
  Reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderComment'] = ResolversParentTypes['OrderComment']> = {
  comment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensation'] = ResolversParentTypes['OrderCompensation']> = {
  bonus?: Resolver<Maybe<ResolversTypes['CompensationBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['CompensationFee']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Maybe<Array<ResolversTypes['CompensationGiftCard']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Maybe<Array<ResolversTypes['CompensationOrderLine']>>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['CompensationPayment']>, ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['PaymentProvider']>, ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Maybe<Array<ResolversTypes['CompensationShippingFee']>>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderCompensationTotals'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchHit'] = ResolversParentTypes['OrderCompensationSearchHit']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderOperationSearchBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['OrderOperationSearchFee']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderOperationSearchGiftCard']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderOperationSearchOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['OrderCompensationSearchPayment']>, ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderOperationSearchShippingFee']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderCompensationSearchTotals'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchHits'] = ResolversParentTypes['OrderCompensationSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['OrderCompensationSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchPayment'] = ResolversParentTypes['OrderCompensationSearchPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchProviderStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchProviderStatus'] = ResolversParentTypes['OrderCompensationSearchProviderStatus']> = {
  current?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  history?: Resolver<Array<ResolversTypes['OrderCompensationSearchProviderStatusHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchProviderStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchProviderStatusHistory'] = ResolversParentTypes['OrderCompensationSearchProviderStatusHistory']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationSearchTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationSearchTotals'] = ResolversParentTypes['OrderCompensationSearchTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCompensationTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCompensationTotals'] = ResolversParentTypes['OrderCompensationTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCustomStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCustomState'] = ResolversParentTypes['OrderCustomState']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  operations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CustomStateType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDelivery'] = ResolversParentTypes['OrderDelivery']> = {
  bonus?: Resolver<Maybe<ResolversTypes['DeliveryBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  capturedPayment?: Resolver<Maybe<ResolversTypes['DeliveryCapture']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['DeliveryGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['DeliveryGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['DeliveryGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['DeliveryOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['DeliveryShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderDeliveryTotals'], ParentType, ContextType>;
  tracking?: Resolver<Maybe<ResolversTypes['DeliveryTracking']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  vouchers?: Resolver<Array<ResolversTypes['DeliveryVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliverySearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliverySearchHit'] = ResolversParentTypes['OrderDeliverySearchHit']> = {
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderDeliverySearchOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['OrderOperationSearchProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderDeliverySearchShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tracking?: Resolver<Maybe<ResolversTypes['OrderDeliverySearchTrackingInfo']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliverySearchOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliverySearchOrderLine'] = ResolversParentTypes['OrderDeliverySearchOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliverySearchShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliverySearchShippingFee'] = ResolversParentTypes['OrderDeliverySearchShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliverySearchTrackingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliverySearchTrackingInfo'] = ResolversParentTypes['OrderDeliverySearchTrackingInfo']> = {
  URL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryTotals'] = ResolversParentTypes['OrderDeliveryTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voucherTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDiscountCodeRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDiscountCodeRule'] = ResolversParentTypes['OrderDiscountCodeRule']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  freeShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDiscountExternalRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDiscountExternalRule'] = ResolversParentTypes['OrderDiscountExternalRule']> = {
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  freeShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDiscountOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDiscountOutcome'] = ResolversParentTypes['OrderDiscountOutcome']> = {
  cartRules?: Resolver<Maybe<Array<ResolversTypes['CartRuleOutcome']>>, ParentType, ContextType>;
  codeRules?: Resolver<Maybe<Array<ResolversTypes['CodeRuleOutcome']>>, ParentType, ContextType>;
  discountReduction?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalRules?: Resolver<Maybe<Array<ResolversTypes['ExternalRuleOutcome']>>, ParentType, ContextType>;
  freeShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shippingTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  totalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDiscountRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDiscountRule'] = ResolversParentTypes['OrderDiscountRule']> = {
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  freeShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGift'] = ResolversParentTypes['OrderGift']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCard'] = ResolversParentTypes['OrderGiftCard']> = {
  __resolveType: TypeResolveFn<'OrderGiftCardBSGGiftCard' | 'OrderGiftCardEmpty' | 'OrderGiftCardKBSGiftCard' | 'OrderGiftCardRetain24', ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderGiftCardBsgGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardBSGGiftCard'] = ResolversParentTypes['OrderGiftCardBSGGiftCard']> = {
  giftCards?: Resolver<Maybe<Array<ResolversTypes['OrderGiftCardItemBSGGiftCard']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardEmpty'] = ResolversParentTypes['OrderGiftCardEmpty']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardItemBsgGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardItemBSGGiftCard'] = ResolversParentTypes['OrderGiftCardItemBSGGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardItemKbsGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardItemKBSGiftCard'] = ResolversParentTypes['OrderGiftCardItemKBSGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardItemRetain24Resolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardItemRetain24'] = ResolversParentTypes['OrderGiftCardItemRetain24']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redeemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardKbsGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardKBSGiftCard'] = ResolversParentTypes['OrderGiftCardKBSGiftCard']> = {
  giftCards?: Resolver<Maybe<Array<ResolversTypes['OrderGiftCardItemKBSGiftCard']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardProduct'] = ResolversParentTypes['OrderGiftCardProduct']> = {
  __resolveType: TypeResolveFn<'OrderGiftCardProductEmpty' | 'OrderGiftCardProductRetain24', ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderGiftCardProductEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardProductEmpty'] = ResolversParentTypes['OrderGiftCardProductEmpty']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardProductItem'] = ResolversParentTypes['OrderGiftCardProductItem']> = {
  __resolveType: TypeResolveFn<'OrderGiftCardProductItemRetain24', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distribution?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderGiftCardProductItemRetain24Resolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardProductItemRetain24'] = ResolversParentTypes['OrderGiftCardProductItemRetain24']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distribution?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  multiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  smsText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardProductRetain24Resolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardProductRetain24'] = ResolversParentTypes['OrderGiftCardProductRetain24']> = {
  giftCardProducts?: Resolver<Maybe<Array<ResolversTypes['OrderGiftCardProductItemRetain24']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGiftCardRetain24Resolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGiftCardRetain24'] = ResolversParentTypes['OrderGiftCardRetain24']> = {
  giftCards?: Resolver<Maybe<Array<ResolversTypes['OrderGiftCardItemRetain24']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistory'] = ResolversParentTypes['OrderHistory']> = {
  history?: Resolver<Array<ResolversTypes['OrderHistoryLogEntry']>, ParentType, ContextType>;
  operations?: Resolver<Maybe<ResolversTypes['OrderHistoryOperations']>, ParentType, ContextType>;
  states?: Resolver<Array<ResolversTypes['OrderState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryLogEntry'] = ResolversParentTypes['OrderHistoryLogEntry']> = {
  actor?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryOperationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryOperations'] = ResolversParentTypes['OrderHistoryOperations']> = {
  compensated?: Resolver<ResolversTypes['OrderHistoryTransactionsCompensated'], ParentType, ContextType>;
  delivered?: Resolver<ResolversTypes['OrderHistoryTransactions'], ParentType, ContextType>;
  refunded?: Resolver<ResolversTypes['OrderHistoryTransactions'], ParentType, ContextType>;
  released?: Resolver<ResolversTypes['OrderHistoryTransactions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionBonus'] = ResolversParentTypes['OrderHistoryTransactionBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionGift'] = ResolversParentTypes['OrderHistoryTransactionGift']> = {
  giftId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionGiftCard'] = ResolversParentTypes['OrderHistoryTransactionGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionGiftCardProduct'] = ResolversParentTypes['OrderHistoryTransactionGiftCardProduct']> = {
  giftCardProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionOrderLine'] = ResolversParentTypes['OrderHistoryTransactionOrderLine']> = {
  orderLineId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionPayment'] = ResolversParentTypes['OrderHistoryTransactionPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionShippingFee'] = ResolversParentTypes['OrderHistoryTransactionShippingFee']> = {
  shippingFeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionVoucher'] = ResolversParentTypes['OrderHistoryTransactionVoucher']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voucherId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactions'] = ResolversParentTypes['OrderHistoryTransactions']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderHistoryTransactionBonus']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['OrderHistoryTransactionGiftCardProduct']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderHistoryTransactionGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['OrderHistoryTransactionGift']>, ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderHistoryTransactionOrderLine']>, ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderHistoryTransactionShippingFee']>, ParentType, ContextType>;
  vouchers?: Resolver<Array<ResolversTypes['OrderHistoryTransactionVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHistoryTransactionsCompensatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHistoryTransactionsCompensated'] = ResolversParentTypes['OrderHistoryTransactionsCompensated']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderHistoryTransactionBonus']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderHistoryTransactionGiftCard']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['OrderHistoryTransactionPayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLine'] = ResolversParentTypes['OrderLine']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['CampaignIdentity']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dimensions?: Resolver<Maybe<ResolversTypes['OrderLineDimensions']>, ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountOutcome?: Resolver<ResolversTypes['OrderLineDiscountOutcome'], ParentType, ContextType>;
  displayDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasExternalPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['OrderLineOption']>, ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineBase'] = ResolversParentTypes['OrderLineBase']> = {
  __resolveType: TypeResolveFn<'OrderLineCreate' | 'OrderLineDelete' | 'OrderLineUpdate', ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['OrderLineCampaign']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OrderLineCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineCampaign'] = ResolversParentTypes['OrderLineCampaign']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  campaignGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderLineCreateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineCreate'] = ResolversParentTypes['OrderLineCreate']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['OrderLineCampaign']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineData'] = ResolversParentTypes['OrderLineData']> = {
  __resolveType: TypeResolveFn<'OrderLineCreate' | 'OrderLineDelete' | 'OrderLineUpdate', ParentType, ContextType>;
};

export type OrderLineDeleteResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineDelete'] = ResolversParentTypes['OrderLineDelete']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['OrderLineCampaign']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineDimensionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineDimensions'] = ResolversParentTypes['OrderLineDimensions']> = {
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineDiscountOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineDiscountOutcome'] = ResolversParentTypes['OrderLineDiscountOutcome']> = {
  bundles?: Resolver<Maybe<Array<ResolversTypes['BundleOutcome']>>, ParentType, ContextType>;
  cartRules?: Resolver<Maybe<Array<ResolversTypes['CartRuleOutcome']>>, ParentType, ContextType>;
  codeRules?: Resolver<Maybe<Array<ResolversTypes['CodeRuleOutcome']>>, ParentType, ContextType>;
  externalRules?: Resolver<Maybe<Array<ResolversTypes['ExternalRuleOutcome']>>, ParentType, ContextType>;
  totalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModification'] = ResolversParentTypes['OrderLineModification']> = {
  data?: Resolver<ResolversTypes['OrderLineModificationData'], ParentType, ContextType>;
  modificationType?: Resolver<ResolversTypes['OrderLineModificationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineModificationCreateDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModificationCreateData'] = ResolversParentTypes['OrderLineModificationCreateData']> = {
  basePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineModificationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModificationData'] = ResolversParentTypes['OrderLineModificationData']> = {
  __resolveType: TypeResolveFn<'OrderLineModificationCreateData' | 'OrderLineModificationDeleteData' | 'OrderLineModificationUpdateData', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderLineModificationDeleteDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModificationDeleteData'] = ResolversParentTypes['OrderLineModificationDeleteData']> = {
  basePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineModificationUpdateDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModificationUpdateData'] = ResolversParentTypes['OrderLineModificationUpdateData']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['OrderLineModificationUpdateDataPrice']>, ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineModificationUpdateDataPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineModificationUpdateDataPrice'] = ResolversParentTypes['OrderLineModificationUpdateDataPrice']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalDiscountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineOption'] = ResolversParentTypes['OrderLineOption']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineUpdateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineUpdate'] = ResolversParentTypes['OrderLineUpdate']> = {
  campaign?: Resolver<Maybe<ResolversTypes['OrderLineCampaign']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['OrderLineUpdatePrice']>, ParentType, ContextType>;
  productParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderLineUpdatePriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderLineUpdatePrice'] = ResolversParentTypes['OrderLineUpdatePrice']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderModification'] = ResolversParentTypes['OrderModification']> = {
  __resolveType: TypeResolveFn<'OrderModificationAddresses' | 'OrderModificationOrderLines' | 'OrderModificationShippingFees', ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderModificationType'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
};

export type OrderModificationAddressesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderModificationAddresses'] = ResolversParentTypes['OrderModificationAddresses']> = {
  addresses?: Resolver<ResolversTypes['OrderAddressesModification'], ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderModificationType'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderModificationOrderLinesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderModificationOrderLines'] = ResolversParentTypes['OrderModificationOrderLines']> = {
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newTotals?: Resolver<Maybe<ResolversTypes['OrderTotals']>, ParentType, ContextType>;
  oldTotals?: Resolver<Maybe<ResolversTypes['OrderTotals']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderLineModification']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderModificationType'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderModificationShippingFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderModificationShippingFees'] = ResolversParentTypes['OrderModificationShippingFees']> = {
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newTotals?: Resolver<Maybe<ResolversTypes['OrderTotals']>, ParentType, ContextType>;
  oldTotals?: Resolver<Maybe<ResolversTypes['OrderTotals']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['ShippingFeeModification']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderModificationType'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationAddressDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationAddressData'] = ResolversParentTypes['OrderOperationAddressData']> = {
  billingAddress?: Resolver<Maybe<ResolversTypes['OrderOperationAddressModificationUpdateAddress']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['OrderOperationAddressModificationUpdateAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationAddressModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationAddressModification'] = ResolversParentTypes['OrderOperationAddressModification']> = {
  data?: Resolver<Maybe<ResolversTypes['OrderOperationAddressData']>, ParentType, ContextType>;
  modificationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prev?: Resolver<Maybe<ResolversTypes['OrderOperationAddressData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationAddressModificationUpdateAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationAddressModificationUpdateAddress'] = ResolversParentTypes['OrderOperationAddressModificationUpdateAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateOrProvince?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddress2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationResult'] = ResolversParentTypes['OrderOperationResult']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchActor'] = ResolversParentTypes['OrderOperationSearchActor']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchBonus'] = ResolversParentTypes['OrderOperationSearchBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchFee'] = ResolversParentTypes['OrderOperationSearchFee']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchGift'] = ResolversParentTypes['OrderOperationSearchGift']> = {
  giftId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchGiftCard'] = ResolversParentTypes['OrderOperationSearchGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchHit'] = ResolversParentTypes['OrderOperationSearchHit']> = {
  __resolveType: TypeResolveFn<'OrderAddressesModificationSearchHit' | 'OrderCancellationSearchHit' | 'OrderCompensationSearchHit' | 'OrderDeliverySearchHit' | 'OrderOrderLinesModificationSearchHit' | 'OrderRefundSearchHit' | 'OrderReleaseSearchHit' | 'OrderShippingFeesModificationSearchHit', ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
};

export type OrderOperationSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchHits'] = ResolversParentTypes['OrderOperationSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['OrderOperationSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchOrderLine'] = ResolversParentTypes['OrderOperationSearchOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchProvider'] = ResolversParentTypes['OrderOperationSearchProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OrderCompensationSearchProviderStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchReason'] = ResolversParentTypes['OrderOperationSearchReason']> = {
  cause?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOperationSearchShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOperationSearchShippingFee'] = ResolversParentTypes['OrderOperationSearchShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOrderLinesModificationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOrderLinesModificationSearchHit'] = ResolversParentTypes['OrderOrderLinesModificationSearchHit']> = {
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderOrderLinesModificationSearchOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderOrderLinesModificationSearchOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderOrderLinesModificationSearchOrderLine'] = ResolversParentTypes['OrderOrderLinesModificationSearchOrderLine']> = {
  data?: Resolver<Maybe<ResolversTypes['OrderLineData']>, ParentType, ContextType>;
  modificationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prev?: Resolver<Maybe<ResolversTypes['OrderLineData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPayment'] = ResolversParentTypes['OrderPayment']> = {
  __resolveType: TypeResolveFn<'OrderPaymentAdyen' | 'OrderPaymentAvarda' | 'OrderPaymentBrinkZeroPayment' | 'OrderPaymentCustomPayment' | 'OrderPaymentKlarnaCheckout' | 'OrderPaymentLedyer' | 'OrderPaymentQliroOne' | 'OrderPaymentSveaCheckout' | 'OrderPaymentWalleyCheckout' | 'OrderPaymentZaver', ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderPaymentAdyenResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentAdyen'] = ResolversParentTypes['OrderPaymentAdyen']> = {
  deepLinkPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantAccountCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethodVariant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  potentialFraud?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentAvardaResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentAvarda'] = ResolversParentTypes['OrderPaymentAvarda']> = {
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentBrinkZeroPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentBrinkZeroPayment'] = ResolversParentTypes['OrderPaymentBrinkZeroPayment']> = {
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalProvider?: Resolver<ResolversTypes['OrderPaymentBrinkZeroPaymentOriginalProvider'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentBrinkZeroPaymentOriginalProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentBrinkZeroPaymentOriginalProvider'] = ResolversParentTypes['OrderPaymentBrinkZeroPaymentOriginalProvider']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentCustomPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentCustomPayment'] = ResolversParentTypes['OrderPaymentCustomPayment']> = {
  customPaymentSessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentKlarnaCheckoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentKlarnaCheckout'] = ResolversParentTypes['OrderPaymentKlarnaCheckout']> = {
  deepLinkPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fraudStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  klarnaMerchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  klarnaOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentLedyerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentLedyer'] = ResolversParentTypes['OrderPaymentLedyer']> = {
  companyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledyerOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentQliroOneResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentQliroOne'] = ResolversParentTypes['OrderPaymentQliroOne']> = {
  identityVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  merchantProvidedQuestionAnswer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderItems?: Resolver<Maybe<Array<ResolversTypes['OrderPaymentQliroOneOrderItem']>>, ParentType, ContextType>;
  paymentTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  qliroOrderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requireIdentityVerification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  signupForNewsletter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  upsell?: Resolver<Maybe<ResolversTypes['OrderPaymentQliroOneUpsell']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentQliroOneOrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentQliroOneOrderItem'] = ResolversParentTypes['OrderPaymentQliroOneOrderItem']> = {
  merchantReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentTransactionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentQliroOneUpsellResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentQliroOneUpsell'] = ResolversParentTypes['OrderPaymentQliroOneUpsell']> = {
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderPaymentQliroOneUpsellItems']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderPaymentQliroOneUpsellTotals'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentQliroOneUpsellItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentQliroOneUpsellItems'] = ResolversParentTypes['OrderPaymentQliroOneUpsellItems']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentQliroOneUpsellTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentQliroOneUpsellTotals'] = ResolversParentTypes['OrderPaymentQliroOneUpsellTotals']> = {
  discountTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentSveaCheckoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentSveaCheckout'] = ResolversParentTypes['OrderPaymentSveaCheckout']> = {
  expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCompany?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  peppolId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sveaMerchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sveaOrderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentWalleyCheckoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentWalleyCheckout'] = ResolversParentTypes['OrderPaymentWalleyCheckout']> = {
  amountToPay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchaseIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchaseResult?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentZaverResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentZaver'] = ResolversParentTypes['OrderPaymentZaver']> = {
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useVerifiedAddress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPromotion'] = ResolversParentTypes['OrderPromotion']> = {
  __resolveType: TypeResolveFn<'OrderPromotionEmpty' | 'OrderPromotionVoyado', ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderPromotionEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPromotionEmpty'] = ResolversParentTypes['OrderPromotionEmpty']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPromotionItemVoyadoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPromotionItemVoyado'] = ResolversParentTypes['OrderPromotionItemVoyado']> = {
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPromotionVoyadoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPromotionVoyado'] = ResolversParentTypes['OrderPromotionVoyado']> = {
  contactId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  promotions?: Resolver<Maybe<Array<ResolversTypes['OrderPromotionItemVoyado']>>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefund'] = ResolversParentTypes['OrderRefund']> = {
  bonus?: Resolver<Maybe<ResolversTypes['RefundBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['RefundFee']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['RefundGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['RefundGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['RefundGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['RefundOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  refundedPayment?: Resolver<Maybe<ResolversTypes['RefundedPayment']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['RefundShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderRefundTotals'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  vouchers?: Resolver<Array<ResolversTypes['RefundVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundSearchGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefundSearchGiftCardProduct'] = ResolversParentTypes['OrderRefundSearchGiftCardProduct']> = {
  cancelErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelErrorStatusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cancelTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createFailedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefundSearchHit'] = ResolversParentTypes['OrderRefundSearchHit']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderOperationSearchBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['OrderOperationSearchFee']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['OrderRefundSearchGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderOperationSearchGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['OrderOperationSearchGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderOperationSearchOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['OrderOperationSearchProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  refundedPayment?: Resolver<Maybe<ResolversTypes['OrderRefundSearchPayment']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderOperationSearchShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderRefundSearchTotals'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundSearchPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefundSearchPayment'] = ResolversParentTypes['OrderRefundSearchPayment']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundSearchTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefundSearchTotals'] = ResolversParentTypes['OrderRefundSearchTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRefundTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRefundTotals'] = ResolversParentTypes['OrderRefundTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voucherTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReleaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRelease'] = ResolversParentTypes['OrderRelease']> = {
  bonus?: Resolver<Maybe<ResolversTypes['ReleaseBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['BonusProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['GiftCardProductProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['ReleaseGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['GiftCardProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['ReleaseGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['ReleaseGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['ReleaseOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['PromotionProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  releasedPayment?: Resolver<Maybe<ResolversTypes['ReleasedPayment']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['ReleaseShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['ShippingProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['VoucherProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReleaseSearchGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderReleaseSearchGiftCardProduct'] = ResolversParentTypes['OrderReleaseSearchGiftCardProduct']> = {
  createFailedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReleaseSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderReleaseSearchHit'] = ResolversParentTypes['OrderReleaseSearchHit']> = {
  bonus?: Resolver<Maybe<ResolversTypes['OrderOperationSearchBonus']>, ParentType, ContextType>;
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['OrderReleaseSearchGiftCardProduct']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['OrderOperationSearchGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['OrderOperationSearchGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['OrderOperationSearchOrderLine']>, ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['OrderOperationSearchProvider'], ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  refundedPayment?: Resolver<Maybe<ResolversTypes['OrderReleaseSearchPayment']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderOperationSearchShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderReleaseSearchTotals'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReleaseSearchPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderReleaseSearchPayment'] = ResolversParentTypes['OrderReleaseSearchPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReleaseSearchTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderReleaseSearchTotals'] = ResolversParentTypes['OrderReleaseSearchTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderReservation'] = ResolversParentTypes['OrderReservation']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedProductVariants?: Resolver<Array<ResolversTypes['ProductVariantReservation']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSearchHit'] = ResolversParentTypes['OrderSearchHit']> = {
  billingAddress?: Resolver<ResolversTypes['OrderAddress'], ParentType, ContextType>;
  channelType?: Resolver<Maybe<ResolversTypes['ChannelType']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  discountCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  discountExternalReferences?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isTaxExempt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxExemptionEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantReference1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantReference2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProviderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingAddress?: Resolver<ResolversTypes['OrderAddress'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderStatus'], ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['OrderTotals'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSearchHits'] = ResolversParentTypes['OrderSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['OrderSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShipping'] = ResolversParentTypes['OrderShipping']> = {
  __resolveType: TypeResolveFn<'OrderShippingAvardaShippingBroker' | 'OrderShippingEmpty' | 'OrderShippingIngrid' | 'OrderShippingKlarnaShippingAssistant' | 'OrderShippingNshift' | 'OrderShippingQliroIntegratedShipping' | 'OrderShippingWalleyDeliveryModule', ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderShippingAvardaShippingBrokerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingAvardaShippingBroker'] = ResolversParentTypes['OrderShippingAvardaShippingBroker']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['AvardaShippingBrokerShipping']>, ParentType, ContextType>;
  shippingBroker?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingEmpty'] = ResolversParentTypes['OrderShippingEmpty']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingFeesModificationSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingFeesModificationSearchHit'] = ResolversParentTypes['OrderShippingFeesModificationSearchHit']> = {
  bonusProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['OrderOperationSearchActor'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  giftCardProductProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  giftCardProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  promotionProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['OrderOperationSearchReason']>, ParentType, ContextType>;
  restarted?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  restartedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  restarts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['OrderShippingFeesModificationSearchShippingFee']>, ParentType, ContextType>;
  shippingProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  startedBy?: Resolver<Maybe<ResolversTypes['OrderOperationSearchActor']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  voucherProvider?: Resolver<Maybe<ResolversTypes['OrderOperationSearchProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingFeesModificationSearchShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingFeesModificationSearchShippingFee'] = ResolversParentTypes['OrderShippingFeesModificationSearchShippingFee']> = {
  data?: Resolver<Maybe<ResolversTypes['ShippingFeeData']>, ParentType, ContextType>;
  modificationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prev?: Resolver<Maybe<ResolversTypes['ShippingFeeData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingIngridResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingIngrid'] = ResolversParentTypes['OrderShippingIngrid']> = {
  deliveries?: Resolver<Maybe<Array<ResolversTypes['IngridDelivery']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingKlarnaShippingAssistantResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingKlarnaShippingAssistant'] = ResolversParentTypes['OrderShippingKlarnaShippingAssistant']> = {
  klarnaMerchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  klarnaOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selectedShippingOption?: Resolver<ResolversTypes['KlarnaShippingAssistantSelectedShippingOption'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingNshiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingNshift'] = ResolversParentTypes['OrderShippingNshift']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preparedShipment?: Resolver<Maybe<ResolversTypes['NshiftPreparedShipment']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingQliroIntegratedShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingQliroIntegratedShipping'] = ResolversParentTypes['OrderShippingQliroIntegratedShipping']> = {
  ingrid?: Resolver<Maybe<ResolversTypes['QliroIngrid']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shipments?: Resolver<Array<ResolversTypes['QliroShipmentOrderItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShippingWalleyDeliveryModuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShippingWalleyDeliveryModule'] = ResolversParentTypes['OrderShippingWalleyDeliveryModule']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchaseIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shipping?: Resolver<ResolversTypes['WalleyDeliveryModuleShipping'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderStatus'] = ResolversParentTypes['OrderStatus']> = {
  customStates?: Resolver<Maybe<Array<ResolversTypes['OrderCustomState']>>, ParentType, ContextType>;
  orderStates?: Resolver<Array<ResolversTypes['OrderState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderTotals'] = ResolversParentTypes['OrderTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voucherTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderVoucher'] = ResolversParentTypes['OrderVoucher']> = {
  __resolveType: TypeResolveFn<'OrderVoucherEmpty' | 'OrderVoucherVoyado', ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderVoucherEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderVoucherEmpty'] = ResolversParentTypes['OrderVoucherEmpty']> = {
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderVoucherItemVoyadoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderVoucherItemVoyado'] = ResolversParentTypes['OrderVoucherItemVoyado']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  checkNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderVoucherVoyadoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderVoucherVoyado'] = ResolversParentTypes['OrderVoucherVoyado']> = {
  contactId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vouchers?: Resolver<Maybe<Array<ResolversTypes['OrderVoucherItemVoyado']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflow'] = ResolversParentTypes['OrderWorkflow']> = {
  Revisions?: Resolver<Array<ResolversTypes['OrderWorkflowRevision']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['OrderWorkflowTrigger']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecution'] = ResolversParentTypes['OrderWorkflowExecution']> = {
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OrderWorkflowExecutionNodeTrigger'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  workflowId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  workflowRevision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNode'] = ResolversParentTypes['OrderWorkflowExecutionNode']> = {
  __resolveType: TypeResolveFn<'OrderWorkflowExecutionNodeAction' | 'OrderWorkflowExecutionNodeBranch' | 'OrderWorkflowExecutionNodeBranchCondition' | 'OrderWorkflowExecutionNodeCondition', ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNodeAction'] = ResolversParentTypes['OrderWorkflowExecutionNodeAction']> = {
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  do?: Resolver<ResolversTypes['OrderWorkflowNodeActionDo'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeBranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNodeBranch'] = ResolversParentTypes['OrderWorkflowExecutionNodeBranch']> = {
  branches?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNodeBranchCondition']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  otherwise?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNode']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeBranchConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNodeBranchCondition'] = ResolversParentTypes['OrderWorkflowExecutionNodeBranchCondition']> = {
  check?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  matched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNodeCondition'] = ResolversParentTypes['OrderWorkflowExecutionNodeCondition']> = {
  check?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  matched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  otherwise?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNode']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionNodeTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionNodeTrigger'] = ResolversParentTypes['OrderWorkflowExecutionNodeTrigger']> = {
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  executionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionSearchHit'] = ResolversParentTypes['OrderWorkflowExecutionSearchHit']> = {
  completed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  started?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  workflowId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  workflowRevision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowExecutionSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowExecutionSearchHits'] = ResolversParentTypes['OrderWorkflowExecutionSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['OrderWorkflowExecutionSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNode'] = ResolversParentTypes['OrderWorkflowNode']> = {
  __resolveType: TypeResolveFn<'OrderWorkflowNodeAction' | 'OrderWorkflowNodeBranch' | 'OrderWorkflowNodeCondition', ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderWorkflowNodeActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeAction'] = ResolversParentTypes['OrderWorkflowNodeAction']> = {
  do?: Resolver<ResolversTypes['OrderWorkflowNodeActionDo'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeActionDoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeActionDo'] = ResolversParentTypes['OrderWorkflowNodeActionDo']> = {
  __resolveType: TypeResolveFn<'OrderWorkflowNodeActionDoCancellation' | 'OrderWorkflowNodeActionDoCustomState', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderWorkflowNodeActionDoCancellationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeActionDoCancellation'] = ResolversParentTypes['OrderWorkflowNodeActionDoCancellation']> = {
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeActionDoCustomStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeActionDoCustomState'] = ResolversParentTypes['OrderWorkflowNodeActionDoCustomState']> = {
  customState?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeBranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeBranch'] = ResolversParentTypes['OrderWorkflowNodeBranch']> = {
  branches?: Resolver<Array<ResolversTypes['OrderWorkflowNodeBranchCondition']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherwise?: Resolver<Array<ResolversTypes['OrderWorkflowNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeBranchConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeBranchCondition'] = ResolversParentTypes['OrderWorkflowNodeBranchCondition']> = {
  check?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeCondition'] = ResolversParentTypes['OrderWorkflowNodeCondition']> = {
  check?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherwise?: Resolver<Array<ResolversTypes['OrderWorkflowNode']>, ParentType, ContextType>;
  then?: Resolver<Array<ResolversTypes['OrderWorkflowNode']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheck'] = ResolversParentTypes['OrderWorkflowNodeConditionCheck']> = {
  __resolveType: TypeResolveFn<'OrderWorkflowNodeConditionCheckAnd' | 'OrderWorkflowNodeConditionCheckCustomHTTP' | 'OrderWorkflowNodeConditionCheckOr' | 'OrderWorkflowNodeConditionCheckOrderDate' | 'OrderWorkflowNodeConditionCheckOrderLineCampaign' | 'OrderWorkflowNodeConditionCheckOrderLineCustomAttributes' | 'OrderWorkflowNodeConditionCheckOrderLineOptions' | 'OrderWorkflowNodeConditionCheckOrderLineProductParentId' | 'OrderWorkflowNodeConditionCheckOrderLineProductVariantId' | 'OrderWorkflowNodeConditionCheckOrderLineTags' | 'OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal' | 'OrderWorkflowNodeConditionCheckPaymentProviderMethod' | 'OrderWorkflowNodeConditionCheckPaymentProviderName' | 'OrderWorkflowNodeConditionCheckPaymentProviderStatus', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckAndResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckAnd'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckAnd']> = {
  check1?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  check2?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckCustomHttpResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckCustomHTTP'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckCustomHTTP']> = {
  customData?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  endpoint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOr'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOr']> = {
  check1?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  check2?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheck'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderDate'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderDate']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaign'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaign']> = {
  fields?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignFields'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaignFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignField'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignField']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCampaignFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignFields'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignFields']> = {
  campaignGroupId?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignField']>, ParentType, ContextType>;
  campaignId?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignField']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCampaignField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributes'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributes']> = {
  keyValue?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue']> = {
  key?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptions'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptions']> = {
  keyValue?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKey'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKey']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue']> = {
  key?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsKey']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineOptionsValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineOptionsValue']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineProductParentIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineProductParentId'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineProductParentId']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineProductVariantIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineProductVariantId'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineProductVariantId']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTags'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTags']> = {
  keyValue?: Resolver<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKey'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKey']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsKeyValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue']> = {
  key?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineTagsKey']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['OrderWorkflowNodeConditionCheckOrderLineTagsValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderLineTagsValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsValue'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderLineTagsValue']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckOrderTotalsGrandTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderMethod'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderMethod']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderName'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderName']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowNodeConditionCheckPaymentProviderStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderStatus'] = ResolversParentTypes['OrderWorkflowNodeConditionCheckPaymentProviderStatus']> = {
  comparison?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowRevisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowRevision'] = ResolversParentTypes['OrderWorkflowRevision']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['OrderWorkflowTrigger']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  then?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowSearchHit'] = ResolversParentTypes['OrderWorkflowSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowSearchHits'] = ResolversParentTypes['OrderWorkflowSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['OrderWorkflowSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowTrigger'] = ResolversParentTypes['OrderWorkflowTrigger']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  published?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderWorkflowTriggersResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderWorkflowTriggers'] = ResolversParentTypes['OrderWorkflowTriggers']> = {
  triggers?: Resolver<Array<ResolversTypes['OrderWorkflowTrigger']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Outcome'] = ResolversParentTypes['Outcome']> = {
  combineItemDiscount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  discountItemRule?: Resolver<Maybe<ResolversTypes['ItemRule']>, ParentType, ContextType>;
  discountQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountValue?: Resolver<Maybe<ResolversTypes['DiscountValue']>, ParentType, ContextType>;
  gifts?: Resolver<Maybe<Array<ResolversTypes['Gift']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurrent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shippingTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  subOutcomes?: Resolver<Maybe<Array<ResolversTypes['SubOutcome']>>, ParentType, ContextType>;
  triggerItemRule?: Resolver<Maybe<ResolversTypes['ItemRule']>, ParentType, ContextType>;
  triggerQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentProvider'] = ResolversParentTypes['PaymentProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['PaymentProviderName'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProviderStatusLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformConfig'] = ResolversParentTypes['PlatformConfig']> = {
  externalApi?: Resolver<ResolversTypes['ExternalApi'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Price'] = ResolversParentTypes['Price']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['CampaignIdentity']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lowestPriceRecord?: Resolver<Maybe<ResolversTypes['PriceRecord']>, ParentType, ContextType>;
  priceRecords?: Resolver<Array<ResolversTypes['PriceRecord']>, ParentType, ContextType>;
  referencePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceRecord'] = ResolversParentTypes['PriceRecord']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['CampaignIdentity']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceRule'] = ResolversParentTypes['PriceRule']> = {
  monies?: Resolver<Maybe<Array<ResolversTypes['CampaignMoney']>>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductParentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductParent'] = ResolversParentTypes['ProductParent']> = {
  Variants?: Resolver<Maybe<Array<ResolversTypes['ProductVariant']>>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayDescriptions?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  displayNames?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductParentSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductParentSearchHit'] = ResolversParentTypes['ProductParentSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductParentSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductParentSearchHits'] = ResolversParentTypes['ProductParentSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['ProductParentSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariant'] = ResolversParentTypes['ProductVariant']> = {
  Stock?: Resolver<Maybe<ResolversTypes['Stock']>, ParentType, ContextType>;
  StoreGroupPrices?: Resolver<Array<ResolversTypes['StoreGroupPrice']>, ParentType, ContextType>;
  TaxGroup?: Resolver<ResolversTypes['TaxGroup'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dimensions?: Resolver<Maybe<ResolversTypes['Dimensions']>, ParentType, ContextType>;
  displayDescriptions?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  displayNames?: Resolver<ResolversTypes['AWSJSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shippingAttributes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariantReservation'] = ResolversParentTypes['ProductVariantReservation']> = {
  inventoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariantRules'] = ResolversParentTypes['ProductVariantRules']> = {
  tagLogic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariantSearchHit'] = ResolversParentTypes['ProductVariantSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['KeyValue']>>, ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariantSearchHits'] = ResolversParentTypes['ProductVariantSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['ProductVariantSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionProvider'] = ResolversParentTypes['PromotionProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['PromotionProviderName'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Provider'] = ResolversParentTypes['Provider']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProviderStatusLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderStatusLog'] = ResolversParentTypes['ProviderStatusLog']> = {
  current?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  history?: Resolver<Array<ResolversTypes['ProviderStatusLogEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProviderStatusLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderStatusLogEntry'] = ResolversParentTypes['ProviderStatusLogEntry']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroIngridResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroIngrid'] = ResolversParentTypes['QliroIngrid']> = {
  checkoutSessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveries?: Resolver<Maybe<Array<ResolversTypes['QliroIngridDelivery']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroIngridDeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroIngridDelivery'] = ResolversParentTypes['QliroIngridDelivery']> = {
  carrierProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryAddress?: Resolver<Maybe<ResolversTypes['QliroIngridDeliveryAddress']>, ParentType, ContextType>;
  deliveryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationExternalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tosId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroIngridDeliveryAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroIngridDeliveryAddress'] = ResolversParentTypes['QliroIngridDeliveryAddress']> = {
  addressLines?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroOneConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroOneConfig'] = ResolversParentTypes['QliroOneConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['QliroOneCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integratedShipping?: Resolver<Maybe<ResolversTypes['QliroOneIntegratedShipping']>, ParentType, ContextType>;
  merchantOrderManagementStatusPushUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  useLegacyIds?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroOneCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroOneCredentials'] = ResolversParentTypes['QliroOneCredentials']> = {
  merchantApiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantApiSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroOneIntegratedShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroOneIntegratedShipping'] = ResolversParentTypes['QliroOneIntegratedShipping']> = {
  deliveryCheckoutId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantOrderAvailableShippingMethodsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroShipmentOrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroShipmentOrderItem'] = ResolversParentTypes['QliroShipmentOrderItem']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['QliroShipmentOrderItemMetadata']>, ParentType, ContextType>;
  paymentTransactionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pricePerItemExVat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricePerItemIncVat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QliroShipmentOrderItemMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['QliroShipmentOrderItemMetadata'] = ResolversParentTypes['QliroShipmentOrderItemMetadata']> = {
  shippingMethodMerchantReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  Configuration?: Resolver<Maybe<ResolversTypes['QueryConfigurationManagement']>, ParentType, ContextType>;
  Order?: Resolver<ResolversTypes['QueryOrderManagement'], ParentType, ContextType>;
  PlatformConfig?: Resolver<Maybe<ResolversTypes['QueryPlatformConfig']>, ParentType, ContextType>;
  Product?: Resolver<ResolversTypes['QueryProductManagement'], ParentType, ContextType>;
  apiClient?: Resolver<ResolversTypes['ApiClientDetails'], ParentType, ContextType, RequireFields<QueryApiClientArgs, 'clientId'>>;
  apiClients?: Resolver<ResolversTypes['ApiClientsList'], ParentType, ContextType, RequireFields<QueryApiClientsArgs, 'limit'>>;
  apiResources?: Resolver<Array<ResolversTypes['ApiResource']>, ParentType, ContextType>;
  getAdyenConfig?: Resolver<ResolversTypes['AdyenConfig'], ParentType, ContextType, RequireFields<QueryGetAdyenConfigArgs, 'id'>>;
  getAdyenWebhooks?: Resolver<Array<ResolversTypes['AdyenWebhookLegacy']>, ParentType, ContextType>;
  getAvardaConfig?: Resolver<ResolversTypes['AvardaConfig'], ParentType, ContextType, RequireFields<QueryGetAvardaConfigArgs, 'id'>>;
  getBSGGiftCardConfig?: Resolver<ResolversTypes['BSGGiftCardConfig'], ParentType, ContextType, RequireFields<QueryGetBsgGiftCardConfigArgs, 'id'>>;
  getBonusConfig?: Resolver<ResolversTypes['BonusConfig'], ParentType, ContextType, RequireFields<QueryGetBonusConfigArgs, 'id'>>;
  getBonusConfigs?: Resolver<Array<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  getBundleGroup?: Resolver<ResolversTypes['BundleGroup'], ParentType, ContextType, RequireFields<QueryGetBundleGroupArgs, 'id'>>;
  getCampaign?: Resolver<ResolversTypes['Campaign'], ParentType, ContextType, RequireFields<QueryGetCampaignArgs, 'id'>>;
  getCampaignGroup?: Resolver<ResolversTypes['CampaignGroupList'], ParentType, ContextType, RequireFields<QueryGetCampaignGroupArgs, 'id'>>;
  getCurrencyRates?: Resolver<Maybe<ResolversTypes['CurrencyRates']>, ParentType, ContextType, RequireFields<QueryGetCurrencyRatesArgs, 'baseCurrencyCode' | 'filterCurrencies'>>;
  getCustomPaymentConfig?: Resolver<ResolversTypes['CustomPaymentConfig'], ParentType, ContextType, RequireFields<QueryGetCustomPaymentConfigArgs, 'id'>>;
  getDiscountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<QueryGetDiscountCodeArgs, 'code'>>;
  getDiscountCodeRule?: Resolver<ResolversTypes['DiscountCodeRule'], ParentType, ContextType, RequireFields<QueryGetDiscountCodeRuleArgs, 'id'>>;
  getDiscountExternalRule?: Resolver<ResolversTypes['DiscountExternalRule'], ParentType, ContextType, RequireFields<QueryGetDiscountExternalRuleArgs, 'id'>>;
  getDiscountRule?: Resolver<ResolversTypes['DiscountRule'], ParentType, ContextType, RequireFields<QueryGetDiscountRuleArgs, 'id'>>;
  getExternalEventsDestinationAPI?: Resolver<ResolversTypes['ExternalEventDestinationAPI'], ParentType, ContextType, RequireFields<QueryGetExternalEventsDestinationApiArgs, 'destName'>>;
  getExternalEventsDestinationAPIs?: Resolver<ResolversTypes['ExternalEventDestinationAPIs'], ParentType, ContextType>;
  getExternalEventsDestinationEventBuses?: Resolver<ResolversTypes['ExternalEventDestinationEventBuses'], ParentType, ContextType>;
  getExternalEventsRule?: Resolver<ResolversTypes['ExternalEventRuleState'], ParentType, ContextType, RequireFields<QueryGetExternalEventsRuleArgs, 'ruleName'>>;
  getExternalEventsRules?: Resolver<ResolversTypes['ExternalEventRules'], ParentType, ContextType>;
  getExternalPriceConfig?: Resolver<ResolversTypes['ExternalPriceConfig'], ParentType, ContextType, RequireFields<QueryGetExternalPriceConfigArgs, 'id'>>;
  getExternalPriceConfigs?: Resolver<Array<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  getGenerateCodes?: Resolver<ResolversTypes['GenerateCodes'], ParentType, ContextType, RequireFields<QueryGetGenerateCodesArgs, 'jobId'>>;
  getGiftCardProviders?: Resolver<Array<ResolversTypes['Provider']>, ParentType, ContextType>;
  getIngridConfig?: Resolver<ResolversTypes['IngridConfig'], ParentType, ContextType, RequireFields<QueryGetIngridConfigArgs, 'id'>>;
  getInventories?: Resolver<Array<ResolversTypes['Inventory']>, ParentType, ContextType>;
  getInventory?: Resolver<ResolversTypes['Inventory'], ParentType, ContextType, RequireFields<QueryGetInventoryArgs, 'id'>>;
  getInventoryStoreMarket?: Resolver<ResolversTypes['InventoryStoreMarket'], ParentType, ContextType, RequireFields<QueryGetInventoryStoreMarketArgs, 'countryCode' | 'storeGroupId'>>;
  getKBSGiftCardConfig?: Resolver<ResolversTypes['KBSGiftCardConfig'], ParentType, ContextType, RequireFields<QueryGetKbsGiftCardConfigArgs, 'id'>>;
  getKlarnaCheckoutConfig?: Resolver<ResolversTypes['KlarnaCheckoutConfig'], ParentType, ContextType, RequireFields<QueryGetKlarnaCheckoutConfigArgs, 'id'>>;
  getLedyerConfig?: Resolver<ResolversTypes['LedyerConfig'], ParentType, ContextType, RequireFields<QueryGetLedyerConfigArgs, 'id'>>;
  getNShiftConfig?: Resolver<ResolversTypes['NShiftConfig'], ParentType, ContextType, RequireFields<QueryGetNShiftConfigArgs, 'id'>>;
  getPaymentProviders?: Resolver<Array<ResolversTypes['Provider']>, ParentType, ContextType>;
  getQliroOneConfig?: Resolver<ResolversTypes['QliroOneConfig'], ParentType, ContextType, RequireFields<QueryGetQliroOneConfigArgs, 'id'>>;
  getRetain24Config?: Resolver<ResolversTypes['Retain24Config'], ParentType, ContextType, RequireFields<QueryGetRetain24ConfigArgs, 'id'>>;
  getShippingProviders?: Resolver<Array<ResolversTypes['Provider']>, ParentType, ContextType>;
  getShippingTaxGroup?: Resolver<ResolversTypes['ShippingTaxGroup'], ParentType, ContextType>;
  getStoreGroup?: Resolver<ResolversTypes['StoreGroup'], ParentType, ContextType, RequireFields<QueryGetStoreGroupArgs, 'id'>>;
  getStoreGroups?: Resolver<Array<ResolversTypes['StoreGroup']>, ParentType, ContextType>;
  getSveaCheckoutConfig?: Resolver<ResolversTypes['SveaCheckoutConfig'], ParentType, ContextType, RequireFields<QueryGetSveaCheckoutConfigArgs, 'id'>>;
  getTaxGroup?: Resolver<ResolversTypes['TaxGroup'], ParentType, ContextType, RequireFields<QueryGetTaxGroupArgs, 'id'>>;
  getTaxJarConfig?: Resolver<ResolversTypes['TaxJarConfig'], ParentType, ContextType, RequireFields<QueryGetTaxJarConfigArgs, 'id'>>;
  getTaxJarConfigs?: Resolver<Array<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  getTaxMarkets?: Resolver<Array<ResolversTypes['TaxMarket']>, ParentType, ContextType, RequireFields<QueryGetTaxMarketsArgs, 'taxGroupId'>>;
  getTaxProviders?: Resolver<Array<ResolversTypes['Provider']>, ParentType, ContextType>;
  getVoyadoConfig?: Resolver<ResolversTypes['VoyadoConfig'], ParentType, ContextType, RequireFields<QueryGetVoyadoConfigArgs, 'id'>>;
  getVoyadoConfigs?: Resolver<Array<ResolversTypes['CapabilityProvider']>, ParentType, ContextType>;
  getWalleyCheckoutConfig?: Resolver<ResolversTypes['WalleyCheckoutConfig'], ParentType, ContextType, RequireFields<QueryGetWalleyCheckoutConfigArgs, 'id'>>;
  getZaverConfig?: Resolver<ResolversTypes['ZaverConfig'], ParentType, ContextType, RequireFields<QueryGetZaverConfigArgs, 'id'>>;
  groupUsers?: Resolver<ResolversTypes['UsersList'], ParentType, ContextType, RequireFields<QueryGroupUsersArgs, 'groupname' | 'limit'>>;
  groups?: Resolver<Maybe<ResolversTypes['GroupsList']>, ParentType, ContextType, RequireFields<QueryGroupsArgs, 'limit'>>;
  identityProviders?: Resolver<Array<ResolversTypes['IdentityProvider']>, ParentType, ContextType>;
  searchBundleGroups?: Resolver<ResolversTypes['BundleGroupSearchHits'], ParentType, ContextType, RequireFields<QuerySearchBundleGroupsArgs, 'from' | 'size'>>;
  searchCampaignGroups?: Resolver<ResolversTypes['CampaignGroupSearchHits'], ParentType, ContextType, RequireFields<QuerySearchCampaignGroupsArgs, 'from' | 'size'>>;
  searchCampaigns?: Resolver<ResolversTypes['CampaignSearchHits'], ParentType, ContextType, RequireFields<QuerySearchCampaignsArgs, 'from' | 'size'>>;
  searchCodesGenerations?: Resolver<ResolversTypes['CodesGenerationSearchHits'], ParentType, ContextType, RequireFields<QuerySearchCodesGenerationsArgs, 'from' | 'size'>>;
  searchDiscountCodeRules?: Resolver<ResolversTypes['DiscountCodeRuleSearchHits'], ParentType, ContextType, RequireFields<QuerySearchDiscountCodeRulesArgs, 'from' | 'size'>>;
  searchDiscountCodes?: Resolver<ResolversTypes['DiscountCodeSearchHits'], ParentType, ContextType, RequireFields<QuerySearchDiscountCodesArgs, 'from' | 'size'>>;
  searchDiscountExternalRules?: Resolver<ResolversTypes['DiscountExternalRuleSearchHits'], ParentType, ContextType, RequireFields<QuerySearchDiscountExternalRulesArgs, 'from' | 'size'>>;
  searchDiscountRules?: Resolver<ResolversTypes['DiscountRuleSearchHits'], ParentType, ContextType, RequireFields<QuerySearchDiscountRulesArgs, 'from' | 'size'>>;
  searchOrderOperations?: Resolver<ResolversTypes['OrderOperationSearchHits'], ParentType, ContextType, Partial<QuerySearchOrderOperationsArgs>>;
  searchOrderWorkflowExecutions?: Resolver<ResolversTypes['OrderWorkflowExecutionSearchHits'], ParentType, ContextType, RequireFields<QuerySearchOrderWorkflowExecutionsArgs, 'from' | 'size'>>;
  searchOrderWorkflows?: Resolver<ResolversTypes['OrderWorkflowSearchHits'], ParentType, ContextType, RequireFields<QuerySearchOrderWorkflowsArgs, 'from' | 'size'>>;
  searchOrders?: Resolver<ResolversTypes['OrderSearchHits'], ParentType, ContextType, RequireFields<QuerySearchOrdersArgs, 'from' | 'size'>>;
  searchProductParents?: Resolver<ResolversTypes['ProductParentSearchHits'], ParentType, ContextType, RequireFields<QuerySearchProductParentsArgs, 'from' | 'size'>>;
  searchProductVariants?: Resolver<ResolversTypes['ProductVariantSearchHits'], ParentType, ContextType, RequireFields<QuerySearchProductVariantsArgs, 'from' | 'size'>>;
  searchShopperInsights?: Resolver<ResolversTypes['ShopperInsightsSearchHits'], ParentType, ContextType, Partial<QuerySearchShopperInsightsArgs>>;
  searchStoreGroups?: Resolver<ResolversTypes['StoreGroupSearchHits'], ParentType, ContextType, RequireFields<QuerySearchStoreGroupsArgs, 'from' | 'size'>>;
  searchStoreMarkets?: Resolver<ResolversTypes['StoreMarketSearchHits'], ParentType, ContextType, RequireFields<QuerySearchStoreMarketsArgs, 'from' | 'size'>>;
  searchTaxGroups?: Resolver<ResolversTypes['TaxGroupSearchHits'], ParentType, ContextType, RequireFields<QuerySearchTaxGroupsArgs, 'from' | 'size'>>;
  searchTaxMarkets?: Resolver<ResolversTypes['TaxMarketSearchHits'], ParentType, ContextType, RequireFields<QuerySearchTaxMarketsArgs, 'from' | 'size'>>;
  tagKeys?: Resolver<Maybe<ResolversTypes['TagKeys']>, ParentType, ContextType>;
  tagValues?: Resolver<Maybe<ResolversTypes['TagValues']>, ParentType, ContextType, RequireFields<QueryTagValuesArgs, 'key'>>;
  user?: Resolver<ResolversTypes['UserDetails'], ParentType, ContextType, RequireFields<QueryUserArgs, 'username'>>;
  users?: Resolver<ResolversTypes['UsersList'], ParentType, ContextType, RequireFields<QueryUsersArgs, 'limit'>>;
};

export type QueryConfigurationManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryConfigurationManagement'] = ResolversParentTypes['QueryConfigurationManagement']> = {
  validate?: Resolver<Maybe<ResolversTypes['QueryConfigurationManagementValidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryConfigurationManagementValidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryConfigurationManagementValidate'] = ResolversParentTypes['QueryConfigurationManagementValidate']> = {
  adyen?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateAdyenArgs, 'baseUrl' | 'merchantAccount' | 'xApiKey'>>;
  avarda?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateAvardaArgs, 'authUrl' | 'baseUrl' | 'clientId' | 'clientSecret'>>;
  bonus?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateBonusArgs, 'input'>>;
  customPayment?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateCustomPaymentArgs, 'authUrl' | 'baseUrl' | 'clientId' | 'clientSecret'>>;
  externalPrice?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateExternalPriceArgs, 'input'>>;
  klarnaCheckout?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateKlarnaCheckoutArgs, 'baseUrl' | 'password' | 'username'>>;
  ledyer?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateLedyerArgs, 'authUrl' | 'baseUrl' | 'clientId' | 'clientSecret'>>;
  qliroOne?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateQliroOneArgs, 'input'>>;
  retain24?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateRetain24Args, 'input'>>;
  sveaCheckout?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateSveaCheckoutArgs, 'baseUrl' | 'checkoutSecret' | 'merchantId'>>;
  taxJar?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateTaxJarArgs, 'input'>>;
  walleyCheckout?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateWalleyCheckoutArgs, 'input'>>;
  zaver?: Resolver<ResolversTypes['ValidateConfigResult'], ParentType, ContextType, RequireFields<QueryConfigurationManagementValidateZaverArgs, 'apiKey' | 'baseUrl'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryOrderManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryOrderManagement'] = ResolversParentTypes['QueryOrderManagement']> = {
  cancellation?: Resolver<ResolversTypes['OrderCancellation'], ParentType, ContextType, RequireFields<QueryOrderManagementCancellationArgs, 'cancellationId'>>;
  compensation?: Resolver<ResolversTypes['OrderCompensation'], ParentType, ContextType, RequireFields<QueryOrderManagementCompensationArgs, 'compensationId'>>;
  customReasonCode?: Resolver<ResolversTypes['CustomReasonCode'], ParentType, ContextType, RequireFields<QueryOrderManagementCustomReasonCodeArgs, 'code'>>;
  customReasonCodes?: Resolver<ResolversTypes['CustomReasonCodes'], ParentType, ContextType>;
  customState?: Resolver<ResolversTypes['CustomState'], ParentType, ContextType, RequireFields<QueryOrderManagementCustomStateArgs, 'stateId'>>;
  customStates?: Resolver<ResolversTypes['CustomStates'], ParentType, ContextType>;
  delivery?: Resolver<ResolversTypes['OrderDelivery'], ParentType, ContextType, RequireFields<QueryOrderManagementDeliveryArgs, 'deliveryId'>>;
  details?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<QueryOrderManagementDetailsArgs, 'id'>>;
  history?: Resolver<ResolversTypes['OrderHistory'], ParentType, ContextType, RequireFields<QueryOrderManagementHistoryArgs, 'id'>>;
  orderModificationAddresses?: Resolver<Maybe<ResolversTypes['OrderModificationAddresses']>, ParentType, ContextType, RequireFields<QueryOrderManagementOrderModificationAddressesArgs, 'modificationId'>>;
  orderModificationOrderLines?: Resolver<Maybe<ResolversTypes['OrderModificationOrderLines']>, ParentType, ContextType, RequireFields<QueryOrderManagementOrderModificationOrderLinesArgs, 'modificationId'>>;
  orderModificationShippingFees?: Resolver<Maybe<ResolversTypes['OrderModificationShippingFees']>, ParentType, ContextType, RequireFields<QueryOrderManagementOrderModificationShippingFeesArgs, 'modificationId'>>;
  refund?: Resolver<ResolversTypes['OrderRefund'], ParentType, ContextType, RequireFields<QueryOrderManagementRefundArgs, 'refundId'>>;
  release?: Resolver<ResolversTypes['OrderRelease'], ParentType, ContextType, RequireFields<QueryOrderManagementReleaseArgs, 'releaseId'>>;
  status?: Resolver<ResolversTypes['OrderHistory'], ParentType, ContextType, RequireFields<QueryOrderManagementStatusArgs, 'id'>>;
  workflow?: Resolver<ResolversTypes['OrderWorkflow'], ParentType, ContextType, RequireFields<QueryOrderManagementWorkflowArgs, 'workflowId'>>;
  workflowExecution?: Resolver<ResolversTypes['OrderWorkflowExecution'], ParentType, ContextType, RequireFields<QueryOrderManagementWorkflowExecutionArgs, 'executionId'>>;
  workflowTriggers?: Resolver<ResolversTypes['OrderWorkflowTriggers'], ParentType, ContextType, RequireFields<QueryOrderManagementWorkflowTriggersArgs, 'workflowTriggerType'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryPlatformConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryPlatformConfig'] = ResolversParentTypes['QueryPlatformConfig']> = {
  campaign?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  store?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['PlatformConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryProductManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryProductManagement'] = ResolversParentTypes['QueryProductManagement']> = {
  parent?: Resolver<ResolversTypes['ProductParent'], ParentType, ContextType, RequireFields<QueryProductManagementParentArgs, 'id'>>;
  variant?: Resolver<ResolversTypes['ProductVariant'], ParentType, ContextType, RequireFields<QueryProductManagementVariantArgs, 'id'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reason'] = ResolversParentTypes['Reason']> = {
  cause?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundBonus'] = ResolversParentTypes['RefundBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFee'] = ResolversParentTypes['RefundFee']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundGift'] = ResolversParentTypes['RefundGift']> = {
  giftId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundGiftCard'] = ResolversParentTypes['RefundGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundGiftCardProduct'] = ResolversParentTypes['RefundGiftCardProduct']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundOrderLine'] = ResolversParentTypes['RefundOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundShippingFee'] = ResolversParentTypes['RefundShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundVoucher'] = ResolversParentTypes['RefundVoucher']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  voucherId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundedPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundedPayment'] = ResolversParentTypes['RefundedPayment']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseBonus'] = ResolversParentTypes['ReleaseBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseGift'] = ResolversParentTypes['ReleaseGift']> = {
  giftId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseGiftCard'] = ResolversParentTypes['ReleaseGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseGiftCardProduct'] = ResolversParentTypes['ReleaseGiftCardProduct']> = {
  cancelErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelErrorStatusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cancelTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createFailedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseOrderLine'] = ResolversParentTypes['ReleaseOrderLine']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLineId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleaseShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleaseShippingFee'] = ResolversParentTypes['ReleaseShippingFee']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingFeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReleasedPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReleasedPayment'] = ResolversParentTypes['ReleasedPayment']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Retain24ConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['Retain24Config'] = ResolversParentTypes['Retain24Config']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['Retain24Credentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  redeem?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  simulationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Retain24CredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Retain24Credentials'] = ResolversParentTypes['Retain24Credentials']> = {
  certificate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privateKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundingRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundingRule'] = ResolversParentTypes['RoundingRule']> = {
  roundDown?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roundUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  targets?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundingRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundingRules'] = ResolversParentTypes['RoundingRules']> = {
  defaultRule?: Resolver<ResolversTypes['RoundingRule'], ParentType, ContextType>;
  marketRules?: Resolver<Maybe<Array<ResolversTypes['MarketRoundingRule']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rule'] = ResolversParentTypes['Rule']> = {
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Schema'] = ResolversParentTypes['Schema']> = {
  mutation?: Resolver<Maybe<ResolversTypes['Mutation']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  subscriptions?: Resolver<Maybe<ResolversTypes['Subscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFee'] = ResolversParentTypes['ShippingFee']> = {
  basePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeData'] = ResolversParentTypes['ShippingFeeData']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ShippingFeeUpdatePrice']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeModification'] = ResolversParentTypes['ShippingFeeModification']> = {
  data?: Resolver<ResolversTypes['ShippingFeeModificationData'], ParentType, ContextType>;
  modificationType?: Resolver<ResolversTypes['ShippingFeeModificationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeModificationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeModificationData'] = ResolversParentTypes['ShippingFeeModificationData']> = {
  __resolveType: TypeResolveFn<'ShippingFeeModificationUpdateData', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ShippingFeeModificationUpdateDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeModificationUpdateData'] = ResolversParentTypes['ShippingFeeModificationUpdateData']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ShippingFeeModificationUpdateDataPrice']>, ParentType, ContextType>;
  taxGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeModificationUpdateDataPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeModificationUpdateDataPrice'] = ResolversParentTypes['ShippingFeeModificationUpdateDataPrice']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salePriceAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingFeeUpdatePriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingFeeUpdatePrice'] = ResolversParentTypes['ShippingFeeUpdatePrice']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingProvider'] = ResolversParentTypes['ShippingProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['ShippingProviderName'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProviderStatusLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingTaxGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingTaxGroup'] = ResolversParentTypes['ShippingTaxGroup']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHit'] = ResolversParentTypes['ShopperInsightsSearchHit']> = {
  __resolveType: TypeResolveFn<'ShopperInsightsSearchHitCheckout' | 'ShopperInsightsSearchHitOrder' | 'ShopperInsightsSearchHitSession', ParentType, ContextType>;
  attributes?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitAttributes']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ShopperInsightsSearchHitAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitAddress'] = ResolversParentTypes['ShopperInsightsSearchHitAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stateOrProvince?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress2?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  telephoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitAttributes'] = ResolversParentTypes['ShopperInsightsSearchHitAttributes']> = {
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantRef1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantRef2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitAttributesCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitAttributesCompany'] = ResolversParentTypes['ShopperInsightsSearchHitAttributesCompany']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registrationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitBundleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitBundle'] = ResolversParentTypes['ShopperInsightsSearchHitBundle']> = {
  bundleGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCampaign'] = ResolversParentTypes['ShopperInsightsSearchHitCampaign']> = {
  campaignGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckout'] = ResolversParentTypes['ShopperInsightsSearchHitCheckout']> = {
  attributes?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitAttributes']>, ParentType, ContextType>;
  bundles?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitBundle']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitCheckoutGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isConfirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPendingConfirmation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitCheckoutItem']>, ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lock?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionLock']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentStatus?: Resolver<ResolversTypes['ShopperInsightsSearchHitCheckoutPaymentStatus'], ParentType, ContextType>;
  providers?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCheckoutProviders']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sessionProviders?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProviders']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitAddress']>, ParentType, ContextType>;
  shippingOptions?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitCheckoutShippingOption']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutGiftCard'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutGiftCard']> = {
  balance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutItem'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutItem']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCampaign']>, ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitTag']>>, ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutPaymentStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutPaymentStatus'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutPaymentStatus']> = {
  current?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  log?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitCheckoutPaymentStatusLog']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutPaymentStatusLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutPaymentStatusLog'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutPaymentStatusLog']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutProvider'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutProvidersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutProviders'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutProviders']> = {
  giftCard?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCheckoutProvider']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCheckoutProvider']>, ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCheckoutProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitCheckoutShippingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitCheckoutShippingOption'] = ResolversParentTypes['ShopperInsightsSearchHitCheckoutShippingOption']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitGift'] = ResolversParentTypes['ShopperInsightsSearchHitGift']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountRuleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrder'] = ResolversParentTypes['ShopperInsightsSearchHitOrder']> = {
  attributes?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitAttributes']>, ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['ShopperInsightsSearchHitAddress'], ParentType, ContextType>;
  bonus?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderBonus']>, ParentType, ContextType>;
  bundles?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitBundle']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  checkoutProviders?: Resolver<ResolversTypes['ShopperInsightsSearchHitOrderCheckoutProviders'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProducts?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderGiftCardProduct']>, ParentType, ContextType>;
  giftCards?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderGiftCard']>, ParentType, ContextType>;
  gifts?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitGift']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTaxExempt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxExemptionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderLines?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderLine']>, ParentType, ContextType>;
  payment?: Resolver<ResolversTypes['ShopperInsightsSearchHitOrderPayment'], ParentType, ContextType>;
  promotions?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderPromotion']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sessionProviders?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderSessionProviders']>, ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderShipping']>, ParentType, ContextType>;
  shippingAddress?: Resolver<ResolversTypes['ShopperInsightsSearchHitAddress'], ParentType, ContextType>;
  shippingFees?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderShippingFee']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['ShopperInsightsSearchHitOrderTotals'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  vouchers?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitOrderVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderBonus'] = ResolversParentTypes['ShopperInsightsSearchHitOrderBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  points?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderCheckoutProvidersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderCheckoutProviders'] = ResolversParentTypes['ShopperInsightsSearchHitOrderCheckoutProviders']> = {
  giftcard?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  payment?: Resolver<ResolversTypes['ShopperInsightsSearchHitOrderProvider'], ParentType, ContextType>;
  shipping?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderGiftCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderGiftCard'] = ResolversParentTypes['ShopperInsightsSearchHitOrderGiftCard']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redeemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderGiftCardProduct'] = ResolversParentTypes['ShopperInsightsSearchHitOrderGiftCardProduct']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distribution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderLine'] = ResolversParentTypes['ShopperInsightsSearchHitOrderLine']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCampaign']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distributedTotalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  distributedTotalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitTag']>>, ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderPayment'] = ResolversParentTypes['ShopperInsightsSearchHitOrderPayment']> = {
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderPromotion'] = ResolversParentTypes['ShopperInsightsSearchHitOrderPromotion']> = {
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderProvider'] = ResolversParentTypes['ShopperInsightsSearchHitOrderProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderSessionProvidersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderSessionProviders'] = ResolversParentTypes['ShopperInsightsSearchHitOrderSessionProviders']> = {
  bonus?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  giftCardProduct?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  promotion?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  voucher?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitOrderProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderShipping'] = ResolversParentTypes['ShopperInsightsSearchHitOrderShipping']> = {
  providerError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderShippingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderShippingFee'] = ResolversParentTypes['ShopperInsightsSearchHitOrderShippingFee']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderTotals'] = ResolversParentTypes['ShopperInsightsSearchHitOrderTotals']> = {
  bonusTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftCardTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shippingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitOrderVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitOrderVoucher'] = ResolversParentTypes['ShopperInsightsSearchHitOrderVoucher']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSession'] = ResolversParentTypes['ShopperInsightsSearchHitSession']> = {
  attributes?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitAttributes']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHitSessionItem']>, ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lock?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionLock']>, ParentType, ContextType>;
  providers?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProviders']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionItem'] = ResolversParentTypes['ShopperInsightsSearchHitSessionItem']> = {
  basePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitCampaign']>, ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productParentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePriceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitTag']>>, ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionLockResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionLock'] = ResolversParentTypes['ShopperInsightsSearchHitSessionLock']> = {
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  closed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProvider'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProvider']> = {
  bonus?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProviderBonus']>, ParentType, ContextType>;
  giftCardProducts?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitSessionProviderGiftCardProduct']>>, ParentType, ContextType>;
  promotions?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitSessionProviderPromotion']>>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vouchers?: Resolver<Maybe<Array<ResolversTypes['ShopperInsightsSearchHitSessionProviderVoucher']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProviderBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProviderBonus'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProviderBonus']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amountToUse?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  points?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservedAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservedPoints?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProviderGiftCardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProviderGiftCardProduct'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProviderGiftCardProduct']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distribution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProviderPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProviderPromotion'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProviderPromotion']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProviderVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProviderVoucher'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProviderVoucher']> = {
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  valueAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitSessionProvidersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitSessionProviders'] = ResolversParentTypes['ShopperInsightsSearchHitSessionProviders']> = {
  bonus?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProvider']>, ParentType, ContextType>;
  giftCardProduct?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProvider']>, ParentType, ContextType>;
  promotion?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProvider']>, ParentType, ContextType>;
  voucher?: Resolver<Maybe<ResolversTypes['ShopperInsightsSearchHitSessionProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHitTag'] = ResolversParentTypes['ShopperInsightsSearchHitTag']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopperInsightsSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopperInsightsSearchHits'] = ResolversParentTypes['ShopperInsightsSearchHits']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['ShopperInsightsSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stock'] = ResolversParentTypes['Stock']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inventories?: Resolver<Array<ResolversTypes['StockInventory']>, ParentType, ContextType>;
  stockQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  validateStock?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockInventory'] = ResolversParentTypes['StockInventory']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  inventoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreGroup'] = ResolversParentTypes['StoreGroup']> = {
  channelType?: Resolver<ResolversTypes['ChannelType'], ParentType, ContextType>;
  countryOfSale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeMarkets?: Resolver<Maybe<Array<ResolversTypes['StoreMarket']>>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreGroupPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreGroupPrice'] = ResolversParentTypes['StoreGroupPrice']> = {
  marketPrices?: Resolver<Array<ResolversTypes['MarketPrice']>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreGroupSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreGroupSearchHit'] = ResolversParentTypes['StoreGroupSearchHit']> = {
  countryOfSale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreGroupSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreGroupSearchHits'] = ResolversParentTypes['StoreGroupSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['StoreGroupSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreMarket'] = ResolversParentTypes['StoreMarket']> = {
  capabilities?: Resolver<Maybe<ResolversTypes['Capabilities']>, ParentType, ContextType>;
  cartCapabilities?: Resolver<Maybe<ResolversTypes['CartCapabilities']>, ParentType, ContextType>;
  channelType?: Resolver<ResolversTypes['ChannelType'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryOfSale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isArchived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxExemptionEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreMarketSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreMarketSearchHit'] = ResolversParentTypes['StoreMarketSearchHit']> = {
  cartCapabilities?: Resolver<Maybe<ResolversTypes['CartCapabilities']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxExemptionEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxIncludedInPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  shippingProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  storeGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxProviders?: Resolver<Maybe<Array<ResolversTypes['Provider']>>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreMarketSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreMarketSearchHits'] = ResolversParentTypes['StoreMarketSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['StoreMarketSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubOutcome'] = ResolversParentTypes['SubOutcome']> = {
  discountQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountValue?: Resolver<Maybe<ResolversTypes['DiscountValue']>, ParentType, ContextType>;
  triggerQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  OnAdyenWebhookChanged?: SubscriptionResolver<Maybe<ResolversTypes['AdyenWebhook']>, "OnAdyenWebhookChanged", ParentType, ContextType, RequireFields<SubscriptionOnAdyenWebhookChangedArgs, 'configId'>>;
};

export type SveaCheckoutConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['SveaCheckoutConfig'] = ResolversParentTypes['SveaCheckoutConfig']> = {
  checkoutBaseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['SveaCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentAdminBaseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SveaCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SveaCredentials'] = ResolversParentTypes['SveaCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TagCondition'] = ResolversParentTypes['TagCondition']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['TagKeys'] = ResolversParentTypes['TagKeys']> = {
  keys?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TagValues'] = ResolversParentTypes['TagValues']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxGroup'] = ResolversParentTypes['TaxGroup']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxGroupSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxGroupSearchHit'] = ResolversParentTypes['TaxGroupSearchHit']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxGroupSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxGroupSearchHits'] = ResolversParentTypes['TaxGroupSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['TaxGroupSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxJarConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxJarConfig'] = ResolversParentTypes['TaxJarConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['TaxJarCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxJarCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxJarCredentials'] = ResolversParentTypes['TaxJarCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxMarket'] = ResolversParentTypes['TaxMarket']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxMarketSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxMarketSearchHit'] = ResolversParentTypes['TaxMarketSearchHit']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  taxGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxPercentageDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxMarketSearchHitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxMarketSearchHits'] = ResolversParentTypes['TaxMarketSearchHits']> = {
  hits?: Resolver<Array<ResolversTypes['TaxMarketSearchHit']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateExternalEventsDestinationApiResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateExternalEventsDestinationAPIResult'] = ResolversParentTypes['UpdateExternalEventsDestinationAPIResult']> = {
  apiDestinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsagePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsagePlan'] = ResolversParentTypes['UsagePlan']> = {
  burstLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quotaLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quotaPeriod?: Resolver<ResolversTypes['QuotaPeriod'], ParentType, ContextType>;
  rateLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDetails'] = ResolversParentTypes['UserDetails']> = {
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersList'] = ResolversParentTypes['UsersList']> = {
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidDateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidDateRange'] = ResolversParentTypes['ValidDateRange']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateConfigResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateConfigResult'] = ResolversParentTypes['ValidateConfigResult']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoucherProvider'] = ResolversParentTypes['VoucherProvider']> = {
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<ResolversTypes['VoucherProviderName'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoyadoConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoyadoConfig'] = ResolversParentTypes['VoyadoConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['VoyadoCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoyadoCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoyadoCredentials'] = ResolversParentTypes['VoyadoCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyCheckoutConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyCheckoutConfig'] = ResolversParentTypes['WalleyCheckoutConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['WalleyCredentials'], ParentType, ContextType>;
  deliveryModuleEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyCredentials'] = ResolversParentTypes['WalleyCredentials']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleDeliveryDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleDeliveryDate'] = ResolversParentTypes['WalleyDeliveryModuleDeliveryDate']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timeFrom?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleDestinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleDestination'] = ResolversParentTypes['WalleyDeliveryModuleDestination']> = {
  deliveryDate?: Resolver<Maybe<ResolversTypes['WalleyDeliveryModuleDeliveryDate']>, ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleOption'] = ResolversParentTypes['WalleyDeliveryModuleOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleShipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleShipment'] = ResolversParentTypes['WalleyDeliveryModuleShipment']> = {
  bookedShipmentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalShipmentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingChoice?: Resolver<ResolversTypes['WalleyDeliveryModuleShippingChoice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleShipping'] = ResolversParentTypes['WalleyDeliveryModuleShipping']> = {
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shipments?: Resolver<Array<ResolversTypes['WalleyDeliveryModuleShipment']>, ParentType, ContextType>;
  shippingFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalleyDeliveryModuleShippingChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalleyDeliveryModuleShippingChoice'] = ResolversParentTypes['WalleyDeliveryModuleShippingChoice']> = {
  destination?: Resolver<ResolversTypes['WalleyDeliveryModuleDestination'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['WalleyDeliveryModuleOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZaverConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ZaverConfig'] = ResolversParentTypes['ZaverConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['ZaverCredentials'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZaverCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ZaverCredentials'] = ResolversParentTypes['ZaverCredentials']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  callbackApiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  Actor?: ActorResolvers<ContextType>;
  AddExternalEventsDestinationAPIResult?: AddExternalEventsDestinationApiResultResolvers<ContextType>;
  AddExternalEventsDestinationEventBusResult?: AddExternalEventsDestinationEventBusResultResolvers<ContextType>;
  AddExternalEventsRuleResult?: AddExternalEventsRuleResultResolvers<ContextType>;
  AdyenConfig?: AdyenConfigResolvers<ContextType>;
  AdyenCredentials?: AdyenCredentialsResolvers<ContextType>;
  AdyenWebhook?: AdyenWebhookResolvers<ContextType>;
  AdyenWebhookCredentials?: AdyenWebhookCredentialsResolvers<ContextType>;
  AdyenWebhookGenerationResult?: AdyenWebhookGenerationResultResolvers<ContextType>;
  AdyenWebhookLegacy?: AdyenWebhookLegacyResolvers<ContextType>;
  ApiClient?: ApiClientResolvers<ContextType>;
  ApiClientDetails?: ApiClientDetailsResolvers<ContextType>;
  ApiClientsList?: ApiClientsListResolvers<ContextType>;
  ApiResource?: ApiResourceResolvers<ContextType>;
  ApiScope?: ApiScopeResolvers<ContextType>;
  AvardaConfig?: AvardaConfigResolvers<ContextType>;
  AvardaCredentials?: AvardaCredentialsResolvers<ContextType>;
  AvardaShippingBroker?: AvardaShippingBrokerResolvers<ContextType>;
  AvardaShippingBrokerShipping?: AvardaShippingBrokerShippingResolvers<ContextType>;
  AvardaShippingBrokerShippingIngrid?: AvardaShippingBrokerShippingIngridResolvers<ContextType>;
  AvardaShippingBrokerShippingIngridCategory?: AvardaShippingBrokerShippingIngridCategoryResolvers<ContextType>;
  AvardaShippingBrokerShippingIngridCategoryTag?: AvardaShippingBrokerShippingIngridCategoryTagResolvers<ContextType>;
  AvardaShippingBrokerShippingIngridLocation?: AvardaShippingBrokerShippingIngridLocationResolvers<ContextType>;
  AvardaShippingBrokerShippingIngridLocationAddress?: AvardaShippingBrokerShippingIngridLocationAddressResolvers<ContextType>;
  AvardaShippingBrokerShippingIngridPriceComponent?: AvardaShippingBrokerShippingIngridPriceComponentResolvers<ContextType>;
  BSGGiftCardConfig?: BsgGiftCardConfigResolvers<ContextType>;
  BSGGiftCardCredentials?: BsgGiftCardCredentialsResolvers<ContextType>;
  BonusConfig?: BonusConfigResolvers<ContextType>;
  BonusCredentials?: BonusCredentialsResolvers<ContextType>;
  BonusProvider?: BonusProviderResolvers<ContextType>;
  Bundle?: BundleResolvers<ContextType>;
  BundleGroup?: BundleGroupResolvers<ContextType>;
  BundleGroupSearchHit?: BundleGroupSearchHitResolvers<ContextType>;
  BundleGroupSearchHits?: BundleGroupSearchHitsResolvers<ContextType>;
  BundleItemRule?: BundleItemRuleResolvers<ContextType>;
  BundleOutcome?: BundleOutcomeResolvers<ContextType>;
  BundleStoreMarket?: BundleStoreMarketResolvers<ContextType>;
  Campaign?: CampaignResolvers<ContextType>;
  CampaignDeletionResult?: CampaignDeletionResultResolvers<ContextType>;
  CampaignGroup?: CampaignGroupResolvers<ContextType>;
  CampaignGroupList?: CampaignGroupListResolvers<ContextType>;
  CampaignGroupSearchHit?: CampaignGroupSearchHitResolvers<ContextType>;
  CampaignGroupSearchHits?: CampaignGroupSearchHitsResolvers<ContextType>;
  CampaignIdentity?: CampaignIdentityResolvers<ContextType>;
  CampaignMoney?: CampaignMoneyResolvers<ContextType>;
  CampaignSearchHit?: CampaignSearchHitResolvers<ContextType>;
  CampaignSearchHits?: CampaignSearchHitsResolvers<ContextType>;
  CampaignStoreMarket?: CampaignStoreMarketResolvers<ContextType>;
  CancellationBonus?: CancellationBonusResolvers<ContextType>;
  CancellationGiftCard?: CancellationGiftCardResolvers<ContextType>;
  CancellationGiftCardProduct?: CancellationGiftCardProductResolvers<ContextType>;
  CancelledPayment?: CancelledPaymentResolvers<ContextType>;
  Capabilities?: CapabilitiesResolvers<ContextType>;
  CapabilityProvider?: CapabilityProviderResolvers<ContextType>;
  CartCapabilities?: CartCapabilitiesResolvers<ContextType>;
  CartRuleOutcome?: CartRuleOutcomeResolvers<ContextType>;
  CodeRuleOutcome?: CodeRuleOutcomeResolvers<ContextType>;
  CodesGenerationSearchHit?: CodesGenerationSearchHitResolvers<ContextType>;
  CodesGenerationSearchHits?: CodesGenerationSearchHitsResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  CompanyAttribute?: CompanyAttributeResolvers<ContextType>;
  CompensationBonus?: CompensationBonusResolvers<ContextType>;
  CompensationFee?: CompensationFeeResolvers<ContextType>;
  CompensationGiftCard?: CompensationGiftCardResolvers<ContextType>;
  CompensationOrderLine?: CompensationOrderLineResolvers<ContextType>;
  CompensationPayment?: CompensationPaymentResolvers<ContextType>;
  CompensationShippingFee?: CompensationShippingFeeResolvers<ContextType>;
  Condition?: ConditionResolvers<ContextType>;
  CreateGenerateCodesResult?: CreateGenerateCodesResultResolvers<ContextType>;
  CurrencyRate?: CurrencyRateResolvers<ContextType>;
  CurrencyRates?: CurrencyRatesResolvers<ContextType>;
  CustomPaymentConfig?: CustomPaymentConfigResolvers<ContextType>;
  CustomPaymentCredentials?: CustomPaymentCredentialsResolvers<ContextType>;
  CustomReasonCode?: CustomReasonCodeResolvers<ContextType>;
  CustomReasonCodes?: CustomReasonCodesResolvers<ContextType>;
  CustomState?: CustomStateResolvers<ContextType>;
  CustomStates?: CustomStatesResolvers<ContextType>;
  DeletedResult?: DeletedResultResolvers<ContextType>;
  DeliveryBonus?: DeliveryBonusResolvers<ContextType>;
  DeliveryCapture?: DeliveryCaptureResolvers<ContextType>;
  DeliveryGift?: DeliveryGiftResolvers<ContextType>;
  DeliveryGiftCard?: DeliveryGiftCardResolvers<ContextType>;
  DeliveryGiftCardProduct?: DeliveryGiftCardProductResolvers<ContextType>;
  DeliveryOrderLine?: DeliveryOrderLineResolvers<ContextType>;
  DeliveryShippingFee?: DeliveryShippingFeeResolvers<ContextType>;
  DeliveryTracking?: DeliveryTrackingResolvers<ContextType>;
  DeliveryVoucher?: DeliveryVoucherResolvers<ContextType>;
  Dimensions?: DimensionsResolvers<ContextType>;
  DiscountCode?: DiscountCodeResolvers<ContextType>;
  DiscountCodeRule?: DiscountCodeRuleResolvers<ContextType>;
  DiscountCodeRuleSearchHit?: DiscountCodeRuleSearchHitResolvers<ContextType>;
  DiscountCodeRuleSearchHits?: DiscountCodeRuleSearchHitsResolvers<ContextType>;
  DiscountCodeSearchHit?: DiscountCodeSearchHitResolvers<ContextType>;
  DiscountCodeSearchHits?: DiscountCodeSearchHitsResolvers<ContextType>;
  DiscountExternalRule?: DiscountExternalRuleResolvers<ContextType>;
  DiscountExternalRuleSearchHit?: DiscountExternalRuleSearchHitResolvers<ContextType>;
  DiscountExternalRuleSearchHits?: DiscountExternalRuleSearchHitsResolvers<ContextType>;
  DiscountManagementQuotas?: DiscountManagementQuotasResolvers<ContextType>;
  DiscountRule?: DiscountRuleResolvers<ContextType>;
  DiscountRuleSearchHit?: DiscountRuleSearchHitResolvers<ContextType>;
  DiscountRuleSearchHits?: DiscountRuleSearchHitsResolvers<ContextType>;
  DiscountValue?: DiscountValueResolvers<ContextType>;
  DisplayName?: DisplayNameResolvers<ContextType>;
  ExternalApi?: ExternalApiResolvers<ContextType>;
  ExternalEventDestinationAPI?: ExternalEventDestinationApiResolvers<ContextType>;
  ExternalEventDestinationAPIFilter?: ExternalEventDestinationApiFilterResolvers<ContextType>;
  ExternalEventDestinationAPIFilterPattern?: ExternalEventDestinationApiFilterPatternResolvers<ContextType>;
  ExternalEventDestinationAPIs?: ExternalEventDestinationApIsResolvers<ContextType>;
  ExternalEventDestinationEventBuses?: ExternalEventDestinationEventBusesResolvers<ContextType>;
  ExternalEventDestinationsDetails?: ExternalEventDestinationsDetailsResolvers<ContextType>;
  ExternalEventRuleState?: ExternalEventRuleStateResolvers<ContextType>;
  ExternalEventRules?: ExternalEventRulesResolvers<ContextType>;
  ExternalPriceConfig?: ExternalPriceConfigResolvers<ContextType>;
  ExternalPriceCredentials?: ExternalPriceCredentialsResolvers<ContextType>;
  ExternalPriceProvider?: ExternalPriceProviderResolvers<ContextType>;
  ExternalRuleOutcome?: ExternalRuleOutcomeResolvers<ContextType>;
  GenerateCodes?: GenerateCodesResolvers<ContextType>;
  Gift?: GiftResolvers<ContextType>;
  GiftCardProductProvider?: GiftCardProductProviderResolvers<ContextType>;
  GiftCardProvider?: GiftCardProviderResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  GroupDetails?: GroupDetailsResolvers<ContextType>;
  GroupsList?: GroupsListResolvers<ContextType>;
  IdentityProvider?: IdentityProviderResolvers<ContextType>;
  IngridConfig?: IngridConfigResolvers<ContextType>;
  IngridCredentials?: IngridCredentialsResolvers<ContextType>;
  IngridDelivery?: IngridDeliveryResolvers<ContextType>;
  IngridDeliveryAddress?: IngridDeliveryAddressResolvers<ContextType>;
  Inventory?: InventoryResolvers<ContextType>;
  InventoryAddress?: InventoryAddressResolvers<ContextType>;
  InventoryProductVariantStock?: InventoryProductVariantStockResolvers<ContextType>;
  InventoryProductVariantStockConfig?: InventoryProductVariantStockConfigResolvers<ContextType>;
  InventoryStoreMarket?: InventoryStoreMarketResolvers<ContextType>;
  InventoryStoreMarketInventories?: InventoryStoreMarketInventoriesResolvers<ContextType>;
  ItemRule?: ItemRuleResolvers<ContextType>;
  KBSGiftCardConfig?: KbsGiftCardConfigResolvers<ContextType>;
  KBSGiftCardCredentials?: KbsGiftCardCredentialsResolvers<ContextType>;
  KeyValue?: KeyValueResolvers<ContextType>;
  KlarnaCheckoutConfig?: KlarnaCheckoutConfigResolvers<ContextType>;
  KlarnaCredentials?: KlarnaCredentialsResolvers<ContextType>;
  KlarnaShippingAssistantAddon?: KlarnaShippingAssistantAddonResolvers<ContextType>;
  KlarnaShippingAssistantAddress?: KlarnaShippingAssistantAddressResolvers<ContextType>;
  KlarnaShippingAssistantCarrierProduct?: KlarnaShippingAssistantCarrierProductResolvers<ContextType>;
  KlarnaShippingAssistantLocation?: KlarnaShippingAssistantLocationResolvers<ContextType>;
  KlarnaShippingAssistantLocationTimeslot?: KlarnaShippingAssistantLocationTimeslotResolvers<ContextType>;
  KlarnaShippingAssistantSelectedShippingOption?: KlarnaShippingAssistantSelectedShippingOptionResolvers<ContextType>;
  LedyerConfig?: LedyerConfigResolvers<ContextType>;
  LedyerCredentials?: LedyerCredentialsResolvers<ContextType>;
  LogicHolder?: LogicHolderResolvers<ContextType>;
  MarketPrice?: MarketPriceResolvers<ContextType>;
  MarketRoundingRule?: MarketRoundingRuleResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MutationOrderManagement?: MutationOrderManagementResolvers<ContextType>;
  NShiftConfig?: NShiftConfigResolvers<ContextType>;
  NShiftCredentials?: NShiftCredentialsResolvers<ContextType>;
  NshiftAddress?: NshiftAddressResolvers<ContextType>;
  NshiftPreparedShipment?: NshiftPreparedShipmentResolvers<ContextType>;
  NshiftService?: NshiftServiceResolvers<ContextType>;
  OperationResult?: OperationResultResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderAddress?: OrderAddressResolvers<ContextType>;
  OrderAddressesModification?: OrderAddressesModificationResolvers<ContextType>;
  OrderAddressesModificationData?: OrderAddressesModificationDataResolvers<ContextType>;
  OrderAddressesModificationSearchHit?: OrderAddressesModificationSearchHitResolvers<ContextType>;
  OrderAddressesModificationUpdateData?: OrderAddressesModificationUpdateDataResolvers<ContextType>;
  OrderAddressesModificationUpdateDataAddress?: OrderAddressesModificationUpdateDataAddressResolvers<ContextType>;
  OrderAttributes?: OrderAttributesResolvers<ContextType>;
  OrderBonus?: OrderBonusResolvers<ContextType>;
  OrderBundle?: OrderBundleResolvers<ContextType>;
  OrderCancellation?: OrderCancellationResolvers<ContextType>;
  OrderCancellationSearchBonus?: OrderCancellationSearchBonusResolvers<ContextType>;
  OrderCancellationSearchGiftCard?: OrderCancellationSearchGiftCardResolvers<ContextType>;
  OrderCancellationSearchGiftCardProduct?: OrderCancellationSearchGiftCardProductResolvers<ContextType>;
  OrderCancellationSearchHit?: OrderCancellationSearchHitResolvers<ContextType>;
  OrderCancellationSearchPayment?: OrderCancellationSearchPaymentResolvers<ContextType>;
  OrderComment?: OrderCommentResolvers<ContextType>;
  OrderCompensation?: OrderCompensationResolvers<ContextType>;
  OrderCompensationSearchHit?: OrderCompensationSearchHitResolvers<ContextType>;
  OrderCompensationSearchHits?: OrderCompensationSearchHitsResolvers<ContextType>;
  OrderCompensationSearchPayment?: OrderCompensationSearchPaymentResolvers<ContextType>;
  OrderCompensationSearchProviderStatus?: OrderCompensationSearchProviderStatusResolvers<ContextType>;
  OrderCompensationSearchProviderStatusHistory?: OrderCompensationSearchProviderStatusHistoryResolvers<ContextType>;
  OrderCompensationSearchTotals?: OrderCompensationSearchTotalsResolvers<ContextType>;
  OrderCompensationTotals?: OrderCompensationTotalsResolvers<ContextType>;
  OrderCustomState?: OrderCustomStateResolvers<ContextType>;
  OrderDelivery?: OrderDeliveryResolvers<ContextType>;
  OrderDeliverySearchHit?: OrderDeliverySearchHitResolvers<ContextType>;
  OrderDeliverySearchOrderLine?: OrderDeliverySearchOrderLineResolvers<ContextType>;
  OrderDeliverySearchShippingFee?: OrderDeliverySearchShippingFeeResolvers<ContextType>;
  OrderDeliverySearchTrackingInfo?: OrderDeliverySearchTrackingInfoResolvers<ContextType>;
  OrderDeliveryTotals?: OrderDeliveryTotalsResolvers<ContextType>;
  OrderDiscountCodeRule?: OrderDiscountCodeRuleResolvers<ContextType>;
  OrderDiscountExternalRule?: OrderDiscountExternalRuleResolvers<ContextType>;
  OrderDiscountOutcome?: OrderDiscountOutcomeResolvers<ContextType>;
  OrderDiscountRule?: OrderDiscountRuleResolvers<ContextType>;
  OrderGift?: OrderGiftResolvers<ContextType>;
  OrderGiftCard?: OrderGiftCardResolvers<ContextType>;
  OrderGiftCardBSGGiftCard?: OrderGiftCardBsgGiftCardResolvers<ContextType>;
  OrderGiftCardEmpty?: OrderGiftCardEmptyResolvers<ContextType>;
  OrderGiftCardItemBSGGiftCard?: OrderGiftCardItemBsgGiftCardResolvers<ContextType>;
  OrderGiftCardItemKBSGiftCard?: OrderGiftCardItemKbsGiftCardResolvers<ContextType>;
  OrderGiftCardItemRetain24?: OrderGiftCardItemRetain24Resolvers<ContextType>;
  OrderGiftCardKBSGiftCard?: OrderGiftCardKbsGiftCardResolvers<ContextType>;
  OrderGiftCardProduct?: OrderGiftCardProductResolvers<ContextType>;
  OrderGiftCardProductEmpty?: OrderGiftCardProductEmptyResolvers<ContextType>;
  OrderGiftCardProductItem?: OrderGiftCardProductItemResolvers<ContextType>;
  OrderGiftCardProductItemRetain24?: OrderGiftCardProductItemRetain24Resolvers<ContextType>;
  OrderGiftCardProductRetain24?: OrderGiftCardProductRetain24Resolvers<ContextType>;
  OrderGiftCardRetain24?: OrderGiftCardRetain24Resolvers<ContextType>;
  OrderHistory?: OrderHistoryResolvers<ContextType>;
  OrderHistoryLogEntry?: OrderHistoryLogEntryResolvers<ContextType>;
  OrderHistoryOperations?: OrderHistoryOperationsResolvers<ContextType>;
  OrderHistoryTransactionBonus?: OrderHistoryTransactionBonusResolvers<ContextType>;
  OrderHistoryTransactionGift?: OrderHistoryTransactionGiftResolvers<ContextType>;
  OrderHistoryTransactionGiftCard?: OrderHistoryTransactionGiftCardResolvers<ContextType>;
  OrderHistoryTransactionGiftCardProduct?: OrderHistoryTransactionGiftCardProductResolvers<ContextType>;
  OrderHistoryTransactionOrderLine?: OrderHistoryTransactionOrderLineResolvers<ContextType>;
  OrderHistoryTransactionPayment?: OrderHistoryTransactionPaymentResolvers<ContextType>;
  OrderHistoryTransactionShippingFee?: OrderHistoryTransactionShippingFeeResolvers<ContextType>;
  OrderHistoryTransactionVoucher?: OrderHistoryTransactionVoucherResolvers<ContextType>;
  OrderHistoryTransactions?: OrderHistoryTransactionsResolvers<ContextType>;
  OrderHistoryTransactionsCompensated?: OrderHistoryTransactionsCompensatedResolvers<ContextType>;
  OrderLine?: OrderLineResolvers<ContextType>;
  OrderLineBase?: OrderLineBaseResolvers<ContextType>;
  OrderLineCampaign?: OrderLineCampaignResolvers<ContextType>;
  OrderLineCreate?: OrderLineCreateResolvers<ContextType>;
  OrderLineData?: OrderLineDataResolvers<ContextType>;
  OrderLineDelete?: OrderLineDeleteResolvers<ContextType>;
  OrderLineDimensions?: OrderLineDimensionsResolvers<ContextType>;
  OrderLineDiscountOutcome?: OrderLineDiscountOutcomeResolvers<ContextType>;
  OrderLineModification?: OrderLineModificationResolvers<ContextType>;
  OrderLineModificationCreateData?: OrderLineModificationCreateDataResolvers<ContextType>;
  OrderLineModificationData?: OrderLineModificationDataResolvers<ContextType>;
  OrderLineModificationDeleteData?: OrderLineModificationDeleteDataResolvers<ContextType>;
  OrderLineModificationUpdateData?: OrderLineModificationUpdateDataResolvers<ContextType>;
  OrderLineModificationUpdateDataPrice?: OrderLineModificationUpdateDataPriceResolvers<ContextType>;
  OrderLineOption?: OrderLineOptionResolvers<ContextType>;
  OrderLineUpdate?: OrderLineUpdateResolvers<ContextType>;
  OrderLineUpdatePrice?: OrderLineUpdatePriceResolvers<ContextType>;
  OrderModification?: OrderModificationResolvers<ContextType>;
  OrderModificationAddresses?: OrderModificationAddressesResolvers<ContextType>;
  OrderModificationOrderLines?: OrderModificationOrderLinesResolvers<ContextType>;
  OrderModificationShippingFees?: OrderModificationShippingFeesResolvers<ContextType>;
  OrderOperationAddressData?: OrderOperationAddressDataResolvers<ContextType>;
  OrderOperationAddressModification?: OrderOperationAddressModificationResolvers<ContextType>;
  OrderOperationAddressModificationUpdateAddress?: OrderOperationAddressModificationUpdateAddressResolvers<ContextType>;
  OrderOperationResult?: OrderOperationResultResolvers<ContextType>;
  OrderOperationSearchActor?: OrderOperationSearchActorResolvers<ContextType>;
  OrderOperationSearchBonus?: OrderOperationSearchBonusResolvers<ContextType>;
  OrderOperationSearchFee?: OrderOperationSearchFeeResolvers<ContextType>;
  OrderOperationSearchGift?: OrderOperationSearchGiftResolvers<ContextType>;
  OrderOperationSearchGiftCard?: OrderOperationSearchGiftCardResolvers<ContextType>;
  OrderOperationSearchHit?: OrderOperationSearchHitResolvers<ContextType>;
  OrderOperationSearchHits?: OrderOperationSearchHitsResolvers<ContextType>;
  OrderOperationSearchOrderLine?: OrderOperationSearchOrderLineResolvers<ContextType>;
  OrderOperationSearchProvider?: OrderOperationSearchProviderResolvers<ContextType>;
  OrderOperationSearchReason?: OrderOperationSearchReasonResolvers<ContextType>;
  OrderOperationSearchShippingFee?: OrderOperationSearchShippingFeeResolvers<ContextType>;
  OrderOrderLinesModificationSearchHit?: OrderOrderLinesModificationSearchHitResolvers<ContextType>;
  OrderOrderLinesModificationSearchOrderLine?: OrderOrderLinesModificationSearchOrderLineResolvers<ContextType>;
  OrderPayment?: OrderPaymentResolvers<ContextType>;
  OrderPaymentAdyen?: OrderPaymentAdyenResolvers<ContextType>;
  OrderPaymentAvarda?: OrderPaymentAvardaResolvers<ContextType>;
  OrderPaymentBrinkZeroPayment?: OrderPaymentBrinkZeroPaymentResolvers<ContextType>;
  OrderPaymentBrinkZeroPaymentOriginalProvider?: OrderPaymentBrinkZeroPaymentOriginalProviderResolvers<ContextType>;
  OrderPaymentCustomPayment?: OrderPaymentCustomPaymentResolvers<ContextType>;
  OrderPaymentKlarnaCheckout?: OrderPaymentKlarnaCheckoutResolvers<ContextType>;
  OrderPaymentLedyer?: OrderPaymentLedyerResolvers<ContextType>;
  OrderPaymentQliroOne?: OrderPaymentQliroOneResolvers<ContextType>;
  OrderPaymentQliroOneOrderItem?: OrderPaymentQliroOneOrderItemResolvers<ContextType>;
  OrderPaymentQliroOneUpsell?: OrderPaymentQliroOneUpsellResolvers<ContextType>;
  OrderPaymentQliroOneUpsellItems?: OrderPaymentQliroOneUpsellItemsResolvers<ContextType>;
  OrderPaymentQliroOneUpsellTotals?: OrderPaymentQliroOneUpsellTotalsResolvers<ContextType>;
  OrderPaymentSveaCheckout?: OrderPaymentSveaCheckoutResolvers<ContextType>;
  OrderPaymentWalleyCheckout?: OrderPaymentWalleyCheckoutResolvers<ContextType>;
  OrderPaymentZaver?: OrderPaymentZaverResolvers<ContextType>;
  OrderPromotion?: OrderPromotionResolvers<ContextType>;
  OrderPromotionEmpty?: OrderPromotionEmptyResolvers<ContextType>;
  OrderPromotionItemVoyado?: OrderPromotionItemVoyadoResolvers<ContextType>;
  OrderPromotionVoyado?: OrderPromotionVoyadoResolvers<ContextType>;
  OrderRefund?: OrderRefundResolvers<ContextType>;
  OrderRefundSearchGiftCardProduct?: OrderRefundSearchGiftCardProductResolvers<ContextType>;
  OrderRefundSearchHit?: OrderRefundSearchHitResolvers<ContextType>;
  OrderRefundSearchPayment?: OrderRefundSearchPaymentResolvers<ContextType>;
  OrderRefundSearchTotals?: OrderRefundSearchTotalsResolvers<ContextType>;
  OrderRefundTotals?: OrderRefundTotalsResolvers<ContextType>;
  OrderRelease?: OrderReleaseResolvers<ContextType>;
  OrderReleaseSearchGiftCardProduct?: OrderReleaseSearchGiftCardProductResolvers<ContextType>;
  OrderReleaseSearchHit?: OrderReleaseSearchHitResolvers<ContextType>;
  OrderReleaseSearchPayment?: OrderReleaseSearchPaymentResolvers<ContextType>;
  OrderReleaseSearchTotals?: OrderReleaseSearchTotalsResolvers<ContextType>;
  OrderReservation?: OrderReservationResolvers<ContextType>;
  OrderSearchHit?: OrderSearchHitResolvers<ContextType>;
  OrderSearchHits?: OrderSearchHitsResolvers<ContextType>;
  OrderShipping?: OrderShippingResolvers<ContextType>;
  OrderShippingAvardaShippingBroker?: OrderShippingAvardaShippingBrokerResolvers<ContextType>;
  OrderShippingEmpty?: OrderShippingEmptyResolvers<ContextType>;
  OrderShippingFeesModificationSearchHit?: OrderShippingFeesModificationSearchHitResolvers<ContextType>;
  OrderShippingFeesModificationSearchShippingFee?: OrderShippingFeesModificationSearchShippingFeeResolvers<ContextType>;
  OrderShippingIngrid?: OrderShippingIngridResolvers<ContextType>;
  OrderShippingKlarnaShippingAssistant?: OrderShippingKlarnaShippingAssistantResolvers<ContextType>;
  OrderShippingNshift?: OrderShippingNshiftResolvers<ContextType>;
  OrderShippingQliroIntegratedShipping?: OrderShippingQliroIntegratedShippingResolvers<ContextType>;
  OrderShippingWalleyDeliveryModule?: OrderShippingWalleyDeliveryModuleResolvers<ContextType>;
  OrderStatus?: OrderStatusResolvers<ContextType>;
  OrderTotals?: OrderTotalsResolvers<ContextType>;
  OrderVoucher?: OrderVoucherResolvers<ContextType>;
  OrderVoucherEmpty?: OrderVoucherEmptyResolvers<ContextType>;
  OrderVoucherItemVoyado?: OrderVoucherItemVoyadoResolvers<ContextType>;
  OrderVoucherVoyado?: OrderVoucherVoyadoResolvers<ContextType>;
  OrderWorkflow?: OrderWorkflowResolvers<ContextType>;
  OrderWorkflowExecution?: OrderWorkflowExecutionResolvers<ContextType>;
  OrderWorkflowExecutionNode?: OrderWorkflowExecutionNodeResolvers<ContextType>;
  OrderWorkflowExecutionNodeAction?: OrderWorkflowExecutionNodeActionResolvers<ContextType>;
  OrderWorkflowExecutionNodeBranch?: OrderWorkflowExecutionNodeBranchResolvers<ContextType>;
  OrderWorkflowExecutionNodeBranchCondition?: OrderWorkflowExecutionNodeBranchConditionResolvers<ContextType>;
  OrderWorkflowExecutionNodeCondition?: OrderWorkflowExecutionNodeConditionResolvers<ContextType>;
  OrderWorkflowExecutionNodeTrigger?: OrderWorkflowExecutionNodeTriggerResolvers<ContextType>;
  OrderWorkflowExecutionSearchHit?: OrderWorkflowExecutionSearchHitResolvers<ContextType>;
  OrderWorkflowExecutionSearchHits?: OrderWorkflowExecutionSearchHitsResolvers<ContextType>;
  OrderWorkflowNode?: OrderWorkflowNodeResolvers<ContextType>;
  OrderWorkflowNodeAction?: OrderWorkflowNodeActionResolvers<ContextType>;
  OrderWorkflowNodeActionDo?: OrderWorkflowNodeActionDoResolvers<ContextType>;
  OrderWorkflowNodeActionDoCancellation?: OrderWorkflowNodeActionDoCancellationResolvers<ContextType>;
  OrderWorkflowNodeActionDoCustomState?: OrderWorkflowNodeActionDoCustomStateResolvers<ContextType>;
  OrderWorkflowNodeBranch?: OrderWorkflowNodeBranchResolvers<ContextType>;
  OrderWorkflowNodeBranchCondition?: OrderWorkflowNodeBranchConditionResolvers<ContextType>;
  OrderWorkflowNodeCondition?: OrderWorkflowNodeConditionResolvers<ContextType>;
  OrderWorkflowNodeConditionCheck?: OrderWorkflowNodeConditionCheckResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckAnd?: OrderWorkflowNodeConditionCheckAndResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckCustomHTTP?: OrderWorkflowNodeConditionCheckCustomHttpResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOr?: OrderWorkflowNodeConditionCheckOrResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderDate?: OrderWorkflowNodeConditionCheckOrderDateResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCampaign?: OrderWorkflowNodeConditionCheckOrderLineCampaignResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCampaignField?: OrderWorkflowNodeConditionCheckOrderLineCampaignFieldResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCampaignFields?: OrderWorkflowNodeConditionCheckOrderLineCampaignFieldsResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributes?: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKey?: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValue?: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesKeyValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValue?: OrderWorkflowNodeConditionCheckOrderLineCustomAttributesValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineOptions?: OrderWorkflowNodeConditionCheckOrderLineOptionsResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKey?: OrderWorkflowNodeConditionCheckOrderLineOptionsKeyResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValue?: OrderWorkflowNodeConditionCheckOrderLineOptionsKeyValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineOptionsValue?: OrderWorkflowNodeConditionCheckOrderLineOptionsValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineProductParentId?: OrderWorkflowNodeConditionCheckOrderLineProductParentIdResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineProductVariantId?: OrderWorkflowNodeConditionCheckOrderLineProductVariantIdResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineTags?: OrderWorkflowNodeConditionCheckOrderLineTagsResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineTagsKey?: OrderWorkflowNodeConditionCheckOrderLineTagsKeyResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineTagsKeyValue?: OrderWorkflowNodeConditionCheckOrderLineTagsKeyValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderLineTagsValue?: OrderWorkflowNodeConditionCheckOrderLineTagsValueResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckOrderTotalsGrandTotal?: OrderWorkflowNodeConditionCheckOrderTotalsGrandTotalResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckPaymentProviderMethod?: OrderWorkflowNodeConditionCheckPaymentProviderMethodResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckPaymentProviderName?: OrderWorkflowNodeConditionCheckPaymentProviderNameResolvers<ContextType>;
  OrderWorkflowNodeConditionCheckPaymentProviderStatus?: OrderWorkflowNodeConditionCheckPaymentProviderStatusResolvers<ContextType>;
  OrderWorkflowRevision?: OrderWorkflowRevisionResolvers<ContextType>;
  OrderWorkflowSearchHit?: OrderWorkflowSearchHitResolvers<ContextType>;
  OrderWorkflowSearchHits?: OrderWorkflowSearchHitsResolvers<ContextType>;
  OrderWorkflowTrigger?: OrderWorkflowTriggerResolvers<ContextType>;
  OrderWorkflowTriggers?: OrderWorkflowTriggersResolvers<ContextType>;
  Outcome?: OutcomeResolvers<ContextType>;
  PaymentProvider?: PaymentProviderResolvers<ContextType>;
  PlatformConfig?: PlatformConfigResolvers<ContextType>;
  Price?: PriceResolvers<ContextType>;
  PriceRecord?: PriceRecordResolvers<ContextType>;
  PriceRule?: PriceRuleResolvers<ContextType>;
  ProductParent?: ProductParentResolvers<ContextType>;
  ProductParentSearchHit?: ProductParentSearchHitResolvers<ContextType>;
  ProductParentSearchHits?: ProductParentSearchHitsResolvers<ContextType>;
  ProductVariant?: ProductVariantResolvers<ContextType>;
  ProductVariantReservation?: ProductVariantReservationResolvers<ContextType>;
  ProductVariantRules?: ProductVariantRulesResolvers<ContextType>;
  ProductVariantSearchHit?: ProductVariantSearchHitResolvers<ContextType>;
  ProductVariantSearchHits?: ProductVariantSearchHitsResolvers<ContextType>;
  PromotionProvider?: PromotionProviderResolvers<ContextType>;
  Provider?: ProviderResolvers<ContextType>;
  ProviderStatusLog?: ProviderStatusLogResolvers<ContextType>;
  ProviderStatusLogEntry?: ProviderStatusLogEntryResolvers<ContextType>;
  QliroIngrid?: QliroIngridResolvers<ContextType>;
  QliroIngridDelivery?: QliroIngridDeliveryResolvers<ContextType>;
  QliroIngridDeliveryAddress?: QliroIngridDeliveryAddressResolvers<ContextType>;
  QliroOneConfig?: QliroOneConfigResolvers<ContextType>;
  QliroOneCredentials?: QliroOneCredentialsResolvers<ContextType>;
  QliroOneIntegratedShipping?: QliroOneIntegratedShippingResolvers<ContextType>;
  QliroShipmentOrderItem?: QliroShipmentOrderItemResolvers<ContextType>;
  QliroShipmentOrderItemMetadata?: QliroShipmentOrderItemMetadataResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryConfigurationManagement?: QueryConfigurationManagementResolvers<ContextType>;
  QueryConfigurationManagementValidate?: QueryConfigurationManagementValidateResolvers<ContextType>;
  QueryOrderManagement?: QueryOrderManagementResolvers<ContextType>;
  QueryPlatformConfig?: QueryPlatformConfigResolvers<ContextType>;
  QueryProductManagement?: QueryProductManagementResolvers<ContextType>;
  Reason?: ReasonResolvers<ContextType>;
  RefundBonus?: RefundBonusResolvers<ContextType>;
  RefundFee?: RefundFeeResolvers<ContextType>;
  RefundGift?: RefundGiftResolvers<ContextType>;
  RefundGiftCard?: RefundGiftCardResolvers<ContextType>;
  RefundGiftCardProduct?: RefundGiftCardProductResolvers<ContextType>;
  RefundOrderLine?: RefundOrderLineResolvers<ContextType>;
  RefundShippingFee?: RefundShippingFeeResolvers<ContextType>;
  RefundVoucher?: RefundVoucherResolvers<ContextType>;
  RefundedPayment?: RefundedPaymentResolvers<ContextType>;
  ReleaseBonus?: ReleaseBonusResolvers<ContextType>;
  ReleaseGift?: ReleaseGiftResolvers<ContextType>;
  ReleaseGiftCard?: ReleaseGiftCardResolvers<ContextType>;
  ReleaseGiftCardProduct?: ReleaseGiftCardProductResolvers<ContextType>;
  ReleaseOrderLine?: ReleaseOrderLineResolvers<ContextType>;
  ReleaseShippingFee?: ReleaseShippingFeeResolvers<ContextType>;
  ReleasedPayment?: ReleasedPaymentResolvers<ContextType>;
  Retain24Config?: Retain24ConfigResolvers<ContextType>;
  Retain24Credentials?: Retain24CredentialsResolvers<ContextType>;
  RoundingRule?: RoundingRuleResolvers<ContextType>;
  RoundingRules?: RoundingRulesResolvers<ContextType>;
  Rule?: RuleResolvers<ContextType>;
  Schema?: SchemaResolvers<ContextType>;
  ShippingFee?: ShippingFeeResolvers<ContextType>;
  ShippingFeeData?: ShippingFeeDataResolvers<ContextType>;
  ShippingFeeModification?: ShippingFeeModificationResolvers<ContextType>;
  ShippingFeeModificationData?: ShippingFeeModificationDataResolvers<ContextType>;
  ShippingFeeModificationUpdateData?: ShippingFeeModificationUpdateDataResolvers<ContextType>;
  ShippingFeeModificationUpdateDataPrice?: ShippingFeeModificationUpdateDataPriceResolvers<ContextType>;
  ShippingFeeUpdatePrice?: ShippingFeeUpdatePriceResolvers<ContextType>;
  ShippingProvider?: ShippingProviderResolvers<ContextType>;
  ShippingTaxGroup?: ShippingTaxGroupResolvers<ContextType>;
  ShopperInsightsSearchHit?: ShopperInsightsSearchHitResolvers<ContextType>;
  ShopperInsightsSearchHitAddress?: ShopperInsightsSearchHitAddressResolvers<ContextType>;
  ShopperInsightsSearchHitAttributes?: ShopperInsightsSearchHitAttributesResolvers<ContextType>;
  ShopperInsightsSearchHitAttributesCompany?: ShopperInsightsSearchHitAttributesCompanyResolvers<ContextType>;
  ShopperInsightsSearchHitBundle?: ShopperInsightsSearchHitBundleResolvers<ContextType>;
  ShopperInsightsSearchHitCampaign?: ShopperInsightsSearchHitCampaignResolvers<ContextType>;
  ShopperInsightsSearchHitCheckout?: ShopperInsightsSearchHitCheckoutResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutGiftCard?: ShopperInsightsSearchHitCheckoutGiftCardResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutItem?: ShopperInsightsSearchHitCheckoutItemResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutPaymentStatus?: ShopperInsightsSearchHitCheckoutPaymentStatusResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutPaymentStatusLog?: ShopperInsightsSearchHitCheckoutPaymentStatusLogResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutProvider?: ShopperInsightsSearchHitCheckoutProviderResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutProviders?: ShopperInsightsSearchHitCheckoutProvidersResolvers<ContextType>;
  ShopperInsightsSearchHitCheckoutShippingOption?: ShopperInsightsSearchHitCheckoutShippingOptionResolvers<ContextType>;
  ShopperInsightsSearchHitGift?: ShopperInsightsSearchHitGiftResolvers<ContextType>;
  ShopperInsightsSearchHitOrder?: ShopperInsightsSearchHitOrderResolvers<ContextType>;
  ShopperInsightsSearchHitOrderBonus?: ShopperInsightsSearchHitOrderBonusResolvers<ContextType>;
  ShopperInsightsSearchHitOrderCheckoutProviders?: ShopperInsightsSearchHitOrderCheckoutProvidersResolvers<ContextType>;
  ShopperInsightsSearchHitOrderGiftCard?: ShopperInsightsSearchHitOrderGiftCardResolvers<ContextType>;
  ShopperInsightsSearchHitOrderGiftCardProduct?: ShopperInsightsSearchHitOrderGiftCardProductResolvers<ContextType>;
  ShopperInsightsSearchHitOrderLine?: ShopperInsightsSearchHitOrderLineResolvers<ContextType>;
  ShopperInsightsSearchHitOrderPayment?: ShopperInsightsSearchHitOrderPaymentResolvers<ContextType>;
  ShopperInsightsSearchHitOrderPromotion?: ShopperInsightsSearchHitOrderPromotionResolvers<ContextType>;
  ShopperInsightsSearchHitOrderProvider?: ShopperInsightsSearchHitOrderProviderResolvers<ContextType>;
  ShopperInsightsSearchHitOrderSessionProviders?: ShopperInsightsSearchHitOrderSessionProvidersResolvers<ContextType>;
  ShopperInsightsSearchHitOrderShipping?: ShopperInsightsSearchHitOrderShippingResolvers<ContextType>;
  ShopperInsightsSearchHitOrderShippingFee?: ShopperInsightsSearchHitOrderShippingFeeResolvers<ContextType>;
  ShopperInsightsSearchHitOrderTotals?: ShopperInsightsSearchHitOrderTotalsResolvers<ContextType>;
  ShopperInsightsSearchHitOrderVoucher?: ShopperInsightsSearchHitOrderVoucherResolvers<ContextType>;
  ShopperInsightsSearchHitSession?: ShopperInsightsSearchHitSessionResolvers<ContextType>;
  ShopperInsightsSearchHitSessionItem?: ShopperInsightsSearchHitSessionItemResolvers<ContextType>;
  ShopperInsightsSearchHitSessionLock?: ShopperInsightsSearchHitSessionLockResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProvider?: ShopperInsightsSearchHitSessionProviderResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProviderBonus?: ShopperInsightsSearchHitSessionProviderBonusResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProviderGiftCardProduct?: ShopperInsightsSearchHitSessionProviderGiftCardProductResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProviderPromotion?: ShopperInsightsSearchHitSessionProviderPromotionResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProviderVoucher?: ShopperInsightsSearchHitSessionProviderVoucherResolvers<ContextType>;
  ShopperInsightsSearchHitSessionProviders?: ShopperInsightsSearchHitSessionProvidersResolvers<ContextType>;
  ShopperInsightsSearchHitTag?: ShopperInsightsSearchHitTagResolvers<ContextType>;
  ShopperInsightsSearchHits?: ShopperInsightsSearchHitsResolvers<ContextType>;
  Stock?: StockResolvers<ContextType>;
  StockInventory?: StockInventoryResolvers<ContextType>;
  StoreGroup?: StoreGroupResolvers<ContextType>;
  StoreGroupPrice?: StoreGroupPriceResolvers<ContextType>;
  StoreGroupSearchHit?: StoreGroupSearchHitResolvers<ContextType>;
  StoreGroupSearchHits?: StoreGroupSearchHitsResolvers<ContextType>;
  StoreMarket?: StoreMarketResolvers<ContextType>;
  StoreMarketSearchHit?: StoreMarketSearchHitResolvers<ContextType>;
  StoreMarketSearchHits?: StoreMarketSearchHitsResolvers<ContextType>;
  SubOutcome?: SubOutcomeResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SveaCheckoutConfig?: SveaCheckoutConfigResolvers<ContextType>;
  SveaCredentials?: SveaCredentialsResolvers<ContextType>;
  TagCondition?: TagConditionResolvers<ContextType>;
  TagKeys?: TagKeysResolvers<ContextType>;
  TagValues?: TagValuesResolvers<ContextType>;
  TaxGroup?: TaxGroupResolvers<ContextType>;
  TaxGroupSearchHit?: TaxGroupSearchHitResolvers<ContextType>;
  TaxGroupSearchHits?: TaxGroupSearchHitsResolvers<ContextType>;
  TaxJarConfig?: TaxJarConfigResolvers<ContextType>;
  TaxJarCredentials?: TaxJarCredentialsResolvers<ContextType>;
  TaxMarket?: TaxMarketResolvers<ContextType>;
  TaxMarketSearchHit?: TaxMarketSearchHitResolvers<ContextType>;
  TaxMarketSearchHits?: TaxMarketSearchHitsResolvers<ContextType>;
  UpdateExternalEventsDestinationAPIResult?: UpdateExternalEventsDestinationApiResultResolvers<ContextType>;
  UsagePlan?: UsagePlanResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserDetails?: UserDetailsResolvers<ContextType>;
  UsersList?: UsersListResolvers<ContextType>;
  ValidDateRange?: ValidDateRangeResolvers<ContextType>;
  ValidateConfigResult?: ValidateConfigResultResolvers<ContextType>;
  VoucherProvider?: VoucherProviderResolvers<ContextType>;
  VoyadoConfig?: VoyadoConfigResolvers<ContextType>;
  VoyadoCredentials?: VoyadoCredentialsResolvers<ContextType>;
  WalleyCheckoutConfig?: WalleyCheckoutConfigResolvers<ContextType>;
  WalleyCredentials?: WalleyCredentialsResolvers<ContextType>;
  WalleyDeliveryModuleDeliveryDate?: WalleyDeliveryModuleDeliveryDateResolvers<ContextType>;
  WalleyDeliveryModuleDestination?: WalleyDeliveryModuleDestinationResolvers<ContextType>;
  WalleyDeliveryModuleOption?: WalleyDeliveryModuleOptionResolvers<ContextType>;
  WalleyDeliveryModuleShipment?: WalleyDeliveryModuleShipmentResolvers<ContextType>;
  WalleyDeliveryModuleShipping?: WalleyDeliveryModuleShippingResolvers<ContextType>;
  WalleyDeliveryModuleShippingChoice?: WalleyDeliveryModuleShippingChoiceResolvers<ContextType>;
  ZaverConfig?: ZaverConfigResolvers<ContextType>;
  ZaverCredentials?: ZaverCredentialsResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  aws_api_key?: Aws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_auth?: Aws_AuthDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda?: Aws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_oidc?: Aws_OidcDirectiveResolver<any, any, ContextType>;
  aws_publish?: Aws_PublishDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
  defer?: DeferDirectiveResolver<any, any, ContextType>;
};
